(function (In, os) {
  typeof exports == 'object' && typeof module < 'u'
    ? (module.exports = os())
    : typeof define == 'function' && define.amd
      ? define(os)
      : ((In = typeof globalThis < 'u' ? globalThis : In || self), (In.QLFQuizGlp1App = os()));
})(this, function () {
  'use strict';
  window.process = { env: { NODE_ENV: 'production' } };
  function In(e, t) {
    return function () {
      return e.apply(t, arguments);
    };
  }
  const { toString: os } = Object.prototype,
    { getPrototypeOf: Xr } = Object,
    { iterator: Ks, toStringTag: zi } = Symbol,
    Ws = ((e) => (t) => {
      const n = os.call(t);
      return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
    })(Object.create(null)),
    dt = (e) => ((e = e.toLowerCase()), (t) => Ws(t) === e),
    Gs = (e) => (t) => typeof t === e,
    { isArray: Rn } = Array,
    Pn = Gs('undefined');
  function is(e) {
    return (
      e !== null &&
      !Pn(e) &&
      e.constructor !== null &&
      !Pn(e.constructor) &&
      Xe(e.constructor.isBuffer) &&
      e.constructor.isBuffer(e)
    );
  }
  const Mi = dt('ArrayBuffer');
  function Zf(e) {
    let t;
    return (
      typeof ArrayBuffer < 'u' && ArrayBuffer.isView
        ? (t = ArrayBuffer.isView(e))
        : (t = e && e.buffer && Mi(e.buffer)),
      t
    );
  }
  const Xf = Gs('string'),
    Xe = Gs('function'),
    Ni = Gs('number'),
    ls = (e) => e !== null && typeof e == 'object',
    ed = (e) => e === !0 || e === !1,
    Js = (e) => {
      if (Ws(e) !== 'object') return !1;
      const t = Xr(e);
      return (
        (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) &&
        !(zi in e) &&
        !(Ks in e)
      );
    },
    td = (e) => {
      if (!ls(e) || is(e)) return !1;
      try {
        return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
      } catch {
        return !1;
      }
    },
    nd = dt('Date'),
    sd = dt('File'),
    rd = dt('Blob'),
    od = dt('FileList'),
    id = (e) => ls(e) && Xe(e.pipe),
    ld = (e) => {
      let t;
      return (
        e &&
        ((typeof FormData == 'function' && e instanceof FormData) ||
          (Xe(e.append) &&
            ((t = Ws(e)) === 'formdata' ||
              (t === 'object' && Xe(e.toString) && e.toString() === '[object FormData]'))))
      );
    },
    ad = dt('URLSearchParams'),
    [ud, cd, fd, dd] = ['ReadableStream', 'Request', 'Response', 'Headers'].map(dt),
    pd = (e) => (e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, ''));
  function as(e, t, { allOwnKeys: n = !1 } = {}) {
    if (e === null || typeof e > 'u') return;
    let s, r;
    if ((typeof e != 'object' && (e = [e]), Rn(e)))
      for (s = 0, r = e.length; s < r; s++) t.call(null, e[s], s, e);
    else {
      if (is(e)) return;
      const o = n ? Object.getOwnPropertyNames(e) : Object.keys(e),
        i = o.length;
      let l;
      for (s = 0; s < i; s++) ((l = o[s]), t.call(null, e[l], l, e));
    }
  }
  function Vi(e, t) {
    if (is(e)) return null;
    t = t.toLowerCase();
    const n = Object.keys(e);
    let s = n.length,
      r;
    for (; s-- > 0; ) if (((r = n[s]), t === r.toLowerCase())) return r;
    return null;
  }
  const ln =
      typeof globalThis < 'u'
        ? globalThis
        : typeof self < 'u'
          ? self
          : typeof window < 'u'
            ? window
            : global,
    Li = (e) => !Pn(e) && e !== ln;
  function eo() {
    const { caseless: e, skipUndefined: t } = (Li(this) && this) || {},
      n = {},
      s = (r, o) => {
        const i = (e && Vi(n, o)) || o;
        Js(n[i]) && Js(r)
          ? (n[i] = eo(n[i], r))
          : Js(r)
            ? (n[i] = eo({}, r))
            : Rn(r)
              ? (n[i] = r.slice())
              : (!t || !Pn(r)) && (n[i] = r);
      };
    for (let r = 0, o = arguments.length; r < o; r++) arguments[r] && as(arguments[r], s);
    return n;
  }
  const hd = (e, t, n, { allOwnKeys: s } = {}) => (
      as(
        t,
        (r, o) => {
          n && Xe(r) ? (e[o] = In(r, n)) : (e[o] = r);
        },
        { allOwnKeys: s }
      ),
      e
    ),
    md = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e),
    gd = (e, t, n, s) => {
      ((e.prototype = Object.create(t.prototype, s)),
        (e.prototype.constructor = e),
        Object.defineProperty(e, 'super', { value: t.prototype }),
        n && Object.assign(e.prototype, n));
    },
    _d = (e, t, n, s) => {
      let r, o, i;
      const l = {};
      if (((t = t || {}), e == null)) return t;
      do {
        for (r = Object.getOwnPropertyNames(e), o = r.length; o-- > 0; )
          ((i = r[o]), (!s || s(i, e, t)) && !l[i] && ((t[i] = e[i]), (l[i] = !0)));
        e = n !== !1 && Xr(e);
      } while (e && (!n || n(e, t)) && e !== Object.prototype);
      return t;
    },
    qd = (e, t, n) => {
      ((e = String(e)), (n === void 0 || n > e.length) && (n = e.length), (n -= t.length));
      const s = e.indexOf(t, n);
      return s !== -1 && s === n;
    },
    vd = (e) => {
      if (!e) return null;
      if (Rn(e)) return e;
      let t = e.length;
      if (!Ni(t)) return null;
      const n = new Array(t);
      for (; t-- > 0; ) n[t] = e[t];
      return n;
    },
    bd = (
      (e) => (t) =>
        e && t instanceof e
    )(typeof Uint8Array < 'u' && Xr(Uint8Array)),
    yd = (e, t) => {
      const s = (e && e[Ks]).call(e);
      let r;
      for (; (r = s.next()) && !r.done; ) {
        const o = r.value;
        t.call(e, o[0], o[1]);
      }
    },
    xd = (e, t) => {
      let n;
      const s = [];
      for (; (n = e.exec(t)) !== null; ) s.push(n);
      return s;
    },
    wd = dt('HTMLFormElement'),
    Sd = (e) =>
      e.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function (n, s, r) {
        return s.toUpperCase() + r;
      }),
    Ui = (
      ({ hasOwnProperty: e }) =>
      (t, n) =>
        e.call(t, n)
    )(Object.prototype),
    Ed = dt('RegExp'),
    ji = (e, t) => {
      const n = Object.getOwnPropertyDescriptors(e),
        s = {};
      (as(n, (r, o) => {
        let i;
        (i = t(r, o, e)) !== !1 && (s[o] = i || r);
      }),
        Object.defineProperties(e, s));
    },
    kd = (e) => {
      ji(e, (t, n) => {
        if (Xe(e) && ['arguments', 'caller', 'callee'].indexOf(n) !== -1) return !1;
        const s = e[n];
        if (Xe(s)) {
          if (((t.enumerable = !1), 'writable' in t)) {
            t.writable = !1;
            return;
          }
          t.set ||
            (t.set = () => {
              throw Error("Can not rewrite read-only method '" + n + "'");
            });
        }
      });
    },
    Cd = (e, t) => {
      const n = {},
        s = (r) => {
          r.forEach((o) => {
            n[o] = !0;
          });
        };
      return (Rn(e) ? s(e) : s(String(e).split(t)), n);
    },
    Ad = () => {},
    Td = (e, t) => (e != null && Number.isFinite((e = +e)) ? e : t);
  function Od(e) {
    return !!(e && Xe(e.append) && e[zi] === 'FormData' && e[Ks]);
  }
  const Bd = (e) => {
      const t = new Array(10),
        n = (s, r) => {
          if (ls(s)) {
            if (t.indexOf(s) >= 0) return;
            if (is(s)) return s;
            if (!('toJSON' in s)) {
              t[r] = s;
              const o = Rn(s) ? [] : {};
              return (
                as(s, (i, l) => {
                  const a = n(i, r + 1);
                  !Pn(a) && (o[l] = a);
                }),
                (t[r] = void 0),
                o
              );
            }
          }
          return s;
        };
      return n(e, 0);
    },
    Id = dt('AsyncFunction'),
    Rd = (e) => e && (ls(e) || Xe(e)) && Xe(e.then) && Xe(e.catch),
    Hi = ((e, t) =>
      e
        ? setImmediate
        : t
          ? ((n, s) => (
              ln.addEventListener(
                'message',
                ({ source: r, data: o }) => {
                  r === ln && o === n && s.length && s.shift()();
                },
                !1
              ),
              (r) => {
                (s.push(r), ln.postMessage(n, '*'));
              }
            ))(`axios@${Math.random()}`, [])
          : (n) => setTimeout(n))(typeof setImmediate == 'function', Xe(ln.postMessage)),
    Pd =
      typeof queueMicrotask < 'u'
        ? queueMicrotask.bind(ln)
        : (typeof process < 'u' && process.nextTick) || Hi,
    y = {
      isArray: Rn,
      isArrayBuffer: Mi,
      isBuffer: is,
      isFormData: ld,
      isArrayBufferView: Zf,
      isString: Xf,
      isNumber: Ni,
      isBoolean: ed,
      isObject: ls,
      isPlainObject: Js,
      isEmptyObject: td,
      isReadableStream: ud,
      isRequest: cd,
      isResponse: fd,
      isHeaders: dd,
      isUndefined: Pn,
      isDate: nd,
      isFile: sd,
      isBlob: rd,
      isRegExp: Ed,
      isFunction: Xe,
      isStream: id,
      isURLSearchParams: ad,
      isTypedArray: bd,
      isFileList: od,
      forEach: as,
      merge: eo,
      extend: hd,
      trim: pd,
      stripBOM: md,
      inherits: gd,
      toFlatObject: _d,
      kindOf: Ws,
      kindOfTest: dt,
      endsWith: qd,
      toArray: vd,
      forEachEntry: yd,
      matchAll: xd,
      isHTMLForm: wd,
      hasOwnProperty: Ui,
      hasOwnProp: Ui,
      reduceDescriptors: ji,
      freezeMethods: kd,
      toObjectSet: Cd,
      toCamelCase: Sd,
      noop: Ad,
      toFiniteNumber: Td,
      findKey: Vi,
      global: ln,
      isContextDefined: Li,
      isSpecCompliantForm: Od,
      toJSONObject: Bd,
      isAsyncFn: Id,
      isThenable: Rd,
      setImmediate: Hi,
      asap: Pd,
      isIterable: (e) => e != null && Xe(e[Ks])
    };
  function ie(e, t, n, s, r) {
    (Error.call(this),
      Error.captureStackTrace
        ? Error.captureStackTrace(this, this.constructor)
        : (this.stack = new Error().stack),
      (this.message = e),
      (this.name = 'AxiosError'),
      t && (this.code = t),
      n && (this.config = n),
      s && (this.request = s),
      r && ((this.response = r), (this.status = r.status ? r.status : null)));
  }
  y.inherits(ie, Error, {
    toJSON: function () {
      return {
        message: this.message,
        name: this.name,
        description: this.description,
        number: this.number,
        fileName: this.fileName,
        lineNumber: this.lineNumber,
        columnNumber: this.columnNumber,
        stack: this.stack,
        config: y.toJSONObject(this.config),
        code: this.code,
        status: this.status
      };
    }
  });
  const Qi = ie.prototype,
    Ki = {};
  ([
    'ERR_BAD_OPTION_VALUE',
    'ERR_BAD_OPTION',
    'ECONNABORTED',
    'ETIMEDOUT',
    'ERR_NETWORK',
    'ERR_FR_TOO_MANY_REDIRECTS',
    'ERR_DEPRECATED',
    'ERR_BAD_RESPONSE',
    'ERR_BAD_REQUEST',
    'ERR_CANCELED',
    'ERR_NOT_SUPPORT',
    'ERR_INVALID_URL'
  ].forEach((e) => {
    Ki[e] = { value: e };
  }),
    Object.defineProperties(ie, Ki),
    Object.defineProperty(Qi, 'isAxiosError', { value: !0 }),
    (ie.from = (e, t, n, s, r, o) => {
      const i = Object.create(Qi);
      y.toFlatObject(
        e,
        i,
        function (u) {
          return u !== Error.prototype;
        },
        (f) => f !== 'isAxiosError'
      );
      const l = e && e.message ? e.message : 'Error',
        a = t == null && e ? e.code : t;
      return (
        ie.call(i, l, a, n, s, r),
        e && i.cause == null && Object.defineProperty(i, 'cause', { value: e, configurable: !0 }),
        (i.name = (e && e.name) || 'Error'),
        o && Object.assign(i, o),
        i
      );
    }));
  const $d = null;
  function to(e) {
    return y.isPlainObject(e) || y.isArray(e);
  }
  function Wi(e) {
    return y.endsWith(e, '[]') ? e.slice(0, -2) : e;
  }
  function Gi(e, t, n) {
    return e
      ? e
          .concat(t)
          .map(function (r, o) {
            return ((r = Wi(r)), !n && o ? '[' + r + ']' : r);
          })
          .join(n ? '.' : '')
      : t;
  }
  function Dd(e) {
    return y.isArray(e) && !e.some(to);
  }
  const Fd = y.toFlatObject(y, {}, null, function (t) {
    return /^is[A-Z]/.test(t);
  });
  function Ys(e, t, n) {
    if (!y.isObject(e)) throw new TypeError('target must be an object');
    ((t = t || new FormData()),
      (n = y.toFlatObject(n, { metaTokens: !0, dots: !1, indexes: !1 }, !1, function (q, v) {
        return !y.isUndefined(v[q]);
      })));
    const s = n.metaTokens,
      r = n.visitor || u,
      o = n.dots,
      i = n.indexes,
      a = (n.Blob || (typeof Blob < 'u' && Blob)) && y.isSpecCompliantForm(t);
    if (!y.isFunction(r)) throw new TypeError('visitor must be a function');
    function f(h) {
      if (h === null) return '';
      if (y.isDate(h)) return h.toISOString();
      if (y.isBoolean(h)) return h.toString();
      if (!a && y.isBlob(h)) throw new ie('Blob is not supported. Use a Buffer instead.');
      return y.isArrayBuffer(h) || y.isTypedArray(h)
        ? a && typeof Blob == 'function'
          ? new Blob([h])
          : Buffer.from(h)
        : h;
    }
    function u(h, q, v) {
      let b = h;
      if (h && !v && typeof h == 'object') {
        if (y.endsWith(q, '{}')) ((q = s ? q : q.slice(0, -2)), (h = JSON.stringify(h)));
        else if (
          (y.isArray(h) && Dd(h)) ||
          ((y.isFileList(h) || y.endsWith(q, '[]')) && (b = y.toArray(h)))
        )
          return (
            (q = Wi(q)),
            b.forEach(function (C, G) {
              !(y.isUndefined(C) || C === null) &&
                t.append(i === !0 ? Gi([q], G, o) : i === null ? q : q + '[]', f(C));
            }),
            !1
          );
      }
      return to(h) ? !0 : (t.append(Gi(v, q, o), f(h)), !1);
    }
    const c = [],
      d = Object.assign(Fd, { defaultVisitor: u, convertValue: f, isVisitable: to });
    function p(h, q) {
      if (!y.isUndefined(h)) {
        if (c.indexOf(h) !== -1) throw Error('Circular reference detected in ' + q.join('.'));
        (c.push(h),
          y.forEach(h, function (b, $) {
            (!(y.isUndefined(b) || b === null) &&
              r.call(t, b, y.isString($) ? $.trim() : $, q, d)) === !0 &&
              p(b, q ? q.concat($) : [$]);
          }),
          c.pop());
      }
    }
    if (!y.isObject(e)) throw new TypeError('data must be an object');
    return (p(e), t);
  }
  function Ji(e) {
    const t = {
      '!': '%21',
      "'": '%27',
      '(': '%28',
      ')': '%29',
      '~': '%7E',
      '%20': '+',
      '%00': '\0'
    };
    return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function (s) {
      return t[s];
    });
  }
  function no(e, t) {
    ((this._pairs = []), e && Ys(e, this, t));
  }
  const Yi = no.prototype;
  ((Yi.append = function (t, n) {
    this._pairs.push([t, n]);
  }),
    (Yi.toString = function (t) {
      const n = t
        ? function (s) {
            return t.call(this, s, Ji);
          }
        : Ji;
      return this._pairs
        .map(function (r) {
          return n(r[0]) + '=' + n(r[1]);
        }, '')
        .join('&');
    }));
  function zd(e) {
    return encodeURIComponent(e)
      .replace(/%3A/gi, ':')
      .replace(/%24/g, '$')
      .replace(/%2C/gi, ',')
      .replace(/%20/g, '+');
  }
  function Zi(e, t, n) {
    if (!t) return e;
    const s = (n && n.encode) || zd;
    y.isFunction(n) && (n = { serialize: n });
    const r = n && n.serialize;
    let o;
    if (
      (r ? (o = r(t, n)) : (o = y.isURLSearchParams(t) ? t.toString() : new no(t, n).toString(s)),
      o)
    ) {
      const i = e.indexOf('#');
      (i !== -1 && (e = e.slice(0, i)), (e += (e.indexOf('?') === -1 ? '?' : '&') + o));
    }
    return e;
  }
  class Xi {
    constructor() {
      this.handlers = [];
    }
    use(t, n, s) {
      return (
        this.handlers.push({
          fulfilled: t,
          rejected: n,
          synchronous: s ? s.synchronous : !1,
          runWhen: s ? s.runWhen : null
        }),
        this.handlers.length - 1
      );
    }
    eject(t) {
      this.handlers[t] && (this.handlers[t] = null);
    }
    clear() {
      this.handlers && (this.handlers = []);
    }
    forEach(t) {
      y.forEach(this.handlers, function (s) {
        s !== null && t(s);
      });
    }
  }
  const el = { silentJSONParsing: !0, forcedJSONParsing: !0, clarifyTimeoutError: !1 },
    Md = {
      isBrowser: !0,
      classes: {
        URLSearchParams: typeof URLSearchParams < 'u' ? URLSearchParams : no,
        FormData: typeof FormData < 'u' ? FormData : null,
        Blob: typeof Blob < 'u' ? Blob : null
      },
      protocols: ['http', 'https', 'file', 'blob', 'url', 'data']
    },
    so = typeof window < 'u' && typeof document < 'u',
    ro = (typeof navigator == 'object' && navigator) || void 0,
    Nd = so && (!ro || ['ReactNative', 'NativeScript', 'NS'].indexOf(ro.product) < 0),
    Vd =
      typeof WorkerGlobalScope < 'u' &&
      self instanceof WorkerGlobalScope &&
      typeof self.importScripts == 'function',
    Ld = (so && window.location.href) || 'http://localhost',
    Ne = {
      ...Object.freeze(
        Object.defineProperty(
          {
            __proto__: null,
            hasBrowserEnv: so,
            hasStandardBrowserEnv: Nd,
            hasStandardBrowserWebWorkerEnv: Vd,
            navigator: ro,
            origin: Ld
          },
          Symbol.toStringTag,
          { value: 'Module' }
        )
      ),
      ...Md
    };
  function Ud(e, t) {
    return Ys(e, new Ne.classes.URLSearchParams(), {
      visitor: function (n, s, r, o) {
        return Ne.isNode && y.isBuffer(n)
          ? (this.append(s, n.toString('base64')), !1)
          : o.defaultVisitor.apply(this, arguments);
      },
      ...t
    });
  }
  function jd(e) {
    return y.matchAll(/\w+|\[(\w*)]/g, e).map((t) => (t[0] === '[]' ? '' : t[1] || t[0]));
  }
  function Hd(e) {
    const t = {},
      n = Object.keys(e);
    let s;
    const r = n.length;
    let o;
    for (s = 0; s < r; s++) ((o = n[s]), (t[o] = e[o]));
    return t;
  }
  function tl(e) {
    function t(n, s, r, o) {
      let i = n[o++];
      if (i === '__proto__') return !0;
      const l = Number.isFinite(+i),
        a = o >= n.length;
      return (
        (i = !i && y.isArray(r) ? r.length : i),
        a
          ? (y.hasOwnProp(r, i) ? (r[i] = [r[i], s]) : (r[i] = s), !l)
          : ((!r[i] || !y.isObject(r[i])) && (r[i] = []),
            t(n, s, r[i], o) && y.isArray(r[i]) && (r[i] = Hd(r[i])),
            !l)
      );
    }
    if (y.isFormData(e) && y.isFunction(e.entries)) {
      const n = {};
      return (
        y.forEachEntry(e, (s, r) => {
          t(jd(s), r, n, 0);
        }),
        n
      );
    }
    return null;
  }
  function Qd(e, t, n) {
    if (y.isString(e))
      try {
        return ((t || JSON.parse)(e), y.trim(e));
      } catch (s) {
        if (s.name !== 'SyntaxError') throw s;
      }
    return (n || JSON.stringify)(e);
  }
  const us = {
    transitional: el,
    adapter: ['xhr', 'http', 'fetch'],
    transformRequest: [
      function (t, n) {
        const s = n.getContentType() || '',
          r = s.indexOf('application/json') > -1,
          o = y.isObject(t);
        if ((o && y.isHTMLForm(t) && (t = new FormData(t)), y.isFormData(t)))
          return r ? JSON.stringify(tl(t)) : t;
        if (
          y.isArrayBuffer(t) ||
          y.isBuffer(t) ||
          y.isStream(t) ||
          y.isFile(t) ||
          y.isBlob(t) ||
          y.isReadableStream(t)
        )
          return t;
        if (y.isArrayBufferView(t)) return t.buffer;
        if (y.isURLSearchParams(t))
          return (
            n.setContentType('application/x-www-form-urlencoded;charset=utf-8', !1),
            t.toString()
          );
        let l;
        if (o) {
          if (s.indexOf('application/x-www-form-urlencoded') > -1)
            return Ud(t, this.formSerializer).toString();
          if ((l = y.isFileList(t)) || s.indexOf('multipart/form-data') > -1) {
            const a = this.env && this.env.FormData;
            return Ys(l ? { 'files[]': t } : t, a && new a(), this.formSerializer);
          }
        }
        return o || r ? (n.setContentType('application/json', !1), Qd(t)) : t;
      }
    ],
    transformResponse: [
      function (t) {
        const n = this.transitional || us.transitional,
          s = n && n.forcedJSONParsing,
          r = this.responseType === 'json';
        if (y.isResponse(t) || y.isReadableStream(t)) return t;
        if (t && y.isString(t) && ((s && !this.responseType) || r)) {
          const i = !(n && n.silentJSONParsing) && r;
          try {
            return JSON.parse(t, this.parseReviver);
          } catch (l) {
            if (i)
              throw l.name === 'SyntaxError'
                ? ie.from(l, ie.ERR_BAD_RESPONSE, this, null, this.response)
                : l;
          }
        }
        return t;
      }
    ],
    timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: { FormData: Ne.classes.FormData, Blob: Ne.classes.Blob },
    validateStatus: function (t) {
      return t >= 200 && t < 300;
    },
    headers: { common: { Accept: 'application/json, text/plain, */*', 'Content-Type': void 0 } }
  };
  y.forEach(['delete', 'get', 'head', 'post', 'put', 'patch'], (e) => {
    us.headers[e] = {};
  });
  const Kd = y.toObjectSet([
      'age',
      'authorization',
      'content-length',
      'content-type',
      'etag',
      'expires',
      'from',
      'host',
      'if-modified-since',
      'if-unmodified-since',
      'last-modified',
      'location',
      'max-forwards',
      'proxy-authorization',
      'referer',
      'retry-after',
      'user-agent'
    ]),
    Wd = (e) => {
      const t = {};
      let n, s, r;
      return (
        e &&
          e
            .split(
              `
`
            )
            .forEach(function (i) {
              ((r = i.indexOf(':')),
                (n = i.substring(0, r).trim().toLowerCase()),
                (s = i.substring(r + 1).trim()),
                !(!n || (t[n] && Kd[n])) &&
                  (n === 'set-cookie'
                    ? t[n]
                      ? t[n].push(s)
                      : (t[n] = [s])
                    : (t[n] = t[n] ? t[n] + ', ' + s : s)));
            }),
        t
      );
    },
    nl = Symbol('internals');
  function cs(e) {
    return e && String(e).trim().toLowerCase();
  }
  function Zs(e) {
    return e === !1 || e == null ? e : y.isArray(e) ? e.map(Zs) : String(e);
  }
  function Gd(e) {
    const t = Object.create(null),
      n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let s;
    for (; (s = n.exec(e)); ) t[s[1]] = s[2];
    return t;
  }
  const Jd = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
  function oo(e, t, n, s, r) {
    if (y.isFunction(s)) return s.call(this, t, n);
    if ((r && (t = n), !!y.isString(t))) {
      if (y.isString(s)) return t.indexOf(s) !== -1;
      if (y.isRegExp(s)) return s.test(t);
    }
  }
  function Yd(e) {
    return e
      .trim()
      .toLowerCase()
      .replace(/([a-z\d])(\w*)/g, (t, n, s) => n.toUpperCase() + s);
  }
  function Zd(e, t) {
    const n = y.toCamelCase(' ' + t);
    ['get', 'set', 'has'].forEach((s) => {
      Object.defineProperty(e, s + n, {
        value: function (r, o, i) {
          return this[s].call(this, t, r, o, i);
        },
        configurable: !0
      });
    });
  }
  let et = class {
    constructor(t) {
      t && this.set(t);
    }
    set(t, n, s) {
      const r = this;
      function o(l, a, f) {
        const u = cs(a);
        if (!u) throw new Error('header name must be a non-empty string');
        const c = y.findKey(r, u);
        (!c || r[c] === void 0 || f === !0 || (f === void 0 && r[c] !== !1)) && (r[c || a] = Zs(l));
      }
      const i = (l, a) => y.forEach(l, (f, u) => o(f, u, a));
      if (y.isPlainObject(t) || t instanceof this.constructor) i(t, n);
      else if (y.isString(t) && (t = t.trim()) && !Jd(t)) i(Wd(t), n);
      else if (y.isObject(t) && y.isIterable(t)) {
        let l = {},
          a,
          f;
        for (const u of t) {
          if (!y.isArray(u)) throw TypeError('Object iterator must return a key-value pair');
          l[(f = u[0])] = (a = l[f]) ? (y.isArray(a) ? [...a, u[1]] : [a, u[1]]) : u[1];
        }
        i(l, n);
      } else t != null && o(n, t, s);
      return this;
    }
    get(t, n) {
      if (((t = cs(t)), t)) {
        const s = y.findKey(this, t);
        if (s) {
          const r = this[s];
          if (!n) return r;
          if (n === !0) return Gd(r);
          if (y.isFunction(n)) return n.call(this, r, s);
          if (y.isRegExp(n)) return n.exec(r);
          throw new TypeError('parser must be boolean|regexp|function');
        }
      }
    }
    has(t, n) {
      if (((t = cs(t)), t)) {
        const s = y.findKey(this, t);
        return !!(s && this[s] !== void 0 && (!n || oo(this, this[s], s, n)));
      }
      return !1;
    }
    delete(t, n) {
      const s = this;
      let r = !1;
      function o(i) {
        if (((i = cs(i)), i)) {
          const l = y.findKey(s, i);
          l && (!n || oo(s, s[l], l, n)) && (delete s[l], (r = !0));
        }
      }
      return (y.isArray(t) ? t.forEach(o) : o(t), r);
    }
    clear(t) {
      const n = Object.keys(this);
      let s = n.length,
        r = !1;
      for (; s--; ) {
        const o = n[s];
        (!t || oo(this, this[o], o, t, !0)) && (delete this[o], (r = !0));
      }
      return r;
    }
    normalize(t) {
      const n = this,
        s = {};
      return (
        y.forEach(this, (r, o) => {
          const i = y.findKey(s, o);
          if (i) {
            ((n[i] = Zs(r)), delete n[o]);
            return;
          }
          const l = t ? Yd(o) : String(o).trim();
          (l !== o && delete n[o], (n[l] = Zs(r)), (s[l] = !0));
        }),
        this
      );
    }
    concat(...t) {
      return this.constructor.concat(this, ...t);
    }
    toJSON(t) {
      const n = Object.create(null);
      return (
        y.forEach(this, (s, r) => {
          s != null && s !== !1 && (n[r] = t && y.isArray(s) ? s.join(', ') : s);
        }),
        n
      );
    }
    [Symbol.iterator]() {
      return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
      return Object.entries(this.toJSON()).map(([t, n]) => t + ': ' + n).join(`
`);
    }
    getSetCookie() {
      return this.get('set-cookie') || [];
    }
    get [Symbol.toStringTag]() {
      return 'AxiosHeaders';
    }
    static from(t) {
      return t instanceof this ? t : new this(t);
    }
    static concat(t, ...n) {
      const s = new this(t);
      return (n.forEach((r) => s.set(r)), s);
    }
    static accessor(t) {
      const s = (this[nl] = this[nl] = { accessors: {} }).accessors,
        r = this.prototype;
      function o(i) {
        const l = cs(i);
        s[l] || (Zd(r, i), (s[l] = !0));
      }
      return (y.isArray(t) ? t.forEach(o) : o(t), this);
    }
  };
  (et.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
  ]),
    y.reduceDescriptors(et.prototype, ({ value: e }, t) => {
      let n = t[0].toUpperCase() + t.slice(1);
      return {
        get: () => e,
        set(s) {
          this[n] = s;
        }
      };
    }),
    y.freezeMethods(et));
  function io(e, t) {
    const n = this || us,
      s = t || n,
      r = et.from(s.headers);
    let o = s.data;
    return (
      y.forEach(e, function (l) {
        o = l.call(n, o, r.normalize(), t ? t.status : void 0);
      }),
      r.normalize(),
      o
    );
  }
  function sl(e) {
    return !!(e && e.__CANCEL__);
  }
  function $n(e, t, n) {
    (ie.call(this, e ?? 'canceled', ie.ERR_CANCELED, t, n), (this.name = 'CanceledError'));
  }
  y.inherits($n, ie, { __CANCEL__: !0 });
  function rl(e, t, n) {
    const s = n.config.validateStatus;
    !n.status || !s || s(n.status)
      ? e(n)
      : t(
          new ie(
            'Request failed with status code ' + n.status,
            [ie.ERR_BAD_REQUEST, ie.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
            n.config,
            n.request,
            n
          )
        );
  }
  function Xd(e) {
    const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
    return (t && t[1]) || '';
  }
  function ep(e, t) {
    e = e || 10;
    const n = new Array(e),
      s = new Array(e);
    let r = 0,
      o = 0,
      i;
    return (
      (t = t !== void 0 ? t : 1e3),
      function (a) {
        const f = Date.now(),
          u = s[o];
        (i || (i = f), (n[r] = a), (s[r] = f));
        let c = o,
          d = 0;
        for (; c !== r; ) ((d += n[c++]), (c = c % e));
        if (((r = (r + 1) % e), r === o && (o = (o + 1) % e), f - i < t)) return;
        const p = u && f - u;
        return p ? Math.round((d * 1e3) / p) : void 0;
      }
    );
  }
  function tp(e, t) {
    let n = 0,
      s = 1e3 / t,
      r,
      o;
    const i = (f, u = Date.now()) => {
      ((n = u), (r = null), o && (clearTimeout(o), (o = null)), e(...f));
    };
    return [
      (...f) => {
        const u = Date.now(),
          c = u - n;
        c >= s
          ? i(f, u)
          : ((r = f),
            o ||
              (o = setTimeout(() => {
                ((o = null), i(r));
              }, s - c)));
      },
      () => r && i(r)
    ];
  }
  const Xs = (e, t, n = 3) => {
      let s = 0;
      const r = ep(50, 250);
      return tp((o) => {
        const i = o.loaded,
          l = o.lengthComputable ? o.total : void 0,
          a = i - s,
          f = r(a),
          u = i <= l;
        s = i;
        const c = {
          loaded: i,
          total: l,
          progress: l ? i / l : void 0,
          bytes: a,
          rate: f || void 0,
          estimated: f && l && u ? (l - i) / f : void 0,
          event: o,
          lengthComputable: l != null,
          [t ? 'download' : 'upload']: !0
        };
        e(c);
      }, n);
    },
    ol = (e, t) => {
      const n = e != null;
      return [(s) => t[0]({ lengthComputable: n, total: e, loaded: s }), t[1]];
    },
    il =
      (e) =>
      (...t) =>
        y.asap(() => e(...t)),
    np = Ne.hasStandardBrowserEnv
      ? ((e, t) => (n) => (
          (n = new URL(n, Ne.origin)),
          e.protocol === n.protocol && e.host === n.host && (t || e.port === n.port)
        ))(new URL(Ne.origin), Ne.navigator && /(msie|trident)/i.test(Ne.navigator.userAgent))
      : () => !0,
    sp = Ne.hasStandardBrowserEnv
      ? {
          write(e, t, n, s, r, o) {
            const i = [e + '=' + encodeURIComponent(t)];
            (y.isNumber(n) && i.push('expires=' + new Date(n).toGMTString()),
              y.isString(s) && i.push('path=' + s),
              y.isString(r) && i.push('domain=' + r),
              o === !0 && i.push('secure'),
              (document.cookie = i.join('; ')));
          },
          read(e) {
            const t = document.cookie.match(new RegExp('(^|;\\s*)(' + e + ')=([^;]*)'));
            return t ? decodeURIComponent(t[3]) : null;
          },
          remove(e) {
            this.write(e, '', Date.now() - 864e5);
          }
        }
      : {
          write() {},
          read() {
            return null;
          },
          remove() {}
        };
  function rp(e) {
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
  }
  function op(e, t) {
    return t ? e.replace(/\/?\/$/, '') + '/' + t.replace(/^\/+/, '') : e;
  }
  function ll(e, t, n) {
    let s = !rp(t);
    return e && (s || n == !1) ? op(e, t) : t;
  }
  const al = (e) => (e instanceof et ? { ...e } : e);
  function an(e, t) {
    t = t || {};
    const n = {};
    function s(f, u, c, d) {
      return y.isPlainObject(f) && y.isPlainObject(u)
        ? y.merge.call({ caseless: d }, f, u)
        : y.isPlainObject(u)
          ? y.merge({}, u)
          : y.isArray(u)
            ? u.slice()
            : u;
    }
    function r(f, u, c, d) {
      if (y.isUndefined(u)) {
        if (!y.isUndefined(f)) return s(void 0, f, c, d);
      } else return s(f, u, c, d);
    }
    function o(f, u) {
      if (!y.isUndefined(u)) return s(void 0, u);
    }
    function i(f, u) {
      if (y.isUndefined(u)) {
        if (!y.isUndefined(f)) return s(void 0, f);
      } else return s(void 0, u);
    }
    function l(f, u, c) {
      if (c in t) return s(f, u);
      if (c in e) return s(void 0, f);
    }
    const a = {
      url: o,
      method: o,
      data: o,
      baseURL: i,
      transformRequest: i,
      transformResponse: i,
      paramsSerializer: i,
      timeout: i,
      timeoutMessage: i,
      withCredentials: i,
      withXSRFToken: i,
      adapter: i,
      responseType: i,
      xsrfCookieName: i,
      xsrfHeaderName: i,
      onUploadProgress: i,
      onDownloadProgress: i,
      decompress: i,
      maxContentLength: i,
      maxBodyLength: i,
      beforeRedirect: i,
      transport: i,
      httpAgent: i,
      httpsAgent: i,
      cancelToken: i,
      socketPath: i,
      responseEncoding: i,
      validateStatus: l,
      headers: (f, u, c) => r(al(f), al(u), c, !0)
    };
    return (
      y.forEach(Object.keys({ ...e, ...t }), function (u) {
        const c = a[u] || r,
          d = c(e[u], t[u], u);
        (y.isUndefined(d) && c !== l) || (n[u] = d);
      }),
      n
    );
  }
  const ul = (e) => {
      const t = an({}, e);
      let {
        data: n,
        withXSRFToken: s,
        xsrfHeaderName: r,
        xsrfCookieName: o,
        headers: i,
        auth: l
      } = t;
      if (
        ((t.headers = i = et.from(i)),
        (t.url = Zi(ll(t.baseURL, t.url, t.allowAbsoluteUrls), e.params, e.paramsSerializer)),
        l &&
          i.set(
            'Authorization',
            'Basic ' +
              btoa(
                (l.username || '') +
                  ':' +
                  (l.password ? unescape(encodeURIComponent(l.password)) : '')
              )
          ),
        y.isFormData(n))
      ) {
        if (Ne.hasStandardBrowserEnv || Ne.hasStandardBrowserWebWorkerEnv) i.setContentType(void 0);
        else if (y.isFunction(n.getHeaders)) {
          const a = n.getHeaders(),
            f = ['content-type', 'content-length'];
          Object.entries(a).forEach(([u, c]) => {
            f.includes(u.toLowerCase()) && i.set(u, c);
          });
        }
      }
      if (
        Ne.hasStandardBrowserEnv &&
        (s && y.isFunction(s) && (s = s(t)), s || (s !== !1 && np(t.url)))
      ) {
        const a = r && o && sp.read(o);
        a && i.set(r, a);
      }
      return t;
    },
    ip =
      typeof XMLHttpRequest < 'u' &&
      function (e) {
        return new Promise(function (n, s) {
          const r = ul(e);
          let o = r.data;
          const i = et.from(r.headers).normalize();
          let { responseType: l, onUploadProgress: a, onDownloadProgress: f } = r,
            u,
            c,
            d,
            p,
            h;
          function q() {
            (p && p(),
              h && h(),
              r.cancelToken && r.cancelToken.unsubscribe(u),
              r.signal && r.signal.removeEventListener('abort', u));
          }
          let v = new XMLHttpRequest();
          (v.open(r.method.toUpperCase(), r.url, !0), (v.timeout = r.timeout));
          function b() {
            if (!v) return;
            const C = et.from('getAllResponseHeaders' in v && v.getAllResponseHeaders()),
              D = {
                data: !l || l === 'text' || l === 'json' ? v.responseText : v.response,
                status: v.status,
                statusText: v.statusText,
                headers: C,
                config: e,
                request: v
              };
            (rl(
              function (V) {
                (n(V), q());
              },
              function (V) {
                (s(V), q());
              },
              D
            ),
              (v = null));
          }
          ('onloadend' in v
            ? (v.onloadend = b)
            : (v.onreadystatechange = function () {
                !v ||
                  v.readyState !== 4 ||
                  (v.status === 0 && !(v.responseURL && v.responseURL.indexOf('file:') === 0)) ||
                  setTimeout(b);
              }),
            (v.onabort = function () {
              v && (s(new ie('Request aborted', ie.ECONNABORTED, e, v)), (v = null));
            }),
            (v.onerror = function (G) {
              const D = G && G.message ? G.message : 'Network Error',
                te = new ie(D, ie.ERR_NETWORK, e, v);
              ((te.event = G || null), s(te), (v = null));
            }),
            (v.ontimeout = function () {
              let G = r.timeout ? 'timeout of ' + r.timeout + 'ms exceeded' : 'timeout exceeded';
              const D = r.transitional || el;
              (r.timeoutErrorMessage && (G = r.timeoutErrorMessage),
                s(new ie(G, D.clarifyTimeoutError ? ie.ETIMEDOUT : ie.ECONNABORTED, e, v)),
                (v = null));
            }),
            o === void 0 && i.setContentType(null),
            'setRequestHeader' in v &&
              y.forEach(i.toJSON(), function (G, D) {
                v.setRequestHeader(D, G);
              }),
            y.isUndefined(r.withCredentials) || (v.withCredentials = !!r.withCredentials),
            l && l !== 'json' && (v.responseType = r.responseType),
            f && (([d, h] = Xs(f, !0)), v.addEventListener('progress', d)),
            a &&
              v.upload &&
              (([c, p] = Xs(a)),
              v.upload.addEventListener('progress', c),
              v.upload.addEventListener('loadend', p)),
            (r.cancelToken || r.signal) &&
              ((u = (C) => {
                v && (s(!C || C.type ? new $n(null, e, v) : C), v.abort(), (v = null));
              }),
              r.cancelToken && r.cancelToken.subscribe(u),
              r.signal && (r.signal.aborted ? u() : r.signal.addEventListener('abort', u))));
          const $ = Xd(r.url);
          if ($ && Ne.protocols.indexOf($) === -1) {
            s(new ie('Unsupported protocol ' + $ + ':', ie.ERR_BAD_REQUEST, e));
            return;
          }
          v.send(o || null);
        });
      },
    lp = (e, t) => {
      const { length: n } = (e = e ? e.filter(Boolean) : []);
      if (t || n) {
        let s = new AbortController(),
          r;
        const o = function (f) {
          if (!r) {
            ((r = !0), l());
            const u = f instanceof Error ? f : this.reason;
            s.abort(u instanceof ie ? u : new $n(u instanceof Error ? u.message : u));
          }
        };
        let i =
          t &&
          setTimeout(() => {
            ((i = null), o(new ie(`timeout ${t} of ms exceeded`, ie.ETIMEDOUT)));
          }, t);
        const l = () => {
          e &&
            (i && clearTimeout(i),
            (i = null),
            e.forEach((f) => {
              f.unsubscribe ? f.unsubscribe(o) : f.removeEventListener('abort', o);
            }),
            (e = null));
        };
        e.forEach((f) => f.addEventListener('abort', o));
        const { signal: a } = s;
        return ((a.unsubscribe = () => y.asap(l)), a);
      }
    },
    ap = function* (e, t) {
      let n = e.byteLength;
      if (n < t) {
        yield e;
        return;
      }
      let s = 0,
        r;
      for (; s < n; ) ((r = s + t), yield e.slice(s, r), (s = r));
    },
    up = async function* (e, t) {
      for await (const n of cp(e)) yield* ap(n, t);
    },
    cp = async function* (e) {
      if (e[Symbol.asyncIterator]) {
        yield* e;
        return;
      }
      const t = e.getReader();
      try {
        for (;;) {
          const { done: n, value: s } = await t.read();
          if (n) break;
          yield s;
        }
      } finally {
        await t.cancel();
      }
    },
    cl = (e, t, n, s) => {
      const r = up(e, t);
      let o = 0,
        i,
        l = (a) => {
          i || ((i = !0), s && s(a));
        };
      return new ReadableStream(
        {
          async pull(a) {
            try {
              const { done: f, value: u } = await r.next();
              if (f) {
                (l(), a.close());
                return;
              }
              let c = u.byteLength;
              if (n) {
                let d = (o += c);
                n(d);
              }
              a.enqueue(new Uint8Array(u));
            } catch (f) {
              throw (l(f), f);
            }
          },
          cancel(a) {
            return (l(a), r.return());
          }
        },
        { highWaterMark: 2 }
      );
    },
    fl = 64 * 1024,
    { isFunction: er } = y,
    fp = (({ Request: e, Response: t }) => ({ Request: e, Response: t }))(y.global),
    { ReadableStream: dl, TextEncoder: pl } = y.global,
    hl = (e, ...t) => {
      try {
        return !!e(...t);
      } catch {
        return !1;
      }
    },
    dp = (e) => {
      e = y.merge.call({ skipUndefined: !0 }, fp, e);
      const { fetch: t, Request: n, Response: s } = e,
        r = t ? er(t) : typeof fetch == 'function',
        o = er(n),
        i = er(s);
      if (!r) return !1;
      const l = r && er(dl),
        a =
          r &&
          (typeof pl == 'function'
            ? (
                (h) => (q) =>
                  h.encode(q)
              )(new pl())
            : async (h) => new Uint8Array(await new n(h).arrayBuffer())),
        f =
          o &&
          l &&
          hl(() => {
            let h = !1;
            const q = new n(Ne.origin, {
              body: new dl(),
              method: 'POST',
              get duplex() {
                return ((h = !0), 'half');
              }
            }).headers.has('Content-Type');
            return h && !q;
          }),
        u = i && l && hl(() => y.isReadableStream(new s('').body)),
        c = { stream: u && ((h) => h.body) };
      r &&
        ['text', 'arrayBuffer', 'blob', 'formData', 'stream'].forEach((h) => {
          !c[h] &&
            (c[h] = (q, v) => {
              let b = q && q[h];
              if (b) return b.call(q);
              throw new ie(`Response type '${h}' is not supported`, ie.ERR_NOT_SUPPORT, v);
            });
        });
      const d = async (h) => {
          if (h == null) return 0;
          if (y.isBlob(h)) return h.size;
          if (y.isSpecCompliantForm(h))
            return (await new n(Ne.origin, { method: 'POST', body: h }).arrayBuffer()).byteLength;
          if (y.isArrayBufferView(h) || y.isArrayBuffer(h)) return h.byteLength;
          if ((y.isURLSearchParams(h) && (h = h + ''), y.isString(h)))
            return (await a(h)).byteLength;
        },
        p = async (h, q) => {
          const v = y.toFiniteNumber(h.getContentLength());
          return v ?? d(q);
        };
      return async (h) => {
        let {
            url: q,
            method: v,
            data: b,
            signal: $,
            cancelToken: C,
            timeout: G,
            onDownloadProgress: D,
            onUploadProgress: te,
            responseType: V,
            headers: ce,
            withCredentials: K = 'same-origin',
            fetchOptions: I
          } = ul(h),
          T = t || fetch;
        V = V ? (V + '').toLowerCase() : 'text';
        let x = lp([$, C && C.toAbortSignal()], G),
          Q = null;
        const Y =
          x &&
          x.unsubscribe &&
          (() => {
            x.unsubscribe();
          });
        let me;
        try {
          if (te && f && v !== 'get' && v !== 'head' && (me = await p(ce, b)) !== 0) {
            let Ce = new n(q, { method: 'POST', body: b, duplex: 'half' }),
              Ee;
            if (
              (y.isFormData(b) && (Ee = Ce.headers.get('content-type')) && ce.setContentType(Ee),
              Ce.body)
            ) {
              const [ze, _t] = ol(me, Xs(il(te)));
              b = cl(Ce.body, fl, ze, _t);
            }
          }
          y.isString(K) || (K = K ? 'include' : 'omit');
          const ae = o && 'credentials' in n.prototype,
            j = {
              ...I,
              signal: x,
              method: v.toUpperCase(),
              headers: ce.normalize().toJSON(),
              body: b,
              duplex: 'half',
              credentials: ae ? K : void 0
            };
          Q = o && new n(q, j);
          let Z = await (o ? T(Q, I) : T(q, j));
          const ue = u && (V === 'stream' || V === 'response');
          if (u && (D || (ue && Y))) {
            const Ce = {};
            ['status', 'statusText', 'headers'].forEach((on) => {
              Ce[on] = Z[on];
            });
            const Ee = y.toFiniteNumber(Z.headers.get('content-length')),
              [ze, _t] = (D && ol(Ee, Xs(il(D), !0))) || [];
            Z = new s(
              cl(Z.body, fl, ze, () => {
                (_t && _t(), Y && Y());
              }),
              Ce
            );
          }
          V = V || 'text';
          let ft = await c[y.findKey(c, V) || 'text'](Z, h);
          return (
            !ue && Y && Y(),
            await new Promise((Ce, Ee) => {
              rl(Ce, Ee, {
                data: ft,
                headers: et.from(Z.headers),
                status: Z.status,
                statusText: Z.statusText,
                config: h,
                request: Q
              });
            })
          );
        } catch (ae) {
          throw (
            Y && Y(),
            ae && ae.name === 'TypeError' && /Load failed|fetch/i.test(ae.message)
              ? Object.assign(new ie('Network Error', ie.ERR_NETWORK, h, Q), {
                  cause: ae.cause || ae
                })
              : ie.from(ae, ae && ae.code, h, Q)
          );
        }
      };
    },
    pp = new Map(),
    ml = (e) => {
      let t = e ? e.env : {};
      const { fetch: n, Request: s, Response: r } = t,
        o = [s, r, n];
      let i = o.length,
        l = i,
        a,
        f,
        u = pp;
      for (; l--; )
        ((a = o[l]),
          (f = u.get(a)),
          f === void 0 && u.set(a, (f = l ? new Map() : dp(t))),
          (u = f));
      return f;
    };
  ml();
  const lo = { http: $d, xhr: ip, fetch: { get: ml } };
  y.forEach(lo, (e, t) => {
    if (e) {
      try {
        Object.defineProperty(e, 'name', { value: t });
      } catch {}
      Object.defineProperty(e, 'adapterName', { value: t });
    }
  });
  const gl = (e) => `- ${e}`,
    hp = (e) => y.isFunction(e) || e === null || e === !1,
    _l = {
      getAdapter: (e, t) => {
        e = y.isArray(e) ? e : [e];
        const { length: n } = e;
        let s, r;
        const o = {};
        for (let i = 0; i < n; i++) {
          s = e[i];
          let l;
          if (((r = s), !hp(s) && ((r = lo[(l = String(s)).toLowerCase()]), r === void 0)))
            throw new ie(`Unknown adapter '${l}'`);
          if (r && (y.isFunction(r) || (r = r.get(t)))) break;
          o[l || '#' + i] = r;
        }
        if (!r) {
          const i = Object.entries(o).map(
            ([a, f]) =>
              `adapter ${a} ` +
              (f === !1 ? 'is not supported by the environment' : 'is not available in the build')
          );
          let l = n
            ? i.length > 1
              ? `since :
` +
                i.map(gl).join(`
`)
              : ' ' + gl(i[0])
            : 'as no adapter specified';
          throw new ie(
            'There is no suitable adapter to dispatch the request ' + l,
            'ERR_NOT_SUPPORT'
          );
        }
        return r;
      },
      adapters: lo
    };
  function ao(e) {
    if ((e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted))
      throw new $n(null, e);
  }
  function ql(e) {
    return (
      ao(e),
      (e.headers = et.from(e.headers)),
      (e.data = io.call(e, e.transformRequest)),
      ['post', 'put', 'patch'].indexOf(e.method) !== -1 &&
        e.headers.setContentType('application/x-www-form-urlencoded', !1),
      _l
        .getAdapter(
          e.adapter || us.adapter,
          e
        )(e)
        .then(
          function (s) {
            return (
              ao(e),
              (s.data = io.call(e, e.transformResponse, s)),
              (s.headers = et.from(s.headers)),
              s
            );
          },
          function (s) {
            return (
              sl(s) ||
                (ao(e),
                s &&
                  s.response &&
                  ((s.response.data = io.call(e, e.transformResponse, s.response)),
                  (s.response.headers = et.from(s.response.headers)))),
              Promise.reject(s)
            );
          }
        )
    );
  }
  const vl = '1.12.2',
    tr = {};
  ['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach((e, t) => {
    tr[e] = function (s) {
      return typeof s === e || 'a' + (t < 1 ? 'n ' : ' ') + e;
    };
  });
  const bl = {};
  ((tr.transitional = function (t, n, s) {
    function r(o, i) {
      return '[Axios v' + vl + "] Transitional option '" + o + "'" + i + (s ? '. ' + s : '');
    }
    return (o, i, l) => {
      if (t === !1)
        throw new ie(r(i, ' has been removed' + (n ? ' in ' + n : '')), ie.ERR_DEPRECATED);
      return (
        n &&
          !bl[i] &&
          ((bl[i] = !0),
          console.warn(
            r(i, ' has been deprecated since v' + n + ' and will be removed in the near future')
          )),
        t ? t(o, i, l) : !0
      );
    };
  }),
    (tr.spelling = function (t) {
      return (n, s) => (console.warn(`${s} is likely a misspelling of ${t}`), !0);
    }));
  function mp(e, t, n) {
    if (typeof e != 'object') throw new ie('options must be an object', ie.ERR_BAD_OPTION_VALUE);
    const s = Object.keys(e);
    let r = s.length;
    for (; r-- > 0; ) {
      const o = s[r],
        i = t[o];
      if (i) {
        const l = e[o],
          a = l === void 0 || i(l, o, e);
        if (a !== !0) throw new ie('option ' + o + ' must be ' + a, ie.ERR_BAD_OPTION_VALUE);
        continue;
      }
      if (n !== !0) throw new ie('Unknown option ' + o, ie.ERR_BAD_OPTION);
    }
  }
  const nr = { assertOptions: mp, validators: tr },
    qt = nr.validators;
  let un = class {
    constructor(t) {
      ((this.defaults = t || {}), (this.interceptors = { request: new Xi(), response: new Xi() }));
    }
    async request(t, n) {
      try {
        return await this._request(t, n);
      } catch (s) {
        if (s instanceof Error) {
          let r = {};
          Error.captureStackTrace ? Error.captureStackTrace(r) : (r = new Error());
          const o = r.stack ? r.stack.replace(/^.+\n/, '') : '';
          try {
            s.stack
              ? o &&
                !String(s.stack).endsWith(o.replace(/^.+\n.+\n/, '')) &&
                (s.stack +=
                  `
` + o)
              : (s.stack = o);
          } catch {}
        }
        throw s;
      }
    }
    _request(t, n) {
      (typeof t == 'string' ? ((n = n || {}), (n.url = t)) : (n = t || {}),
        (n = an(this.defaults, n)));
      const { transitional: s, paramsSerializer: r, headers: o } = n;
      (s !== void 0 &&
        nr.assertOptions(
          s,
          {
            silentJSONParsing: qt.transitional(qt.boolean),
            forcedJSONParsing: qt.transitional(qt.boolean),
            clarifyTimeoutError: qt.transitional(qt.boolean)
          },
          !1
        ),
        r != null &&
          (y.isFunction(r)
            ? (n.paramsSerializer = { serialize: r })
            : nr.assertOptions(r, { encode: qt.function, serialize: qt.function }, !0)),
        n.allowAbsoluteUrls !== void 0 ||
          (this.defaults.allowAbsoluteUrls !== void 0
            ? (n.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls)
            : (n.allowAbsoluteUrls = !0)),
        nr.assertOptions(
          n,
          { baseUrl: qt.spelling('baseURL'), withXsrfToken: qt.spelling('withXSRFToken') },
          !0
        ),
        (n.method = (n.method || this.defaults.method || 'get').toLowerCase()));
      let i = o && y.merge(o.common, o[n.method]);
      (o &&
        y.forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'common'], (h) => {
          delete o[h];
        }),
        (n.headers = et.concat(i, o)));
      const l = [];
      let a = !0;
      this.interceptors.request.forEach(function (q) {
        (typeof q.runWhen == 'function' && q.runWhen(n) === !1) ||
          ((a = a && q.synchronous), l.unshift(q.fulfilled, q.rejected));
      });
      const f = [];
      this.interceptors.response.forEach(function (q) {
        f.push(q.fulfilled, q.rejected);
      });
      let u,
        c = 0,
        d;
      if (!a) {
        const h = [ql.bind(this), void 0];
        for (h.unshift(...l), h.push(...f), d = h.length, u = Promise.resolve(n); c < d; )
          u = u.then(h[c++], h[c++]);
        return u;
      }
      d = l.length;
      let p = n;
      for (; c < d; ) {
        const h = l[c++],
          q = l[c++];
        try {
          p = h(p);
        } catch (v) {
          q.call(this, v);
          break;
        }
      }
      try {
        u = ql.call(this, p);
      } catch (h) {
        return Promise.reject(h);
      }
      for (c = 0, d = f.length; c < d; ) u = u.then(f[c++], f[c++]);
      return u;
    }
    getUri(t) {
      t = an(this.defaults, t);
      const n = ll(t.baseURL, t.url, t.allowAbsoluteUrls);
      return Zi(n, t.params, t.paramsSerializer);
    }
  };
  (y.forEach(['delete', 'get', 'head', 'options'], function (t) {
    un.prototype[t] = function (n, s) {
      return this.request(an(s || {}, { method: t, url: n, data: (s || {}).data }));
    };
  }),
    y.forEach(['post', 'put', 'patch'], function (t) {
      function n(s) {
        return function (o, i, l) {
          return this.request(
            an(l || {}, {
              method: t,
              headers: s ? { 'Content-Type': 'multipart/form-data' } : {},
              url: o,
              data: i
            })
          );
        };
      }
      ((un.prototype[t] = n()), (un.prototype[t + 'Form'] = n(!0)));
    }));
  let gp = class Yf {
    constructor(t) {
      if (typeof t != 'function') throw new TypeError('executor must be a function.');
      let n;
      this.promise = new Promise(function (o) {
        n = o;
      });
      const s = this;
      (this.promise.then((r) => {
        if (!s._listeners) return;
        let o = s._listeners.length;
        for (; o-- > 0; ) s._listeners[o](r);
        s._listeners = null;
      }),
        (this.promise.then = (r) => {
          let o;
          const i = new Promise((l) => {
            (s.subscribe(l), (o = l));
          }).then(r);
          return (
            (i.cancel = function () {
              s.unsubscribe(o);
            }),
            i
          );
        }),
        t(function (o, i, l) {
          s.reason || ((s.reason = new $n(o, i, l)), n(s.reason));
        }));
    }
    throwIfRequested() {
      if (this.reason) throw this.reason;
    }
    subscribe(t) {
      if (this.reason) {
        t(this.reason);
        return;
      }
      this._listeners ? this._listeners.push(t) : (this._listeners = [t]);
    }
    unsubscribe(t) {
      if (!this._listeners) return;
      const n = this._listeners.indexOf(t);
      n !== -1 && this._listeners.splice(n, 1);
    }
    toAbortSignal() {
      const t = new AbortController(),
        n = (s) => {
          t.abort(s);
        };
      return (this.subscribe(n), (t.signal.unsubscribe = () => this.unsubscribe(n)), t.signal);
    }
    static source() {
      let t;
      return {
        token: new Yf(function (r) {
          t = r;
        }),
        cancel: t
      };
    }
  };
  function _p(e) {
    return function (n) {
      return e.apply(null, n);
    };
  }
  function qp(e) {
    return y.isObject(e) && e.isAxiosError === !0;
  }
  const uo = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
  };
  Object.entries(uo).forEach(([e, t]) => {
    uo[t] = e;
  });
  function yl(e) {
    const t = new un(e),
      n = In(un.prototype.request, t);
    return (
      y.extend(n, un.prototype, t, { allOwnKeys: !0 }),
      y.extend(n, t, null, { allOwnKeys: !0 }),
      (n.create = function (r) {
        return yl(an(e, r));
      }),
      n
    );
  }
  const Oe = yl(us);
  ((Oe.Axios = un),
    (Oe.CanceledError = $n),
    (Oe.CancelToken = gp),
    (Oe.isCancel = sl),
    (Oe.VERSION = vl),
    (Oe.toFormData = Ys),
    (Oe.AxiosError = ie),
    (Oe.Cancel = Oe.CanceledError),
    (Oe.all = function (t) {
      return Promise.all(t);
    }),
    (Oe.spread = _p),
    (Oe.isAxiosError = qp),
    (Oe.mergeConfig = an),
    (Oe.AxiosHeaders = et),
    (Oe.formToJSON = (e) => tl(y.isHTMLForm(e) ? new FormData(e) : e)),
    (Oe.getAdapter = _l.getAdapter),
    (Oe.HttpStatusCode = uo),
    (Oe.default = Oe));
  const {
    Axios: uy,
    AxiosError: cy,
    CanceledError: fy,
    isCancel: dy,
    CancelToken: py,
    VERSION: hy,
    all: my,
    Cancel: gy,
    isAxiosError: _y,
    spread: qy,
    toFormData: vy,
    AxiosHeaders: by,
    HttpStatusCode: yy,
    formToJSON: xy,
    getAdapter: wy,
    mergeConfig: Sy
  } = Oe;
  ((window.axios = Oe),
    (window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'));
  /**
   * @vue/shared v3.5.13
   * (c) 2018-present Yuxi (Evan) You and Vue contributors
   * @license MIT
   **/ /*! #__NO_SIDE_EFFECTS__ */ function Dt(e) {
    const t = Object.create(null);
    for (const n of e.split(',')) t[n] = 1;
    return (n) => n in t;
  }
  const ge = Object.freeze({}),
    Dn = Object.freeze([]),
    Ve = () => {},
    vp = () => !1,
    fs = (e) =>
      e.charCodeAt(0) === 111 &&
      e.charCodeAt(1) === 110 &&
      (e.charCodeAt(2) > 122 || e.charCodeAt(2) < 97),
    sr = (e) => e.startsWith('onUpdate:'),
    ke = Object.assign,
    co = (e, t) => {
      const n = e.indexOf(t);
      n > -1 && e.splice(n, 1);
    },
    bp = Object.prototype.hasOwnProperty,
    de = (e, t) => bp.call(e, t),
    J = Array.isArray,
    cn = (e) => rr(e) === '[object Map]',
    xl = (e) => rr(e) === '[object Set]',
    ee = (e) => typeof e == 'function',
    we = (e) => typeof e == 'string',
    Ft = (e) => typeof e == 'symbol',
    pe = (e) => e !== null && typeof e == 'object',
    fo = (e) => (pe(e) || ee(e)) && ee(e.then) && ee(e.catch),
    wl = Object.prototype.toString,
    rr = (e) => wl.call(e),
    po = (e) => rr(e).slice(8, -1),
    Sl = (e) => rr(e) === '[object Object]',
    ho = (e) => we(e) && e !== 'NaN' && e[0] !== '-' && '' + parseInt(e, 10) === e,
    ds = Dt(
      ',key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted'
    ),
    yp = Dt('bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo'),
    or = (e) => {
      const t = Object.create(null);
      return (n) => t[n] || (t[n] = e(n));
    },
    xp = /-(\w)/g,
    He = or((e) => e.replace(xp, (t, n) => (n ? n.toUpperCase() : ''))),
    wp = /\B([A-Z])/g,
    zt = or((e) => e.replace(wp, '-$1').toLowerCase()),
    fn = or((e) => e.charAt(0).toUpperCase() + e.slice(1)),
    dn = or((e) => (e ? `on${fn(e)}` : '')),
    Wt = (e, t) => !Object.is(e, t),
    Fn = (e, ...t) => {
      for (let n = 0; n < e.length; n++) e[n](...t);
    },
    ir = (e, t, n, s = !1) => {
      Object.defineProperty(e, t, { configurable: !0, enumerable: !1, writable: s, value: n });
    },
    mo = (e) => {
      const t = parseFloat(e);
      return isNaN(t) ? e : t;
    },
    Sp = (e) => {
      const t = we(e) ? Number(e) : NaN;
      return isNaN(t) ? e : t;
    };
  let El;
  const ps = () =>
    El ||
    (El =
      typeof globalThis < 'u'
        ? globalThis
        : typeof self < 'u'
          ? self
          : typeof window < 'u'
            ? window
            : typeof global < 'u'
              ? global
              : {});
  function nt(e) {
    if (J(e)) {
      const t = {};
      for (let n = 0; n < e.length; n++) {
        const s = e[n],
          r = we(s) ? Ap(s) : nt(s);
        if (r) for (const o in r) t[o] = r[o];
      }
      return t;
    } else if (we(e) || pe(e)) return e;
  }
  const Ep = /;(?![^(]*\))/g,
    kp = /:([^]+)/,
    Cp = /\/\*[^]*?\*\//g;
  function Ap(e) {
    const t = {};
    return (
      e
        .replace(Cp, '')
        .split(Ep)
        .forEach((n) => {
          if (n) {
            const s = n.split(kp);
            s.length > 1 && (t[s[0].trim()] = s[1].trim());
          }
        }),
      t
    );
  }
  function $e(e) {
    let t = '';
    if (we(e)) t = e;
    else if (J(e))
      for (let n = 0; n < e.length; n++) {
        const s = $e(e[n]);
        s && (t += s + ' ');
      }
    else if (pe(e)) for (const n in e) e[n] && (t += n + ' ');
    return t.trim();
  }
  const Tp =
      'html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot',
    Op =
      'svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view',
    Bp =
      'annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics',
    Ip = Dt(Tp),
    Rp = Dt(Op),
    Pp = Dt(Bp),
    $p = Dt('itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly');
  function kl(e) {
    return !!e || e === '';
  }
  const Cl = (e) => !!(e && e.__v_isRef === !0),
    ve = (e) =>
      we(e)
        ? e
        : e == null
          ? ''
          : J(e) || (pe(e) && (e.toString === wl || !ee(e.toString)))
            ? Cl(e)
              ? ve(e.value)
              : JSON.stringify(e, Al, 2)
            : String(e),
    Al = (e, t) =>
      Cl(t)
        ? Al(e, t.value)
        : cn(t)
          ? {
              [`Map(${t.size})`]: [...t.entries()].reduce(
                (n, [s, r], o) => ((n[go(s, o) + ' =>'] = r), n),
                {}
              )
            }
          : xl(t)
            ? { [`Set(${t.size})`]: [...t.values()].map((n) => go(n)) }
            : Ft(t)
              ? go(t)
              : pe(t) && !J(t) && !Sl(t)
                ? String(t)
                : t,
    go = (e, t = '') => {
      var n;
      return Ft(e) ? `Symbol(${(n = e.description) != null ? n : t})` : e;
    };
  var Dp = { NODE_ENV: '"production"' };
  function lt(e, ...t) {
    console.warn(`[Vue warn] ${e}`, ...t);
  }
  let Qe;
  class Tl {
    constructor(t = !1) {
      ((this.detached = t),
        (this._active = !0),
        (this.effects = []),
        (this.cleanups = []),
        (this._isPaused = !1),
        (this.parent = Qe),
        !t && Qe && (this.index = (Qe.scopes || (Qe.scopes = [])).push(this) - 1));
    }
    get active() {
      return this._active;
    }
    pause() {
      if (this._active) {
        this._isPaused = !0;
        let t, n;
        if (this.scopes) for (t = 0, n = this.scopes.length; t < n; t++) this.scopes[t].pause();
        for (t = 0, n = this.effects.length; t < n; t++) this.effects[t].pause();
      }
    }
    resume() {
      if (this._active && this._isPaused) {
        this._isPaused = !1;
        let t, n;
        if (this.scopes) for (t = 0, n = this.scopes.length; t < n; t++) this.scopes[t].resume();
        for (t = 0, n = this.effects.length; t < n; t++) this.effects[t].resume();
      }
    }
    run(t) {
      if (this._active) {
        const n = Qe;
        try {
          return ((Qe = this), t());
        } finally {
          Qe = n;
        }
      } else lt('cannot run an inactive effect scope.');
    }
    on() {
      Qe = this;
    }
    off() {
      Qe = this.parent;
    }
    stop(t) {
      if (this._active) {
        this._active = !1;
        let n, s;
        for (n = 0, s = this.effects.length; n < s; n++) this.effects[n].stop();
        for (this.effects.length = 0, n = 0, s = this.cleanups.length; n < s; n++)
          this.cleanups[n]();
        if (((this.cleanups.length = 0), this.scopes)) {
          for (n = 0, s = this.scopes.length; n < s; n++) this.scopes[n].stop(!0);
          this.scopes.length = 0;
        }
        if (!this.detached && this.parent && !t) {
          const r = this.parent.scopes.pop();
          r && r !== this && ((this.parent.scopes[this.index] = r), (r.index = this.index));
        }
        this.parent = void 0;
      }
    }
  }
  function Ol(e) {
    return new Tl(e);
  }
  function Bl() {
    return Qe;
  }
  function Fp(e, t = !1) {
    Qe
      ? Qe.cleanups.push(e)
      : t ||
        lt(
          'onScopeDispose() is called when there is no active effect scope to be associated with.'
        );
  }
  let _e;
  const _o = new WeakSet();
  class Il {
    constructor(t) {
      ((this.fn = t),
        (this.deps = void 0),
        (this.depsTail = void 0),
        (this.flags = 5),
        (this.next = void 0),
        (this.cleanup = void 0),
        (this.scheduler = void 0),
        Qe && Qe.active && Qe.effects.push(this));
    }
    pause() {
      this.flags |= 64;
    }
    resume() {
      this.flags & 64 && ((this.flags &= -65), _o.has(this) && (_o.delete(this), this.trigger()));
    }
    notify() {
      (this.flags & 2 && !(this.flags & 32)) || this.flags & 8 || Pl(this);
    }
    run() {
      if (!(this.flags & 1)) return this.fn();
      ((this.flags |= 2), Ml(this), $l(this));
      const t = _e,
        n = pt;
      ((_e = this), (pt = !0));
      try {
        return this.fn();
      } finally {
        (_e !== this &&
          lt('Active effect was not restored correctly - this is likely a Vue internal bug.'),
          Dl(this),
          (_e = t),
          (pt = n),
          (this.flags &= -3));
      }
    }
    stop() {
      if (this.flags & 1) {
        for (let t = this.deps; t; t = t.nextDep) yo(t);
        ((this.deps = this.depsTail = void 0),
          Ml(this),
          this.onStop && this.onStop(),
          (this.flags &= -2));
      }
    }
    trigger() {
      this.flags & 64 ? _o.add(this) : this.scheduler ? this.scheduler() : this.runIfDirty();
    }
    runIfDirty() {
      bo(this) && this.run();
    }
    get dirty() {
      return bo(this);
    }
  }
  let Rl = 0,
    hs,
    ms;
  function Pl(e, t = !1) {
    if (((e.flags |= 8), t)) {
      ((e.next = ms), (ms = e));
      return;
    }
    ((e.next = hs), (hs = e));
  }
  function qo() {
    Rl++;
  }
  function vo() {
    if (--Rl > 0) return;
    if (ms) {
      let t = ms;
      for (ms = void 0; t; ) {
        const n = t.next;
        ((t.next = void 0), (t.flags &= -9), (t = n));
      }
    }
    let e;
    for (; hs; ) {
      let t = hs;
      for (hs = void 0; t; ) {
        const n = t.next;
        if (((t.next = void 0), (t.flags &= -9), t.flags & 1))
          try {
            t.trigger();
          } catch (s) {
            e || (e = s);
          }
        t = n;
      }
    }
    if (e) throw e;
  }
  function $l(e) {
    for (let t = e.deps; t; t = t.nextDep)
      ((t.version = -1), (t.prevActiveLink = t.dep.activeLink), (t.dep.activeLink = t));
  }
  function Dl(e) {
    let t,
      n = e.depsTail,
      s = n;
    for (; s; ) {
      const r = s.prevDep;
      (s.version === -1 ? (s === n && (n = r), yo(s), zp(s)) : (t = s),
        (s.dep.activeLink = s.prevActiveLink),
        (s.prevActiveLink = void 0),
        (s = r));
    }
    ((e.deps = t), (e.depsTail = n));
  }
  function bo(e) {
    for (let t = e.deps; t; t = t.nextDep)
      if (
        t.dep.version !== t.version ||
        (t.dep.computed && (Fl(t.dep.computed) || t.dep.version !== t.version))
      )
        return !0;
    return !!e._dirty;
  }
  function Fl(e) {
    if ((e.flags & 4 && !(e.flags & 16)) || ((e.flags &= -17), e.globalVersion === gs)) return;
    e.globalVersion = gs;
    const t = e.dep;
    if (((e.flags |= 2), t.version > 0 && !e.isSSR && e.deps && !bo(e))) {
      e.flags &= -3;
      return;
    }
    const n = _e,
      s = pt;
    ((_e = e), (pt = !0));
    try {
      $l(e);
      const r = e.fn(e._value);
      (t.version === 0 || Wt(r, e._value)) && ((e._value = r), t.version++);
    } catch (r) {
      throw (t.version++, r);
    } finally {
      ((_e = n), (pt = s), Dl(e), (e.flags &= -3));
    }
  }
  function yo(e, t = !1) {
    const { dep: n, prevSub: s, nextSub: r } = e;
    if (
      (s && ((s.nextSub = r), (e.prevSub = void 0)),
      r && ((r.prevSub = s), (e.nextSub = void 0)),
      n.subsHead === e && (n.subsHead = r),
      n.subs === e && ((n.subs = s), !s && n.computed))
    ) {
      n.computed.flags &= -5;
      for (let o = n.computed.deps; o; o = o.nextDep) yo(o, !0);
    }
    !t && !--n.sc && n.map && n.map.delete(n.key);
  }
  function zp(e) {
    const { prevDep: t, nextDep: n } = e;
    (t && ((t.nextDep = n), (e.prevDep = void 0)), n && ((n.prevDep = t), (e.nextDep = void 0)));
  }
  let pt = !0;
  const zl = [];
  function Mt() {
    (zl.push(pt), (pt = !1));
  }
  function Nt() {
    const e = zl.pop();
    pt = e === void 0 ? !0 : e;
  }
  function Ml(e) {
    const { cleanup: t } = e;
    if (((e.cleanup = void 0), t)) {
      const n = _e;
      _e = void 0;
      try {
        t();
      } finally {
        _e = n;
      }
    }
  }
  let gs = 0;
  class Mp {
    constructor(t, n) {
      ((this.sub = t),
        (this.dep = n),
        (this.version = n.version),
        (this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0));
    }
  }
  class xo {
    constructor(t) {
      ((this.computed = t),
        (this.version = 0),
        (this.activeLink = void 0),
        (this.subs = void 0),
        (this.map = void 0),
        (this.key = void 0),
        (this.sc = 0),
        (this.subsHead = void 0));
    }
    track(t) {
      if (!_e || !pt || _e === this.computed) return;
      let n = this.activeLink;
      if (n === void 0 || n.sub !== _e)
        ((n = this.activeLink = new Mp(_e, this)),
          _e.deps
            ? ((n.prevDep = _e.depsTail), (_e.depsTail.nextDep = n), (_e.depsTail = n))
            : (_e.deps = _e.depsTail = n),
          Nl(n));
      else if (n.version === -1 && ((n.version = this.version), n.nextDep)) {
        const s = n.nextDep;
        ((s.prevDep = n.prevDep),
          n.prevDep && (n.prevDep.nextDep = s),
          (n.prevDep = _e.depsTail),
          (n.nextDep = void 0),
          (_e.depsTail.nextDep = n),
          (_e.depsTail = n),
          _e.deps === n && (_e.deps = s));
      }
      return (_e.onTrack && _e.onTrack(ke({ effect: _e }, t)), n);
    }
    trigger(t) {
      (this.version++, gs++, this.notify(t));
    }
    notify(t) {
      qo();
      try {
        if (Dp.NODE_ENV !== 'production')
          for (let n = this.subsHead; n; n = n.nextSub)
            n.sub.onTrigger && !(n.sub.flags & 8) && n.sub.onTrigger(ke({ effect: n.sub }, t));
        for (let n = this.subs; n; n = n.prevSub) n.sub.notify() && n.sub.dep.notify();
      } finally {
        vo();
      }
    }
  }
  function Nl(e) {
    if ((e.dep.sc++, e.sub.flags & 4)) {
      const t = e.dep.computed;
      if (t && !e.dep.subs) {
        t.flags |= 20;
        for (let s = t.deps; s; s = s.nextDep) Nl(s);
      }
      const n = e.dep.subs;
      (n !== e && ((e.prevSub = n), n && (n.nextSub = e)),
        e.dep.subsHead === void 0 && (e.dep.subsHead = e),
        (e.dep.subs = e));
    }
  }
  const lr = new WeakMap(),
    pn = Symbol('Object iterate'),
    wo = Symbol('Map keys iterate'),
    _s = Symbol('Array iterate');
  function De(e, t, n) {
    if (pt && _e) {
      let s = lr.get(e);
      s || lr.set(e, (s = new Map()));
      let r = s.get(n);
      (r || (s.set(n, (r = new xo())), (r.map = s), (r.key = n)),
        r.track({ target: e, type: t, key: n }));
    }
  }
  function vt(e, t, n, s, r, o) {
    const i = lr.get(e);
    if (!i) {
      gs++;
      return;
    }
    const l = (a) => {
      a && a.trigger({ target: e, type: t, key: n, newValue: s, oldValue: r, oldTarget: o });
    };
    if ((qo(), t === 'clear')) i.forEach(l);
    else {
      const a = J(e),
        f = a && ho(n);
      if (a && n === 'length') {
        const u = Number(s);
        i.forEach((c, d) => {
          (d === 'length' || d === _s || (!Ft(d) && d >= u)) && l(c);
        });
      } else
        switch (((n !== void 0 || i.has(void 0)) && l(i.get(n)), f && l(i.get(_s)), t)) {
          case 'add':
            a ? f && l(i.get('length')) : (l(i.get(pn)), cn(e) && l(i.get(wo)));
            break;
          case 'delete':
            a || (l(i.get(pn)), cn(e) && l(i.get(wo)));
            break;
          case 'set':
            cn(e) && l(i.get(pn));
            break;
        }
    }
    vo();
  }
  function Np(e, t) {
    const n = lr.get(e);
    return n && n.get(t);
  }
  function zn(e) {
    const t = se(e);
    return t === e ? t : (De(t, 'iterate', _s), Ke(e) ? t : t.map(Le));
  }
  function ar(e) {
    return (De((e = se(e)), 'iterate', _s), e);
  }
  const Vp = {
    __proto__: null,
    [Symbol.iterator]() {
      return So(this, Symbol.iterator, Le);
    },
    concat(...e) {
      return zn(this).concat(...e.map((t) => (J(t) ? zn(t) : t)));
    },
    entries() {
      return So(this, 'entries', (e) => ((e[1] = Le(e[1])), e));
    },
    every(e, t) {
      return Vt(this, 'every', e, t, void 0, arguments);
    },
    filter(e, t) {
      return Vt(this, 'filter', e, t, (n) => n.map(Le), arguments);
    },
    find(e, t) {
      return Vt(this, 'find', e, t, Le, arguments);
    },
    findIndex(e, t) {
      return Vt(this, 'findIndex', e, t, void 0, arguments);
    },
    findLast(e, t) {
      return Vt(this, 'findLast', e, t, Le, arguments);
    },
    findLastIndex(e, t) {
      return Vt(this, 'findLastIndex', e, t, void 0, arguments);
    },
    forEach(e, t) {
      return Vt(this, 'forEach', e, t, void 0, arguments);
    },
    includes(...e) {
      return Eo(this, 'includes', e);
    },
    indexOf(...e) {
      return Eo(this, 'indexOf', e);
    },
    join(e) {
      return zn(this).join(e);
    },
    lastIndexOf(...e) {
      return Eo(this, 'lastIndexOf', e);
    },
    map(e, t) {
      return Vt(this, 'map', e, t, void 0, arguments);
    },
    pop() {
      return qs(this, 'pop');
    },
    push(...e) {
      return qs(this, 'push', e);
    },
    reduce(e, ...t) {
      return Vl(this, 'reduce', e, t);
    },
    reduceRight(e, ...t) {
      return Vl(this, 'reduceRight', e, t);
    },
    shift() {
      return qs(this, 'shift');
    },
    some(e, t) {
      return Vt(this, 'some', e, t, void 0, arguments);
    },
    splice(...e) {
      return qs(this, 'splice', e);
    },
    toReversed() {
      return zn(this).toReversed();
    },
    toSorted(e) {
      return zn(this).toSorted(e);
    },
    toSpliced(...e) {
      return zn(this).toSpliced(...e);
    },
    unshift(...e) {
      return qs(this, 'unshift', e);
    },
    values() {
      return So(this, 'values', Le);
    }
  };
  function So(e, t, n) {
    const s = ar(e),
      r = s[t]();
    return (
      s !== e &&
        !Ke(e) &&
        ((r._next = r.next),
        (r.next = () => {
          const o = r._next();
          return (o.value && (o.value = n(o.value)), o);
        })),
      r
    );
  }
  const Lp = Array.prototype;
  function Vt(e, t, n, s, r, o) {
    const i = ar(e),
      l = i !== e && !Ke(e),
      a = i[t];
    if (a !== Lp[t]) {
      const c = a.apply(e, o);
      return l ? Le(c) : c;
    }
    let f = n;
    i !== e &&
      (l
        ? (f = function (c, d) {
            return n.call(this, Le(c), d, e);
          })
        : n.length > 2 &&
          (f = function (c, d) {
            return n.call(this, c, d, e);
          }));
    const u = a.call(i, f, s);
    return l && r ? r(u) : u;
  }
  function Vl(e, t, n, s) {
    const r = ar(e);
    let o = n;
    return (
      r !== e &&
        (Ke(e)
          ? n.length > 3 &&
            (o = function (i, l, a) {
              return n.call(this, i, l, a, e);
            })
          : (o = function (i, l, a) {
              return n.call(this, i, Le(l), a, e);
            })),
      r[t](o, ...s)
    );
  }
  function Eo(e, t, n) {
    const s = se(e);
    De(s, 'iterate', _s);
    const r = s[t](...n);
    return (r === -1 || r === !1) && vs(n[0]) ? ((n[0] = se(n[0])), s[t](...n)) : r;
  }
  function qs(e, t, n = []) {
    (Mt(), qo());
    const s = se(e)[t].apply(e, n);
    return (vo(), Nt(), s);
  }
  const Up = Dt('__proto__,__v_isRef,__isVue'),
    Ll = new Set(
      Object.getOwnPropertyNames(Symbol)
        .filter((e) => e !== 'arguments' && e !== 'caller')
        .map((e) => Symbol[e])
        .filter(Ft)
    );
  function jp(e) {
    Ft(e) || (e = String(e));
    const t = se(this);
    return (De(t, 'has', e), t.hasOwnProperty(e));
  }
  class Ul {
    constructor(t = !1, n = !1) {
      ((this._isReadonly = t), (this._isShallow = n));
    }
    get(t, n, s) {
      if (n === '__v_skip') return t.__v_skip;
      const r = this._isReadonly,
        o = this._isShallow;
      if (n === '__v_isReactive') return !r;
      if (n === '__v_isReadonly') return r;
      if (n === '__v_isShallow') return o;
      if (n === '__v_raw')
        return s === (r ? (o ? Jl : Gl) : o ? Wl : Kl).get(t) ||
          Object.getPrototypeOf(t) === Object.getPrototypeOf(s)
          ? t
          : void 0;
      const i = J(t);
      if (!r) {
        let a;
        if (i && (a = Vp[n])) return a;
        if (n === 'hasOwnProperty') return jp;
      }
      const l = Reflect.get(t, n, be(t) ? t : s);
      return (Ft(n) ? Ll.has(n) : Up(n)) || (r || De(t, 'get', n), o)
        ? l
        : be(l)
          ? i && ho(n)
            ? l
            : l.value
          : pe(l)
            ? r
              ? Yl(l)
              : dr(l)
            : l;
    }
  }
  class jl extends Ul {
    constructor(t = !1) {
      super(!1, t);
    }
    set(t, n, s, r) {
      let o = t[n];
      if (!this._isShallow) {
        const a = Lt(o);
        if ((!Ke(s) && !Lt(s) && ((o = se(o)), (s = se(s))), !J(t) && be(o) && !be(s)))
          return a ? !1 : ((o.value = s), !0);
      }
      const i = J(t) && ho(n) ? Number(n) < t.length : de(t, n),
        l = Reflect.set(t, n, s, be(t) ? t : r);
      return (t === se(r) && (i ? Wt(s, o) && vt(t, 'set', n, s, o) : vt(t, 'add', n, s)), l);
    }
    deleteProperty(t, n) {
      const s = de(t, n),
        r = t[n],
        o = Reflect.deleteProperty(t, n);
      return (o && s && vt(t, 'delete', n, void 0, r), o);
    }
    has(t, n) {
      const s = Reflect.has(t, n);
      return ((!Ft(n) || !Ll.has(n)) && De(t, 'has', n), s);
    }
    ownKeys(t) {
      return (De(t, 'iterate', J(t) ? 'length' : pn), Reflect.ownKeys(t));
    }
  }
  class Hl extends Ul {
    constructor(t = !1) {
      super(!0, t);
    }
    set(t, n) {
      return (lt(`Set operation on key "${String(n)}" failed: target is readonly.`, t), !0);
    }
    deleteProperty(t, n) {
      return (lt(`Delete operation on key "${String(n)}" failed: target is readonly.`, t), !0);
    }
  }
  const Hp = new jl(),
    Qp = new Hl(),
    Kp = new jl(!0),
    Wp = new Hl(!0),
    ko = (e) => e,
    ur = (e) => Reflect.getPrototypeOf(e);
  function Gp(e, t, n) {
    return function (...s) {
      const r = this.__v_raw,
        o = se(r),
        i = cn(o),
        l = e === 'entries' || (e === Symbol.iterator && i),
        a = e === 'keys' && i,
        f = r[e](...s),
        u = n ? ko : t ? Co : Le;
      return (
        !t && De(o, 'iterate', a ? wo : pn),
        {
          next() {
            const { value: c, done: d } = f.next();
            return d ? { value: c, done: d } : { value: l ? [u(c[0]), u(c[1])] : u(c), done: d };
          },
          [Symbol.iterator]() {
            return this;
          }
        }
      );
    };
  }
  function cr(e) {
    return function (...t) {
      {
        const n = t[0] ? `on key "${t[0]}" ` : '';
        lt(`${fn(e)} operation ${n}failed: target is readonly.`, se(this));
      }
      return e === 'delete' ? !1 : e === 'clear' ? void 0 : this;
    };
  }
  function Jp(e, t) {
    const n = {
      get(r) {
        const o = this.__v_raw,
          i = se(o),
          l = se(r);
        e || (Wt(r, l) && De(i, 'get', r), De(i, 'get', l));
        const { has: a } = ur(i),
          f = t ? ko : e ? Co : Le;
        if (a.call(i, r)) return f(o.get(r));
        if (a.call(i, l)) return f(o.get(l));
        o !== i && o.get(r);
      },
      get size() {
        const r = this.__v_raw;
        return (!e && De(se(r), 'iterate', pn), Reflect.get(r, 'size', r));
      },
      has(r) {
        const o = this.__v_raw,
          i = se(o),
          l = se(r);
        return (
          e || (Wt(r, l) && De(i, 'has', r), De(i, 'has', l)),
          r === l ? o.has(r) : o.has(r) || o.has(l)
        );
      },
      forEach(r, o) {
        const i = this,
          l = i.__v_raw,
          a = se(l),
          f = t ? ko : e ? Co : Le;
        return (!e && De(a, 'iterate', pn), l.forEach((u, c) => r.call(o, f(u), f(c), i)));
      }
    };
    return (
      ke(
        n,
        e
          ? { add: cr('add'), set: cr('set'), delete: cr('delete'), clear: cr('clear') }
          : {
              add(r) {
                !t && !Ke(r) && !Lt(r) && (r = se(r));
                const o = se(this);
                return (ur(o).has.call(o, r) || (o.add(r), vt(o, 'add', r, r)), this);
              },
              set(r, o) {
                !t && !Ke(o) && !Lt(o) && (o = se(o));
                const i = se(this),
                  { has: l, get: a } = ur(i);
                let f = l.call(i, r);
                f ? Ql(i, l, r) : ((r = se(r)), (f = l.call(i, r)));
                const u = a.call(i, r);
                return (
                  i.set(r, o),
                  f ? Wt(o, u) && vt(i, 'set', r, o, u) : vt(i, 'add', r, o),
                  this
                );
              },
              delete(r) {
                const o = se(this),
                  { has: i, get: l } = ur(o);
                let a = i.call(o, r);
                a ? Ql(o, i, r) : ((r = se(r)), (a = i.call(o, r)));
                const f = l ? l.call(o, r) : void 0,
                  u = o.delete(r);
                return (a && vt(o, 'delete', r, void 0, f), u);
              },
              clear() {
                const r = se(this),
                  o = r.size !== 0,
                  i = cn(r) ? new Map(r) : new Set(r),
                  l = r.clear();
                return (o && vt(r, 'clear', void 0, void 0, i), l);
              }
            }
      ),
      ['keys', 'values', 'entries', Symbol.iterator].forEach((r) => {
        n[r] = Gp(r, e, t);
      }),
      n
    );
  }
  function fr(e, t) {
    const n = Jp(e, t);
    return (s, r, o) =>
      r === '__v_isReactive'
        ? !e
        : r === '__v_isReadonly'
          ? e
          : r === '__v_raw'
            ? s
            : Reflect.get(de(n, r) && r in s ? n : s, r, o);
  }
  const Yp = { get: fr(!1, !1) },
    Zp = { get: fr(!1, !0) },
    Xp = { get: fr(!0, !1) },
    eh = { get: fr(!0, !0) };
  function Ql(e, t, n) {
    const s = se(n);
    if (s !== n && t.call(e, s)) {
      const r = po(e);
      lt(
        `Reactive ${r} contains both the raw and reactive versions of the same object${r === 'Map' ? ' as keys' : ''}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`
      );
    }
  }
  const Kl = new WeakMap(),
    Wl = new WeakMap(),
    Gl = new WeakMap(),
    Jl = new WeakMap();
  function th(e) {
    switch (e) {
      case 'Object':
      case 'Array':
        return 1;
      case 'Map':
      case 'Set':
      case 'WeakMap':
      case 'WeakSet':
        return 2;
      default:
        return 0;
    }
  }
  function nh(e) {
    return e.__v_skip || !Object.isExtensible(e) ? 0 : th(po(e));
  }
  function dr(e) {
    return Lt(e) ? e : pr(e, !1, Hp, Yp, Kl);
  }
  function sh(e) {
    return pr(e, !1, Kp, Zp, Wl);
  }
  function Yl(e) {
    return pr(e, !0, Qp, Xp, Gl);
  }
  function bt(e) {
    return pr(e, !0, Wp, eh, Jl);
  }
  function pr(e, t, n, s, r) {
    if (!pe(e)) return (lt(`value cannot be made ${t ? 'readonly' : 'reactive'}: ${String(e)}`), e);
    if (e.__v_raw && !(t && e.__v_isReactive)) return e;
    const o = r.get(e);
    if (o) return o;
    const i = nh(e);
    if (i === 0) return e;
    const l = new Proxy(e, i === 2 ? s : n);
    return (r.set(e, l), l);
  }
  function yt(e) {
    return Lt(e) ? yt(e.__v_raw) : !!(e && e.__v_isReactive);
  }
  function Lt(e) {
    return !!(e && e.__v_isReadonly);
  }
  function Ke(e) {
    return !!(e && e.__v_isShallow);
  }
  function vs(e) {
    return e ? !!e.__v_raw : !1;
  }
  function se(e) {
    const t = e && e.__v_raw;
    return t ? se(t) : e;
  }
  function Gt(e) {
    return (!de(e, '__v_skip') && Object.isExtensible(e) && ir(e, '__v_skip', !0), e);
  }
  const Le = (e) => (pe(e) ? dr(e) : e),
    Co = (e) => (pe(e) ? Yl(e) : e);
  function be(e) {
    return e ? e.__v_isRef === !0 : !1;
  }
  function U(e) {
    return rh(e, !1);
  }
  function rh(e, t) {
    return be(e) ? e : new oh(e, t);
  }
  class oh {
    constructor(t, n) {
      ((this.dep = new xo()),
        (this.__v_isRef = !0),
        (this.__v_isShallow = !1),
        (this._rawValue = n ? t : se(t)),
        (this._value = n ? t : Le(t)),
        (this.__v_isShallow = n));
    }
    get value() {
      return (this.dep.track({ target: this, type: 'get', key: 'value' }), this._value);
    }
    set value(t) {
      const n = this._rawValue,
        s = this.__v_isShallow || Ke(t) || Lt(t);
      ((t = s ? t : se(t)),
        Wt(t, n) &&
          ((this._rawValue = t),
          (this._value = s ? t : Le(t)),
          this.dep.trigger({ target: this, type: 'set', key: 'value', newValue: t, oldValue: n })));
    }
  }
  function Ut(e) {
    return be(e) ? e.value : e;
  }
  const ih = {
    get: (e, t, n) => (t === '__v_raw' ? e : Ut(Reflect.get(e, t, n))),
    set: (e, t, n, s) => {
      const r = e[t];
      return be(r) && !be(n) ? ((r.value = n), !0) : Reflect.set(e, t, n, s);
    }
  };
  function Zl(e) {
    return yt(e) ? e : new Proxy(e, ih);
  }
  function Xl(e) {
    vs(e) || lt('toRefs() expects a reactive object but received a plain one.');
    const t = J(e) ? new Array(e.length) : {};
    for (const n in e) t[n] = ea(e, n);
    return t;
  }
  class lh {
    constructor(t, n, s) {
      ((this._object = t),
        (this._key = n),
        (this._defaultValue = s),
        (this.__v_isRef = !0),
        (this._value = void 0));
    }
    get value() {
      const t = this._object[this._key];
      return (this._value = t === void 0 ? this._defaultValue : t);
    }
    set value(t) {
      this._object[this._key] = t;
    }
    get dep() {
      return Np(se(this._object), this._key);
    }
  }
  class ah {
    constructor(t) {
      ((this._getter = t),
        (this.__v_isRef = !0),
        (this.__v_isReadonly = !0),
        (this._value = void 0));
    }
    get value() {
      return (this._value = this._getter());
    }
  }
  function Ao(e, t, n) {
    return be(e) ? e : ee(e) ? new ah(e) : pe(e) && arguments.length > 1 ? ea(e, t, n) : U(e);
  }
  function ea(e, t, n) {
    const s = e[t];
    return be(s) ? s : new lh(e, t, n);
  }
  class uh {
    constructor(t, n, s) {
      ((this.fn = t),
        (this.setter = n),
        (this._value = void 0),
        (this.dep = new xo(this)),
        (this.__v_isRef = !0),
        (this.deps = void 0),
        (this.depsTail = void 0),
        (this.flags = 16),
        (this.globalVersion = gs - 1),
        (this.next = void 0),
        (this.effect = this),
        (this.__v_isReadonly = !n),
        (this.isSSR = s));
    }
    notify() {
      if (((this.flags |= 16), !(this.flags & 8) && _e !== this)) return (Pl(this, !0), !0);
    }
    get value() {
      const t = this.dep.track({ target: this, type: 'get', key: 'value' });
      return (Fl(this), t && (t.version = this.dep.version), this._value);
    }
    set value(t) {
      this.setter ? this.setter(t) : lt('Write operation failed: computed value is readonly');
    }
  }
  function ch(e, t, n = !1) {
    let s, r;
    return (ee(e) ? (s = e) : ((s = e.get), (r = e.set)), new uh(s, r, n));
  }
  const hr = {},
    mr = new WeakMap();
  let hn;
  function fh(e, t = !1, n = hn) {
    if (n) {
      let s = mr.get(n);
      (s || mr.set(n, (s = [])), s.push(e));
    } else
      t || lt('onWatcherCleanup() was called when there was no active watcher to associate with.');
  }
  function dh(e, t, n = ge) {
    const { immediate: s, deep: r, once: o, scheduler: i, augmentJob: l, call: a } = n,
      f = (D) => {
        (n.onWarn || lt)(
          'Invalid watch source: ',
          D,
          'A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.'
        );
      },
      u = (D) => (r ? D : Ke(D) || r === !1 || r === 0 ? jt(D, 1) : jt(D));
    let c,
      d,
      p,
      h,
      q = !1,
      v = !1;
    if (
      (be(e)
        ? ((d = () => e.value), (q = Ke(e)))
        : yt(e)
          ? ((d = () => u(e)), (q = !0))
          : J(e)
            ? ((v = !0),
              (q = e.some((D) => yt(D) || Ke(D))),
              (d = () =>
                e.map((D) => {
                  if (be(D)) return D.value;
                  if (yt(D)) return u(D);
                  if (ee(D)) return a ? a(D, 2) : D();
                  f(D);
                })))
            : ee(e)
              ? t
                ? (d = a ? () => a(e, 2) : e)
                : (d = () => {
                    if (p) {
                      Mt();
                      try {
                        p();
                      } finally {
                        Nt();
                      }
                    }
                    const D = hn;
                    hn = c;
                    try {
                      return a ? a(e, 3, [h]) : e(h);
                    } finally {
                      hn = D;
                    }
                  })
              : ((d = Ve), f(e)),
      t && r)
    ) {
      const D = d,
        te = r === !0 ? 1 / 0 : r;
      d = () => jt(D(), te);
    }
    const b = Bl(),
      $ = () => {
        (c.stop(), b && b.active && co(b.effects, c));
      };
    if (o && t) {
      const D = t;
      t = (...te) => {
        (D(...te), $());
      };
    }
    let C = v ? new Array(e.length).fill(hr) : hr;
    const G = (D) => {
      if (!(!(c.flags & 1) || (!c.dirty && !D)))
        if (t) {
          const te = c.run();
          if (r || q || (v ? te.some((V, ce) => Wt(V, C[ce])) : Wt(te, C))) {
            p && p();
            const V = hn;
            hn = c;
            try {
              const ce = [te, C === hr ? void 0 : v && C[0] === hr ? [] : C, h];
              (a ? a(t, 3, ce) : t(...ce), (C = te));
            } finally {
              hn = V;
            }
          }
        } else c.run();
    };
    return (
      l && l(G),
      (c = new Il(d)),
      (c.scheduler = i ? () => i(G, !1) : G),
      (h = (D) => fh(D, !1, c)),
      (p = c.onStop =
        () => {
          const D = mr.get(c);
          if (D) {
            if (a) a(D, 4);
            else for (const te of D) te();
            mr.delete(c);
          }
        }),
      (c.onTrack = n.onTrack),
      (c.onTrigger = n.onTrigger),
      t ? (s ? G(!0) : (C = c.run())) : i ? i(G.bind(null, !0), !0) : c.run(),
      ($.pause = c.pause.bind(c)),
      ($.resume = c.resume.bind(c)),
      ($.stop = $),
      $
    );
  }
  function jt(e, t = 1 / 0, n) {
    if (t <= 0 || !pe(e) || e.__v_skip || ((n = n || new Set()), n.has(e))) return e;
    if ((n.add(e), t--, be(e))) jt(e.value, t, n);
    else if (J(e)) for (let s = 0; s < e.length; s++) jt(e[s], t, n);
    else if (xl(e) || cn(e))
      e.forEach((s) => {
        jt(s, t, n);
      });
    else if (Sl(e)) {
      for (const s in e) jt(e[s], t, n);
      for (const s of Object.getOwnPropertySymbols(e))
        Object.prototype.propertyIsEnumerable.call(e, s) && jt(e[s], t, n);
    }
    return e;
  }
  var Jt = { NODE_ENV: '"production"' };
  const mn = [];
  function gr(e) {
    mn.push(e);
  }
  function _r() {
    mn.pop();
  }
  let To = !1;
  function R(e, ...t) {
    if (To) return;
    ((To = !0), Mt());
    const n = mn.length ? mn[mn.length - 1].component : null,
      s = n && n.appContext.config.warnHandler,
      r = ph();
    if (s)
      Mn(s, n, 11, [
        e +
          t
            .map((o) => {
              var i, l;
              return (l = (i = o.toString) == null ? void 0 : i.call(o)) != null
                ? l
                : JSON.stringify(o);
            })
            .join(''),
        n && n.proxy,
        r.map(({ vnode: o }) => `at <${$r(n, o.type)}>`).join(`
`),
        r
      ]);
    else {
      const o = [`[Vue warn]: ${e}`, ...t];
      (r.length &&
        o.push(
          `
`,
          ...hh(r)
        ),
        console.warn(...o));
    }
    (Nt(), (To = !1));
  }
  function ph() {
    let e = mn[mn.length - 1];
    if (!e) return [];
    const t = [];
    for (; e; ) {
      const n = t[0];
      n && n.vnode === e ? n.recurseCount++ : t.push({ vnode: e, recurseCount: 0 });
      const s = e.component && e.component.parent;
      e = s && s.vnode;
    }
    return t;
  }
  function hh(e) {
    const t = [];
    return (
      e.forEach((n, s) => {
        t.push(
          ...(s === 0
            ? []
            : [
                `
`
              ]),
          ...mh(n)
        );
      }),
      t
    );
  }
  function mh({ vnode: e, recurseCount: t }) {
    const n = t > 0 ? `... (${t} recursive calls)` : '',
      s = e.component ? e.component.parent == null : !1,
      r = ` at <${$r(e.component, e.type, s)}`,
      o = '>' + n;
    return e.props ? [r, ...gh(e.props), o] : [r + o];
  }
  function gh(e) {
    const t = [],
      n = Object.keys(e);
    return (
      n.slice(0, 3).forEach((s) => {
        t.push(...ta(s, e[s]));
      }),
      n.length > 3 && t.push(' ...'),
      t
    );
  }
  function ta(e, t, n) {
    return we(t)
      ? ((t = JSON.stringify(t)), n ? t : [`${e}=${t}`])
      : typeof t == 'number' || typeof t == 'boolean' || t == null
        ? n
          ? t
          : [`${e}=${t}`]
        : be(t)
          ? ((t = ta(e, se(t.value), !0)), n ? t : [`${e}=Ref<`, t, '>'])
          : ee(t)
            ? [`${e}=fn${t.name ? `<${t.name}>` : ''}`]
            : ((t = se(t)), n ? t : [`${e}=`, t]);
  }
  function _h(e, t) {
    e !== void 0 &&
      (typeof e != 'number'
        ? R(`${t} is not a valid number - got ${JSON.stringify(e)}.`)
        : isNaN(e) && R(`${t} is NaN - the duration expression might be incorrect.`));
  }
  const Oo = {
    sp: 'serverPrefetch hook',
    bc: 'beforeCreate hook',
    c: 'created hook',
    bm: 'beforeMount hook',
    m: 'mounted hook',
    bu: 'beforeUpdate hook',
    u: 'updated',
    bum: 'beforeUnmount hook',
    um: 'unmounted hook',
    a: 'activated hook',
    da: 'deactivated hook',
    ec: 'errorCaptured hook',
    rtc: 'renderTracked hook',
    rtg: 'renderTriggered hook',
    0: 'setup function',
    1: 'render function',
    2: 'watcher getter',
    3: 'watcher callback',
    4: 'watcher cleanup function',
    5: 'native event handler',
    6: 'component event handler',
    7: 'vnode hook',
    8: 'directive hook',
    9: 'transition hook',
    10: 'app errorHandler',
    11: 'app warnHandler',
    12: 'ref function',
    13: 'async component loader',
    14: 'scheduler flush',
    15: 'component update',
    16: 'app unmount cleanup function'
  };
  function Mn(e, t, n, s) {
    try {
      return s ? e(...s) : e();
    } catch (r) {
      bs(r, t, n);
    }
  }
  function ht(e, t, n, s) {
    if (ee(e)) {
      const r = Mn(e, t, n, s);
      return (
        r &&
          fo(r) &&
          r.catch((o) => {
            bs(o, t, n);
          }),
        r
      );
    }
    if (J(e)) {
      const r = [];
      for (let o = 0; o < e.length; o++) r.push(ht(e[o], t, n, s));
      return r;
    } else R(`Invalid value type passed to callWithAsyncErrorHandling(): ${typeof e}`);
  }
  function bs(e, t, n, s = !0) {
    const r = t ? t.vnode : null,
      { errorHandler: o, throwUnhandledErrorInProduction: i } = (t && t.appContext.config) || ge;
    if (t) {
      let l = t.parent;
      const a = t.proxy,
        f = Oo[n];
      for (; l; ) {
        const u = l.ec;
        if (u) {
          for (let c = 0; c < u.length; c++) if (u[c](e, a, f) === !1) return;
        }
        l = l.parent;
      }
      if (o) {
        (Mt(), Mn(o, null, 10, [e, a, f]), Nt());
        return;
      }
    }
    qh(e, n, r, s, i);
  }
  function qh(e, t, n, s = !0, r = !1) {
    {
      const o = Oo[t];
      if ((n && gr(n), R(`Unhandled error${o ? ` during execution of ${o}` : ''}`), n && _r(), s))
        throw e;
      console.error(e);
    }
  }
  const We = [];
  let xt = -1;
  const Nn = [];
  let Yt = null,
    Vn = 0;
  const na = Promise.resolve();
  let qr = null;
  const vh = 100;
  function Bo(e) {
    const t = qr || na;
    return e ? t.then(this ? e.bind(this) : e) : t;
  }
  function bh(e) {
    let t = xt + 1,
      n = We.length;
    for (; t < n; ) {
      const s = (t + n) >>> 1,
        r = We[s],
        o = ys(r);
      o < e || (o === e && r.flags & 2) ? (t = s + 1) : (n = s);
    }
    return t;
  }
  function vr(e) {
    if (!(e.flags & 1)) {
      const t = ys(e),
        n = We[We.length - 1];
      (!n || (!(e.flags & 2) && t >= ys(n)) ? We.push(e) : We.splice(bh(t), 0, e),
        (e.flags |= 1),
        sa());
    }
  }
  function sa() {
    qr || (qr = na.then(la));
  }
  function ra(e) {
    (J(e)
      ? Nn.push(...e)
      : Yt && e.id === -1
        ? Yt.splice(Vn + 1, 0, e)
        : e.flags & 1 || (Nn.push(e), (e.flags |= 1)),
      sa());
  }
  function oa(e, t, n = xt + 1) {
    for (t = t || new Map(); n < We.length; n++) {
      const s = We[n];
      if (s && s.flags & 2) {
        if ((e && s.id !== e.uid) || Io(t, s)) continue;
        (We.splice(n, 1), n--, s.flags & 4 && (s.flags &= -2), s(), s.flags & 4 || (s.flags &= -2));
      }
    }
  }
  function ia(e) {
    if (Nn.length) {
      const t = [...new Set(Nn)].sort((n, s) => ys(n) - ys(s));
      if (((Nn.length = 0), Yt)) {
        Yt.push(...t);
        return;
      }
      for (Yt = t, e = e || new Map(), Vn = 0; Vn < Yt.length; Vn++) {
        const n = Yt[Vn];
        Io(e, n) || (n.flags & 4 && (n.flags &= -2), n.flags & 8 || n(), (n.flags &= -2));
      }
      ((Yt = null), (Vn = 0));
    }
  }
  const ys = (e) => (e.id == null ? (e.flags & 2 ? -1 : 1 / 0) : e.id);
  function la(e) {
    e = e || new Map();
    const t = (n) => Io(e, n);
    try {
      for (xt = 0; xt < We.length; xt++) {
        const n = We[xt];
        if (n && !(n.flags & 8)) {
          if (Jt.NODE_ENV !== 'production' && t(n)) continue;
          (n.flags & 4 && (n.flags &= -2),
            Mn(n, n.i, n.i ? 15 : 14),
            n.flags & 4 || (n.flags &= -2));
        }
      }
    } finally {
      for (; xt < We.length; xt++) {
        const n = We[xt];
        n && (n.flags &= -2);
      }
      ((xt = -1), (We.length = 0), ia(e), (qr = null), (We.length || Nn.length) && la(e));
    }
  }
  function Io(e, t) {
    const n = e.get(t) || 0;
    if (n > vh) {
      const s = t.i,
        r = s && Xo(s.type);
      return (
        bs(
          `Maximum recursive updates exceeded${r ? ` in component <${r}>` : ''}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`,
          null,
          10
        ),
        !0
      );
    }
    return (e.set(t, n + 1), !1);
  }
  let wt = !1;
  const br = new Map();
  ps().__VUE_HMR_RUNTIME__ = { createRecord: Ro(aa), rerender: Ro(wh), reload: Ro(Sh) };
  const gn = new Map();
  function yh(e) {
    const t = e.type.__hmrId;
    let n = gn.get(t);
    (n || (aa(t, e.type), (n = gn.get(t))), n.instances.add(e));
  }
  function xh(e) {
    gn.get(e.type.__hmrId).instances.delete(e);
  }
  function aa(e, t) {
    return gn.has(e) ? !1 : (gn.set(e, { initialDef: yr(t), instances: new Set() }), !0);
  }
  function yr(e) {
    return mu(e) ? e.__vccOpts : e;
  }
  function wh(e, t) {
    const n = gn.get(e);
    n &&
      ((n.initialDef.render = t),
      [...n.instances].forEach((s) => {
        (t && ((s.render = t), (yr(s.type).render = t)),
          (s.renderCache = []),
          (wt = !0),
          s.update(),
          (wt = !1));
      }));
  }
  function Sh(e, t) {
    const n = gn.get(e);
    if (!n) return;
    ((t = yr(t)), ua(n.initialDef, t));
    const s = [...n.instances];
    for (let r = 0; r < s.length; r++) {
      const o = s[r],
        i = yr(o.type);
      let l = br.get(i);
      (l || (i !== n.initialDef && ua(i, t), br.set(i, (l = new Set()))),
        l.add(o),
        o.appContext.propsCache.delete(o.type),
        o.appContext.emitsCache.delete(o.type),
        o.appContext.optionsCache.delete(o.type),
        o.ceReload
          ? (l.add(o), o.ceReload(t.styles), l.delete(o))
          : o.parent
            ? vr(() => {
                ((wt = !0), o.parent.update(), (wt = !1), l.delete(o));
              })
            : o.appContext.reload
              ? o.appContext.reload()
              : typeof window < 'u'
                ? window.location.reload()
                : console.warn(
                    '[HMR] Root or manually mounted instance modified. Full reload required.'
                  ),
        o.root.ce && o !== o.root && o.root.ce._removeChildStyle(i));
    }
    ra(() => {
      br.clear();
    });
  }
  function ua(e, t) {
    ke(e, t);
    for (const n in e) n !== '__file' && !(n in t) && delete e[n];
  }
  function Ro(e) {
    return (t, n) => {
      try {
        return e(t, n);
      } catch (s) {
        (console.error(s),
          console.warn(
            '[HMR] Something went wrong during Vue component hot-reload. Full reload required.'
          ));
      }
    };
  }
  let St,
    xs = [],
    Po = !1;
  function ws(e, ...t) {
    St ? St.emit(e, ...t) : Po || xs.push({ event: e, args: t });
  }
  function ca(e, t) {
    var n, s;
    ((St = e),
      St
        ? ((St.enabled = !0), xs.forEach(({ event: r, args: o }) => St.emit(r, ...o)), (xs = []))
        : typeof window < 'u' &&
            window.HTMLElement &&
            !(
              (s = (n = window.navigator) == null ? void 0 : n.userAgent) != null &&
              s.includes('jsdom')
            )
          ? ((t.__VUE_DEVTOOLS_HOOK_REPLAY__ = t.__VUE_DEVTOOLS_HOOK_REPLAY__ || []).push((o) => {
              ca(o, t);
            }),
            setTimeout(() => {
              St || ((t.__VUE_DEVTOOLS_HOOK_REPLAY__ = null), (Po = !0), (xs = []));
            }, 3e3))
          : ((Po = !0), (xs = [])));
  }
  function Eh(e, t) {
    ws('app:init', e, t, { Fragment: Ae, Text: Qn, Comment: Ie, Static: Ts });
  }
  function kh(e) {
    ws('app:unmount', e);
  }
  const Ch = $o('component:added'),
    fa = $o('component:updated'),
    Ah = $o('component:removed'),
    Th = (e) => {
      St && typeof St.cleanupBuffer == 'function' && !St.cleanupBuffer(e) && Ah(e);
    };
  /*! #__NO_SIDE_EFFECTS__ */ function $o(e) {
    return (t) => {
      ws(e, t.appContext.app, t.uid, t.parent ? t.parent.uid : void 0, t);
    };
  }
  const Oh = da('perf:start'),
    Bh = da('perf:end');
  function da(e) {
    return (t, n, s) => {
      ws(e, t.appContext.app, t.uid, t, n, s);
    };
  }
  function Ih(e, t, n) {
    ws('component:emit', e.appContext.app, e, t, n);
  }
  let Be = null,
    pa = null;
  function xr(e) {
    const t = Be;
    return ((Be = e), (pa = (e && e.type.__scopeId) || null), t);
  }
  function Et(e, t = Be, n) {
    if (!t || e._n) return e;
    const s = (...r) => {
      s._d && iu(-1);
      const o = xr(t);
      let i;
      try {
        i = e(...r);
      } finally {
        (xr(o), s._d && iu(1));
      }
      return (fa(t), i);
    };
    return ((s._n = !0), (s._c = !0), (s._d = !0), s);
  }
  function ha(e) {
    yp(e) && R('Do not use built-in directive ids as custom directive id: ' + e);
  }
  function Ln(e, t) {
    if (Be === null) return (R('withDirectives can only be used inside render functions.'), e);
    const n = Pr(Be),
      s = e.dirs || (e.dirs = []);
    for (let r = 0; r < t.length; r++) {
      let [o, i, l, a = ge] = t[r];
      o &&
        (ee(o) && (o = { mounted: o, updated: o }),
        o.deep && jt(i),
        s.push({ dir: o, instance: n, value: i, oldValue: void 0, arg: l, modifiers: a }));
    }
    return e;
  }
  function _n(e, t, n, s) {
    const r = e.dirs,
      o = t && t.dirs;
    for (let i = 0; i < r.length; i++) {
      const l = r[i];
      o && (l.oldValue = o[i].value);
      let a = l.dir[s];
      a && (Mt(), ht(a, n, 8, [e.el, l, e, t]), Nt());
    }
  }
  const Rh = Symbol('_vte'),
    ma = (e) => e.__isTeleport,
    Zt = Symbol('_leaveCb'),
    wr = Symbol('_enterCb');
  function ga() {
    const e = { isMounted: !1, isLeaving: !1, isUnmounting: !1, leavingVNodes: new Map() };
    return (
      Me(() => {
        e.isMounted = !0;
      }),
      Ea(() => {
        e.isUnmounting = !0;
      }),
      e
    );
  }
  const at = [Function, Array],
    _a = {
      mode: String,
      appear: Boolean,
      persisted: Boolean,
      onBeforeEnter: at,
      onEnter: at,
      onAfterEnter: at,
      onEnterCancelled: at,
      onBeforeLeave: at,
      onLeave: at,
      onAfterLeave: at,
      onLeaveCancelled: at,
      onBeforeAppear: at,
      onAppear: at,
      onAfterAppear: at,
      onAppearCancelled: at
    },
    qa = (e) => {
      const t = e.subTree;
      return t.component ? qa(t.component) : t;
    },
    Ph = {
      name: 'BaseTransition',
      props: _a,
      setup(e, { slots: t }) {
        const n = Ir(),
          s = ga();
        return () => {
          const r = t.default && Fo(t.default(), !0);
          if (!r || !r.length) return;
          const o = va(r),
            i = se(e),
            { mode: l } = i;
          if (
            (l &&
              l !== 'in-out' &&
              l !== 'out-in' &&
              l !== 'default' &&
              R(`invalid <transition> mode: ${l}`),
            s.isLeaving)
          )
            return Do(o);
          const a = ya(o);
          if (!a) return Do(o);
          let f = Ss(a, i, s, n, (c) => (f = c));
          a.type !== Ie && qn(a, f);
          let u = n.subTree && ya(n.subTree);
          if (u && u.type !== Ie && !En(a, u) && qa(n).type !== Ie) {
            let c = Ss(u, i, s, n);
            if ((qn(u, c), l === 'out-in' && a.type !== Ie))
              return (
                (s.isLeaving = !0),
                (c.afterLeave = () => {
                  ((s.isLeaving = !1),
                    n.job.flags & 8 || n.update(),
                    delete c.afterLeave,
                    (u = void 0));
                }),
                Do(o)
              );
            l === 'in-out' && a.type !== Ie
              ? (c.delayLeave = (d, p, h) => {
                  const q = ba(s, u);
                  ((q[String(u.key)] = u),
                    (d[Zt] = () => {
                      (p(), (d[Zt] = void 0), delete f.delayedLeave, (u = void 0));
                    }),
                    (f.delayedLeave = () => {
                      (h(), delete f.delayedLeave, (u = void 0));
                    }));
                })
              : (u = void 0);
          } else u && (u = void 0);
          return o;
        };
      }
    };
  function va(e) {
    let t = e[0];
    if (e.length > 1) {
      let n = !1;
      for (const s of e)
        if (s.type !== Ie) {
          if (n) {
            R(
              '<transition> can only be used on a single element or component. Use <transition-group> for lists.'
            );
            break;
          }
          ((t = s), (n = !0));
        }
    }
    return t;
  }
  const $h = Ph;
  function ba(e, t) {
    const { leavingVNodes: n } = e;
    let s = n.get(t.type);
    return (s || ((s = Object.create(null)), n.set(t.type, s)), s);
  }
  function Ss(e, t, n, s, r) {
    const {
        appear: o,
        mode: i,
        persisted: l = !1,
        onBeforeEnter: a,
        onEnter: f,
        onAfterEnter: u,
        onEnterCancelled: c,
        onBeforeLeave: d,
        onLeave: p,
        onAfterLeave: h,
        onLeaveCancelled: q,
        onBeforeAppear: v,
        onAppear: b,
        onAfterAppear: $,
        onAppearCancelled: C
      } = t,
      G = String(e.key),
      D = ba(n, e),
      te = (K, I) => {
        K && ht(K, s, 9, I);
      },
      V = (K, I) => {
        const T = I[1];
        (te(K, I), J(K) ? K.every((x) => x.length <= 1) && T() : K.length <= 1 && T());
      },
      ce = {
        mode: i,
        persisted: l,
        beforeEnter(K) {
          let I = a;
          if (!n.isMounted)
            if (o) I = v || a;
            else return;
          K[Zt] && K[Zt](!0);
          const T = D[G];
          (T && En(e, T) && T.el[Zt] && T.el[Zt](), te(I, [K]));
        },
        enter(K) {
          let I = f,
            T = u,
            x = c;
          if (!n.isMounted)
            if (o) ((I = b || f), (T = $ || u), (x = C || c));
            else return;
          let Q = !1;
          const Y = (K[wr] = (me) => {
            Q ||
              ((Q = !0),
              me ? te(x, [K]) : te(T, [K]),
              ce.delayedLeave && ce.delayedLeave(),
              (K[wr] = void 0));
          });
          I ? V(I, [K, Y]) : Y();
        },
        leave(K, I) {
          const T = String(e.key);
          if ((K[wr] && K[wr](!0), n.isUnmounting)) return I();
          te(d, [K]);
          let x = !1;
          const Q = (K[Zt] = (Y) => {
            x ||
              ((x = !0),
              I(),
              Y ? te(q, [K]) : te(h, [K]),
              (K[Zt] = void 0),
              D[T] === e && delete D[T]);
          });
          ((D[T] = e), p ? V(p, [K, Q]) : Q());
        },
        clone(K) {
          const I = Ss(K, t, n, s, r);
          return (r && r(I), I);
        }
      };
    return ce;
  }
  function Do(e) {
    if (Es(e)) return ((e = kt(e)), (e.children = null), e);
  }
  function ya(e) {
    if (!Es(e)) return ma(e.type) && e.children ? va(e.children) : e;
    if (e.component) return e.component.subTree;
    const { shapeFlag: t, children: n } = e;
    if (n) {
      if (t & 16) return n[0];
      if (t & 32 && ee(n.default)) return n.default();
    }
  }
  function qn(e, t) {
    e.shapeFlag & 6 && e.component
      ? ((e.transition = t), qn(e.component.subTree, t))
      : e.shapeFlag & 128
        ? ((e.ssContent.transition = t.clone(e.ssContent)),
          (e.ssFallback.transition = t.clone(e.ssFallback)))
        : (e.transition = t);
  }
  function Fo(e, t = !1, n) {
    let s = [],
      r = 0;
    for (let o = 0; o < e.length; o++) {
      let i = e[o];
      const l = n == null ? i.key : String(n) + String(i.key != null ? i.key : o);
      i.type === Ae
        ? (i.patchFlag & 128 && r++, (s = s.concat(Fo(i.children, t, l))))
        : (t || i.type !== Ie) && s.push(l != null ? kt(i, { key: l }) : i);
    }
    if (r > 1) for (let o = 0; o < s.length; o++) s[o].patchFlag = -2;
    return s;
  }
  /*! #__NO_SIDE_EFFECTS__ */ function re(e, t) {
    return ee(e) ? ke({ name: e.name }, t, { setup: e }) : e;
  }
  function xa(e) {
    e.ids = [e.ids[0] + e.ids[2]++ + '-', 0, 0];
  }
  const Dh = new WeakSet();
  function Sr(e, t, n, s, r = !1) {
    if (J(e)) {
      e.forEach((h, q) => Sr(h, t && (J(t) ? t[q] : t), n, s, r));
      return;
    }
    if (Un(s) && !r) {
      s.shapeFlag & 512 &&
        s.type.__asyncResolved &&
        s.component.subTree.component &&
        Sr(e, t, n, s.component.subTree);
      return;
    }
    const o = s.shapeFlag & 4 ? Pr(s.component) : s.el,
      i = r ? null : o,
      { i: l, r: a } = e;
    if (!l) {
      R(
        'Missing ref owner context. ref cannot be used on hoisted vnodes. A vnode with ref must be created inside the render function.'
      );
      return;
    }
    const f = t && t.r,
      u = l.refs === ge ? (l.refs = {}) : l.refs,
      c = l.setupState,
      d = se(c),
      p =
        c === ge
          ? () => !1
          : (h) => (
              de(d, h) &&
                !be(d[h]) &&
                R(
                  `Template ref "${h}" used on a non-ref value. It will not work in the production build.`
                ),
              Dh.has(d[h]) ? !1 : de(d, h)
            );
    if (
      (f != null &&
        f !== a &&
        (we(f) ? ((u[f] = null), p(f) && (c[f] = null)) : be(f) && (f.value = null)),
      ee(a))
    )
      Mn(a, l, 12, [i, u]);
    else {
      const h = we(a),
        q = be(a);
      if (h || q) {
        const v = () => {
          if (e.f) {
            const b = h ? (p(a) ? c[a] : u[a]) : a.value;
            r
              ? J(b) && co(b, o)
              : J(b)
                ? b.includes(o) || b.push(o)
                : h
                  ? ((u[a] = [o]), p(a) && (c[a] = u[a]))
                  : ((a.value = [o]), e.k && (u[e.k] = a.value));
          } else
            h
              ? ((u[a] = i), p(a) && (c[a] = i))
              : q
                ? ((a.value = i), e.k && (u[e.k] = i))
                : R('Invalid template ref type:', a, `(${typeof a})`);
        };
        i ? ((v.id = -1), st(v, n)) : v();
      } else R('Invalid template ref type:', a, `(${typeof a})`);
    }
  }
  (ps().requestIdleCallback, ps().cancelIdleCallback);
  const Un = (e) => !!e.type.__asyncLoader,
    Es = (e) => e.type.__isKeepAlive;
  function Fh(e, t) {
    wa(e, 'a', t);
  }
  function zh(e, t) {
    wa(e, 'da', t);
  }
  function wa(e, t, n = Re) {
    const s =
      e.__wdc ||
      (e.__wdc = () => {
        let r = n;
        for (; r; ) {
          if (r.isDeactivated) return;
          r = r.parent;
        }
        return e();
      });
    if ((Er(t, s, n), n)) {
      let r = n.parent;
      for (; r && r.parent; ) (Es(r.parent.vnode) && Mh(s, t, n, r), (r = r.parent));
    }
  }
  function Mh(e, t, n, s) {
    const r = Er(t, e, s, !0);
    kr(() => {
      co(s[t], r);
    }, n);
  }
  function Er(e, t, n = Re, s = !1) {
    if (n) {
      const r = n[e] || (n[e] = []),
        o =
          t.__weh ||
          (t.__weh = (...i) => {
            Mt();
            const l = Is(n),
              a = ht(t, n, e, i);
            return (l(), Nt(), a);
          });
      return (s ? r.unshift(o) : r.push(o), o);
    } else {
      const r = dn(Oo[e].replace(/ hook$/, ''));
      R(
        `${r} is called when there is no active component instance to be associated with. Lifecycle injection APIs can only be used during execution of setup(). If you are using async setup(), make sure to register lifecycle hooks before the first await statement.`
      );
    }
  }
  const Ht =
      (e) =>
      (t, n = Re) => {
        (!Rs || e === 'sp') && Er(e, (...s) => t(...s), n);
      },
    Nh = Ht('bm'),
    Me = Ht('m'),
    Vh = Ht('bu'),
    Sa = Ht('u'),
    Ea = Ht('bum'),
    kr = Ht('um'),
    Lh = Ht('sp'),
    Uh = Ht('rtg'),
    jh = Ht('rtc');
  function Hh(e, t = Re) {
    Er('ec', e, t);
  }
  const Qh = 'components',
    ka = Symbol.for('v-ndc');
  function Kh(e) {
    return we(e) ? Wh(Qh, e, !1) || e : e || ka;
  }
  function Wh(e, t, n = !0, s = !1) {
    const r = Be || Re;
    if (r) {
      const o = r.type;
      {
        const l = Xo(o, !1);
        if (l && (l === t || l === He(t) || l === fn(He(t)))) return o;
      }
      const i = Ca(r[e] || o[e], t) || Ca(r.appContext[e], t);
      return !i && s
        ? o
        : (n &&
            !i &&
            R(`Failed to resolve ${e.slice(0, -1)}: ${t}
If this is a native custom element, make sure to exclude it from component resolution via compilerOptions.isCustomElement.`),
          i);
    } else R(`resolve${fn(e.slice(0, -1))} can only be used in render() or setup().`);
  }
  function Ca(e, t) {
    return e && (e[t] || e[He(t)] || e[fn(He(t))]);
  }
  function vn(e, t, n, s) {
    let r;
    const o = n,
      i = J(e);
    if (i || we(e)) {
      const l = i && yt(e);
      let a = !1;
      (l && ((a = !Ke(e)), (e = ar(e))), (r = new Array(e.length)));
      for (let f = 0, u = e.length; f < u; f++) r[f] = t(a ? Le(e[f]) : e[f], f, void 0, o);
    } else if (typeof e == 'number') {
      (Number.isInteger(e) || R(`The v-for range expect an integer value but got ${e}.`),
        (r = new Array(e)));
      for (let l = 0; l < e; l++) r[l] = t(l + 1, l, void 0, o);
    } else if (pe(e))
      if (e[Symbol.iterator]) r = Array.from(e, (l, a) => t(l, a, void 0, o));
      else {
        const l = Object.keys(e);
        r = new Array(l.length);
        for (let a = 0, f = l.length; a < f; a++) {
          const u = l[a];
          r[a] = t(e[u], u, a, o);
        }
      }
    else r = [];
    return r;
  }
  function Aa(e, t, n = {}, s, r) {
    if (Be.ce || (Be.parent && Un(Be.parent) && Be.parent.ce))
      return (P(), wn(Ae, null, [S('slot', n, s && s())], 64));
    let o = e[t];
    (o &&
      o.length > 1 &&
      (R(
        'SSR-optimized slot function detected in a non-SSR-optimized render function. You need to mark this component with $dynamic-slots in the parent template.'
      ),
      (o = () => [])),
      o && o._c && (o._d = !1),
      P());
    const i = o && Ta(o(n)),
      l = n.key || (i && i.key),
      a = wn(
        Ae,
        { key: (l && !Ft(l) ? l : `_${t}`) + (!i && s ? '_fb' : '') },
        i || (s ? s() : []),
        i && e._ === 1 ? 64 : -2
      );
    return (a.scopeId && (a.slotScopeIds = [a.scopeId + '-s']), o && o._c && (o._d = !0), a);
  }
  function Ta(e) {
    return e.some((t) => (Sn(t) ? !(t.type === Ie || (t.type === Ae && !Ta(t.children))) : !0))
      ? e
      : null;
  }
  const zo = (e) => (e ? (du(e) ? Pr(e) : zo(e.parent)) : null),
    bn = ke(Object.create(null), {
      $: (e) => e,
      $el: (e) => e.vnode.el,
      $data: (e) => e.data,
      $props: (e) => bt(e.props),
      $attrs: (e) => bt(e.attrs),
      $slots: (e) => bt(e.slots),
      $refs: (e) => bt(e.refs),
      $parent: (e) => zo(e.parent),
      $root: (e) => zo(e.root),
      $host: (e) => e.ce,
      $emit: (e) => e.emit,
      $options: (e) => Pa(e),
      $forceUpdate: (e) =>
        e.f ||
        (e.f = () => {
          vr(e.update);
        }),
      $nextTick: (e) => e.n || (e.n = Bo.bind(e.proxy)),
      $watch: (e) => Am.bind(e)
    }),
    Mo = (e) => e === '_' || e === '$',
    No = (e, t) => e !== ge && !e.__isScriptSetup && de(e, t),
    Oa = {
      get({ _: e }, t) {
        if (t === '__v_skip') return !0;
        const {
          ctx: n,
          setupState: s,
          data: r,
          props: o,
          accessCache: i,
          type: l,
          appContext: a
        } = e;
        if (t === '__isVue') return !0;
        let f;
        if (t[0] !== '$') {
          const p = i[t];
          if (p !== void 0)
            switch (p) {
              case 1:
                return s[t];
              case 2:
                return r[t];
              case 4:
                return n[t];
              case 3:
                return o[t];
            }
          else {
            if (No(s, t)) return ((i[t] = 1), s[t]);
            if (r !== ge && de(r, t)) return ((i[t] = 2), r[t]);
            if ((f = e.propsOptions[0]) && de(f, t)) return ((i[t] = 3), o[t]);
            if (n !== ge && de(n, t)) return ((i[t] = 4), n[t]);
            Vo && (i[t] = 0);
          }
        }
        const u = bn[t];
        let c, d;
        if (u)
          return (
            t === '$attrs' ? (De(e.attrs, 'get', ''), Or()) : t === '$slots' && De(e, 'get', t),
            u(e)
          );
        if ((c = l.__cssModules) && (c = c[t])) return c;
        if (n !== ge && de(n, t)) return ((i[t] = 4), n[t]);
        if (((d = a.config.globalProperties), de(d, t))) return d[t];
        Be &&
          (!we(t) || t.indexOf('__v') !== 0) &&
          (r !== ge && Mo(t[0]) && de(r, t)
            ? R(
                `Property ${JSON.stringify(t)} must be accessed via $data because it starts with a reserved character ("$" or "_") and is not proxied on the render context.`
              )
            : e === Be &&
              R(
                `Property ${JSON.stringify(t)} was accessed during render but is not defined on instance.`
              ));
      },
      set({ _: e }, t, n) {
        const { data: s, setupState: r, ctx: o } = e;
        return No(r, t)
          ? ((r[t] = n), !0)
          : r.__isScriptSetup && de(r, t)
            ? (R(`Cannot mutate <script setup> binding "${t}" from Options API.`), !1)
            : s !== ge && de(s, t)
              ? ((s[t] = n), !0)
              : de(e.props, t)
                ? (R(`Attempting to mutate prop "${t}". Props are readonly.`), !1)
                : t[0] === '$' && t.slice(1) in e
                  ? (R(
                      `Attempting to mutate public property "${t}". Properties starting with $ are reserved and readonly.`
                    ),
                    !1)
                  : (t in e.appContext.config.globalProperties
                      ? Object.defineProperty(o, t, { enumerable: !0, configurable: !0, value: n })
                      : (o[t] = n),
                    !0);
      },
      has(
        { _: { data: e, setupState: t, accessCache: n, ctx: s, appContext: r, propsOptions: o } },
        i
      ) {
        let l;
        return (
          !!n[i] ||
          (e !== ge && de(e, i)) ||
          No(t, i) ||
          ((l = o[0]) && de(l, i)) ||
          de(s, i) ||
          de(bn, i) ||
          de(r.config.globalProperties, i)
        );
      },
      defineProperty(e, t, n) {
        return (
          n.get != null
            ? (e._.accessCache[t] = 0)
            : de(n, 'value') && this.set(e, t, n.value, null),
          Reflect.defineProperty(e, t, n)
        );
      }
    };
  Oa.ownKeys = (e) => (
    R(
      'Avoid app logic that relies on enumerating keys on a component instance. The keys will be empty in production mode to avoid performance overhead.'
    ),
    Reflect.ownKeys(e)
  );
  function Gh(e) {
    const t = {};
    return (
      Object.defineProperty(t, '_', { configurable: !0, enumerable: !1, get: () => e }),
      Object.keys(bn).forEach((n) => {
        Object.defineProperty(t, n, {
          configurable: !0,
          enumerable: !1,
          get: () => bn[n](e),
          set: Ve
        });
      }),
      t
    );
  }
  function Jh(e) {
    const {
      ctx: t,
      propsOptions: [n]
    } = e;
    n &&
      Object.keys(n).forEach((s) => {
        Object.defineProperty(t, s, {
          enumerable: !0,
          configurable: !0,
          get: () => e.props[s],
          set: Ve
        });
      });
  }
  function Yh(e) {
    const { ctx: t, setupState: n } = e;
    Object.keys(se(n)).forEach((s) => {
      if (!n.__isScriptSetup) {
        if (Mo(s[0])) {
          R(
            `setup() return property ${JSON.stringify(s)} should not start with "$" or "_" which are reserved prefixes for Vue internals.`
          );
          return;
        }
        Object.defineProperty(t, s, { enumerable: !0, configurable: !0, get: () => n[s], set: Ve });
      }
    });
  }
  function Ba(e) {
    return J(e) ? e.reduce((t, n) => ((t[n] = null), t), {}) : e;
  }
  function Zh() {
    const e = Object.create(null);
    return (t, n) => {
      e[n] ? R(`${t} property "${n}" is already defined in ${e[n]}.`) : (e[n] = t);
    };
  }
  let Vo = !0;
  function Xh(e) {
    const t = Pa(e),
      n = e.proxy,
      s = e.ctx;
    ((Vo = !1), t.beforeCreate && Ia(t.beforeCreate, e, 'bc'));
    const {
        data: r,
        computed: o,
        methods: i,
        watch: l,
        provide: a,
        inject: f,
        created: u,
        beforeMount: c,
        mounted: d,
        beforeUpdate: p,
        updated: h,
        activated: q,
        deactivated: v,
        beforeDestroy: b,
        beforeUnmount: $,
        destroyed: C,
        unmounted: G,
        render: D,
        renderTracked: te,
        renderTriggered: V,
        errorCaptured: ce,
        serverPrefetch: K,
        expose: I,
        inheritAttrs: T,
        components: x,
        directives: Q,
        filters: Y
      } = t,
      me = Zh();
    {
      const [j] = e.propsOptions;
      if (j) for (const Z in j) me('Props', Z);
    }
    if ((f && em(f, s, me), i))
      for (const j in i) {
        const Z = i[j];
        ee(Z)
          ? (Object.defineProperty(s, j, {
              value: Z.bind(n),
              configurable: !0,
              enumerable: !0,
              writable: !0
            }),
            me('Methods', j))
          : R(
              `Method "${j}" has type "${typeof Z}" in the component definition. Did you reference the function correctly?`
            );
      }
    if (r) {
      ee(r) || R('The data option must be a function. Plain object usage is no longer supported.');
      const j = r.call(n, n);
      if (
        (fo(j) &&
          R(
            'data() returned a Promise - note data() cannot be async; If you intend to perform data fetching before component renders, use async setup() + <Suspense>.'
          ),
        !pe(j))
      )
        R('data() should return an object.');
      else {
        e.data = dr(j);
        for (const Z in j)
          (me('Data', Z),
            Mo(Z[0]) ||
              Object.defineProperty(s, Z, {
                configurable: !0,
                enumerable: !0,
                get: () => j[Z],
                set: Ve
              }));
      }
    }
    if (((Vo = !0), o))
      for (const j in o) {
        const Z = o[j],
          ue = ee(Z) ? Z.bind(n, n) : ee(Z.get) ? Z.get.bind(n, n) : Ve;
        ue === Ve && R(`Computed property "${j}" has no getter.`);
        const ft =
            !ee(Z) && ee(Z.set)
              ? Z.set.bind(n)
              : () => {
                  R(`Write operation failed: computed property "${j}" is readonly.`);
                },
          Ce = H({ get: ue, set: ft });
        (Object.defineProperty(s, j, {
          enumerable: !0,
          configurable: !0,
          get: () => Ce.value,
          set: (Ee) => (Ce.value = Ee)
        }),
          me('Computed', j));
      }
    if (l) for (const j in l) Ra(l[j], s, n, j);
    if (a) {
      const j = ee(a) ? a.call(n) : a;
      Reflect.ownKeys(j).forEach((Z) => {
        im(Z, j[Z]);
      });
    }
    u && Ia(u, e, 'c');
    function ae(j, Z) {
      J(Z) ? Z.forEach((ue) => j(ue.bind(n))) : Z && j(Z.bind(n));
    }
    if (
      (ae(Nh, c),
      ae(Me, d),
      ae(Vh, p),
      ae(Sa, h),
      ae(Fh, q),
      ae(zh, v),
      ae(Hh, ce),
      ae(jh, te),
      ae(Uh, V),
      ae(Ea, $),
      ae(kr, G),
      ae(Lh, K),
      J(I))
    )
      if (I.length) {
        const j = e.exposed || (e.exposed = {});
        I.forEach((Z) => {
          Object.defineProperty(j, Z, { get: () => n[Z], set: (ue) => (n[Z] = ue) });
        });
      } else e.exposed || (e.exposed = {});
    (D && e.render === Ve && (e.render = D),
      T != null && (e.inheritAttrs = T),
      x && (e.components = x),
      Q && (e.directives = Q),
      K && xa(e));
  }
  function em(e, t, n = Ve) {
    J(e) && (e = Lo(e));
    for (const s in e) {
      const r = e[s];
      let o;
      (pe(r)
        ? 'default' in r
          ? (o = Cs(r.from || s, r.default, !0))
          : (o = Cs(r.from || s))
        : (o = Cs(r)),
        be(o)
          ? Object.defineProperty(t, s, {
              enumerable: !0,
              configurable: !0,
              get: () => o.value,
              set: (i) => (o.value = i)
            })
          : (t[s] = o),
        n('Inject', s));
    }
  }
  function Ia(e, t, n) {
    ht(J(e) ? e.map((s) => s.bind(t.proxy)) : e.bind(t.proxy), t, n);
  }
  function Ra(e, t, n, s) {
    let r = s.includes('.') ? Xa(n, s) : () => n[s];
    if (we(e)) {
      const o = t[e];
      ee(o) ? Se(r, o) : R(`Invalid watch handler specified by key "${e}"`, o);
    } else if (ee(e)) Se(r, e.bind(n));
    else if (pe(e))
      if (J(e)) e.forEach((o) => Ra(o, t, n, s));
      else {
        const o = ee(e.handler) ? e.handler.bind(n) : t[e.handler];
        ee(o) ? Se(r, o, e) : R(`Invalid watch handler specified by key "${e.handler}"`, o);
      }
    else R(`Invalid watch option: "${s}"`, e);
  }
  function Pa(e) {
    const t = e.type,
      { mixins: n, extends: s } = t,
      {
        mixins: r,
        optionsCache: o,
        config: { optionMergeStrategies: i }
      } = e.appContext,
      l = o.get(t);
    let a;
    return (
      l
        ? (a = l)
        : !r.length && !n && !s
          ? (a = t)
          : ((a = {}), r.length && r.forEach((f) => Cr(a, f, i, !0)), Cr(a, t, i)),
      pe(t) && o.set(t, a),
      a
    );
  }
  function Cr(e, t, n, s = !1) {
    const { mixins: r, extends: o } = t;
    (o && Cr(e, o, n, !0), r && r.forEach((i) => Cr(e, i, n, !0)));
    for (const i in t)
      if (s && i === 'expose')
        R(
          '"expose" option is ignored when declared in mixins or extends. It should only be declared in the base component itself.'
        );
      else {
        const l = tm[i] || (n && n[i]);
        e[i] = l ? l(e[i], t[i]) : t[i];
      }
    return e;
  }
  const tm = {
    data: $a,
    props: Da,
    emits: Da,
    methods: ks,
    computed: ks,
    beforeCreate: Ge,
    created: Ge,
    beforeMount: Ge,
    mounted: Ge,
    beforeUpdate: Ge,
    updated: Ge,
    beforeDestroy: Ge,
    beforeUnmount: Ge,
    destroyed: Ge,
    unmounted: Ge,
    activated: Ge,
    deactivated: Ge,
    errorCaptured: Ge,
    serverPrefetch: Ge,
    components: ks,
    directives: ks,
    watch: sm,
    provide: $a,
    inject: nm
  };
  function $a(e, t) {
    return t
      ? e
        ? function () {
            return ke(ee(e) ? e.call(this, this) : e, ee(t) ? t.call(this, this) : t);
          }
        : t
      : e;
  }
  function nm(e, t) {
    return ks(Lo(e), Lo(t));
  }
  function Lo(e) {
    if (J(e)) {
      const t = {};
      for (let n = 0; n < e.length; n++) t[e[n]] = e[n];
      return t;
    }
    return e;
  }
  function Ge(e, t) {
    return e ? [...new Set([].concat(e, t))] : t;
  }
  function ks(e, t) {
    return e ? ke(Object.create(null), e, t) : t;
  }
  function Da(e, t) {
    return e
      ? J(e) && J(t)
        ? [...new Set([...e, ...t])]
        : ke(Object.create(null), Ba(e), Ba(t ?? {}))
      : t;
  }
  function sm(e, t) {
    if (!e) return t;
    if (!t) return e;
    const n = ke(Object.create(null), e);
    for (const s in t) n[s] = Ge(e[s], t[s]);
    return n;
  }
  function Fa() {
    return {
      app: null,
      config: {
        isNativeTag: vp,
        performance: !1,
        globalProperties: {},
        optionMergeStrategies: {},
        errorHandler: void 0,
        warnHandler: void 0,
        compilerOptions: {}
      },
      mixins: [],
      components: {},
      directives: {},
      provides: Object.create(null),
      optionsCache: new WeakMap(),
      propsCache: new WeakMap(),
      emitsCache: new WeakMap()
    };
  }
  let rm = 0;
  function om(e, t) {
    return function (s, r = null) {
      (ee(s) || (s = ke({}, s)),
        r != null &&
          !pe(r) &&
          (R('root props passed to app.mount() must be an object.'), (r = null)));
      const o = Fa(),
        i = new WeakSet(),
        l = [];
      let a = !1;
      const f = (o.app = {
        _uid: rm++,
        _component: s,
        _props: r,
        _container: null,
        _context: o,
        _instance: null,
        version: gu,
        get config() {
          return o.config;
        },
        set config(u) {
          R('app.config cannot be replaced. Modify individual options instead.');
        },
        use(u, ...c) {
          return (
            i.has(u)
              ? R('Plugin has already been applied to target app.')
              : u && ee(u.install)
                ? (i.add(u), u.install(f, ...c))
                : ee(u)
                  ? (i.add(u), u(f, ...c))
                  : R(
                      'A plugin must either be a function or an object with an "install" function.'
                    ),
            f
          );
        },
        mixin(u) {
          return (
            o.mixins.includes(u)
              ? R('Mixin has already been applied to target app' + (u.name ? `: ${u.name}` : ''))
              : o.mixins.push(u),
            f
          );
        },
        component(u, c) {
          return (
            Zo(u, o.config),
            c
              ? (o.components[u] &&
                  R(`Component "${u}" has already been registered in target app.`),
                (o.components[u] = c),
                f)
              : o.components[u]
          );
        },
        directive(u, c) {
          return (
            ha(u),
            c
              ? (o.directives[u] &&
                  R(`Directive "${u}" has already been registered in target app.`),
                (o.directives[u] = c),
                f)
              : o.directives[u]
          );
        },
        mount(u, c, d) {
          if (a)
            R(
              'App has already been mounted.\nIf you want to remount the same app, move your app creation logic into a factory function and create fresh app instances for each mount - e.g. `const createMyApp = () => createApp(App)`'
            );
          else {
            u.__vue_app__ &&
              R(
                'There is already an app instance mounted on the host container.\n If you want to mount another app on the same host container, you need to unmount the previous app by calling `app.unmount()` first.'
              );
            const p = f._ceVNode || S(s, r);
            return (
              (p.appContext = o),
              d === !0 ? (d = 'svg') : d === !1 && (d = void 0),
              (o.reload = () => {
                e(kt(p), u, d);
              }),
              e(p, u, d),
              (a = !0),
              (f._container = u),
              (u.__vue_app__ = f),
              (f._instance = p.component),
              Eh(f, gu),
              Pr(p.component)
            );
          }
        },
        onUnmount(u) {
          (typeof u != 'function' &&
            R(`Expected function as first argument to app.onUnmount(), but got ${typeof u}`),
            l.push(u));
        },
        unmount() {
          a
            ? (ht(l, f._instance, 16),
              e(null, f._container),
              (f._instance = null),
              kh(f),
              delete f._container.__vue_app__)
            : R('Cannot unmount an app that is not mounted.');
        },
        provide(u, c) {
          return (
            u in o.provides &&
              R(
                `App already provides property with key "${String(u)}". It will be overwritten with the new value.`
              ),
            (o.provides[u] = c),
            f
          );
        },
        runWithContext(u) {
          const c = yn;
          yn = f;
          try {
            return u();
          } finally {
            yn = c;
          }
        }
      });
      return f;
    };
  }
  let yn = null;
  function im(e, t) {
    if (!Re) R('provide() can only be used inside setup().');
    else {
      let n = Re.provides;
      const s = Re.parent && Re.parent.provides;
      (s === n && (n = Re.provides = Object.create(s)), (n[e] = t));
    }
  }
  function Cs(e, t, n = !1) {
    const s = Re || Be;
    if (s || yn) {
      const r = yn
        ? yn._context.provides
        : s
          ? s.parent == null
            ? s.vnode.appContext && s.vnode.appContext.provides
            : s.parent.provides
          : void 0;
      if (r && e in r) return r[e];
      if (arguments.length > 1) return n && ee(t) ? t.call(s && s.proxy) : t;
      R(`injection "${String(e)}" not found.`);
    } else R('inject() can only be used inside setup() or functional components.');
  }
  function lm() {
    return !!(Re || Be || yn);
  }
  const za = {},
    Ma = () => Object.create(za),
    Na = (e) => Object.getPrototypeOf(e) === za;
  function am(e, t, n, s = !1) {
    const r = {},
      o = Ma();
    ((e.propsDefaults = Object.create(null)), Va(e, t, r, o));
    for (const i in e.propsOptions[0]) i in r || (r[i] = void 0);
    (ja(t || {}, r, e),
      n ? (e.props = s ? r : sh(r)) : e.type.props ? (e.props = r) : (e.props = o),
      (e.attrs = o));
  }
  function um(e) {
    for (; e; ) {
      if (e.type.__hmrId) return !0;
      e = e.parent;
    }
  }
  function cm(e, t, n, s) {
    const {
        props: r,
        attrs: o,
        vnode: { patchFlag: i }
      } = e,
      l = se(r),
      [a] = e.propsOptions;
    let f = !1;
    if (!um(e) && (s || i > 0) && !(i & 16)) {
      if (i & 8) {
        const u = e.vnode.dynamicProps;
        for (let c = 0; c < u.length; c++) {
          let d = u[c];
          if (Tr(e.emitsOptions, d)) continue;
          const p = t[d];
          if (a)
            if (de(o, d)) p !== o[d] && ((o[d] = p), (f = !0));
            else {
              const h = He(d);
              r[h] = Uo(a, l, h, p, e, !1);
            }
          else p !== o[d] && ((o[d] = p), (f = !0));
        }
      }
    } else {
      Va(e, t, r, o) && (f = !0);
      let u;
      for (const c in l)
        (!t || (!de(t, c) && ((u = zt(c)) === c || !de(t, u)))) &&
          (a
            ? n && (n[c] !== void 0 || n[u] !== void 0) && (r[c] = Uo(a, l, c, void 0, e, !0))
            : delete r[c]);
      if (o !== l) for (const c in o) (!t || !de(t, c)) && (delete o[c], (f = !0));
    }
    (f && vt(e.attrs, 'set', ''), ja(t || {}, r, e));
  }
  function Va(e, t, n, s) {
    const [r, o] = e.propsOptions;
    let i = !1,
      l;
    if (t)
      for (let a in t) {
        if (ds(a)) continue;
        const f = t[a];
        let u;
        r && de(r, (u = He(a)))
          ? !o || !o.includes(u)
            ? (n[u] = f)
            : ((l || (l = {}))[u] = f)
          : Tr(e.emitsOptions, a) || ((!(a in s) || f !== s[a]) && ((s[a] = f), (i = !0)));
      }
    if (o) {
      const a = se(n),
        f = l || ge;
      for (let u = 0; u < o.length; u++) {
        const c = o[u];
        n[c] = Uo(r, a, c, f[c], e, !de(f, c));
      }
    }
    return i;
  }
  function Uo(e, t, n, s, r, o) {
    const i = e[n];
    if (i != null) {
      const l = de(i, 'default');
      if (l && s === void 0) {
        const a = i.default;
        if (i.type !== Function && !i.skipFactory && ee(a)) {
          const { propsDefaults: f } = r;
          if (n in f) s = f[n];
          else {
            const u = Is(r);
            ((s = f[n] = a.call(null, t)), u());
          }
        } else s = a;
        r.ce && r.ce._setProp(n, s);
      }
      i[0] && (o && !l ? (s = !1) : i[1] && (s === '' || s === zt(n)) && (s = !0));
    }
    return s;
  }
  const fm = new WeakMap();
  function La(e, t, n = !1) {
    const s = n ? fm : t.propsCache,
      r = s.get(e);
    if (r) return r;
    const o = e.props,
      i = {},
      l = [];
    let a = !1;
    if (!ee(e)) {
      const u = (c) => {
        a = !0;
        const [d, p] = La(c, t, !0);
        (ke(i, d), p && l.push(...p));
      };
      (!n && t.mixins.length && t.mixins.forEach(u),
        e.extends && u(e.extends),
        e.mixins && e.mixins.forEach(u));
    }
    if (!o && !a) return (pe(e) && s.set(e, Dn), Dn);
    if (J(o))
      for (let u = 0; u < o.length; u++) {
        we(o[u]) || R('props must be strings when using array syntax.', o[u]);
        const c = He(o[u]);
        Ua(c) && (i[c] = ge);
      }
    else if (o) {
      pe(o) || R('invalid props options', o);
      for (const u in o) {
        const c = He(u);
        if (Ua(c)) {
          const d = o[u],
            p = (i[c] = J(d) || ee(d) ? { type: d } : ke({}, d)),
            h = p.type;
          let q = !1,
            v = !0;
          if (J(h))
            for (let b = 0; b < h.length; ++b) {
              const $ = h[b],
                C = ee($) && $.name;
              if (C === 'Boolean') {
                q = !0;
                break;
              } else C === 'String' && (v = !1);
            }
          else q = ee(h) && h.name === 'Boolean';
          ((p[0] = q), (p[1] = v), (q || de(p, 'default')) && l.push(c));
        }
      }
    }
    const f = [i, l];
    return (pe(e) && s.set(e, f), f);
  }
  function Ua(e) {
    return e[0] !== '$' && !ds(e)
      ? !0
      : (R(`Invalid prop name: "${e}" is a reserved property.`), !1);
  }
  function dm(e) {
    return e === null
      ? 'null'
      : typeof e == 'function'
        ? e.name || ''
        : (typeof e == 'object' && e.constructor && e.constructor.name) || '';
  }
  function ja(e, t, n) {
    const s = se(t),
      r = n.propsOptions[0],
      o = Object.keys(e).map((i) => He(i));
    for (const i in r) {
      let l = r[i];
      l != null && pm(i, s[i], l, bt(s), !o.includes(i));
    }
  }
  function pm(e, t, n, s, r) {
    const { type: o, required: i, validator: l, skipCheck: a } = n;
    if (i && r) {
      R('Missing required prop: "' + e + '"');
      return;
    }
    if (!(t == null && !i)) {
      if (o != null && o !== !0 && !a) {
        let f = !1;
        const u = J(o) ? o : [o],
          c = [];
        for (let d = 0; d < u.length && !f; d++) {
          const { valid: p, expectedType: h } = mm(t, u[d]);
          (c.push(h || ''), (f = p));
        }
        if (!f) {
          R(gm(e, t, c));
          return;
        }
      }
      l && !l(t, s) && R('Invalid prop: custom validator check failed for prop "' + e + '".');
    }
  }
  const hm = Dt('String,Number,Boolean,Function,Symbol,BigInt');
  function mm(e, t) {
    let n;
    const s = dm(t);
    if (s === 'null') n = e === null;
    else if (hm(s)) {
      const r = typeof e;
      ((n = r === s.toLowerCase()), !n && r === 'object' && (n = e instanceof t));
    } else s === 'Object' ? (n = pe(e)) : s === 'Array' ? (n = J(e)) : (n = e instanceof t);
    return { valid: n, expectedType: s };
  }
  function gm(e, t, n) {
    if (n.length === 0)
      return `Prop type [] for prop "${e}" won't match anything. Did you mean to use type Array instead?`;
    let s = `Invalid prop: type check failed for prop "${e}". Expected ${n.map(fn).join(' | ')}`;
    const r = n[0],
      o = po(t),
      i = Ha(t, r),
      l = Ha(t, o);
    return (
      n.length === 1 && Qa(r) && !_m(r, o) && (s += ` with value ${i}`),
      (s += `, got ${o} `),
      Qa(o) && (s += `with value ${l}.`),
      s
    );
  }
  function Ha(e, t) {
    return t === 'String' ? `"${e}"` : t === 'Number' ? `${Number(e)}` : `${e}`;
  }
  function Qa(e) {
    return ['string', 'number', 'boolean'].some((n) => e.toLowerCase() === n);
  }
  function _m(...e) {
    return e.some((t) => t.toLowerCase() === 'boolean');
  }
  const Ka = (e) => e[0] === '_' || e === '$stable',
    jo = (e) => (J(e) ? e.map(mt) : [mt(e)]),
    qm = (e, t, n) => {
      if (t._n) return t;
      const s = Et(
        (...r) => (
          Jt.NODE_ENV !== 'production' &&
            Re &&
            (!n || n.root === Re.root) &&
            R(
              `Slot "${e}" invoked outside of the render function: this will not track dependencies used in the slot. Invoke the slot function inside the render function instead.`
            ),
          jo(t(...r))
        ),
        n
      );
      return ((s._c = !1), s);
    },
    Wa = (e, t, n) => {
      const s = e._ctx;
      for (const r in e) {
        if (Ka(r)) continue;
        const o = e[r];
        if (ee(o)) t[r] = qm(r, o, s);
        else if (o != null) {
          R(
            `Non-function value encountered for slot "${r}". Prefer function slots for better performance.`
          );
          const i = jo(o);
          t[r] = () => i;
        }
      }
    },
    Ga = (e, t) => {
      Es(e.vnode) ||
        R(
          'Non-function value encountered for default slot. Prefer function slots for better performance.'
        );
      const n = jo(t);
      e.slots.default = () => n;
    },
    Ho = (e, t, n) => {
      for (const s in t) (n || s !== '_') && (e[s] = t[s]);
    },
    vm = (e, t, n) => {
      const s = (e.slots = Ma());
      if (e.vnode.shapeFlag & 32) {
        const r = t._;
        r ? (Ho(s, t, n), n && ir(s, '_', r, !0)) : Wa(t, s);
      } else t && Ga(e, t);
    },
    bm = (e, t, n) => {
      const { vnode: s, slots: r } = e;
      let o = !0,
        i = ge;
      if (s.shapeFlag & 32) {
        const l = t._;
        (l
          ? wt
            ? (Ho(r, t, n), vt(e, 'set', '$slots'))
            : n && l === 1
              ? (o = !1)
              : Ho(r, t, n)
          : ((o = !t.$stable), Wa(t, r)),
          (i = t));
      } else t && (Ga(e, t), (i = { default: 1 }));
      if (o) for (const l in r) !Ka(l) && i[l] == null && delete r[l];
    };
  let As, Xt;
  function jn(e, t) {
    (e.appContext.config.performance && Ar() && Xt.mark(`vue-${t}-${e.uid}`),
      Oh(e, t, Ar() ? Xt.now() : Date.now()));
  }
  function Hn(e, t) {
    if (e.appContext.config.performance && Ar()) {
      const n = `vue-${t}-${e.uid}`,
        s = n + ':end';
      (Xt.mark(s), Xt.measure(`<${$r(e, e.type)}> ${t}`, n, s), Xt.clearMarks(n), Xt.clearMarks(s));
    }
    Bh(e, t, Ar() ? Xt.now() : Date.now());
  }
  function Ar() {
    return (
      As !== void 0 ||
        (typeof window < 'u' && window.performance
          ? ((As = !0), (Xt = window.performance))
          : (As = !1)),
      As
    );
  }
  function ym() {
    const e = [];
    if (e.length) {
      const t = e.length > 1;
      console.warn(`Feature flag${t ? 's' : ''} ${e.join(', ')} ${t ? 'are' : 'is'} not explicitly defined. You are running the esm-bundler build of Vue, which expects these compile-time feature flags to be globally injected via the bundler config in order to get better tree-shaking in the production bundle.

For more details, see https://link.vuejs.org/feature-flags.`);
    }
  }
  const st = $m;
  function xm(e) {
    return wm(e);
  }
  function wm(e, t) {
    ym();
    const n = ps();
    ((n.__VUE__ = !0), ca(n.__VUE_DEVTOOLS_GLOBAL_HOOK__, n));
    const {
        insert: s,
        remove: r,
        patchProp: o,
        createElement: i,
        createText: l,
        createComment: a,
        setText: f,
        setElementText: u,
        parentNode: c,
        nextSibling: d,
        setScopeId: p = Ve,
        insertStaticContent: h
      } = e,
      q = (
        m,
        g,
        w,
        O = null,
        k = null,
        A = null,
        N = void 0,
        z = null,
        F = wt ? !1 : !!g.dynamicChildren
      ) => {
        if (m === g) return;
        (m && !En(m, g) && ((O = Zr(m)), ze(m, k, A, !0), (m = null)),
          g.patchFlag === -2 && ((F = !1), (g.dynamicChildren = null)));
        const { type: B, ref: ne, shapeFlag: L } = g;
        switch (B) {
          case Qn:
            v(m, g, w, O);
            break;
          case Ie:
            b(m, g, w, O);
            break;
          case Ts:
            m == null ? $(g, w, O, N) : C(m, g, w, N);
            break;
          case Ae:
            Q(m, g, w, O, k, A, N, z, F);
            break;
          default:
            L & 1
              ? te(m, g, w, O, k, A, N, z, F)
              : L & 6
                ? Y(m, g, w, O, k, A, N, z, F)
                : L & 64 || L & 128
                  ? B.process(m, g, w, O, k, A, N, z, F, Hs)
                  : R('Invalid VNode type:', B, `(${typeof B})`);
        }
        ne != null && k && Sr(ne, m && m.ref, A, g || m, !g);
      },
      v = (m, g, w, O) => {
        if (m == null) s((g.el = l(g.children)), w, O);
        else {
          const k = (g.el = m.el);
          g.children !== m.children && f(k, g.children);
        }
      },
      b = (m, g, w, O) => {
        m == null ? s((g.el = a(g.children || '')), w, O) : (g.el = m.el);
      },
      $ = (m, g, w, O) => {
        [m.el, m.anchor] = h(m.children, g, w, O, m.el, m.anchor);
      },
      C = (m, g, w, O) => {
        if (g.children !== m.children) {
          const k = d(m.anchor);
          (D(m), ([g.el, g.anchor] = h(g.children, w, k, O)));
        } else ((g.el = m.el), (g.anchor = m.anchor));
      },
      G = ({ el: m, anchor: g }, w, O) => {
        let k;
        for (; m && m !== g; ) ((k = d(m)), s(m, w, O), (m = k));
        s(g, w, O);
      },
      D = ({ el: m, anchor: g }) => {
        let w;
        for (; m && m !== g; ) ((w = d(m)), r(m), (m = w));
        r(g);
      },
      te = (m, g, w, O, k, A, N, z, F) => {
        (g.type === 'svg' ? (N = 'svg') : g.type === 'math' && (N = 'mathml'),
          m == null ? V(g, w, O, k, A, N, z, F) : I(m, g, k, A, N, z, F));
      },
      V = (m, g, w, O, k, A, N, z) => {
        let F, B;
        const { props: ne, shapeFlag: L, transition: X, dirs: oe } = m;
        if (
          ((F = m.el = i(m.type, A, ne && ne.is, ne)),
          L & 8 ? u(F, m.children) : L & 16 && K(m.children, F, null, O, k, Qo(m, A), N, z),
          oe && _n(m, null, O, 'created'),
          ce(F, m, m.scopeId, N, O),
          ne)
        ) {
          for (const ye in ne) ye !== 'value' && !ds(ye) && o(F, ye, null, ne[ye], A, O);
          ('value' in ne && o(F, 'value', null, ne.value, A),
            (B = ne.onVnodeBeforeMount) && Ct(B, O, m));
        }
        (ir(F, '__vnode', m, !0),
          ir(F, '__vueParentComponent', O, !0),
          oe && _n(m, null, O, 'beforeMount'));
        const fe = Sm(k, X);
        (fe && X.beforeEnter(F),
          s(F, g, w),
          ((B = ne && ne.onVnodeMounted) || fe || oe) &&
            st(() => {
              (B && Ct(B, O, m), fe && X.enter(F), oe && _n(m, null, O, 'mounted'));
            }, k));
      },
      ce = (m, g, w, O, k) => {
        if ((w && p(m, w), O)) for (let A = 0; A < O.length; A++) p(m, O[A]);
        if (k) {
          let A = k.subTree;
          if (
            (A.patchFlag > 0 && A.patchFlag & 2048 && (A = Go(A.children) || A),
            g === A || (ou(A.type) && (A.ssContent === g || A.ssFallback === g)))
          ) {
            const N = k.vnode;
            ce(m, N, N.scopeId, N.slotScopeIds, k.parent);
          }
        }
      },
      K = (m, g, w, O, k, A, N, z, F = 0) => {
        for (let B = F; B < m.length; B++) {
          const ne = (m[B] = z ? en(m[B]) : mt(m[B]));
          q(null, ne, g, w, O, k, A, N, z);
        }
      },
      I = (m, g, w, O, k, A, N) => {
        const z = (g.el = m.el);
        z.__vnode = g;
        let { patchFlag: F, dynamicChildren: B, dirs: ne } = g;
        F |= m.patchFlag & 16;
        const L = m.props || ge,
          X = g.props || ge;
        let oe;
        if (
          (w && xn(w, !1),
          (oe = X.onVnodeBeforeUpdate) && Ct(oe, w, g, m),
          ne && _n(g, m, w, 'beforeUpdate'),
          w && xn(w, !0),
          wt && ((F = 0), (N = !1), (B = null)),
          ((L.innerHTML && X.innerHTML == null) || (L.textContent && X.textContent == null)) &&
            u(z, ''),
          B
            ? (T(m.dynamicChildren, B, z, w, O, Qo(g, k), A), Ko(m, g))
            : N || ue(m, g, z, null, w, O, Qo(g, k), A, !1),
          F > 0)
        ) {
          if (F & 16) x(z, L, X, w, k);
          else if (
            (F & 2 && L.class !== X.class && o(z, 'class', null, X.class, k),
            F & 4 && o(z, 'style', L.style, X.style, k),
            F & 8)
          ) {
            const fe = g.dynamicProps;
            for (let ye = 0; ye < fe.length; ye++) {
              const qe = fe[ye],
                it = L[qe],
                tt = X[qe];
              (tt !== it || qe === 'value') && o(z, qe, it, tt, k, w);
            }
          }
          F & 1 && m.children !== g.children && u(z, g.children);
        } else !N && B == null && x(z, L, X, w, k);
        ((oe = X.onVnodeUpdated) || ne) &&
          st(() => {
            (oe && Ct(oe, w, g, m), ne && _n(g, m, w, 'updated'));
          }, O);
      },
      T = (m, g, w, O, k, A, N) => {
        for (let z = 0; z < g.length; z++) {
          const F = m[z],
            B = g[z],
            ne = F.el && (F.type === Ae || !En(F, B) || F.shapeFlag & 70) ? c(F.el) : w;
          q(F, B, ne, null, O, k, A, N, !0);
        }
      },
      x = (m, g, w, O, k) => {
        if (g !== w) {
          if (g !== ge) for (const A in g) !ds(A) && !(A in w) && o(m, A, g[A], null, k, O);
          for (const A in w) {
            if (ds(A)) continue;
            const N = w[A],
              z = g[A];
            N !== z && A !== 'value' && o(m, A, z, N, k, O);
          }
          'value' in w && o(m, 'value', g.value, w.value, k);
        }
      },
      Q = (m, g, w, O, k, A, N, z, F) => {
        const B = (g.el = m ? m.el : l('')),
          ne = (g.anchor = m ? m.anchor : l(''));
        let { patchFlag: L, dynamicChildren: X, slotScopeIds: oe } = g;
        ((wt || L & 2048) && ((L = 0), (F = !1), (X = null)),
          oe && (z = z ? z.concat(oe) : oe),
          m == null
            ? (s(B, w, O), s(ne, w, O), K(g.children || [], w, ne, k, A, N, z, F))
            : L > 0 && L & 64 && X && m.dynamicChildren
              ? (T(m.dynamicChildren, X, w, k, A, N, z), Ko(m, g))
              : ue(m, g, w, ne, k, A, N, z, F));
      },
      Y = (m, g, w, O, k, A, N, z, F) => {
        ((g.slotScopeIds = z),
          m == null
            ? g.shapeFlag & 512
              ? k.ctx.activate(g, w, O, N, F)
              : me(g, w, O, k, A, N, F)
            : ae(m, g, F));
      },
      me = (m, g, w, O, k, A, N) => {
        const z = (m.component = Um(m, O, k));
        if (
          (z.type.__hmrId && yh(z),
          gr(m),
          jn(z, 'mount'),
          Es(m) && (z.ctx.renderer = Hs),
          jn(z, 'init'),
          Hm(z, !1, N),
          Hn(z, 'init'),
          z.asyncDep)
        ) {
          if ((wt && (m.el = null), k && k.registerDep(z, j, N), !m.el)) {
            const F = (z.subTree = S(Ie));
            b(null, F, g, w);
          }
        } else j(z, m, g, w, k, A, N);
        (_r(), Hn(z, 'mount'));
      },
      ae = (m, g, w) => {
        const O = (g.component = m.component);
        if (Rm(m, g, w))
          if (O.asyncDep && !O.asyncResolved) {
            (gr(g), Z(O, g, w), _r());
            return;
          } else ((O.next = g), O.update());
        else ((g.el = m.el), (O.vnode = g));
      },
      j = (m, g, w, O, k, A, N) => {
        const z = () => {
          if (m.isMounted) {
            let { next: L, bu: X, u: oe, parent: fe, vnode: ye } = m;
            {
              const Pt = Ja(m);
              if (Pt) {
                (L && ((L.el = ye.el), Z(m, L, N)),
                  Pt.asyncDep.then(() => {
                    m.isUnmounted || z();
                  }));
                return;
              }
            }
            let qe = L,
              it;
            (gr(L || m.vnode),
              xn(m, !1),
              L ? ((L.el = ye.el), Z(m, L, N)) : (L = ye),
              X && Fn(X),
              (it = L.props && L.props.onVnodeBeforeUpdate) && Ct(it, fe, L, ye),
              xn(m, !0),
              jn(m, 'render'));
            const tt = tu(m);
            Hn(m, 'render');
            const Rt = m.subTree;
            ((m.subTree = tt),
              jn(m, 'patch'),
              q(Rt, tt, c(Rt.el), Zr(Rt), m, k, A),
              Hn(m, 'patch'),
              (L.el = tt.el),
              qe === null && Pm(m, tt.el),
              oe && st(oe, k),
              (it = L.props && L.props.onVnodeUpdated) && st(() => Ct(it, fe, L, ye), k),
              fa(m),
              _r());
          } else {
            let L;
            const { el: X, props: oe } = g,
              { bm: fe, m: ye, parent: qe, root: it, type: tt } = m,
              Rt = Un(g);
            (xn(m, !1),
              fe && Fn(fe),
              !Rt && (L = oe && oe.onVnodeBeforeMount) && Ct(L, qe, g),
              xn(m, !0));
            {
              (it.ce && it.ce._injectChildStyle(tt), jn(m, 'render'));
              const Pt = (m.subTree = tu(m));
              (Hn(m, 'render'),
                jn(m, 'patch'),
                q(null, Pt, w, O, m, k, A),
                Hn(m, 'patch'),
                (g.el = Pt.el));
            }
            if ((ye && st(ye, k), !Rt && (L = oe && oe.onVnodeMounted))) {
              const Pt = g;
              st(() => Ct(L, qe, Pt), k);
            }
            ((g.shapeFlag & 256 || (qe && Un(qe.vnode) && qe.vnode.shapeFlag & 256)) &&
              m.a &&
              st(m.a, k),
              (m.isMounted = !0),
              Ch(m),
              (g = w = O = null));
          }
        };
        m.scope.on();
        const F = (m.effect = new Il(z));
        m.scope.off();
        const B = (m.update = F.run.bind(F)),
          ne = (m.job = F.runIfDirty.bind(F));
        ((ne.i = m),
          (ne.id = m.uid),
          (F.scheduler = () => vr(ne)),
          xn(m, !0),
          (F.onTrack = m.rtc ? (L) => Fn(m.rtc, L) : void 0),
          (F.onTrigger = m.rtg ? (L) => Fn(m.rtg, L) : void 0),
          B());
      },
      Z = (m, g, w) => {
        g.component = m;
        const O = m.vnode.props;
        ((m.vnode = g),
          (m.next = null),
          cm(m, g.props, O, w),
          bm(m, g.children, w),
          Mt(),
          oa(m),
          Nt());
      },
      ue = (m, g, w, O, k, A, N, z, F = !1) => {
        const B = m && m.children,
          ne = m ? m.shapeFlag : 0,
          L = g.children,
          { patchFlag: X, shapeFlag: oe } = g;
        if (X > 0) {
          if (X & 128) {
            Ce(B, L, w, O, k, A, N, z, F);
            return;
          } else if (X & 256) {
            ft(B, L, w, O, k, A, N, z, F);
            return;
          }
        }
        oe & 8
          ? (ne & 16 && js(B, k, A), L !== B && u(w, L))
          : ne & 16
            ? oe & 16
              ? Ce(B, L, w, O, k, A, N, z, F)
              : js(B, k, A, !0)
            : (ne & 8 && u(w, ''), oe & 16 && K(L, w, O, k, A, N, z, F));
      },
      ft = (m, g, w, O, k, A, N, z, F) => {
        ((m = m || Dn), (g = g || Dn));
        const B = m.length,
          ne = g.length,
          L = Math.min(B, ne);
        let X;
        for (X = 0; X < L; X++) {
          const oe = (g[X] = F ? en(g[X]) : mt(g[X]));
          q(m[X], oe, w, null, k, A, N, z, F);
        }
        B > ne ? js(m, k, A, !0, !1, L) : K(g, w, O, k, A, N, z, F, L);
      },
      Ce = (m, g, w, O, k, A, N, z, F) => {
        let B = 0;
        const ne = g.length;
        let L = m.length - 1,
          X = ne - 1;
        for (; B <= L && B <= X; ) {
          const oe = m[B],
            fe = (g[B] = F ? en(g[B]) : mt(g[B]));
          if (En(oe, fe)) q(oe, fe, w, null, k, A, N, z, F);
          else break;
          B++;
        }
        for (; B <= L && B <= X; ) {
          const oe = m[L],
            fe = (g[X] = F ? en(g[X]) : mt(g[X]));
          if (En(oe, fe)) q(oe, fe, w, null, k, A, N, z, F);
          else break;
          (L--, X--);
        }
        if (B > L) {
          if (B <= X) {
            const oe = X + 1,
              fe = oe < ne ? g[oe].el : O;
            for (; B <= X; ) (q(null, (g[B] = F ? en(g[B]) : mt(g[B])), w, fe, k, A, N, z, F), B++);
          }
        } else if (B > X) for (; B <= L; ) (ze(m[B], k, A, !0), B++);
        else {
          const oe = B,
            fe = B,
            ye = new Map();
          for (B = fe; B <= X; B++) {
            const Ze = (g[B] = F ? en(g[B]) : mt(g[B]));
            Ze.key != null &&
              (ye.has(Ze.key) &&
                R(
                  'Duplicate keys found during update:',
                  JSON.stringify(Ze.key),
                  'Make sure keys are unique.'
                ),
              ye.set(Ze.key, B));
          }
          let qe,
            it = 0;
          const tt = X - fe + 1;
          let Rt = !1,
            Pt = 0;
          const Qs = new Array(tt);
          for (B = 0; B < tt; B++) Qs[B] = 0;
          for (B = oe; B <= L; B++) {
            const Ze = m[B];
            if (it >= tt) {
              ze(Ze, k, A, !0);
              continue;
            }
            let $t;
            if (Ze.key != null) $t = ye.get(Ze.key);
            else
              for (qe = fe; qe <= X; qe++)
                if (Qs[qe - fe] === 0 && En(Ze, g[qe])) {
                  $t = qe;
                  break;
                }
            $t === void 0
              ? ze(Ze, k, A, !0)
              : ((Qs[$t - fe] = B + 1),
                $t >= Pt ? (Pt = $t) : (Rt = !0),
                q(Ze, g[$t], w, null, k, A, N, z, F),
                it++);
          }
          const Gf = Rt ? Em(Qs) : Dn;
          for (qe = Gf.length - 1, B = tt - 1; B >= 0; B--) {
            const Ze = fe + B,
              $t = g[Ze],
              Jf = Ze + 1 < ne ? g[Ze + 1].el : O;
            Qs[B] === 0
              ? q(null, $t, w, Jf, k, A, N, z, F)
              : Rt && (qe < 0 || B !== Gf[qe] ? Ee($t, w, Jf, 2) : qe--);
          }
        }
      },
      Ee = (m, g, w, O, k = null) => {
        const { el: A, type: N, transition: z, children: F, shapeFlag: B } = m;
        if (B & 6) {
          Ee(m.component.subTree, g, w, O);
          return;
        }
        if (B & 128) {
          m.suspense.move(g, w, O);
          return;
        }
        if (B & 64) {
          N.move(m, g, w, Hs);
          return;
        }
        if (N === Ae) {
          s(A, g, w);
          for (let L = 0; L < F.length; L++) Ee(F[L], g, w, O);
          s(m.anchor, g, w);
          return;
        }
        if (N === Ts) {
          G(m, g, w);
          return;
        }
        if (O !== 2 && B & 1 && z)
          if (O === 0) (z.beforeEnter(A), s(A, g, w), st(() => z.enter(A), k));
          else {
            const { leave: L, delayLeave: X, afterLeave: oe } = z,
              fe = () => s(A, g, w),
              ye = () => {
                L(A, () => {
                  (fe(), oe && oe());
                });
              };
            X ? X(A, fe, ye) : ye();
          }
        else s(A, g, w);
      },
      ze = (m, g, w, O = !1, k = !1) => {
        const {
          type: A,
          props: N,
          ref: z,
          children: F,
          dynamicChildren: B,
          shapeFlag: ne,
          patchFlag: L,
          dirs: X,
          cacheIndex: oe
        } = m;
        if (
          (L === -2 && (k = !1),
          z != null && Sr(z, null, w, m, !0),
          oe != null && (g.renderCache[oe] = void 0),
          ne & 256)
        ) {
          g.ctx.deactivate(m);
          return;
        }
        const fe = ne & 1 && X,
          ye = !Un(m);
        let qe;
        if ((ye && (qe = N && N.onVnodeBeforeUnmount) && Ct(qe, g, m), ne & 6))
          ny(m.component, w, O);
        else {
          if (ne & 128) {
            m.suspense.unmount(w, O);
            return;
          }
          (fe && _n(m, null, g, 'beforeUnmount'),
            ne & 64
              ? m.type.remove(m, g, w, Hs, O)
              : B && !B.hasOnce && (A !== Ae || (L > 0 && L & 64))
                ? js(B, g, w, !1, !0)
                : ((A === Ae && L & 384) || (!k && ne & 16)) && js(F, g, w),
            O && _t(m));
        }
        ((ye && (qe = N && N.onVnodeUnmounted)) || fe) &&
          st(() => {
            (qe && Ct(qe, g, m), fe && _n(m, null, g, 'unmounted'));
          }, w);
      },
      _t = (m) => {
        const { type: g, el: w, anchor: O, transition: k } = m;
        if (g === Ae) {
          m.patchFlag > 0 && m.patchFlag & 2048 && k && !k.persisted
            ? m.children.forEach((N) => {
                N.type === Ie ? r(N.el) : _t(N);
              })
            : on(w, O);
          return;
        }
        if (g === Ts) {
          D(m);
          return;
        }
        const A = () => {
          (r(w), k && !k.persisted && k.afterLeave && k.afterLeave());
        };
        if (m.shapeFlag & 1 && k && !k.persisted) {
          const { leave: N, delayLeave: z } = k,
            F = () => N(w, A);
          z ? z(m.el, A, F) : F();
        } else A();
      },
      on = (m, g) => {
        let w;
        for (; m !== g; ) ((w = d(m)), r(m), (m = w));
        r(g);
      },
      ny = (m, g, w) => {
        m.type.__hmrId && xh(m);
        const { bum: O, scope: k, job: A, subTree: N, um: z, m: F, a: B } = m;
        (Ya(F),
          Ya(B),
          O && Fn(O),
          k.stop(),
          A && ((A.flags |= 8), ze(N, m, g, w)),
          z && st(z, g),
          st(() => {
            m.isUnmounted = !0;
          }, g),
          g &&
            g.pendingBranch &&
            !g.isUnmounted &&
            m.asyncDep &&
            !m.asyncResolved &&
            m.suspenseId === g.pendingId &&
            (g.deps--, g.deps === 0 && g.resolve()),
          Th(m));
      },
      js = (m, g, w, O = !1, k = !1, A = 0) => {
        for (let N = A; N < m.length; N++) ze(m[N], g, w, O, k);
      },
      Zr = (m) => {
        if (m.shapeFlag & 6) return Zr(m.component.subTree);
        if (m.shapeFlag & 128) return m.suspense.next();
        const g = d(m.anchor || m.el),
          w = g && g[Rh];
        return w ? d(w) : g;
      };
    let Fi = !1;
    const Wf = (m, g, w) => {
        (m == null
          ? g._vnode && ze(g._vnode, null, null, !0)
          : q(g._vnode || null, m, g, null, null, null, w),
          (g._vnode = m),
          Fi || ((Fi = !0), oa(), ia(), (Fi = !1)));
      },
      Hs = { p: q, um: ze, m: Ee, r: _t, mt: me, mc: K, pc: ue, pbc: T, n: Zr, o: e };
    return { render: Wf, hydrate: void 0, createApp: om(Wf) };
  }
  function Qo({ type: e, props: t }, n) {
    return (n === 'svg' && e === 'foreignObject') ||
      (n === 'mathml' && e === 'annotation-xml' && t && t.encoding && t.encoding.includes('html'))
      ? void 0
      : n;
  }
  function xn({ effect: e, job: t }, n) {
    n ? ((e.flags |= 32), (t.flags |= 4)) : ((e.flags &= -33), (t.flags &= -5));
  }
  function Sm(e, t) {
    return (!e || (e && !e.pendingBranch)) && t && !t.persisted;
  }
  function Ko(e, t, n = !1) {
    const s = e.children,
      r = t.children;
    if (J(s) && J(r))
      for (let o = 0; o < s.length; o++) {
        const i = s[o];
        let l = r[o];
        (l.shapeFlag & 1 &&
          !l.dynamicChildren &&
          ((l.patchFlag <= 0 || l.patchFlag === 32) && ((l = r[o] = en(r[o])), (l.el = i.el)),
          !n && l.patchFlag !== -2 && Ko(i, l)),
          l.type === Qn && (l.el = i.el),
          l.type === Ie && !l.el && (l.el = i.el));
      }
  }
  function Em(e) {
    const t = e.slice(),
      n = [0];
    let s, r, o, i, l;
    const a = e.length;
    for (s = 0; s < a; s++) {
      const f = e[s];
      if (f !== 0) {
        if (((r = n[n.length - 1]), e[r] < f)) {
          ((t[s] = r), n.push(s));
          continue;
        }
        for (o = 0, i = n.length - 1; o < i; )
          ((l = (o + i) >> 1), e[n[l]] < f ? (o = l + 1) : (i = l));
        f < e[n[o]] && (o > 0 && (t[s] = n[o - 1]), (n[o] = s));
      }
    }
    for (o = n.length, i = n[o - 1]; o-- > 0; ) ((n[o] = i), (i = t[i]));
    return n;
  }
  function Ja(e) {
    const t = e.subTree.component;
    if (t) return t.asyncDep && !t.asyncResolved ? t : Ja(t);
  }
  function Ya(e) {
    if (e) for (let t = 0; t < e.length; t++) e[t].flags |= 8;
  }
  const km = Symbol.for('v-scx'),
    Cm = () => {
      {
        const e = Cs(km);
        return (
          e ||
            R(
              'Server rendering context not provided. Make sure to only call useSSRContext() conditionally in the server build.'
            ),
          e
        );
      }
    };
  function Se(e, t, n) {
    return (
      ee(t) ||
        R(
          '`watch(fn, options?)` signature has been moved to a separate API. Use `watchEffect(fn, options?)` instead. `watch` now only supports `watch(source, cb, options?) signature.'
        ),
      Za(e, t, n)
    );
  }
  function Za(e, t, n = ge) {
    const { immediate: s, deep: r, flush: o, once: i } = n;
    t ||
      (s !== void 0 &&
        R(
          'watch() "immediate" option is only respected when using the watch(source, callback, options?) signature.'
        ),
      r !== void 0 &&
        R(
          'watch() "deep" option is only respected when using the watch(source, callback, options?) signature.'
        ),
      i !== void 0 &&
        R(
          'watch() "once" option is only respected when using the watch(source, callback, options?) signature.'
        ));
    const l = ke({}, n);
    l.onWarn = R;
    const a = (t && s) || (!t && o !== 'post');
    let f;
    if (Rs) {
      if (o === 'sync') {
        const p = Cm();
        f = p.__watcherHandles || (p.__watcherHandles = []);
      } else if (!a) {
        const p = () => {};
        return ((p.stop = Ve), (p.resume = Ve), (p.pause = Ve), p);
      }
    }
    const u = Re;
    l.call = (p, h, q) => ht(p, u, h, q);
    let c = !1;
    (o === 'post'
      ? (l.scheduler = (p) => {
          st(p, u && u.suspense);
        })
      : o !== 'sync' &&
        ((c = !0),
        (l.scheduler = (p, h) => {
          h ? p() : vr(p);
        })),
      (l.augmentJob = (p) => {
        (t && (p.flags |= 4), c && ((p.flags |= 2), u && ((p.id = u.uid), (p.i = u))));
      }));
    const d = dh(e, t, l);
    return (Rs && (f ? f.push(d) : a && d()), d);
  }
  function Am(e, t, n) {
    const s = this.proxy,
      r = we(e) ? (e.includes('.') ? Xa(s, e) : () => s[e]) : e.bind(s, s);
    let o;
    ee(t) ? (o = t) : ((o = t.handler), (n = t));
    const i = Is(this),
      l = Za(r, o.bind(s), n);
    return (i(), l);
  }
  function Xa(e, t) {
    const n = t.split('.');
    return () => {
      let s = e;
      for (let r = 0; r < n.length && s; r++) s = s[n[r]];
      return s;
    };
  }
  const Tm = (e, t) =>
    t === 'modelValue' || t === 'model-value'
      ? e.modelModifiers
      : e[`${t}Modifiers`] || e[`${He(t)}Modifiers`] || e[`${zt(t)}Modifiers`];
  function Om(e, t, ...n) {
    if (e.isUnmounted) return;
    const s = e.vnode.props || ge;
    {
      const {
        emitsOptions: u,
        propsOptions: [c]
      } = e;
      if (u)
        if (!(t in u))
          (!c || !(dn(He(t)) in c)) &&
            R(
              `Component emitted event "${t}" but it is neither declared in the emits option nor as an "${dn(He(t))}" prop.`
            );
        else {
          const d = u[t];
          ee(d) &&
            (d(...n) || R(`Invalid event arguments: event validation failed for event "${t}".`));
        }
    }
    let r = n;
    const o = t.startsWith('update:'),
      i = o && Tm(s, t.slice(7));
    (i && (i.trim && (r = n.map((u) => (we(u) ? u.trim() : u))), i.number && (r = n.map(mo))),
      Ih(e, t, r));
    {
      const u = t.toLowerCase();
      u !== t &&
        s[dn(u)] &&
        R(
          `Event "${u}" is emitted in component ${$r(e, e.type)} but the handler is registered for "${t}". Note that HTML attributes are case-insensitive and you cannot use v-on to listen to camelCase events when using in-DOM templates. You should probably use "${zt(t)}" instead of "${t}".`
        );
    }
    let l,
      a = s[(l = dn(t))] || s[(l = dn(He(t)))];
    (!a && o && (a = s[(l = dn(zt(t)))]), a && ht(a, e, 6, r));
    const f = s[l + 'Once'];
    if (f) {
      if (!e.emitted) e.emitted = {};
      else if (e.emitted[l]) return;
      ((e.emitted[l] = !0), ht(f, e, 6, r));
    }
  }
  function eu(e, t, n = !1) {
    const s = t.emitsCache,
      r = s.get(e);
    if (r !== void 0) return r;
    const o = e.emits;
    let i = {},
      l = !1;
    if (!ee(e)) {
      const a = (f) => {
        const u = eu(f, t, !0);
        u && ((l = !0), ke(i, u));
      };
      (!n && t.mixins.length && t.mixins.forEach(a),
        e.extends && a(e.extends),
        e.mixins && e.mixins.forEach(a));
    }
    return !o && !l
      ? (pe(e) && s.set(e, null), null)
      : (J(o) ? o.forEach((a) => (i[a] = null)) : ke(i, o), pe(e) && s.set(e, i), i);
  }
  function Tr(e, t) {
    return !e || !fs(t)
      ? !1
      : ((t = t.slice(2).replace(/Once$/, '')),
        de(e, t[0].toLowerCase() + t.slice(1)) || de(e, zt(t)) || de(e, t));
  }
  let Wo = !1;
  function Or() {
    Wo = !0;
  }
  function tu(e) {
    const {
        type: t,
        vnode: n,
        proxy: s,
        withProxy: r,
        propsOptions: [o],
        slots: i,
        attrs: l,
        emit: a,
        render: f,
        renderCache: u,
        props: c,
        data: d,
        setupState: p,
        ctx: h,
        inheritAttrs: q
      } = e,
      v = xr(e);
    let b, $;
    Wo = !1;
    try {
      if (n.shapeFlag & 4) {
        const D = r || s,
          te =
            Jt.NODE_ENV !== 'production' && p.__isScriptSetup
              ? new Proxy(D, {
                  get(V, ce, K) {
                    return (
                      R(
                        `Property '${String(ce)}' was accessed via 'this'. Avoid using 'this' in templates.`
                      ),
                      Reflect.get(V, ce, K)
                    );
                  }
                })
              : D;
        ((b = mt(f.call(te, D, u, Jt.NODE_ENV !== 'production' ? bt(c) : c, p, d, h))), ($ = l));
      } else {
        const D = t;
        (Jt.NODE_ENV !== 'production' && l === c && Or(),
          (b = mt(
            D.length > 1
              ? D(
                  Jt.NODE_ENV !== 'production' ? bt(c) : c,
                  Jt.NODE_ENV !== 'production'
                    ? {
                        get attrs() {
                          return (Or(), bt(l));
                        },
                        slots: i,
                        emit: a
                      }
                    : { attrs: l, slots: i, emit: a }
                )
              : D(Jt.NODE_ENV !== 'production' ? bt(c) : c, null)
          )),
          ($ = t.props ? l : Bm(l)));
      }
    } catch (D) {
      ((Os.length = 0), bs(D, e, 1), (b = S(Ie)));
    }
    let C = b,
      G;
    if ((b.patchFlag > 0 && b.patchFlag & 2048 && ([C, G] = nu(b)), $ && q !== !1)) {
      const D = Object.keys($),
        { shapeFlag: te } = C;
      if (D.length) {
        if (te & 7) (o && D.some(sr) && ($ = Im($, o)), (C = kt(C, $, !1, !0)));
        else if (!Wo && C.type !== Ie) {
          const V = Object.keys(l),
            ce = [],
            K = [];
          for (let I = 0, T = V.length; I < T; I++) {
            const x = V[I];
            fs(x) ? sr(x) || ce.push(x[2].toLowerCase() + x.slice(3)) : K.push(x);
          }
          (K.length &&
            R(
              `Extraneous non-props attributes (${K.join(', ')}) were passed to component but could not be automatically inherited because component renders fragment or text or teleport root nodes.`
            ),
            ce.length &&
              R(
                `Extraneous non-emits event listeners (${ce.join(', ')}) were passed to component but could not be automatically inherited because component renders fragment or text root nodes. If the listener is intended to be a component custom event listener only, declare it using the "emits" option.`
              ));
        }
      }
    }
    return (
      n.dirs &&
        (su(C) ||
          R(
            'Runtime directive used on component with non-element root node. The directives will not function as intended.'
          ),
        (C = kt(C, null, !1, !0)),
        (C.dirs = C.dirs ? C.dirs.concat(n.dirs) : n.dirs)),
      n.transition &&
        (su(C) ||
          R('Component inside <Transition> renders non-element root node that cannot be animated.'),
        qn(C, n.transition)),
      G ? G(C) : (b = C),
      xr(v),
      b
    );
  }
  const nu = (e) => {
    const t = e.children,
      n = e.dynamicChildren,
      s = Go(t, !1);
    if (s) {
      if (s.patchFlag > 0 && s.patchFlag & 2048) return nu(s);
    } else return [e, void 0];
    const r = t.indexOf(s),
      o = n ? n.indexOf(s) : -1,
      i = (l) => {
        ((t[r] = l),
          n && (o > -1 ? (n[o] = l) : l.patchFlag > 0 && (e.dynamicChildren = [...n, l])));
      };
    return [mt(s), i];
  };
  function Go(e, t = !0) {
    let n;
    for (let s = 0; s < e.length; s++) {
      const r = e[s];
      if (Sn(r)) {
        if (r.type !== Ie || r.children === 'v-if') {
          if (n) return;
          if (((n = r), t && n.patchFlag > 0 && n.patchFlag & 2048)) return Go(n.children);
        }
      } else return;
    }
    return n;
  }
  const Bm = (e) => {
      let t;
      for (const n in e) (n === 'class' || n === 'style' || fs(n)) && ((t || (t = {}))[n] = e[n]);
      return t;
    },
    Im = (e, t) => {
      const n = {};
      for (const s in e) (!sr(s) || !(s.slice(9) in t)) && (n[s] = e[s]);
      return n;
    },
    su = (e) => e.shapeFlag & 7 || e.type === Ie;
  function Rm(e, t, n) {
    const { props: s, children: r, component: o } = e,
      { props: i, children: l, patchFlag: a } = t,
      f = o.emitsOptions;
    if (((r || l) && wt) || t.dirs || t.transition) return !0;
    if (n && a >= 0) {
      if (a & 1024) return !0;
      if (a & 16) return s ? ru(s, i, f) : !!i;
      if (a & 8) {
        const u = t.dynamicProps;
        for (let c = 0; c < u.length; c++) {
          const d = u[c];
          if (i[d] !== s[d] && !Tr(f, d)) return !0;
        }
      }
    } else
      return (r || l) && (!l || !l.$stable) ? !0 : s === i ? !1 : s ? (i ? ru(s, i, f) : !0) : !!i;
    return !1;
  }
  function ru(e, t, n) {
    const s = Object.keys(t);
    if (s.length !== Object.keys(e).length) return !0;
    for (let r = 0; r < s.length; r++) {
      const o = s[r];
      if (t[o] !== e[o] && !Tr(n, o)) return !0;
    }
    return !1;
  }
  function Pm({ vnode: e, parent: t }, n) {
    for (; t; ) {
      const s = t.subTree;
      if ((s.suspense && s.suspense.activeBranch === e && (s.el = e.el), s === e))
        (((e = t.vnode).el = n), (t = t.parent));
      else break;
    }
  }
  const ou = (e) => e.__isSuspense;
  function $m(e, t) {
    t && t.pendingBranch ? (J(e) ? t.effects.push(...e) : t.effects.push(e)) : ra(e);
  }
  const Ae = Symbol.for('v-fgt'),
    Qn = Symbol.for('v-txt'),
    Ie = Symbol.for('v-cmt'),
    Ts = Symbol.for('v-stc'),
    Os = [];
  let rt = null;
  function P(e = !1) {
    Os.push((rt = e ? null : []));
  }
  function Dm() {
    (Os.pop(), (rt = Os[Os.length - 1] || null));
  }
  let Bs = 1;
  function iu(e, t = !1) {
    ((Bs += e), e < 0 && rt && t && (rt.hasOnce = !0));
  }
  function lu(e) {
    return ((e.dynamicChildren = Bs > 0 ? rt || Dn : null), Dm(), Bs > 0 && rt && rt.push(e), e);
  }
  function M(e, t, n, s, r, o) {
    return lu(_(e, t, n, s, r, o, !0));
  }
  function wn(e, t, n, s, r) {
    return lu(S(e, t, n, s, r, !0));
  }
  function Sn(e) {
    return e ? e.__v_isVNode === !0 : !1;
  }
  function En(e, t) {
    if (t.shapeFlag & 6 && e.component) {
      const n = br.get(t.type);
      if (n && n.has(e.component)) return ((e.shapeFlag &= -257), (t.shapeFlag &= -513), !1);
    }
    return e.type === t.type && e.key === t.key;
  }
  const Fm = (...e) => zm(...e),
    au = ({ key: e }) => e ?? null,
    Br = ({ ref: e, ref_key: t, ref_for: n }) => (
      typeof e == 'number' && (e = '' + e),
      e != null ? (we(e) || be(e) || ee(e) ? { i: Be, r: e, k: t, f: !!n } : e) : null
    );
  function _(e, t = null, n = null, s = 0, r = null, o = e === Ae ? 0 : 1, i = !1, l = !1) {
    const a = {
      __v_isVNode: !0,
      __v_skip: !0,
      type: e,
      props: t,
      key: t && au(t),
      ref: t && Br(t),
      scopeId: pa,
      slotScopeIds: null,
      children: n,
      component: null,
      suspense: null,
      ssContent: null,
      ssFallback: null,
      dirs: null,
      transition: null,
      el: null,
      anchor: null,
      target: null,
      targetStart: null,
      targetAnchor: null,
      staticCount: 0,
      shapeFlag: o,
      patchFlag: s,
      dynamicProps: r,
      dynamicChildren: null,
      appContext: null,
      ctx: Be
    };
    return (
      l ? (Jo(a, n), o & 128 && e.normalize(a)) : n && (a.shapeFlag |= we(n) ? 8 : 16),
      a.key !== a.key && R('VNode created with invalid key (NaN). VNode type:', a.type),
      Bs > 0 && !i && rt && (a.patchFlag > 0 || o & 6) && a.patchFlag !== 32 && rt.push(a),
      a
    );
  }
  const S = Fm;
  function zm(e, t = null, n = null, s = 0, r = null, o = !1) {
    if (
      ((!e || e === ka) && (e || R(`Invalid vnode type when creating vnode: ${e}.`), (e = Ie)),
      Sn(e))
    ) {
      const l = kt(e, t, !0);
      return (
        n && Jo(l, n),
        Bs > 0 && !o && rt && (l.shapeFlag & 6 ? (rt[rt.indexOf(e)] = l) : rt.push(l)),
        (l.patchFlag = -2),
        l
      );
    }
    if ((mu(e) && (e = e.__vccOpts), t)) {
      t = Mm(t);
      let { class: l, style: a } = t;
      (l && !we(l) && (t.class = $e(l)),
        pe(a) && (vs(a) && !J(a) && (a = ke({}, a)), (t.style = nt(a))));
    }
    const i = we(e) ? 1 : ou(e) ? 128 : ma(e) ? 64 : pe(e) ? 4 : ee(e) ? 2 : 0;
    return (
      i & 4 &&
        vs(e) &&
        ((e = se(e)),
        R(
          'Vue received a Component that was made a reactive object. This can lead to unnecessary performance overhead and should be avoided by marking the component with `markRaw` or using `shallowRef` instead of `ref`.',
          `
Component that was made reactive: `,
          e
        )),
      _(e, t, n, s, r, i, o, !0)
    );
  }
  function Mm(e) {
    return e ? (vs(e) || Na(e) ? ke({}, e) : e) : null;
  }
  function kt(e, t, n = !1, s = !1) {
    const { props: r, ref: o, patchFlag: i, children: l, transition: a } = e,
      f = t ? Nm(r || {}, t) : r,
      u = {
        __v_isVNode: !0,
        __v_skip: !0,
        type: e.type,
        props: f,
        key: f && au(f),
        ref: t && t.ref ? (n && o ? (J(o) ? o.concat(Br(t)) : [o, Br(t)]) : Br(t)) : o,
        scopeId: e.scopeId,
        slotScopeIds: e.slotScopeIds,
        children: i === -1 && J(l) ? l.map(uu) : l,
        target: e.target,
        targetStart: e.targetStart,
        targetAnchor: e.targetAnchor,
        staticCount: e.staticCount,
        shapeFlag: e.shapeFlag,
        patchFlag: t && e.type !== Ae ? (i === -1 ? 16 : i | 16) : i,
        dynamicProps: e.dynamicProps,
        dynamicChildren: e.dynamicChildren,
        appContext: e.appContext,
        dirs: e.dirs,
        transition: a,
        component: e.component,
        suspense: e.suspense,
        ssContent: e.ssContent && kt(e.ssContent),
        ssFallback: e.ssFallback && kt(e.ssFallback),
        el: e.el,
        anchor: e.anchor,
        ctx: e.ctx,
        ce: e.ce
      };
    return (a && s && qn(u, a.clone(u)), u);
  }
  function uu(e) {
    const t = kt(e);
    return (J(e.children) && (t.children = e.children.map(uu)), t);
  }
  function Kn(e = ' ', t = 0) {
    return S(Qn, null, e, t);
  }
  function cu(e, t) {
    const n = S(Ts, null, e);
    return ((n.staticCount = t), n);
  }
  function Te(e = '', t = !1) {
    return t ? (P(), wn(Ie, null, e)) : S(Ie, null, e);
  }
  function mt(e) {
    return e == null || typeof e == 'boolean'
      ? S(Ie)
      : J(e)
        ? S(Ae, null, e.slice())
        : Sn(e)
          ? en(e)
          : S(Qn, null, String(e));
  }
  function en(e) {
    return (e.el === null && e.patchFlag !== -1) || e.memo ? e : kt(e);
  }
  function Jo(e, t) {
    let n = 0;
    const { shapeFlag: s } = e;
    if (t == null) t = null;
    else if (J(t)) n = 16;
    else if (typeof t == 'object')
      if (s & 65) {
        const r = t.default;
        r && (r._c && (r._d = !1), Jo(e, r()), r._c && (r._d = !0));
        return;
      } else {
        n = 32;
        const r = t._;
        !r && !Na(t)
          ? (t._ctx = Be)
          : r === 3 && Be && (Be.slots._ === 1 ? (t._ = 1) : ((t._ = 2), (e.patchFlag |= 1024)));
      }
    else
      ee(t)
        ? ((t = { default: t, _ctx: Be }), (n = 32))
        : ((t = String(t)), s & 64 ? ((n = 16), (t = [Kn(t)])) : (n = 8));
    ((e.children = t), (e.shapeFlag |= n));
  }
  function Nm(...e) {
    const t = {};
    for (let n = 0; n < e.length; n++) {
      const s = e[n];
      for (const r in s)
        if (r === 'class') t.class !== s.class && (t.class = $e([t.class, s.class]));
        else if (r === 'style') t.style = nt([t.style, s.style]);
        else if (fs(r)) {
          const o = t[r],
            i = s[r];
          i && o !== i && !(J(o) && o.includes(i)) && (t[r] = o ? [].concat(o, i) : i);
        } else r !== '' && (t[r] = s[r]);
    }
    return t;
  }
  function Ct(e, t, n, s = null) {
    ht(e, t, 7, [n, s]);
  }
  const Vm = Fa();
  let Lm = 0;
  function Um(e, t, n) {
    const s = e.type,
      r = (t ? t.appContext : e.appContext) || Vm,
      o = {
        uid: Lm++,
        vnode: e,
        type: s,
        parent: t,
        appContext: r,
        root: null,
        next: null,
        subTree: null,
        effect: null,
        update: null,
        job: null,
        scope: new Tl(!0),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: t ? t.provides : Object.create(r.provides),
        ids: t ? t.ids : ['', 0, 0],
        accessCache: null,
        renderCache: [],
        components: null,
        directives: null,
        propsOptions: La(s, r),
        emitsOptions: eu(s, r),
        emit: null,
        emitted: null,
        propsDefaults: ge,
        inheritAttrs: s.inheritAttrs,
        ctx: ge,
        data: ge,
        props: ge,
        attrs: ge,
        slots: ge,
        refs: ge,
        setupState: ge,
        setupContext: null,
        suspense: n,
        suspenseId: n ? n.pendingId : 0,
        asyncDep: null,
        asyncResolved: !1,
        isMounted: !1,
        isUnmounted: !1,
        isDeactivated: !1,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
      };
    return (
      (o.ctx = Gh(o)),
      (o.root = t ? t.root : o),
      (o.emit = Om.bind(null, o)),
      e.ce && e.ce(o),
      o
    );
  }
  let Re = null;
  const Ir = () => Re || Be;
  let Rr, Yo;
  {
    const e = ps(),
      t = (n, s) => {
        let r;
        return (
          (r = e[n]) || (r = e[n] = []),
          r.push(s),
          (o) => {
            r.length > 1 ? r.forEach((i) => i(o)) : r[0](o);
          }
        );
      };
    ((Rr = t('__VUE_INSTANCE_SETTERS__', (n) => (Re = n))),
      (Yo = t('__VUE_SSR_SETTERS__', (n) => (Rs = n))));
  }
  const Is = (e) => {
      const t = Re;
      return (
        Rr(e),
        e.scope.on(),
        () => {
          (e.scope.off(), Rr(t));
        }
      );
    },
    fu = () => {
      (Re && Re.scope.off(), Rr(null));
    },
    jm = Dt('slot,component');
  function Zo(e, { isNativeTag: t }) {
    (jm(e) || t(e)) && R('Do not use built-in or reserved HTML elements as component id: ' + e);
  }
  function du(e) {
    return e.vnode.shapeFlag & 4;
  }
  let Rs = !1;
  function Hm(e, t = !1, n = !1) {
    t && Yo(t);
    const { props: s, children: r } = e.vnode,
      o = du(e);
    (am(e, s, o, t), vm(e, r, n));
    const i = o ? Qm(e, t) : void 0;
    return (t && Yo(!1), i);
  }
  function Qm(e, t) {
    var n;
    const s = e.type;
    {
      if ((s.name && Zo(s.name, e.appContext.config), s.components)) {
        const o = Object.keys(s.components);
        for (let i = 0; i < o.length; i++) Zo(o[i], e.appContext.config);
      }
      if (s.directives) {
        const o = Object.keys(s.directives);
        for (let i = 0; i < o.length; i++) ha(o[i]);
      }
      s.compilerOptions &&
        Km() &&
        R(
          '"compilerOptions" is only supported when using a build of Vue that includes the runtime compiler. Since you are using a runtime-only build, the options should be passed via your build tool config instead.'
        );
    }
    ((e.accessCache = Object.create(null)), (e.proxy = new Proxy(e.ctx, Oa)), Jh(e));
    const { setup: r } = s;
    if (r) {
      Mt();
      const o = (e.setupContext = r.length > 1 ? Jm(e) : null),
        i = Is(e),
        l = Mn(r, e, 0, [bt(e.props), o]),
        a = fo(l);
      if ((Nt(), i(), (a || e.sp) && !Un(e) && xa(e), a)) {
        if ((l.then(fu, fu), t))
          return l
            .then((f) => {
              pu(e, f, t);
            })
            .catch((f) => {
              bs(f, e, 0);
            });
        if (((e.asyncDep = l), !e.suspense)) {
          const f = (n = s.name) != null ? n : 'Anonymous';
          R(
            `Component <${f}>: setup function returned a promise, but no <Suspense> boundary was found in the parent component tree. A component with async setup() must be nested in a <Suspense> in order to be rendered.`
          );
        }
      } else pu(e, l, t);
    } else hu(e, t);
  }
  function pu(e, t, n) {
    (ee(t)
      ? e.type.__ssrInlineRender
        ? (e.ssrRender = t)
        : (e.render = t)
      : pe(t)
        ? (Sn(t) &&
            R('setup() should not return VNodes directly - return a render function instead.'),
          (e.devtoolsRawSetupState = t),
          (e.setupState = Zl(t)),
          Yh(e))
        : t !== void 0 &&
          R(`setup() should return an object. Received: ${t === null ? 'null' : typeof t}`),
      hu(e, n));
  }
  const Km = () => !0;
  function hu(e, t, n) {
    const s = e.type;
    e.render || (e.render = s.render || Ve);
    {
      const r = Is(e);
      Mt();
      try {
        Xh(e);
      } finally {
        (Nt(), r());
      }
    }
    !s.render &&
      e.render === Ve &&
      !t &&
      (s.template
        ? R(
            'Component provided template option but runtime compilation is not supported in this build of Vue. Configure your bundler to alias "vue" to "vue/dist/vue.esm-bundler.js".'
          )
        : R('Component is missing template or render function: ', s));
  }
  const Wm = {
    get(e, t) {
      return (Or(), De(e, 'get', ''), e[t]);
    },
    set() {
      return (R('setupContext.attrs is readonly.'), !1);
    },
    deleteProperty() {
      return (R('setupContext.attrs is readonly.'), !1);
    }
  };
  function Gm(e) {
    return new Proxy(e.slots, {
      get(t, n) {
        return (De(e, 'get', '$slots'), t[n]);
      }
    });
  }
  function Jm(e) {
    const t = (n) => {
      if ((e.exposed && R('expose() should be called only once per setup().'), n != null)) {
        let s = typeof n;
        (s === 'object' && (J(n) ? (s = 'array') : be(n) && (s = 'ref')),
          s !== 'object' && R(`expose() should be passed a plain object, received ${s}.`));
      }
      e.exposed = n || {};
    };
    {
      let n, s;
      return Object.freeze({
        get attrs() {
          return n || (n = new Proxy(e.attrs, Wm));
        },
        get slots() {
          return s || (s = Gm(e));
        },
        get emit() {
          return (r, ...o) => e.emit(r, ...o);
        },
        expose: t
      });
    }
  }
  function Pr(e) {
    return e.exposed
      ? e.exposeProxy ||
          (e.exposeProxy = new Proxy(Zl(Gt(e.exposed)), {
            get(t, n) {
              if (n in t) return t[n];
              if (n in bn) return bn[n](e);
            },
            has(t, n) {
              return n in t || n in bn;
            }
          }))
      : e.proxy;
  }
  const Ym = /(?:^|[-_])(\w)/g,
    Zm = (e) => e.replace(Ym, (t) => t.toUpperCase()).replace(/[-_]/g, '');
  function Xo(e, t = !0) {
    return ee(e) ? e.displayName || e.name : e.name || (t && e.__name);
  }
  function $r(e, t, n = !1) {
    let s = Xo(t);
    if (!s && t.__file) {
      const r = t.__file.match(/([^/\\]+)\.\w+$/);
      r && (s = r[1]);
    }
    if (!s && e && e.parent) {
      const r = (o) => {
        for (const i in o) if (o[i] === t) return i;
      };
      s = r(e.components || e.parent.type.components) || r(e.appContext.components);
    }
    return s ? Zm(s) : n ? 'App' : 'Anonymous';
  }
  function mu(e) {
    return ee(e) && '__vccOpts' in e;
  }
  const H = (e, t) => {
    const n = ch(e, t, Rs);
    {
      const s = Ir();
      s && s.appContext.config.warnRecursiveComputed && (n._warnRecursive = !0);
    }
    return n;
  };
  function Xm(e, t, n) {
    const s = arguments.length;
    return s === 2
      ? pe(t) && !J(t)
        ? Sn(t)
          ? S(e, null, [t])
          : S(e, t)
        : S(e, null, t)
      : (s > 3 ? (n = Array.prototype.slice.call(arguments, 2)) : s === 3 && Sn(n) && (n = [n]),
        S(e, t, n));
  }
  function e0() {
    if (typeof window > 'u') return;
    const e = { style: 'color:#3ba776' },
      t = { style: 'color:#1677ff' },
      n = { style: 'color:#f5222d' },
      s = { style: 'color:#eb2f96' },
      r = {
        __vue_custom_formatter: !0,
        header(c) {
          return pe(c)
            ? c.__isVue
              ? ['div', e, 'VueInstance']
              : be(c)
                ? ['div', {}, ['span', e, u(c)], '<', l('_value' in c ? c._value : c), '>']
                : yt(c)
                  ? [
                      'div',
                      {},
                      ['span', e, Ke(c) ? 'ShallowReactive' : 'Reactive'],
                      '<',
                      l(c),
                      `>${Lt(c) ? ' (readonly)' : ''}`
                    ]
                  : Lt(c)
                    ? [
                        'div',
                        {},
                        ['span', e, Ke(c) ? 'ShallowReadonly' : 'Readonly'],
                        '<',
                        l(c),
                        '>'
                      ]
                    : null
            : null;
        },
        hasBody(c) {
          return c && c.__isVue;
        },
        body(c) {
          if (c && c.__isVue) return ['div', {}, ...o(c.$)];
        }
      };
    function o(c) {
      const d = [];
      (c.type.props && c.props && d.push(i('props', se(c.props))),
        c.setupState !== ge && d.push(i('setup', c.setupState)),
        c.data !== ge && d.push(i('data', se(c.data))));
      const p = a(c, 'computed');
      p && d.push(i('computed', p));
      const h = a(c, 'inject');
      return (
        h && d.push(i('injected', h)),
        d.push([
          'div',
          {},
          ['span', { style: s.style + ';opacity:0.66' }, '$ (internal): '],
          ['object', { object: c }]
        ]),
        d
      );
    }
    function i(c, d) {
      return (
        (d = ke({}, d)),
        Object.keys(d).length
          ? [
              'div',
              { style: 'line-height:1.25em;margin-bottom:0.6em' },
              ['div', { style: 'color:#476582' }, c],
              [
                'div',
                { style: 'padding-left:1.25em' },
                ...Object.keys(d).map((p) => ['div', {}, ['span', s, p + ': '], l(d[p], !1)])
              ]
            ]
          : ['span', {}]
      );
    }
    function l(c, d = !0) {
      return typeof c == 'number'
        ? ['span', t, c]
        : typeof c == 'string'
          ? ['span', n, JSON.stringify(c)]
          : typeof c == 'boolean'
            ? ['span', s, c]
            : pe(c)
              ? ['object', { object: d ? se(c) : c }]
              : ['span', n, String(c)];
    }
    function a(c, d) {
      const p = c.type;
      if (ee(p)) return;
      const h = {};
      for (const q in c.ctx) f(p, q, d) && (h[q] = c.ctx[q]);
      return h;
    }
    function f(c, d, p) {
      const h = c[p];
      if (
        (J(h) && h.includes(d)) ||
        (pe(h) && d in h) ||
        (c.extends && f(c.extends, d, p)) ||
        (c.mixins && c.mixins.some((q) => f(q, d, p)))
      )
        return !0;
    }
    function u(c) {
      return Ke(c) ? 'ShallowRef' : c.effect ? 'ComputedRef' : 'Ref';
    }
    window.devtoolsFormatters
      ? window.devtoolsFormatters.push(r)
      : (window.devtoolsFormatters = [r]);
  }
  const gu = '3.5.13',
    At = R;
  let ei;
  const _u = typeof window < 'u' && window.trustedTypes;
  if (_u)
    try {
      ei = _u.createPolicy('vue', { createHTML: (e) => e });
    } catch (e) {
      At(`Error creating trusted types policy: ${e}`);
    }
  const qu = ei ? (e) => ei.createHTML(e) : (e) => e,
    t0 = 'http://www.w3.org/2000/svg',
    n0 = 'http://www.w3.org/1998/Math/MathML',
    Qt = typeof document < 'u' ? document : null,
    vu = Qt && Qt.createElement('template'),
    s0 = {
      insert: (e, t, n) => {
        t.insertBefore(e, n || null);
      },
      remove: (e) => {
        const t = e.parentNode;
        t && t.removeChild(e);
      },
      createElement: (e, t, n, s) => {
        const r =
          t === 'svg'
            ? Qt.createElementNS(t0, e)
            : t === 'mathml'
              ? Qt.createElementNS(n0, e)
              : n
                ? Qt.createElement(e, { is: n })
                : Qt.createElement(e);
        return (
          e === 'select' && s && s.multiple != null && r.setAttribute('multiple', s.multiple),
          r
        );
      },
      createText: (e) => Qt.createTextNode(e),
      createComment: (e) => Qt.createComment(e),
      setText: (e, t) => {
        e.nodeValue = t;
      },
      setElementText: (e, t) => {
        e.textContent = t;
      },
      parentNode: (e) => e.parentNode,
      nextSibling: (e) => e.nextSibling,
      querySelector: (e) => Qt.querySelector(e),
      setScopeId(e, t) {
        e.setAttribute(t, '');
      },
      insertStaticContent(e, t, n, s, r, o) {
        const i = n ? n.previousSibling : t.lastChild;
        if (r && (r === o || r.nextSibling))
          for (; t.insertBefore(r.cloneNode(!0), n), !(r === o || !(r = r.nextSibling)); );
        else {
          vu.innerHTML = qu(
            s === 'svg' ? `<svg>${e}</svg>` : s === 'mathml' ? `<math>${e}</math>` : e
          );
          const l = vu.content;
          if (s === 'svg' || s === 'mathml') {
            const a = l.firstChild;
            for (; a.firstChild; ) l.appendChild(a.firstChild);
            l.removeChild(a);
          }
          t.insertBefore(l, n);
        }
        return [i ? i.nextSibling : t.firstChild, n ? n.previousSibling : t.lastChild];
      }
    },
    tn = 'transition',
    Ps = 'animation',
    Wn = Symbol('_vtc'),
    bu = {
      name: String,
      type: String,
      css: { type: Boolean, default: !0 },
      duration: [String, Number, Object],
      enterFromClass: String,
      enterActiveClass: String,
      enterToClass: String,
      appearFromClass: String,
      appearActiveClass: String,
      appearToClass: String,
      leaveFromClass: String,
      leaveActiveClass: String,
      leaveToClass: String
    },
    yu = ke({}, _a, bu),
    Dr = ((e) => ((e.displayName = 'Transition'), (e.props = yu), e))((e, { slots: t }) =>
      Xm($h, wu(e), t)
    ),
    kn = (e, t = []) => {
      J(e) ? e.forEach((n) => n(...t)) : e && e(...t);
    },
    xu = (e) => (e ? (J(e) ? e.some((t) => t.length > 1) : e.length > 1) : !1);
  function wu(e) {
    const t = {};
    for (const x in e) x in bu || (t[x] = e[x]);
    if (e.css === !1) return t;
    const {
        name: n = 'v',
        type: s,
        duration: r,
        enterFromClass: o = `${n}-enter-from`,
        enterActiveClass: i = `${n}-enter-active`,
        enterToClass: l = `${n}-enter-to`,
        appearFromClass: a = o,
        appearActiveClass: f = i,
        appearToClass: u = l,
        leaveFromClass: c = `${n}-leave-from`,
        leaveActiveClass: d = `${n}-leave-active`,
        leaveToClass: p = `${n}-leave-to`
      } = e,
      h = r0(r),
      q = h && h[0],
      v = h && h[1],
      {
        onBeforeEnter: b,
        onEnter: $,
        onEnterCancelled: C,
        onLeave: G,
        onLeaveCancelled: D,
        onBeforeAppear: te = b,
        onAppear: V = $,
        onAppearCancelled: ce = C
      } = t,
      K = (x, Q, Y, me) => {
        ((x._enterCancelled = me), nn(x, Q ? u : l), nn(x, Q ? f : i), Y && Y());
      },
      I = (x, Q) => {
        ((x._isLeaving = !1), nn(x, c), nn(x, p), nn(x, d), Q && Q());
      },
      T = (x) => (Q, Y) => {
        const me = x ? V : $,
          ae = () => K(Q, x, Y);
        (kn(me, [Q, ae]),
          Su(() => {
            (nn(Q, x ? a : o), Tt(Q, x ? u : l), xu(me) || Eu(Q, s, q, ae));
          }));
      };
    return ke(t, {
      onBeforeEnter(x) {
        (kn(b, [x]), Tt(x, o), Tt(x, i));
      },
      onBeforeAppear(x) {
        (kn(te, [x]), Tt(x, a), Tt(x, f));
      },
      onEnter: T(!1),
      onAppear: T(!0),
      onLeave(x, Q) {
        x._isLeaving = !0;
        const Y = () => I(x, Q);
        (Tt(x, c),
          x._enterCancelled ? (Tt(x, d), ni()) : (ni(), Tt(x, d)),
          Su(() => {
            x._isLeaving && (nn(x, c), Tt(x, p), xu(G) || Eu(x, s, v, Y));
          }),
          kn(G, [x, Y]));
      },
      onEnterCancelled(x) {
        (K(x, !1, void 0, !0), kn(C, [x]));
      },
      onAppearCancelled(x) {
        (K(x, !0, void 0, !0), kn(ce, [x]));
      },
      onLeaveCancelled(x) {
        (I(x), kn(D, [x]));
      }
    });
  }
  function r0(e) {
    if (e == null) return null;
    if (pe(e)) return [ti(e.enter), ti(e.leave)];
    {
      const t = ti(e);
      return [t, t];
    }
  }
  function ti(e) {
    const t = Sp(e);
    return (_h(t, '<transition> explicit duration'), t);
  }
  function Tt(e, t) {
    (t.split(/\s+/).forEach((n) => n && e.classList.add(n)), (e[Wn] || (e[Wn] = new Set())).add(t));
  }
  function nn(e, t) {
    t.split(/\s+/).forEach((s) => s && e.classList.remove(s));
    const n = e[Wn];
    n && (n.delete(t), n.size || (e[Wn] = void 0));
  }
  function Su(e) {
    requestAnimationFrame(() => {
      requestAnimationFrame(e);
    });
  }
  let o0 = 0;
  function Eu(e, t, n, s) {
    const r = (e._endId = ++o0),
      o = () => {
        r === e._endId && s();
      };
    if (n != null) return setTimeout(o, n);
    const { type: i, timeout: l, propCount: a } = ku(e, t);
    if (!i) return s();
    const f = i + 'end';
    let u = 0;
    const c = () => {
        (e.removeEventListener(f, d), o());
      },
      d = (p) => {
        p.target === e && ++u >= a && c();
      };
    (setTimeout(() => {
      u < a && c();
    }, l + 1),
      e.addEventListener(f, d));
  }
  function ku(e, t) {
    const n = window.getComputedStyle(e),
      s = (h) => (n[h] || '').split(', '),
      r = s(`${tn}Delay`),
      o = s(`${tn}Duration`),
      i = Cu(r, o),
      l = s(`${Ps}Delay`),
      a = s(`${Ps}Duration`),
      f = Cu(l, a);
    let u = null,
      c = 0,
      d = 0;
    t === tn
      ? i > 0 && ((u = tn), (c = i), (d = o.length))
      : t === Ps
        ? f > 0 && ((u = Ps), (c = f), (d = a.length))
        : ((c = Math.max(i, f)),
          (u = c > 0 ? (i > f ? tn : Ps) : null),
          (d = u ? (u === tn ? o.length : a.length) : 0));
    const p = u === tn && /\b(transform|all)(,|$)/.test(s(`${tn}Property`).toString());
    return { type: u, timeout: c, propCount: d, hasTransform: p };
  }
  function Cu(e, t) {
    for (; e.length < t.length; ) e = e.concat(e);
    return Math.max(...t.map((n, s) => Au(n) + Au(e[s])));
  }
  function Au(e) {
    return e === 'auto' ? 0 : Number(e.slice(0, -1).replace(',', '.')) * 1e3;
  }
  function ni() {
    return document.body.offsetHeight;
  }
  function i0(e, t, n) {
    const s = e[Wn];
    (s && (t = (t ? [t, ...s] : [...s]).join(' ')),
      t == null ? e.removeAttribute('class') : n ? e.setAttribute('class', t) : (e.className = t));
  }
  const Tu = Symbol('_vod'),
    l0 = Symbol('_vsh'),
    a0 = Symbol('CSS_VAR_TEXT'),
    u0 = /(^|;)\s*display\s*:/;
  function c0(e, t, n) {
    const s = e.style,
      r = we(n);
    let o = !1;
    if (n && !r) {
      if (t)
        if (we(t))
          for (const i of t.split(';')) {
            const l = i.slice(0, i.indexOf(':')).trim();
            n[l] == null && Fr(s, l, '');
          }
        else for (const i in t) n[i] == null && Fr(s, i, '');
      for (const i in n) (i === 'display' && (o = !0), Fr(s, i, n[i]));
    } else if (r) {
      if (t !== n) {
        const i = s[a0];
        (i && (n += ';' + i), (s.cssText = n), (o = u0.test(n)));
      }
    } else t && e.removeAttribute('style');
    Tu in e && ((e[Tu] = o ? s.display : ''), e[l0] && (s.display = 'none'));
  }
  const f0 = /[^\\];\s*$/,
    Ou = /\s*!important$/;
  function Fr(e, t, n) {
    if (J(n)) n.forEach((s) => Fr(e, t, s));
    else if (
      (n == null && (n = ''),
      f0.test(n) && At(`Unexpected semicolon at the end of '${t}' style value: '${n}'`),
      t.startsWith('--'))
    )
      e.setProperty(t, n);
    else {
      const s = d0(e, t);
      Ou.test(n) ? e.setProperty(zt(s), n.replace(Ou, ''), 'important') : (e[s] = n);
    }
  }
  const Bu = ['Webkit', 'Moz', 'ms'],
    si = {};
  function d0(e, t) {
    const n = si[t];
    if (n) return n;
    let s = He(t);
    if (s !== 'filter' && s in e) return (si[t] = s);
    s = fn(s);
    for (let r = 0; r < Bu.length; r++) {
      const o = Bu[r] + s;
      if (o in e) return (si[t] = o);
    }
    return t;
  }
  const Iu = 'http://www.w3.org/1999/xlink';
  function Ru(e, t, n, s, r, o = $p(t)) {
    s && t.startsWith('xlink:')
      ? n == null
        ? e.removeAttributeNS(Iu, t.slice(6, t.length))
        : e.setAttributeNS(Iu, t, n)
      : n == null || (o && !kl(n))
        ? e.removeAttribute(t)
        : e.setAttribute(t, o ? '' : Ft(n) ? String(n) : n);
  }
  function Pu(e, t, n, s, r) {
    if (t === 'innerHTML' || t === 'textContent') {
      n != null && (e[t] = t === 'innerHTML' ? qu(n) : n);
      return;
    }
    const o = e.tagName;
    if (t === 'value' && o !== 'PROGRESS' && !o.includes('-')) {
      const l = o === 'OPTION' ? e.getAttribute('value') || '' : e.value,
        a = n == null ? (e.type === 'checkbox' ? 'on' : '') : String(n);
      ((l !== a || !('_value' in e)) && (e.value = a),
        n == null && e.removeAttribute(t),
        (e._value = n));
      return;
    }
    let i = !1;
    if (n === '' || n == null) {
      const l = typeof e[t];
      l === 'boolean'
        ? (n = kl(n))
        : n == null && l === 'string'
          ? ((n = ''), (i = !0))
          : l === 'number' && ((n = 0), (i = !0));
    }
    try {
      e[t] = n;
    } catch (l) {
      i || At(`Failed setting prop "${t}" on <${o.toLowerCase()}>: value ${n} is invalid.`, l);
    }
    i && e.removeAttribute(r || t);
  }
  function Gn(e, t, n, s) {
    e.addEventListener(t, n, s);
  }
  function p0(e, t, n, s) {
    e.removeEventListener(t, n, s);
  }
  const $u = Symbol('_vei');
  function h0(e, t, n, s, r = null) {
    const o = e[$u] || (e[$u] = {}),
      i = o[t];
    if (s && i) i.value = Fu(s, t);
    else {
      const [l, a] = m0(t);
      if (s) {
        const f = (o[t] = q0(Fu(s, t), r));
        Gn(e, l, f, a);
      } else i && (p0(e, l, i, a), (o[t] = void 0));
    }
  }
  const Du = /(?:Once|Passive|Capture)$/;
  function m0(e) {
    let t;
    if (Du.test(e)) {
      t = {};
      let s;
      for (; (s = e.match(Du)); )
        ((e = e.slice(0, e.length - s[0].length)), (t[s[0].toLowerCase()] = !0));
    }
    return [e[2] === ':' ? e.slice(3) : zt(e.slice(2)), t];
  }
  let ri = 0;
  const g0 = Promise.resolve(),
    _0 = () => ri || (g0.then(() => (ri = 0)), (ri = Date.now()));
  function q0(e, t) {
    const n = (s) => {
      if (!s._vts) s._vts = Date.now();
      else if (s._vts <= n.attached) return;
      ht(v0(s, n.value), t, 5, [s]);
    };
    return ((n.value = e), (n.attached = _0()), n);
  }
  function Fu(e, t) {
    return ee(e) || J(e)
      ? e
      : (At(`Wrong type passed as event handler to ${t} - did you forget @ or : in front of your prop?
Expected function or array of functions, received type ${typeof e}.`),
        Ve);
  }
  function v0(e, t) {
    if (J(t)) {
      const n = e.stopImmediatePropagation;
      return (
        (e.stopImmediatePropagation = () => {
          (n.call(e), (e._stopped = !0));
        }),
        t.map((s) => (r) => !r._stopped && s && s(r))
      );
    } else return t;
  }
  const zu = (e) =>
      e.charCodeAt(0) === 111 &&
      e.charCodeAt(1) === 110 &&
      e.charCodeAt(2) > 96 &&
      e.charCodeAt(2) < 123,
    b0 = (e, t, n, s, r, o) => {
      const i = r === 'svg';
      t === 'class'
        ? i0(e, s, i)
        : t === 'style'
          ? c0(e, n, s)
          : fs(t)
            ? sr(t) || h0(e, t, n, s, o)
            : (
                  t[0] === '.'
                    ? ((t = t.slice(1)), !0)
                    : t[0] === '^'
                      ? ((t = t.slice(1)), !1)
                      : y0(e, t, s, i)
                )
              ? (Pu(e, t, s),
                !e.tagName.includes('-') &&
                  (t === 'value' || t === 'checked' || t === 'selected') &&
                  Ru(e, t, s, i, o, t !== 'value'))
              : e._isVueCE && (/[A-Z]/.test(t) || !we(s))
                ? Pu(e, He(t), s, o, t)
                : (t === 'true-value'
                    ? (e._trueValue = s)
                    : t === 'false-value' && (e._falseValue = s),
                  Ru(e, t, s, i));
    };
  function y0(e, t, n, s) {
    if (s) return !!(t === 'innerHTML' || t === 'textContent' || (t in e && zu(t) && ee(n)));
    if (
      t === 'spellcheck' ||
      t === 'draggable' ||
      t === 'translate' ||
      t === 'form' ||
      (t === 'list' && e.tagName === 'INPUT') ||
      (t === 'type' && e.tagName === 'TEXTAREA')
    )
      return !1;
    if (t === 'width' || t === 'height') {
      const r = e.tagName;
      if (r === 'IMG' || r === 'VIDEO' || r === 'CANVAS' || r === 'SOURCE') return !1;
    }
    return zu(t) && we(n) ? !1 : t in e;
  }
  const Mu = new WeakMap(),
    Nu = new WeakMap(),
    zr = Symbol('_moveCb'),
    Vu = Symbol('_enterCb'),
    x0 = ((e) => (delete e.props.mode, e))({
      name: 'TransitionGroup',
      props: ke({}, yu, { tag: String, moveClass: String }),
      setup(e, { slots: t }) {
        const n = Ir(),
          s = ga();
        let r, o;
        return (
          Sa(() => {
            if (!r.length) return;
            const i = e.moveClass || `${e.name || 'v'}-move`;
            if (!k0(r[0].el, n.vnode.el, i)) return;
            (r.forEach(w0), r.forEach(S0));
            const l = r.filter(E0);
            (ni(),
              l.forEach((a) => {
                const f = a.el,
                  u = f.style;
                (Tt(f, i), (u.transform = u.webkitTransform = u.transitionDuration = ''));
                const c = (f[zr] = (d) => {
                  (d && d.target !== f) ||
                    ((!d || /transform$/.test(d.propertyName)) &&
                      (f.removeEventListener('transitionend', c), (f[zr] = null), nn(f, i)));
                });
                f.addEventListener('transitionend', c);
              }));
          }),
          () => {
            const i = se(e),
              l = wu(i);
            let a = i.tag || Ae;
            if (((r = []), o))
              for (let f = 0; f < o.length; f++) {
                const u = o[f];
                u.el &&
                  u.el instanceof Element &&
                  (r.push(u), qn(u, Ss(u, l, s, n)), Mu.set(u, u.el.getBoundingClientRect()));
              }
            o = t.default ? Fo(t.default()) : [];
            for (let f = 0; f < o.length; f++) {
              const u = o[f];
              u.key != null
                ? qn(u, Ss(u, l, s, n))
                : u.type !== Qn && At('<TransitionGroup> children must be keyed.');
            }
            return S(a, null, o);
          }
        );
      }
    });
  function w0(e) {
    const t = e.el;
    (t[zr] && t[zr](), t[Vu] && t[Vu]());
  }
  function S0(e) {
    Nu.set(e, e.el.getBoundingClientRect());
  }
  function E0(e) {
    const t = Mu.get(e),
      n = Nu.get(e),
      s = t.left - n.left,
      r = t.top - n.top;
    if (s || r) {
      const o = e.el.style;
      return (
        (o.transform = o.webkitTransform = `translate(${s}px,${r}px)`),
        (o.transitionDuration = '0s'),
        e
      );
    }
  }
  function k0(e, t, n) {
    const s = e.cloneNode(),
      r = e[Wn];
    (r &&
      r.forEach((l) => {
        l.split(/\s+/).forEach((a) => a && s.classList.remove(a));
      }),
      n.split(/\s+/).forEach((l) => l && s.classList.add(l)),
      (s.style.display = 'none'));
    const o = t.nodeType === 1 ? t : t.parentNode;
    o.appendChild(s);
    const { hasTransform: i } = ku(s);
    return (o.removeChild(s), i);
  }
  const Lu = (e) => {
    const t = e.props['onUpdate:modelValue'] || !1;
    return J(t) ? (n) => Fn(t, n) : t;
  };
  function C0(e) {
    e.target.composing = !0;
  }
  function Uu(e) {
    const t = e.target;
    t.composing && ((t.composing = !1), t.dispatchEvent(new Event('input')));
  }
  const oi = Symbol('_assign'),
    Jn = {
      created(e, { modifiers: { lazy: t, trim: n, number: s } }, r) {
        e[oi] = Lu(r);
        const o = s || (r.props && r.props.type === 'number');
        (Gn(e, t ? 'change' : 'input', (i) => {
          if (i.target.composing) return;
          let l = e.value;
          (n && (l = l.trim()), o && (l = mo(l)), e[oi](l));
        }),
          n &&
            Gn(e, 'change', () => {
              e.value = e.value.trim();
            }),
          t || (Gn(e, 'compositionstart', C0), Gn(e, 'compositionend', Uu), Gn(e, 'change', Uu)));
      },
      mounted(e, { value: t }) {
        e.value = t ?? '';
      },
      beforeUpdate(e, { value: t, oldValue: n, modifiers: { lazy: s, trim: r, number: o } }, i) {
        if (((e[oi] = Lu(i)), e.composing)) return;
        const l = (o || e.type === 'number') && !/^0\d/.test(e.value) ? mo(e.value) : e.value,
          a = t ?? '';
        l !== a &&
          ((document.activeElement === e &&
            e.type !== 'range' &&
            ((s && t === n) || (r && e.value.trim() === a))) ||
            (e.value = a));
      }
    },
    A0 = ['ctrl', 'shift', 'alt', 'meta'],
    T0 = {
      stop: (e) => e.stopPropagation(),
      prevent: (e) => e.preventDefault(),
      self: (e) => e.target !== e.currentTarget,
      ctrl: (e) => !e.ctrlKey,
      shift: (e) => !e.shiftKey,
      alt: (e) => !e.altKey,
      meta: (e) => !e.metaKey,
      left: (e) => 'button' in e && e.button !== 0,
      middle: (e) => 'button' in e && e.button !== 1,
      right: (e) => 'button' in e && e.button !== 2,
      exact: (e, t) => A0.some((n) => e[`${n}Key`] && !t.includes(n))
    },
    ju = (e, t) => {
      const n = e._withMods || (e._withMods = {}),
        s = t.join('.');
      return (
        n[s] ||
        (n[s] = (r, ...o) => {
          for (let i = 0; i < t.length; i++) {
            const l = T0[t[i]];
            if (l && l(r, t)) return;
          }
          return e(r, ...o);
        })
      );
    },
    O0 = {
      esc: 'escape',
      space: ' ',
      up: 'arrow-up',
      left: 'arrow-left',
      right: 'arrow-right',
      down: 'arrow-down',
      delete: 'backspace'
    },
    Hu = (e, t) => {
      const n = e._withKeys || (e._withKeys = {}),
        s = t.join('.');
      return (
        n[s] ||
        (n[s] = (r) => {
          if (!('key' in r)) return;
          const o = zt(r.key);
          if (t.some((i) => i === o || O0[i] === o)) return e(r);
        })
      );
    },
    B0 = ke({ patchProp: b0 }, s0);
  let Qu;
  function I0() {
    return Qu || (Qu = xm(B0));
  }
  const R0 = (...e) => {
    const t = I0().createApp(...e);
    ($0(t), D0(t));
    const { mount: n } = t;
    return (
      (t.mount = (s) => {
        const r = F0(s);
        if (!r) return;
        const o = t._component;
        (!ee(o) && !o.render && !o.template && (o.template = r.innerHTML),
          r.nodeType === 1 && (r.textContent = ''));
        const i = n(r, !1, P0(r));
        return (
          r instanceof Element && (r.removeAttribute('v-cloak'), r.setAttribute('data-v-app', '')),
          i
        );
      }),
      t
    );
  };
  function P0(e) {
    if (e instanceof SVGElement) return 'svg';
    if (typeof MathMLElement == 'function' && e instanceof MathMLElement) return 'mathml';
  }
  function $0(e) {
    Object.defineProperty(e.config, 'isNativeTag', {
      value: (t) => Ip(t) || Rp(t) || Pp(t),
      writable: !1
    });
  }
  function D0(e) {
    {
      const t = e.config.isCustomElement;
      Object.defineProperty(e.config, 'isCustomElement', {
        get() {
          return t;
        },
        set() {
          At(
            'The `isCustomElement` config option is deprecated. Use `compilerOptions.isCustomElement` instead.'
          );
        }
      });
      const n = e.config.compilerOptions,
        s =
          'The `compilerOptions` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, `compilerOptions` must be passed to `@vue/compiler-dom` in the build setup instead.\n- For vue-loader: pass it via vue-loader\'s `compilerOptions` loader option.\n- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader\n- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc';
      Object.defineProperty(e.config, 'compilerOptions', {
        get() {
          return (At(s), n);
        },
        set() {
          At(s);
        }
      });
    }
  }
  function F0(e) {
    if (we(e)) {
      const t = document.querySelector(e);
      return (t || At(`Failed to mount app: mount target selector "${e}" returned null.`), t);
    }
    return (
      window.ShadowRoot &&
        e instanceof window.ShadowRoot &&
        e.mode === 'closed' &&
        At('mounting on a ShadowRoot with `{mode: "closed"}` may lead to unpredictable bugs'),
      e
    );
  }
  function z0() {
    e0();
  }
  z0();
  var M0 = Object.create,
    Ku = Object.defineProperty,
    N0 = Object.getOwnPropertyDescriptor,
    ii = Object.getOwnPropertyNames,
    V0 = Object.getPrototypeOf,
    L0 = Object.prototype.hasOwnProperty,
    U0 = (e, t) =>
      function () {
        return (e && (t = (0, e[ii(e)[0]])((e = 0))), t);
      },
    j0 = (e, t) =>
      function () {
        return (t || (0, e[ii(e)[0]])((t = { exports: {} }).exports, t), t.exports);
      },
    H0 = (e, t, n, s) => {
      if ((t && typeof t == 'object') || typeof t == 'function')
        for (let r of ii(t))
          !L0.call(e, r) &&
            r !== n &&
            Ku(e, r, { get: () => t[r], enumerable: !(s = N0(t, r)) || s.enumerable });
      return e;
    },
    Q0 = (e, t, n) => (
      (n = e != null ? M0(V0(e)) : {}),
      H0(Ku(n, 'default', { value: e, enumerable: !0 }), e)
    ),
    $s = U0({
      '../../node_modules/.pnpm/tsup@8.4.0_@microsoft+api-extractor@7.51.1_@types+node@22.13.14__jiti@2.4.2_postcss@8.5_96eb05a9d65343021e53791dd83f3773/node_modules/tsup/assets/esm_shims.js'() {}
    }),
    K0 = j0({
      '../../node_modules/.pnpm/rfdc@1.4.1/node_modules/rfdc/index.js'(e, t) {
        ($s(), (t.exports = s));
        function n(o) {
          return o instanceof Buffer
            ? Buffer.from(o)
            : new o.constructor(o.buffer.slice(), o.byteOffset, o.length);
        }
        function s(o) {
          if (((o = o || {}), o.circles)) return r(o);
          const i = new Map();
          if (
            (i.set(Date, (c) => new Date(c)),
            i.set(Map, (c, d) => new Map(a(Array.from(c), d))),
            i.set(Set, (c, d) => new Set(a(Array.from(c), d))),
            o.constructorHandlers)
          )
            for (const c of o.constructorHandlers) i.set(c[0], c[1]);
          let l = null;
          return o.proto ? u : f;
          function a(c, d) {
            const p = Object.keys(c),
              h = new Array(p.length);
            for (let q = 0; q < p.length; q++) {
              const v = p[q],
                b = c[v];
              typeof b != 'object' || b === null
                ? (h[v] = b)
                : b.constructor !== Object && (l = i.get(b.constructor))
                  ? (h[v] = l(b, d))
                  : ArrayBuffer.isView(b)
                    ? (h[v] = n(b))
                    : (h[v] = d(b));
            }
            return h;
          }
          function f(c) {
            if (typeof c != 'object' || c === null) return c;
            if (Array.isArray(c)) return a(c, f);
            if (c.constructor !== Object && (l = i.get(c.constructor))) return l(c, f);
            const d = {};
            for (const p in c) {
              if (Object.hasOwnProperty.call(c, p) === !1) continue;
              const h = c[p];
              typeof h != 'object' || h === null
                ? (d[p] = h)
                : h.constructor !== Object && (l = i.get(h.constructor))
                  ? (d[p] = l(h, f))
                  : ArrayBuffer.isView(h)
                    ? (d[p] = n(h))
                    : (d[p] = f(h));
            }
            return d;
          }
          function u(c) {
            if (typeof c != 'object' || c === null) return c;
            if (Array.isArray(c)) return a(c, u);
            if (c.constructor !== Object && (l = i.get(c.constructor))) return l(c, u);
            const d = {};
            for (const p in c) {
              const h = c[p];
              typeof h != 'object' || h === null
                ? (d[p] = h)
                : h.constructor !== Object && (l = i.get(h.constructor))
                  ? (d[p] = l(h, u))
                  : ArrayBuffer.isView(h)
                    ? (d[p] = n(h))
                    : (d[p] = u(h));
            }
            return d;
          }
        }
        function r(o) {
          const i = [],
            l = [],
            a = new Map();
          if (
            (a.set(Date, (p) => new Date(p)),
            a.set(Map, (p, h) => new Map(u(Array.from(p), h))),
            a.set(Set, (p, h) => new Set(u(Array.from(p), h))),
            o.constructorHandlers)
          )
            for (const p of o.constructorHandlers) a.set(p[0], p[1]);
          let f = null;
          return o.proto ? d : c;
          function u(p, h) {
            const q = Object.keys(p),
              v = new Array(q.length);
            for (let b = 0; b < q.length; b++) {
              const $ = q[b],
                C = p[$];
              if (typeof C != 'object' || C === null) v[$] = C;
              else if (C.constructor !== Object && (f = a.get(C.constructor))) v[$] = f(C, h);
              else if (ArrayBuffer.isView(C)) v[$] = n(C);
              else {
                const G = i.indexOf(C);
                G !== -1 ? (v[$] = l[G]) : (v[$] = h(C));
              }
            }
            return v;
          }
          function c(p) {
            if (typeof p != 'object' || p === null) return p;
            if (Array.isArray(p)) return u(p, c);
            if (p.constructor !== Object && (f = a.get(p.constructor))) return f(p, c);
            const h = {};
            (i.push(p), l.push(h));
            for (const q in p) {
              if (Object.hasOwnProperty.call(p, q) === !1) continue;
              const v = p[q];
              if (typeof v != 'object' || v === null) h[q] = v;
              else if (v.constructor !== Object && (f = a.get(v.constructor))) h[q] = f(v, c);
              else if (ArrayBuffer.isView(v)) h[q] = n(v);
              else {
                const b = i.indexOf(v);
                b !== -1 ? (h[q] = l[b]) : (h[q] = c(v));
              }
            }
            return (i.pop(), l.pop(), h);
          }
          function d(p) {
            if (typeof p != 'object' || p === null) return p;
            if (Array.isArray(p)) return u(p, d);
            if (p.constructor !== Object && (f = a.get(p.constructor))) return f(p, d);
            const h = {};
            (i.push(p), l.push(h));
            for (const q in p) {
              const v = p[q];
              if (typeof v != 'object' || v === null) h[q] = v;
              else if (v.constructor !== Object && (f = a.get(v.constructor))) h[q] = f(v, d);
              else if (ArrayBuffer.isView(v)) h[q] = n(v);
              else {
                const b = i.indexOf(v);
                b !== -1 ? (h[q] = l[b]) : (h[q] = d(v));
              }
            }
            return (i.pop(), l.pop(), h);
          }
        }
      }
    });
  ($s(), $s(), $s());
  var Wu = typeof navigator < 'u',
    W =
      typeof window < 'u'
        ? window
        : typeof globalThis < 'u'
          ? globalThis
          : typeof global < 'u'
            ? global
            : {};
  (typeof W.chrome < 'u' && W.chrome.devtools, Wu && (W.self, W.top));
  var Gu;
  (typeof navigator < 'u' &&
    ((Gu = navigator.userAgent) == null || Gu.toLowerCase().includes('electron')),
    $s());
  var W0 = Q0(K0()),
    G0 = /(?:^|[-_/])(\w)/g;
  function J0(e, t) {
    return t ? t.toUpperCase() : '';
  }
  function Y0(e) {
    return e && `${e}`.replace(G0, J0);
  }
  function Z0(e, t) {
    let n = e.replace(/^[a-z]:/i, '').replace(/\\/g, '/');
    n.endsWith(`index${t}`) && (n = n.replace(`/index${t}`, t));
    const s = n.lastIndexOf('/'),
      r = n.substring(s + 1);
    {
      const o = r.lastIndexOf(t);
      return r.substring(0, o);
    }
  }
  var Ju = (0, W0.default)({ circles: !0 });
  const X0 = { trailing: !0 };
  function Yn(e, t = 25, n = {}) {
    if (((n = { ...X0, ...n }), !Number.isFinite(t)))
      throw new TypeError('Expected `wait` to be a finite number');
    let s,
      r,
      o = [],
      i,
      l;
    const a = (f, u) => (
      (i = eg(e, f, u)),
      i.finally(() => {
        if (((i = null), n.trailing && l && !r)) {
          const c = a(f, l);
          return ((l = null), c);
        }
      }),
      i
    );
    return function (...f) {
      return i
        ? (n.trailing && (l = f), i)
        : new Promise((u) => {
            const c = !r && n.leading;
            (clearTimeout(r),
              (r = setTimeout(() => {
                r = null;
                const d = n.leading ? s : a(this, f);
                for (const p of o) p(d);
                o = [];
              }, t)),
              c ? ((s = a(this, f)), u(s)) : o.push(u));
          });
    };
  }
  async function eg(e, t, n) {
    return await e.apply(t, n);
  }
  function li(e, t = {}, n) {
    for (const s in e) {
      const r = e[s],
        o = n ? `${n}:${s}` : s;
      typeof r == 'object' && r !== null ? li(r, t, o) : typeof r == 'function' && (t[o] = r);
    }
    return t;
  }
  const tg = { run: (e) => e() },
    ng = () => tg,
    Yu = typeof console.createTask < 'u' ? console.createTask : ng;
  function sg(e, t) {
    const n = t.shift(),
      s = Yu(n);
    return e.reduce((r, o) => r.then(() => s.run(() => o(...t))), Promise.resolve());
  }
  function rg(e, t) {
    const n = t.shift(),
      s = Yu(n);
    return Promise.all(e.map((r) => s.run(() => r(...t))));
  }
  function ai(e, t) {
    for (const n of [...e]) n(t);
  }
  class og {
    constructor() {
      ((this._hooks = {}),
        (this._before = void 0),
        (this._after = void 0),
        (this._deprecatedMessages = void 0),
        (this._deprecatedHooks = {}),
        (this.hook = this.hook.bind(this)),
        (this.callHook = this.callHook.bind(this)),
        (this.callHookWith = this.callHookWith.bind(this)));
    }
    hook(t, n, s = {}) {
      if (!t || typeof n != 'function') return () => {};
      const r = t;
      let o;
      for (; this._deprecatedHooks[t]; ) ((o = this._deprecatedHooks[t]), (t = o.to));
      if (o && !s.allowDeprecated) {
        let i = o.message;
        (i || (i = `${r} hook has been deprecated` + (o.to ? `, please use ${o.to}` : '')),
          this._deprecatedMessages || (this._deprecatedMessages = new Set()),
          this._deprecatedMessages.has(i) || (console.warn(i), this._deprecatedMessages.add(i)));
      }
      if (!n.name)
        try {
          Object.defineProperty(n, 'name', {
            get: () => '_' + t.replace(/\W+/g, '_') + '_hook_cb',
            configurable: !0
          });
        } catch {}
      return (
        (this._hooks[t] = this._hooks[t] || []),
        this._hooks[t].push(n),
        () => {
          n && (this.removeHook(t, n), (n = void 0));
        }
      );
    }
    hookOnce(t, n) {
      let s,
        r = (...o) => (typeof s == 'function' && s(), (s = void 0), (r = void 0), n(...o));
      return ((s = this.hook(t, r)), s);
    }
    removeHook(t, n) {
      if (this._hooks[t]) {
        const s = this._hooks[t].indexOf(n);
        (s !== -1 && this._hooks[t].splice(s, 1),
          this._hooks[t].length === 0 && delete this._hooks[t]);
      }
    }
    deprecateHook(t, n) {
      this._deprecatedHooks[t] = typeof n == 'string' ? { to: n } : n;
      const s = this._hooks[t] || [];
      delete this._hooks[t];
      for (const r of s) this.hook(t, r);
    }
    deprecateHooks(t) {
      Object.assign(this._deprecatedHooks, t);
      for (const n in t) this.deprecateHook(n, t[n]);
    }
    addHooks(t) {
      const n = li(t),
        s = Object.keys(n).map((r) => this.hook(r, n[r]));
      return () => {
        for (const r of s.splice(0, s.length)) r();
      };
    }
    removeHooks(t) {
      const n = li(t);
      for (const s in n) this.removeHook(s, n[s]);
    }
    removeAllHooks() {
      for (const t in this._hooks) delete this._hooks[t];
    }
    callHook(t, ...n) {
      return (n.unshift(t), this.callHookWith(sg, t, ...n));
    }
    callHookParallel(t, ...n) {
      return (n.unshift(t), this.callHookWith(rg, t, ...n));
    }
    callHookWith(t, n, ...s) {
      const r = this._before || this._after ? { name: n, args: s, context: {} } : void 0;
      this._before && ai(this._before, r);
      const o = t(n in this._hooks ? [...this._hooks[n]] : [], s);
      return o instanceof Promise
        ? o.finally(() => {
            this._after && r && ai(this._after, r);
          })
        : (this._after && r && ai(this._after, r), o);
    }
    beforeEach(t) {
      return (
        (this._before = this._before || []),
        this._before.push(t),
        () => {
          if (this._before !== void 0) {
            const n = this._before.indexOf(t);
            n !== -1 && this._before.splice(n, 1);
          }
        }
      );
    }
    afterEach(t) {
      return (
        (this._after = this._after || []),
        this._after.push(t),
        () => {
          if (this._after !== void 0) {
            const n = this._after.indexOf(t);
            n !== -1 && this._after.splice(n, 1);
          }
        }
      );
    }
  }
  function Zu() {
    return new og();
  }
  var ig = Object.create,
    Xu = Object.defineProperty,
    lg = Object.getOwnPropertyDescriptor,
    ui = Object.getOwnPropertyNames,
    ag = Object.getPrototypeOf,
    ug = Object.prototype.hasOwnProperty,
    cg = (e, t) =>
      function () {
        return (e && (t = (0, e[ui(e)[0]])((e = 0))), t);
      },
    ec = (e, t) =>
      function () {
        return (t || (0, e[ui(e)[0]])((t = { exports: {} }).exports, t), t.exports);
      },
    fg = (e, t, n, s) => {
      if ((t && typeof t == 'object') || typeof t == 'function')
        for (let r of ui(t))
          !ug.call(e, r) &&
            r !== n &&
            Xu(e, r, { get: () => t[r], enumerable: !(s = lg(t, r)) || s.enumerable });
      return e;
    },
    dg = (e, t, n) => (
      (n = e != null ? ig(ag(e)) : {}),
      fg(Xu(n, 'default', { value: e, enumerable: !0 }), e)
    ),
    E = cg({
      '../../node_modules/.pnpm/tsup@8.4.0_@microsoft+api-extractor@7.51.1_@types+node@22.13.14__jiti@2.4.2_postcss@8.5_96eb05a9d65343021e53791dd83f3773/node_modules/tsup/assets/esm_shims.js'() {}
    }),
    pg = ec({
      '../../node_modules/.pnpm/speakingurl@14.0.1/node_modules/speakingurl/lib/speakingurl.js'(
        e,
        t
      ) {
        (E(),
          (function (n) {
            var s = {
                À: 'A',
                Á: 'A',
                Â: 'A',
                Ã: 'A',
                Ä: 'Ae',
                Å: 'A',
                Æ: 'AE',
                Ç: 'C',
                È: 'E',
                É: 'E',
                Ê: 'E',
                Ë: 'E',
                Ì: 'I',
                Í: 'I',
                Î: 'I',
                Ï: 'I',
                Ð: 'D',
                Ñ: 'N',
                Ò: 'O',
                Ó: 'O',
                Ô: 'O',
                Õ: 'O',
                Ö: 'Oe',
                Ő: 'O',
                Ø: 'O',
                Ù: 'U',
                Ú: 'U',
                Û: 'U',
                Ü: 'Ue',
                Ű: 'U',
                Ý: 'Y',
                Þ: 'TH',
                ß: 'ss',
                à: 'a',
                á: 'a',
                â: 'a',
                ã: 'a',
                ä: 'ae',
                å: 'a',
                æ: 'ae',
                ç: 'c',
                è: 'e',
                é: 'e',
                ê: 'e',
                ë: 'e',
                ì: 'i',
                í: 'i',
                î: 'i',
                ï: 'i',
                ð: 'd',
                ñ: 'n',
                ò: 'o',
                ó: 'o',
                ô: 'o',
                õ: 'o',
                ö: 'oe',
                ő: 'o',
                ø: 'o',
                ù: 'u',
                ú: 'u',
                û: 'u',
                ü: 'ue',
                ű: 'u',
                ý: 'y',
                þ: 'th',
                ÿ: 'y',
                ẞ: 'SS',
                ا: 'a',
                أ: 'a',
                إ: 'i',
                آ: 'aa',
                ؤ: 'u',
                ئ: 'e',
                ء: 'a',
                ب: 'b',
                ت: 't',
                ث: 'th',
                ج: 'j',
                ح: 'h',
                خ: 'kh',
                د: 'd',
                ذ: 'th',
                ر: 'r',
                ز: 'z',
                س: 's',
                ش: 'sh',
                ص: 's',
                ض: 'dh',
                ط: 't',
                ظ: 'z',
                ع: 'a',
                غ: 'gh',
                ف: 'f',
                ق: 'q',
                ك: 'k',
                ل: 'l',
                م: 'm',
                ن: 'n',
                ه: 'h',
                و: 'w',
                ي: 'y',
                ى: 'a',
                ة: 'h',
                ﻻ: 'la',
                ﻷ: 'laa',
                ﻹ: 'lai',
                ﻵ: 'laa',
                گ: 'g',
                چ: 'ch',
                پ: 'p',
                ژ: 'zh',
                ک: 'k',
                ی: 'y',
                'َ': 'a',
                'ً': 'an',
                'ِ': 'e',
                'ٍ': 'en',
                'ُ': 'u',
                'ٌ': 'on',
                'ْ': '',
                '٠': '0',
                '١': '1',
                '٢': '2',
                '٣': '3',
                '٤': '4',
                '٥': '5',
                '٦': '6',
                '٧': '7',
                '٨': '8',
                '٩': '9',
                '۰': '0',
                '۱': '1',
                '۲': '2',
                '۳': '3',
                '۴': '4',
                '۵': '5',
                '۶': '6',
                '۷': '7',
                '۸': '8',
                '۹': '9',
                က: 'k',
                ခ: 'kh',
                ဂ: 'g',
                ဃ: 'ga',
                င: 'ng',
                စ: 's',
                ဆ: 'sa',
                ဇ: 'z',
                စျ: 'za',
                ည: 'ny',
                ဋ: 't',
                ဌ: 'ta',
                ဍ: 'd',
                ဎ: 'da',
                ဏ: 'na',
                တ: 't',
                ထ: 'ta',
                ဒ: 'd',
                ဓ: 'da',
                န: 'n',
                ပ: 'p',
                ဖ: 'pa',
                ဗ: 'b',
                ဘ: 'ba',
                မ: 'm',
                ယ: 'y',
                ရ: 'ya',
                လ: 'l',
                ဝ: 'w',
                သ: 'th',
                ဟ: 'h',
                ဠ: 'la',
                အ: 'a',
                'ြ': 'y',
                'ျ': 'ya',
                'ွ': 'w',
                'ြွ': 'yw',
                'ျွ': 'ywa',
                'ှ': 'h',
                ဧ: 'e',
                '၏': '-e',
                ဣ: 'i',
                ဤ: '-i',
                ဉ: 'u',
                ဦ: '-u',
                ဩ: 'aw',
                သြော: 'aw',
                ဪ: 'aw',
                '၀': '0',
                '၁': '1',
                '၂': '2',
                '၃': '3',
                '၄': '4',
                '၅': '5',
                '၆': '6',
                '၇': '7',
                '၈': '8',
                '၉': '9',
                '္': '',
                '့': '',
                'း': '',
                č: 'c',
                ď: 'd',
                ě: 'e',
                ň: 'n',
                ř: 'r',
                š: 's',
                ť: 't',
                ů: 'u',
                ž: 'z',
                Č: 'C',
                Ď: 'D',
                Ě: 'E',
                Ň: 'N',
                Ř: 'R',
                Š: 'S',
                Ť: 'T',
                Ů: 'U',
                Ž: 'Z',
                ހ: 'h',
                ށ: 'sh',
                ނ: 'n',
                ރ: 'r',
                ބ: 'b',
                ޅ: 'lh',
                ކ: 'k',
                އ: 'a',
                ވ: 'v',
                މ: 'm',
                ފ: 'f',
                ދ: 'dh',
                ތ: 'th',
                ލ: 'l',
                ގ: 'g',
                ޏ: 'gn',
                ސ: 's',
                ޑ: 'd',
                ޒ: 'z',
                ޓ: 't',
                ޔ: 'y',
                ޕ: 'p',
                ޖ: 'j',
                ޗ: 'ch',
                ޘ: 'tt',
                ޙ: 'hh',
                ޚ: 'kh',
                ޛ: 'th',
                ޜ: 'z',
                ޝ: 'sh',
                ޞ: 's',
                ޟ: 'd',
                ޠ: 't',
                ޡ: 'z',
                ޢ: 'a',
                ޣ: 'gh',
                ޤ: 'q',
                ޥ: 'w',
                'ަ': 'a',
                'ާ': 'aa',
                'ި': 'i',
                'ީ': 'ee',
                'ު': 'u',
                'ޫ': 'oo',
                'ެ': 'e',
                'ޭ': 'ey',
                'ޮ': 'o',
                'ޯ': 'oa',
                'ް': '',
                ა: 'a',
                ბ: 'b',
                გ: 'g',
                დ: 'd',
                ე: 'e',
                ვ: 'v',
                ზ: 'z',
                თ: 't',
                ი: 'i',
                კ: 'k',
                ლ: 'l',
                მ: 'm',
                ნ: 'n',
                ო: 'o',
                პ: 'p',
                ჟ: 'zh',
                რ: 'r',
                ს: 's',
                ტ: 't',
                უ: 'u',
                ფ: 'p',
                ქ: 'k',
                ღ: 'gh',
                ყ: 'q',
                შ: 'sh',
                ჩ: 'ch',
                ც: 'ts',
                ძ: 'dz',
                წ: 'ts',
                ჭ: 'ch',
                ხ: 'kh',
                ჯ: 'j',
                ჰ: 'h',
                α: 'a',
                β: 'v',
                γ: 'g',
                δ: 'd',
                ε: 'e',
                ζ: 'z',
                η: 'i',
                θ: 'th',
                ι: 'i',
                κ: 'k',
                λ: 'l',
                μ: 'm',
                ν: 'n',
                ξ: 'ks',
                ο: 'o',
                π: 'p',
                ρ: 'r',
                σ: 's',
                τ: 't',
                υ: 'y',
                φ: 'f',
                χ: 'x',
                ψ: 'ps',
                ω: 'o',
                ά: 'a',
                έ: 'e',
                ί: 'i',
                ό: 'o',
                ύ: 'y',
                ή: 'i',
                ώ: 'o',
                ς: 's',
                ϊ: 'i',
                ΰ: 'y',
                ϋ: 'y',
                ΐ: 'i',
                Α: 'A',
                Β: 'B',
                Γ: 'G',
                Δ: 'D',
                Ε: 'E',
                Ζ: 'Z',
                Η: 'I',
                Θ: 'TH',
                Ι: 'I',
                Κ: 'K',
                Λ: 'L',
                Μ: 'M',
                Ν: 'N',
                Ξ: 'KS',
                Ο: 'O',
                Π: 'P',
                Ρ: 'R',
                Σ: 'S',
                Τ: 'T',
                Υ: 'Y',
                Φ: 'F',
                Χ: 'X',
                Ψ: 'PS',
                Ω: 'O',
                Ά: 'A',
                Έ: 'E',
                Ί: 'I',
                Ό: 'O',
                Ύ: 'Y',
                Ή: 'I',
                Ώ: 'O',
                Ϊ: 'I',
                Ϋ: 'Y',
                ā: 'a',
                ē: 'e',
                ģ: 'g',
                ī: 'i',
                ķ: 'k',
                ļ: 'l',
                ņ: 'n',
                ū: 'u',
                Ā: 'A',
                Ē: 'E',
                Ģ: 'G',
                Ī: 'I',
                Ķ: 'k',
                Ļ: 'L',
                Ņ: 'N',
                Ū: 'U',
                Ќ: 'Kj',
                ќ: 'kj',
                Љ: 'Lj',
                љ: 'lj',
                Њ: 'Nj',
                њ: 'nj',
                Тс: 'Ts',
                тс: 'ts',
                ą: 'a',
                ć: 'c',
                ę: 'e',
                ł: 'l',
                ń: 'n',
                ś: 's',
                ź: 'z',
                ż: 'z',
                Ą: 'A',
                Ć: 'C',
                Ę: 'E',
                Ł: 'L',
                Ń: 'N',
                Ś: 'S',
                Ź: 'Z',
                Ż: 'Z',
                Є: 'Ye',
                І: 'I',
                Ї: 'Yi',
                Ґ: 'G',
                є: 'ye',
                і: 'i',
                ї: 'yi',
                ґ: 'g',
                ă: 'a',
                Ă: 'A',
                ș: 's',
                Ș: 'S',
                ț: 't',
                Ț: 'T',
                ţ: 't',
                Ţ: 'T',
                а: 'a',
                б: 'b',
                в: 'v',
                г: 'g',
                д: 'd',
                е: 'e',
                ё: 'yo',
                ж: 'zh',
                з: 'z',
                и: 'i',
                й: 'i',
                к: 'k',
                л: 'l',
                м: 'm',
                н: 'n',
                о: 'o',
                п: 'p',
                р: 'r',
                с: 's',
                т: 't',
                у: 'u',
                ф: 'f',
                х: 'kh',
                ц: 'c',
                ч: 'ch',
                ш: 'sh',
                щ: 'sh',
                ъ: '',
                ы: 'y',
                ь: '',
                э: 'e',
                ю: 'yu',
                я: 'ya',
                А: 'A',
                Б: 'B',
                В: 'V',
                Г: 'G',
                Д: 'D',
                Е: 'E',
                Ё: 'Yo',
                Ж: 'Zh',
                З: 'Z',
                И: 'I',
                Й: 'I',
                К: 'K',
                Л: 'L',
                М: 'M',
                Н: 'N',
                О: 'O',
                П: 'P',
                Р: 'R',
                С: 'S',
                Т: 'T',
                У: 'U',
                Ф: 'F',
                Х: 'Kh',
                Ц: 'C',
                Ч: 'Ch',
                Ш: 'Sh',
                Щ: 'Sh',
                Ъ: '',
                Ы: 'Y',
                Ь: '',
                Э: 'E',
                Ю: 'Yu',
                Я: 'Ya',
                ђ: 'dj',
                ј: 'j',
                ћ: 'c',
                џ: 'dz',
                Ђ: 'Dj',
                Ј: 'j',
                Ћ: 'C',
                Џ: 'Dz',
                ľ: 'l',
                ĺ: 'l',
                ŕ: 'r',
                Ľ: 'L',
                Ĺ: 'L',
                Ŕ: 'R',
                ş: 's',
                Ş: 'S',
                ı: 'i',
                İ: 'I',
                ğ: 'g',
                Ğ: 'G',
                ả: 'a',
                Ả: 'A',
                ẳ: 'a',
                Ẳ: 'A',
                ẩ: 'a',
                Ẩ: 'A',
                đ: 'd',
                Đ: 'D',
                ẹ: 'e',
                Ẹ: 'E',
                ẽ: 'e',
                Ẽ: 'E',
                ẻ: 'e',
                Ẻ: 'E',
                ế: 'e',
                Ế: 'E',
                ề: 'e',
                Ề: 'E',
                ệ: 'e',
                Ệ: 'E',
                ễ: 'e',
                Ễ: 'E',
                ể: 'e',
                Ể: 'E',
                ỏ: 'o',
                ọ: 'o',
                Ọ: 'o',
                ố: 'o',
                Ố: 'O',
                ồ: 'o',
                Ồ: 'O',
                ổ: 'o',
                Ổ: 'O',
                ộ: 'o',
                Ộ: 'O',
                ỗ: 'o',
                Ỗ: 'O',
                ơ: 'o',
                Ơ: 'O',
                ớ: 'o',
                Ớ: 'O',
                ờ: 'o',
                Ờ: 'O',
                ợ: 'o',
                Ợ: 'O',
                ỡ: 'o',
                Ỡ: 'O',
                Ở: 'o',
                ở: 'o',
                ị: 'i',
                Ị: 'I',
                ĩ: 'i',
                Ĩ: 'I',
                ỉ: 'i',
                Ỉ: 'i',
                ủ: 'u',
                Ủ: 'U',
                ụ: 'u',
                Ụ: 'U',
                ũ: 'u',
                Ũ: 'U',
                ư: 'u',
                Ư: 'U',
                ứ: 'u',
                Ứ: 'U',
                ừ: 'u',
                Ừ: 'U',
                ự: 'u',
                Ự: 'U',
                ữ: 'u',
                Ữ: 'U',
                ử: 'u',
                Ử: 'ư',
                ỷ: 'y',
                Ỷ: 'y',
                ỳ: 'y',
                Ỳ: 'Y',
                ỵ: 'y',
                Ỵ: 'Y',
                ỹ: 'y',
                Ỹ: 'Y',
                ạ: 'a',
                Ạ: 'A',
                ấ: 'a',
                Ấ: 'A',
                ầ: 'a',
                Ầ: 'A',
                ậ: 'a',
                Ậ: 'A',
                ẫ: 'a',
                Ẫ: 'A',
                ắ: 'a',
                Ắ: 'A',
                ằ: 'a',
                Ằ: 'A',
                ặ: 'a',
                Ặ: 'A',
                ẵ: 'a',
                Ẵ: 'A',
                '⓪': '0',
                '①': '1',
                '②': '2',
                '③': '3',
                '④': '4',
                '⑤': '5',
                '⑥': '6',
                '⑦': '7',
                '⑧': '8',
                '⑨': '9',
                '⑩': '10',
                '⑪': '11',
                '⑫': '12',
                '⑬': '13',
                '⑭': '14',
                '⑮': '15',
                '⑯': '16',
                '⑰': '17',
                '⑱': '18',
                '⑲': '18',
                '⑳': '18',
                '⓵': '1',
                '⓶': '2',
                '⓷': '3',
                '⓸': '4',
                '⓹': '5',
                '⓺': '6',
                '⓻': '7',
                '⓼': '8',
                '⓽': '9',
                '⓾': '10',
                '⓿': '0',
                '⓫': '11',
                '⓬': '12',
                '⓭': '13',
                '⓮': '14',
                '⓯': '15',
                '⓰': '16',
                '⓱': '17',
                '⓲': '18',
                '⓳': '19',
                '⓴': '20',
                'Ⓐ': 'A',
                'Ⓑ': 'B',
                'Ⓒ': 'C',
                'Ⓓ': 'D',
                'Ⓔ': 'E',
                'Ⓕ': 'F',
                'Ⓖ': 'G',
                'Ⓗ': 'H',
                'Ⓘ': 'I',
                'Ⓙ': 'J',
                'Ⓚ': 'K',
                'Ⓛ': 'L',
                'Ⓜ': 'M',
                'Ⓝ': 'N',
                'Ⓞ': 'O',
                'Ⓟ': 'P',
                'Ⓠ': 'Q',
                'Ⓡ': 'R',
                'Ⓢ': 'S',
                'Ⓣ': 'T',
                'Ⓤ': 'U',
                'Ⓥ': 'V',
                'Ⓦ': 'W',
                'Ⓧ': 'X',
                'Ⓨ': 'Y',
                'Ⓩ': 'Z',
                'ⓐ': 'a',
                'ⓑ': 'b',
                'ⓒ': 'c',
                'ⓓ': 'd',
                'ⓔ': 'e',
                'ⓕ': 'f',
                'ⓖ': 'g',
                'ⓗ': 'h',
                'ⓘ': 'i',
                'ⓙ': 'j',
                'ⓚ': 'k',
                'ⓛ': 'l',
                'ⓜ': 'm',
                'ⓝ': 'n',
                'ⓞ': 'o',
                'ⓟ': 'p',
                'ⓠ': 'q',
                'ⓡ': 'r',
                'ⓢ': 's',
                'ⓣ': 't',
                'ⓤ': 'u',
                'ⓦ': 'v',
                'ⓥ': 'w',
                'ⓧ': 'x',
                'ⓨ': 'y',
                'ⓩ': 'z',
                '“': '"',
                '”': '"',
                '‘': "'",
                '’': "'",
                '∂': 'd',
                ƒ: 'f',
                '™': '(TM)',
                '©': '(C)',
                œ: 'oe',
                Œ: 'OE',
                '®': '(R)',
                '†': '+',
                '℠': '(SM)',
                '…': '...',
                '˚': 'o',
                º: 'o',
                ª: 'a',
                '•': '*',
                '၊': ',',
                '။': '.',
                $: 'USD',
                '€': 'EUR',
                '₢': 'BRN',
                '₣': 'FRF',
                '£': 'GBP',
                '₤': 'ITL',
                '₦': 'NGN',
                '₧': 'ESP',
                '₩': 'KRW',
                '₪': 'ILS',
                '₫': 'VND',
                '₭': 'LAK',
                '₮': 'MNT',
                '₯': 'GRD',
                '₱': 'ARS',
                '₲': 'PYG',
                '₳': 'ARA',
                '₴': 'UAH',
                '₵': 'GHS',
                '¢': 'cent',
                '¥': 'CNY',
                元: 'CNY',
                円: 'YEN',
                '﷼': 'IRR',
                '₠': 'EWE',
                '฿': 'THB',
                '₨': 'INR',
                '₹': 'INR',
                '₰': 'PF',
                '₺': 'TRY',
                '؋': 'AFN',
                '₼': 'AZN',
                лв: 'BGN',
                '៛': 'KHR',
                '₡': 'CRC',
                '₸': 'KZT',
                ден: 'MKD',
                zł: 'PLN',
                '₽': 'RUB',
                '₾': 'GEL'
              },
              r = ['်', 'ް'],
              o = {
                'ာ': 'a',
                'ါ': 'a',
                'ေ': 'e',
                'ဲ': 'e',
                'ိ': 'i',
                'ီ': 'i',
                'ို': 'o',
                'ု': 'u',
                'ူ': 'u',
                'ေါင်': 'aung',
                'ော': 'aw',
                'ော်': 'aw',
                'ေါ': 'aw',
                'ေါ်': 'aw',
                '်': '်',
                က်: 'et',
                'ိုက်': 'aik',
                'ောက်': 'auk',
                င်: 'in',
                'ိုင်': 'aing',
                'ောင်': 'aung',
                စ်: 'it',
                ည်: 'i',
                တ်: 'at',
                'ိတ်': 'eik',
                'ုတ်': 'ok',
                'ွတ်': 'ut',
                'ေတ်': 'it',
                ဒ်: 'd',
                'ိုဒ်': 'ok',
                'ုဒ်': 'ait',
                န်: 'an',
                'ာန်': 'an',
                'ိန်': 'ein',
                'ုန်': 'on',
                'ွန်': 'un',
                ပ်: 'at',
                'ိပ်': 'eik',
                'ုပ်': 'ok',
                'ွပ်': 'ut',
                န်ုပ်: 'nub',
                မ်: 'an',
                'ိမ်': 'ein',
                'ုမ်': 'on',
                'ွမ်': 'un',
                ယ်: 'e',
                'ိုလ်': 'ol',
                ဉ်: 'in',
                'ံ': 'an',
                'ိံ': 'ein',
                'ုံ': 'on',
                'ައް': 'ah',
                'ަށް': 'ah'
              },
              i = {
                en: {},
                az: {
                  ç: 'c',
                  ə: 'e',
                  ğ: 'g',
                  ı: 'i',
                  ö: 'o',
                  ş: 's',
                  ü: 'u',
                  Ç: 'C',
                  Ə: 'E',
                  Ğ: 'G',
                  İ: 'I',
                  Ö: 'O',
                  Ş: 'S',
                  Ü: 'U'
                },
                cs: {
                  č: 'c',
                  ď: 'd',
                  ě: 'e',
                  ň: 'n',
                  ř: 'r',
                  š: 's',
                  ť: 't',
                  ů: 'u',
                  ž: 'z',
                  Č: 'C',
                  Ď: 'D',
                  Ě: 'E',
                  Ň: 'N',
                  Ř: 'R',
                  Š: 'S',
                  Ť: 'T',
                  Ů: 'U',
                  Ž: 'Z'
                },
                fi: { ä: 'a', Ä: 'A', ö: 'o', Ö: 'O' },
                hu: { ä: 'a', Ä: 'A', ö: 'o', Ö: 'O', ü: 'u', Ü: 'U', ű: 'u', Ű: 'U' },
                lt: {
                  ą: 'a',
                  č: 'c',
                  ę: 'e',
                  ė: 'e',
                  į: 'i',
                  š: 's',
                  ų: 'u',
                  ū: 'u',
                  ž: 'z',
                  Ą: 'A',
                  Č: 'C',
                  Ę: 'E',
                  Ė: 'E',
                  Į: 'I',
                  Š: 'S',
                  Ų: 'U',
                  Ū: 'U'
                },
                lv: {
                  ā: 'a',
                  č: 'c',
                  ē: 'e',
                  ģ: 'g',
                  ī: 'i',
                  ķ: 'k',
                  ļ: 'l',
                  ņ: 'n',
                  š: 's',
                  ū: 'u',
                  ž: 'z',
                  Ā: 'A',
                  Č: 'C',
                  Ē: 'E',
                  Ģ: 'G',
                  Ī: 'i',
                  Ķ: 'k',
                  Ļ: 'L',
                  Ņ: 'N',
                  Š: 'S',
                  Ū: 'u',
                  Ž: 'Z'
                },
                pl: {
                  ą: 'a',
                  ć: 'c',
                  ę: 'e',
                  ł: 'l',
                  ń: 'n',
                  ó: 'o',
                  ś: 's',
                  ź: 'z',
                  ż: 'z',
                  Ą: 'A',
                  Ć: 'C',
                  Ę: 'e',
                  Ł: 'L',
                  Ń: 'N',
                  Ó: 'O',
                  Ś: 'S',
                  Ź: 'Z',
                  Ż: 'Z'
                },
                sv: { ä: 'a', Ä: 'A', ö: 'o', Ö: 'O' },
                sk: { ä: 'a', Ä: 'A' },
                sr: { љ: 'lj', њ: 'nj', Љ: 'Lj', Њ: 'Nj', đ: 'dj', Đ: 'Dj' },
                tr: { Ü: 'U', Ö: 'O', ü: 'u', ö: 'o' }
              },
              l = {
                ar: {
                  '∆': 'delta',
                  '∞': 'la-nihaya',
                  '♥': 'hob',
                  '&': 'wa',
                  '|': 'aw',
                  '<': 'aqal-men',
                  '>': 'akbar-men',
                  '∑': 'majmou',
                  '¤': 'omla'
                },
                az: {},
                ca: {
                  '∆': 'delta',
                  '∞': 'infinit',
                  '♥': 'amor',
                  '&': 'i',
                  '|': 'o',
                  '<': 'menys que',
                  '>': 'mes que',
                  '∑': 'suma dels',
                  '¤': 'moneda'
                },
                cs: {
                  '∆': 'delta',
                  '∞': 'nekonecno',
                  '♥': 'laska',
                  '&': 'a',
                  '|': 'nebo',
                  '<': 'mensi nez',
                  '>': 'vetsi nez',
                  '∑': 'soucet',
                  '¤': 'mena'
                },
                de: {
                  '∆': 'delta',
                  '∞': 'unendlich',
                  '♥': 'Liebe',
                  '&': 'und',
                  '|': 'oder',
                  '<': 'kleiner als',
                  '>': 'groesser als',
                  '∑': 'Summe von',
                  '¤': 'Waehrung'
                },
                dv: {
                  '∆': 'delta',
                  '∞': 'kolunulaa',
                  '♥': 'loabi',
                  '&': 'aai',
                  '|': 'noonee',
                  '<': 'ah vure kuda',
                  '>': 'ah vure bodu',
                  '∑': 'jumula',
                  '¤': 'faisaa'
                },
                en: {
                  '∆': 'delta',
                  '∞': 'infinity',
                  '♥': 'love',
                  '&': 'and',
                  '|': 'or',
                  '<': 'less than',
                  '>': 'greater than',
                  '∑': 'sum',
                  '¤': 'currency'
                },
                es: {
                  '∆': 'delta',
                  '∞': 'infinito',
                  '♥': 'amor',
                  '&': 'y',
                  '|': 'u',
                  '<': 'menos que',
                  '>': 'mas que',
                  '∑': 'suma de los',
                  '¤': 'moneda'
                },
                fa: {
                  '∆': 'delta',
                  '∞': 'bi-nahayat',
                  '♥': 'eshgh',
                  '&': 'va',
                  '|': 'ya',
                  '<': 'kamtar-az',
                  '>': 'bishtar-az',
                  '∑': 'majmooe',
                  '¤': 'vahed'
                },
                fi: {
                  '∆': 'delta',
                  '∞': 'aarettomyys',
                  '♥': 'rakkaus',
                  '&': 'ja',
                  '|': 'tai',
                  '<': 'pienempi kuin',
                  '>': 'suurempi kuin',
                  '∑': 'summa',
                  '¤': 'valuutta'
                },
                fr: {
                  '∆': 'delta',
                  '∞': 'infiniment',
                  '♥': 'Amour',
                  '&': 'et',
                  '|': 'ou',
                  '<': 'moins que',
                  '>': 'superieure a',
                  '∑': 'somme des',
                  '¤': 'monnaie'
                },
                ge: {
                  '∆': 'delta',
                  '∞': 'usasruloba',
                  '♥': 'siqvaruli',
                  '&': 'da',
                  '|': 'an',
                  '<': 'naklebi',
                  '>': 'meti',
                  '∑': 'jami',
                  '¤': 'valuta'
                },
                gr: {},
                hu: {
                  '∆': 'delta',
                  '∞': 'vegtelen',
                  '♥': 'szerelem',
                  '&': 'es',
                  '|': 'vagy',
                  '<': 'kisebb mint',
                  '>': 'nagyobb mint',
                  '∑': 'szumma',
                  '¤': 'penznem'
                },
                it: {
                  '∆': 'delta',
                  '∞': 'infinito',
                  '♥': 'amore',
                  '&': 'e',
                  '|': 'o',
                  '<': 'minore di',
                  '>': 'maggiore di',
                  '∑': 'somma',
                  '¤': 'moneta'
                },
                lt: {
                  '∆': 'delta',
                  '∞': 'begalybe',
                  '♥': 'meile',
                  '&': 'ir',
                  '|': 'ar',
                  '<': 'maziau nei',
                  '>': 'daugiau nei',
                  '∑': 'suma',
                  '¤': 'valiuta'
                },
                lv: {
                  '∆': 'delta',
                  '∞': 'bezgaliba',
                  '♥': 'milestiba',
                  '&': 'un',
                  '|': 'vai',
                  '<': 'mazak neka',
                  '>': 'lielaks neka',
                  '∑': 'summa',
                  '¤': 'valuta'
                },
                my: {
                  '∆': 'kwahkhyaet',
                  '∞': 'asaonasme',
                  '♥': 'akhyait',
                  '&': 'nhin',
                  '|': 'tho',
                  '<': 'ngethaw',
                  '>': 'kyithaw',
                  '∑': 'paungld',
                  '¤': 'ngwekye'
                },
                mk: {},
                nl: {
                  '∆': 'delta',
                  '∞': 'oneindig',
                  '♥': 'liefde',
                  '&': 'en',
                  '|': 'of',
                  '<': 'kleiner dan',
                  '>': 'groter dan',
                  '∑': 'som',
                  '¤': 'valuta'
                },
                pl: {
                  '∆': 'delta',
                  '∞': 'nieskonczonosc',
                  '♥': 'milosc',
                  '&': 'i',
                  '|': 'lub',
                  '<': 'mniejsze niz',
                  '>': 'wieksze niz',
                  '∑': 'suma',
                  '¤': 'waluta'
                },
                pt: {
                  '∆': 'delta',
                  '∞': 'infinito',
                  '♥': 'amor',
                  '&': 'e',
                  '|': 'ou',
                  '<': 'menor que',
                  '>': 'maior que',
                  '∑': 'soma',
                  '¤': 'moeda'
                },
                ro: {
                  '∆': 'delta',
                  '∞': 'infinit',
                  '♥': 'dragoste',
                  '&': 'si',
                  '|': 'sau',
                  '<': 'mai mic ca',
                  '>': 'mai mare ca',
                  '∑': 'suma',
                  '¤': 'valuta'
                },
                ru: {
                  '∆': 'delta',
                  '∞': 'beskonechno',
                  '♥': 'lubov',
                  '&': 'i',
                  '|': 'ili',
                  '<': 'menshe',
                  '>': 'bolshe',
                  '∑': 'summa',
                  '¤': 'valjuta'
                },
                sk: {
                  '∆': 'delta',
                  '∞': 'nekonecno',
                  '♥': 'laska',
                  '&': 'a',
                  '|': 'alebo',
                  '<': 'menej ako',
                  '>': 'viac ako',
                  '∑': 'sucet',
                  '¤': 'mena'
                },
                sr: {},
                tr: {
                  '∆': 'delta',
                  '∞': 'sonsuzluk',
                  '♥': 'ask',
                  '&': 've',
                  '|': 'veya',
                  '<': 'kucuktur',
                  '>': 'buyuktur',
                  '∑': 'toplam',
                  '¤': 'para birimi'
                },
                uk: {
                  '∆': 'delta',
                  '∞': 'bezkinechnist',
                  '♥': 'lubov',
                  '&': 'i',
                  '|': 'abo',
                  '<': 'menshe',
                  '>': 'bilshe',
                  '∑': 'suma',
                  '¤': 'valjuta'
                },
                vn: {
                  '∆': 'delta',
                  '∞': 'vo cuc',
                  '♥': 'yeu',
                  '&': 'va',
                  '|': 'hoac',
                  '<': 'nho hon',
                  '>': 'lon hon',
                  '∑': 'tong',
                  '¤': 'tien te'
                }
              },
              a = [';', '?', ':', '@', '&', '=', '+', '$', ',', '/'].join(''),
              f = [';', '?', ':', '@', '&', '=', '+', '$', ','].join(''),
              u = ['.', '!', '~', '*', "'", '(', ')'].join(''),
              c = function (v, b) {
                var $ = '-',
                  C = '',
                  G = '',
                  D = !0,
                  te = {},
                  V,
                  ce,
                  K,
                  I,
                  T,
                  x,
                  Q,
                  Y,
                  me,
                  ae,
                  j,
                  Z,
                  ue,
                  ft,
                  Ce = '';
                if (typeof v != 'string') return '';
                if (
                  (typeof b == 'string' && ($ = b), (Q = l.en), (Y = i.en), typeof b == 'object')
                ) {
                  ((V = b.maintainCase || !1),
                    (te = b.custom && typeof b.custom == 'object' ? b.custom : te),
                    (K = (+b.truncate > 1 && b.truncate) || !1),
                    (I = b.uric || !1),
                    (T = b.uricNoSlash || !1),
                    (x = b.mark || !1),
                    (D = !(b.symbols === !1 || b.lang === !1)),
                    ($ = b.separator || $),
                    I && (Ce += a),
                    T && (Ce += f),
                    x && (Ce += u),
                    (Q = b.lang && l[b.lang] && D ? l[b.lang] : D ? l.en : {}),
                    (Y =
                      b.lang && i[b.lang] ? i[b.lang] : b.lang === !1 || b.lang === !0 ? {} : i.en),
                    b.titleCase &&
                    typeof b.titleCase.length == 'number' &&
                    Array.prototype.toString.call(b.titleCase)
                      ? (b.titleCase.forEach(function (Ee) {
                          te[Ee + ''] = Ee + '';
                        }),
                        (ce = !0))
                      : (ce = !!b.titleCase),
                    b.custom &&
                      typeof b.custom.length == 'number' &&
                      Array.prototype.toString.call(b.custom) &&
                      b.custom.forEach(function (Ee) {
                        te[Ee + ''] = Ee + '';
                      }),
                    Object.keys(te).forEach(function (Ee) {
                      var ze;
                      (Ee.length > 1
                        ? (ze = new RegExp('\\b' + p(Ee) + '\\b', 'gi'))
                        : (ze = new RegExp(p(Ee), 'gi')),
                        (v = v.replace(ze, te[Ee])));
                    }));
                  for (j in te) Ce += j;
                }
                for (
                  Ce += $,
                    Ce = p(Ce),
                    v = v.replace(/(^\s+|\s+$)/g, ''),
                    ue = !1,
                    ft = !1,
                    ae = 0,
                    Z = v.length;
                  ae < Z;
                  ae++
                )
                  ((j = v[ae]),
                    h(j, te)
                      ? (ue = !1)
                      : Y[j]
                        ? ((j = ue && Y[j].match(/[A-Za-z0-9]/) ? ' ' + Y[j] : Y[j]), (ue = !1))
                        : j in s
                          ? (ae + 1 < Z && r.indexOf(v[ae + 1]) >= 0
                              ? ((G += j), (j = ''))
                              : ft === !0
                                ? ((j = o[G] + s[j]), (G = ''))
                                : (j = ue && s[j].match(/[A-Za-z0-9]/) ? ' ' + s[j] : s[j]),
                            (ue = !1),
                            (ft = !1))
                          : j in o
                            ? ((G += j), (j = ''), ae === Z - 1 && (j = o[G]), (ft = !0))
                            : Q[j] && !(I && a.indexOf(j) !== -1) && !(T && f.indexOf(j) !== -1)
                              ? ((j = ue || C.substr(-1).match(/[A-Za-z0-9]/) ? $ + Q[j] : Q[j]),
                                (j +=
                                  v[ae + 1] !== void 0 && v[ae + 1].match(/[A-Za-z0-9]/) ? $ : ''),
                                (ue = !0))
                              : (ft === !0
                                  ? ((j = o[G] + j), (G = ''), (ft = !1))
                                  : ue &&
                                    (/[A-Za-z0-9]/.test(j) || C.substr(-1).match(/A-Za-z0-9]/)) &&
                                    (j = ' ' + j),
                                (ue = !1)),
                    (C += j.replace(new RegExp('[^\\w\\s' + Ce + '_-]', 'g'), $)));
                return (
                  ce &&
                    (C = C.replace(/(\w)(\S*)/g, function (Ee, ze, _t) {
                      var on = ze.toUpperCase() + (_t !== null ? _t : '');
                      return Object.keys(te).indexOf(on.toLowerCase()) < 0 ? on : on.toLowerCase();
                    })),
                  (C = C.replace(/\s+/g, $)
                    .replace(new RegExp('\\' + $ + '+', 'g'), $)
                    .replace(new RegExp('(^\\' + $ + '+|\\' + $ + '+$)', 'g'), '')),
                  K &&
                    C.length > K &&
                    ((me = C.charAt(K) === $),
                    (C = C.slice(0, K)),
                    me || (C = C.slice(0, C.lastIndexOf($)))),
                  !V && !ce && (C = C.toLowerCase()),
                  C
                );
              },
              d = function (v) {
                return function ($) {
                  return c($, v);
                };
              },
              p = function (v) {
                return v.replace(/[-\\^$*+?.()|[\]{}\/]/g, '\\$&');
              },
              h = function (q, v) {
                for (var b in v) if (v[b] === q) return !0;
              };
            if (typeof t < 'u' && t.exports) ((t.exports = c), (t.exports.createSlug = d));
            else if (typeof define < 'u' && define.amd)
              define([], function () {
                return c;
              });
            else
              try {
                if (n.getSlug || n.createSlug)
                  throw 'speakingurl: globals exists /(getSlug|createSlug)/';
                ((n.getSlug = c), (n.createSlug = d));
              } catch {}
          })(e));
      }
    }),
    hg = ec({
      '../../node_modules/.pnpm/speakingurl@14.0.1/node_modules/speakingurl/index.js'(e, t) {
        (E(), (t.exports = pg()));
      }
    });
  (E(), E(), E(), E(), E(), E(), E(), E());
  function mg(e) {
    var t;
    const n = e.name || e._componentTag || e.__VUE_DEVTOOLS_COMPONENT_GUSSED_NAME__ || e.__name;
    return n === 'index' && (t = e.__file) != null && t.endsWith('index.vue') ? '' : n;
  }
  function gg(e) {
    const t = e.__file;
    if (t) return Y0(Z0(t, '.vue'));
  }
  function tc(e, t) {
    return ((e.type.__VUE_DEVTOOLS_COMPONENT_GUSSED_NAME__ = t), t);
  }
  function ci(e) {
    if (e.__VUE_DEVTOOLS_NEXT_APP_RECORD__) return e.__VUE_DEVTOOLS_NEXT_APP_RECORD__;
    if (e.root) return e.appContext.app.__VUE_DEVTOOLS_NEXT_APP_RECORD__;
  }
  function nc(e) {
    var t, n;
    const s = (t = e.subTree) == null ? void 0 : t.type,
      r = ci(e);
    return r ? ((n = r == null ? void 0 : r.types) == null ? void 0 : n.Fragment) === s : !1;
  }
  function Mr(e) {
    var t, n, s;
    const r = mg((e == null ? void 0 : e.type) || {});
    if (r) return r;
    if ((e == null ? void 0 : e.root) === e) return 'Root';
    for (const i in (n = (t = e.parent) == null ? void 0 : t.type) == null ? void 0 : n.components)
      if (e.parent.type.components[i] === (e == null ? void 0 : e.type)) return tc(e, i);
    for (const i in (s = e.appContext) == null ? void 0 : s.components)
      if (e.appContext.components[i] === (e == null ? void 0 : e.type)) return tc(e, i);
    const o = gg((e == null ? void 0 : e.type) || {});
    return o || 'Anonymous Component';
  }
  function _g(e) {
    var t, n, s;
    const r =
        (s =
          (n = (t = e == null ? void 0 : e.appContext) == null ? void 0 : t.app) == null
            ? void 0
            : n.__VUE_DEVTOOLS_NEXT_APP_RECORD_ID__) != null
          ? s
          : 0,
      o = e === (e == null ? void 0 : e.root) ? 'root' : e.uid;
    return `${r}:${o}`;
  }
  function fi(e, t) {
    return ((t = t || `${e.id}:root`), e.instanceMap.get(t) || e.instanceMap.get(':root'));
  }
  function qg() {
    const e = {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      get width() {
        return e.right - e.left;
      },
      get height() {
        return e.bottom - e.top;
      }
    };
    return e;
  }
  var Nr;
  function vg(e) {
    return (Nr || (Nr = document.createRange()), Nr.selectNode(e), Nr.getBoundingClientRect());
  }
  function bg(e) {
    const t = qg();
    if (!e.children) return t;
    for (let n = 0, s = e.children.length; n < s; n++) {
      const r = e.children[n];
      let o;
      if (r.component) o = Cn(r.component);
      else if (r.el) {
        const i = r.el;
        i.nodeType === 1 || i.getBoundingClientRect
          ? (o = i.getBoundingClientRect())
          : i.nodeType === 3 && i.data.trim() && (o = vg(i));
      }
      o && yg(t, o);
    }
    return t;
  }
  function yg(e, t) {
    return (
      (!e.top || t.top < e.top) && (e.top = t.top),
      (!e.bottom || t.bottom > e.bottom) && (e.bottom = t.bottom),
      (!e.left || t.left < e.left) && (e.left = t.left),
      (!e.right || t.right > e.right) && (e.right = t.right),
      e
    );
  }
  var sc = { top: 0, left: 0, right: 0, bottom: 0, width: 0, height: 0 };
  function Cn(e) {
    const t = e.subTree.el;
    return typeof window > 'u'
      ? sc
      : nc(e)
        ? bg(e.subTree)
        : (t == null ? void 0 : t.nodeType) === 1
          ? t == null
            ? void 0
            : t.getBoundingClientRect()
          : e.subTree.component
            ? Cn(e.subTree.component)
            : sc;
  }
  E();
  function di(e) {
    return nc(e) ? xg(e.subTree) : e.subTree ? [e.subTree.el] : [];
  }
  function xg(e) {
    if (!e.children) return [];
    const t = [];
    return (
      e.children.forEach((n) => {
        n.component ? t.push(...di(n.component)) : n != null && n.el && t.push(n.el);
      }),
      t
    );
  }
  var rc = '__vue-devtools-component-inspector__',
    oc = '__vue-devtools-component-inspector__card__',
    ic = '__vue-devtools-component-inspector__name__',
    lc = '__vue-devtools-component-inspector__indicator__',
    ac = {
      display: 'block',
      zIndex: 2147483640,
      position: 'fixed',
      backgroundColor: '#42b88325',
      border: '1px solid #42b88350',
      borderRadius: '5px',
      transition: 'all 0.1s ease-in',
      pointerEvents: 'none'
    },
    wg = {
      fontFamily: 'Arial, Helvetica, sans-serif',
      padding: '5px 8px',
      borderRadius: '4px',
      textAlign: 'left',
      position: 'absolute',
      left: 0,
      color: '#e9e9e9',
      fontSize: '14px',
      fontWeight: 600,
      lineHeight: '24px',
      backgroundColor: '#42b883',
      boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1)'
    },
    Sg = {
      display: 'inline-block',
      fontWeight: 400,
      fontStyle: 'normal',
      fontSize: '12px',
      opacity: 0.7
    };
  function Zn() {
    return document.getElementById(rc);
  }
  function Eg() {
    return document.getElementById(oc);
  }
  function kg() {
    return document.getElementById(lc);
  }
  function Cg() {
    return document.getElementById(ic);
  }
  function pi(e) {
    return {
      left: `${Math.round(e.left * 100) / 100}px`,
      top: `${Math.round(e.top * 100) / 100}px`,
      width: `${Math.round(e.width * 100) / 100}px`,
      height: `${Math.round(e.height * 100) / 100}px`
    };
  }
  function hi(e) {
    var t;
    const n = document.createElement('div');
    ((n.id = (t = e.elementId) != null ? t : rc),
      Object.assign(n.style, { ...ac, ...pi(e.bounds), ...e.style }));
    const s = document.createElement('span');
    ((s.id = oc), Object.assign(s.style, { ...wg, top: e.bounds.top < 35 ? 0 : '-35px' }));
    const r = document.createElement('span');
    ((r.id = ic), (r.innerHTML = `&lt;${e.name}&gt;&nbsp;&nbsp;`));
    const o = document.createElement('i');
    return (
      (o.id = lc),
      (o.innerHTML = `${Math.round(e.bounds.width * 100) / 100} x ${Math.round(e.bounds.height * 100) / 100}`),
      Object.assign(o.style, Sg),
      s.appendChild(r),
      s.appendChild(o),
      n.appendChild(s),
      document.body.appendChild(n),
      n
    );
  }
  function mi(e) {
    const t = Zn(),
      n = Eg(),
      s = Cg(),
      r = kg();
    t &&
      (Object.assign(t.style, { ...ac, ...pi(e.bounds) }),
      Object.assign(n.style, { top: e.bounds.top < 35 ? 0 : '-35px' }),
      (s.innerHTML = `&lt;${e.name}&gt;&nbsp;&nbsp;`),
      (r.innerHTML = `${Math.round(e.bounds.width * 100) / 100} x ${Math.round(e.bounds.height * 100) / 100}`));
  }
  function Ag(e) {
    const t = Cn(e);
    if (!t.width && !t.height) return;
    const n = Mr(e);
    Zn() ? mi({ bounds: t, name: n }) : hi({ bounds: t, name: n });
  }
  function uc() {
    const e = Zn();
    e && (e.style.display = 'none');
  }
  var gi = null;
  function _i(e) {
    const t = e.target;
    if (t) {
      const n = t.__vueParentComponent;
      if (n && ((gi = n), n.vnode.el)) {
        const r = Cn(n),
          o = Mr(n);
        Zn() ? mi({ bounds: r, name: o }) : hi({ bounds: r, name: o });
      }
    }
  }
  function Tg(e, t) {
    if ((e.preventDefault(), e.stopPropagation(), gi)) {
      const n = _g(gi);
      t(n);
    }
  }
  var Vr = null;
  function Og() {
    (uc(),
      window.removeEventListener('mouseover', _i),
      window.removeEventListener('click', Vr, !0),
      (Vr = null));
  }
  function Bg() {
    return (
      window.addEventListener('mouseover', _i),
      new Promise((e) => {
        function t(n) {
          (n.preventDefault(),
            n.stopPropagation(),
            Tg(n, (s) => {
              (window.removeEventListener('click', t, !0),
                (Vr = null),
                window.removeEventListener('mouseover', _i));
              const r = Zn();
              (r && (r.style.display = 'none'), e(JSON.stringify({ id: s })));
            }));
        }
        ((Vr = t), window.addEventListener('click', t, !0));
      })
    );
  }
  function Ig(e) {
    const t = fi(Je.value, e.id);
    if (t) {
      const [n] = di(t);
      if (typeof n.scrollIntoView == 'function') n.scrollIntoView({ behavior: 'smooth' });
      else {
        const s = Cn(t),
          r = document.createElement('div'),
          o = { ...pi(s), position: 'absolute' };
        (Object.assign(r.style, o),
          document.body.appendChild(r),
          r.scrollIntoView({ behavior: 'smooth' }),
          setTimeout(() => {
            document.body.removeChild(r);
          }, 2e3));
      }
      setTimeout(() => {
        const s = Cn(t);
        if (s.width || s.height) {
          const r = Mr(t),
            o = Zn();
          (o ? mi({ ...e, name: r, bounds: s }) : hi({ ...e, name: r, bounds: s }),
            setTimeout(() => {
              o && (o.style.display = 'none');
            }, 1500));
        }
      }, 1200);
    }
  }
  E();
  var cc, fc;
  (fc = (cc = W).__VUE_DEVTOOLS_COMPONENT_INSPECTOR_ENABLED__) != null ||
    (cc.__VUE_DEVTOOLS_COMPONENT_INSPECTOR_ENABLED__ = !0);
  function Rg(e) {
    let t = 0;
    const n = setInterval(() => {
      (W.__VUE_INSPECTOR__ && (clearInterval(n), (t += 30), e()), t >= 5e3 && clearInterval(n));
    }, 30);
  }
  function Pg() {
    const e = W.__VUE_INSPECTOR__,
      t = e.openInEditor;
    e.openInEditor = async (...n) => {
      (e.disable(), t(...n));
    };
  }
  function $g() {
    return new Promise((e) => {
      function t() {
        (Pg(), e(W.__VUE_INSPECTOR__));
      }
      W.__VUE_INSPECTOR__
        ? t()
        : Rg(() => {
            t();
          });
    });
  }
  (E(), E());
  function Dg(e) {
    return !!(e && e.__v_isReadonly);
  }
  function dc(e) {
    return Dg(e) ? dc(e.__v_raw) : !!(e && e.__v_isReactive);
  }
  function qi(e) {
    return !!(e && e.__v_isRef === !0);
  }
  function Ds(e) {
    const t = e && e.__v_raw;
    return t ? Ds(t) : e;
  }
  var Fg = class {
      constructor() {
        this.refEditor = new zg();
      }
      set(e, t, n, s) {
        const r = Array.isArray(t) ? t : t.split('.');
        for (; r.length > 1; ) {
          const l = r.shift();
          (e instanceof Map
            ? (e = e.get(l))
            : e instanceof Set
              ? (e = Array.from(e.values())[l])
              : (e = e[l]),
            this.refEditor.isRef(e) && (e = this.refEditor.get(e)));
        }
        const o = r[0],
          i = this.refEditor.get(e)[o];
        s ? s(e, o, n) : this.refEditor.isRef(i) ? this.refEditor.set(i, n) : (e[o] = n);
      }
      get(e, t) {
        const n = Array.isArray(t) ? t : t.split('.');
        for (let s = 0; s < n.length; s++)
          if (
            (e instanceof Map ? (e = e.get(n[s])) : (e = e[n[s]]),
            this.refEditor.isRef(e) && (e = this.refEditor.get(e)),
            !e)
          )
            return;
        return e;
      }
      has(e, t, n = !1) {
        if (typeof e > 'u') return !1;
        const s = Array.isArray(t) ? t.slice() : t.split('.'),
          r = n ? 2 : 1;
        for (; e && s.length > r; ) {
          const o = s.shift();
          ((e = e[o]), this.refEditor.isRef(e) && (e = this.refEditor.get(e)));
        }
        return e != null && Object.prototype.hasOwnProperty.call(e, s[0]);
      }
      createDefaultSetCallback(e) {
        return (t, n, s) => {
          if (
            ((e.remove || e.newKey) &&
              (Array.isArray(t)
                ? t.splice(n, 1)
                : Ds(t) instanceof Map
                  ? t.delete(n)
                  : Ds(t) instanceof Set
                    ? t.delete(Array.from(t.values())[n])
                    : Reflect.deleteProperty(t, n)),
            !e.remove)
          ) {
            const r = t[e.newKey || n];
            this.refEditor.isRef(r)
              ? this.refEditor.set(r, s)
              : Ds(t) instanceof Map
                ? t.set(e.newKey || n, s)
                : Ds(t) instanceof Set
                  ? t.add(s)
                  : (t[e.newKey || n] = s);
          }
        };
      }
    },
    zg = class {
      set(e, t) {
        if (qi(e)) e.value = t;
        else {
          if (e instanceof Set && Array.isArray(t)) {
            (e.clear(), t.forEach((r) => e.add(r)));
            return;
          }
          const n = Object.keys(t);
          if (e instanceof Map) {
            const r = new Set(e.keys());
            (n.forEach((o) => {
              (e.set(o, Reflect.get(t, o)), r.delete(o));
            }),
              r.forEach((o) => e.delete(o)));
            return;
          }
          const s = new Set(Object.keys(e));
          (n.forEach((r) => {
            (Reflect.set(e, r, Reflect.get(t, r)), s.delete(r));
          }),
            s.forEach((r) => Reflect.deleteProperty(e, r)));
        }
      }
      get(e) {
        return qi(e) ? e.value : e;
      }
      isRef(e) {
        return qi(e) || dc(e);
      }
    };
  (E(), E(), E());
  var Mg = '__VUE_DEVTOOLS_KIT_TIMELINE_LAYERS_STATE__';
  function Ng() {
    if (!Wu || typeof localStorage > 'u' || localStorage === null)
      return {
        recordingState: !1,
        mouseEventEnabled: !1,
        keyboardEventEnabled: !1,
        componentEventEnabled: !1,
        performanceEventEnabled: !1,
        selected: ''
      };
    const e = localStorage.getItem(Mg);
    return e
      ? JSON.parse(e)
      : {
          recordingState: !1,
          mouseEventEnabled: !1,
          keyboardEventEnabled: !1,
          componentEventEnabled: !1,
          performanceEventEnabled: !1,
          selected: ''
        };
  }
  (E(), E(), E());
  var pc, hc;
  (hc = (pc = W).__VUE_DEVTOOLS_KIT_TIMELINE_LAYERS) != null ||
    (pc.__VUE_DEVTOOLS_KIT_TIMELINE_LAYERS = []);
  var Vg = new Proxy(W.__VUE_DEVTOOLS_KIT_TIMELINE_LAYERS, {
    get(e, t, n) {
      return Reflect.get(e, t, n);
    }
  });
  function Lg(e, t) {
    ((Pe.timelineLayersState[t.id] = !1),
      Vg.push({ ...e, descriptorId: t.id, appRecord: ci(t.app) }));
  }
  var mc, gc;
  (gc = (mc = W).__VUE_DEVTOOLS_KIT_INSPECTOR__) != null ||
    (mc.__VUE_DEVTOOLS_KIT_INSPECTOR__ = []);
  var vi = new Proxy(W.__VUE_DEVTOOLS_KIT_INSPECTOR__, {
      get(e, t, n) {
        return Reflect.get(e, t, n);
      }
    }),
    _c = Yn(() => {
      es.hooks.callHook('sendInspectorToClient', qc());
    });
  function Ug(e, t) {
    var n, s;
    (vi.push({
      options: e,
      descriptor: t,
      treeFilterPlaceholder: (n = e.treeFilterPlaceholder) != null ? n : 'Search tree...',
      stateFilterPlaceholder: (s = e.stateFilterPlaceholder) != null ? s : 'Search state...',
      treeFilter: '',
      selectedNodeId: '',
      appRecord: ci(t.app)
    }),
      _c());
  }
  function qc() {
    return vi
      .filter((e) => e.descriptor.app === Je.value.app)
      .filter((e) => e.descriptor.id !== 'components')
      .map((e) => {
        var t;
        const n = e.descriptor,
          s = e.options;
        return {
          id: s.id,
          label: s.label,
          logo: n.logo,
          icon: `custom-ic-baseline-${(t = s == null ? void 0 : s.icon) == null ? void 0 : t.replace(/_/g, '-')}`,
          packageName: n.packageName,
          homepage: n.homepage,
          pluginId: n.id
        };
      });
  }
  function Lr(e, t) {
    return vi.find((n) => n.options.id === e && (t ? n.descriptor.app === t : !0));
  }
  function jg() {
    const e = Zu();
    e.hook('addInspector', ({ inspector: s, plugin: r }) => {
      Ug(s, r.descriptor);
    });
    const t = Yn(async ({ inspectorId: s, plugin: r }) => {
      var o;
      if (
        !s ||
        !((o = r == null ? void 0 : r.descriptor) != null && o.app) ||
        Pe.highPerfModeEnabled
      )
        return;
      const i = Lr(s, r.descriptor.app),
        l = {
          app: r.descriptor.app,
          inspectorId: s,
          filter: (i == null ? void 0 : i.treeFilter) || '',
          rootNodes: []
        };
      (await new Promise((a) => {
        e.callHookWith(async (f) => {
          (await Promise.all(f.map((u) => u(l))), a());
        }, 'getInspectorTree');
      }),
        e.callHookWith(async (a) => {
          await Promise.all(a.map((f) => f({ inspectorId: s, rootNodes: l.rootNodes })));
        }, 'sendInspectorTreeToClient'));
    }, 120);
    e.hook('sendInspectorTree', t);
    const n = Yn(async ({ inspectorId: s, plugin: r }) => {
      var o;
      if (
        !s ||
        !((o = r == null ? void 0 : r.descriptor) != null && o.app) ||
        Pe.highPerfModeEnabled
      )
        return;
      const i = Lr(s, r.descriptor.app),
        l = {
          app: r.descriptor.app,
          inspectorId: s,
          nodeId: (i == null ? void 0 : i.selectedNodeId) || '',
          state: null
        },
        a = { currentTab: `custom-inspector:${s}` };
      (l.nodeId &&
        (await new Promise((f) => {
          e.callHookWith(async (u) => {
            (await Promise.all(u.map((c) => c(l, a))), f());
          }, 'getInspectorState');
        })),
        e.callHookWith(async (f) => {
          await Promise.all(f.map((u) => u({ inspectorId: s, nodeId: l.nodeId, state: l.state })));
        }, 'sendInspectorStateToClient'));
    }, 120);
    return (
      e.hook('sendInspectorState', n),
      e.hook('customInspectorSelectNode', ({ inspectorId: s, nodeId: r, plugin: o }) => {
        const i = Lr(s, o.descriptor.app);
        i && (i.selectedNodeId = r);
      }),
      e.hook('timelineLayerAdded', ({ options: s, plugin: r }) => {
        Lg(s, r.descriptor);
      }),
      e.hook('timelineEventAdded', ({ options: s, plugin: r }) => {
        var o;
        const i = ['performance', 'component-event', 'keyboard', 'mouse'];
        Pe.highPerfModeEnabled ||
          (!((o = Pe.timelineLayersState) != null && o[r.descriptor.id]) &&
            !i.includes(s.layerId)) ||
          e.callHookWith(async (l) => {
            await Promise.all(l.map((a) => a(s)));
          }, 'sendTimelineEventToClient');
      }),
      e.hook('getComponentInstances', async ({ app: s }) => {
        const r = s.__VUE_DEVTOOLS_NEXT_APP_RECORD__;
        if (!r) return null;
        const o = r.id.toString();
        return [...r.instanceMap].filter(([l]) => l.split(':')[0] === o).map(([, l]) => l);
      }),
      e.hook('getComponentBounds', async ({ instance: s }) => Cn(s)),
      e.hook('getComponentName', ({ instance: s }) => Mr(s)),
      e.hook('componentHighlight', ({ uid: s }) => {
        const r = Je.value.instanceMap.get(s);
        r && Ag(r);
      }),
      e.hook('componentUnhighlight', () => {
        uc();
      }),
      e
    );
  }
  var vc, bc;
  (bc = (vc = W).__VUE_DEVTOOLS_KIT_APP_RECORDS__) != null ||
    (vc.__VUE_DEVTOOLS_KIT_APP_RECORDS__ = []);
  var yc, xc;
  (xc = (yc = W).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__) != null ||
    (yc.__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__ = {});
  var wc, Sc;
  (Sc = (wc = W).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD_ID__) != null ||
    (wc.__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD_ID__ = '');
  var Ec, kc;
  (kc = (Ec = W).__VUE_DEVTOOLS_KIT_CUSTOM_TABS__) != null ||
    (Ec.__VUE_DEVTOOLS_KIT_CUSTOM_TABS__ = []);
  var Cc, Ac;
  (Ac = (Cc = W).__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__) != null ||
    (Cc.__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__ = []);
  var An = '__VUE_DEVTOOLS_KIT_GLOBAL_STATE__';
  function Hg() {
    return {
      connected: !1,
      clientConnected: !1,
      vitePluginDetected: !0,
      appRecords: [],
      activeAppRecordId: '',
      tabs: [],
      commands: [],
      highPerfModeEnabled: !0,
      devtoolsClientDetected: {},
      perfUniqueGroupId: 0,
      timelineLayersState: Ng()
    };
  }
  var Tc, Oc;
  (Oc = (Tc = W)[An]) != null || (Tc[An] = Hg());
  var Qg = Yn((e) => {
    es.hooks.callHook('devtoolsStateUpdated', { state: e });
  });
  Yn((e, t) => {
    es.hooks.callHook('devtoolsConnectedUpdated', { state: e, oldState: t });
  });
  var Ur = new Proxy(W.__VUE_DEVTOOLS_KIT_APP_RECORDS__, {
      get(e, t, n) {
        return t === 'value'
          ? W.__VUE_DEVTOOLS_KIT_APP_RECORDS__
          : W.__VUE_DEVTOOLS_KIT_APP_RECORDS__[t];
      }
    }),
    Je = new Proxy(W.__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__, {
      get(e, t, n) {
        return t === 'value'
          ? W.__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__
          : t === 'id'
            ? W.__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD_ID__
            : W.__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__[t];
      }
    });
  function Bc() {
    Qg({
      ...W[An],
      appRecords: Ur.value,
      activeAppRecordId: Je.id,
      tabs: W.__VUE_DEVTOOLS_KIT_CUSTOM_TABS__,
      commands: W.__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__
    });
  }
  function Kg(e) {
    ((W.__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__ = e), Bc());
  }
  function Wg(e) {
    ((W.__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD_ID__ = e), Bc());
  }
  var Pe = new Proxy(W[An], {
    get(e, t) {
      return t === 'appRecords'
        ? Ur
        : t === 'activeAppRecordId'
          ? Je.id
          : t === 'tabs'
            ? W.__VUE_DEVTOOLS_KIT_CUSTOM_TABS__
            : t === 'commands'
              ? W.__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__
              : W[An][t];
    },
    deleteProperty(e, t) {
      return (delete e[t], !0);
    },
    set(e, t, n) {
      return ({ ...W[An] }, (e[t] = n), (W[An][t] = n), !0);
    }
  });
  function Gg(e = {}) {
    var t, n, s;
    const { file: r, host: o, baseUrl: i = window.location.origin, line: l = 0, column: a = 0 } = e;
    if (r) {
      if (o === 'chrome-extension') {
        const f = r.replace(/\\/g, '\\\\'),
          u =
            (n = (t = window.VUE_DEVTOOLS_CONFIG) == null ? void 0 : t.openInEditorHost) != null
              ? n
              : '/';
        fetch(`${u}__open-in-editor?file=${encodeURI(r)}`).then((c) => {
          if (!c.ok) {
            const d = `Opening component ${f} failed`;
            console.log(`%c${d}`, 'color:red');
          }
        });
      } else if (Pe.vitePluginDetected) {
        const f = (s = W.__VUE_DEVTOOLS_OPEN_IN_EDITOR_BASE_URL__) != null ? s : i;
        W.__VUE_INSPECTOR__.openInEditor(f, r, l, a);
      }
    }
  }
  (E(), E(), E(), E(), E());
  var Ic, Rc;
  (Rc = (Ic = W).__VUE_DEVTOOLS_KIT_PLUGIN_BUFFER__) != null ||
    (Ic.__VUE_DEVTOOLS_KIT_PLUGIN_BUFFER__ = []);
  var bi = new Proxy(W.__VUE_DEVTOOLS_KIT_PLUGIN_BUFFER__, {
    get(e, t, n) {
      return Reflect.get(e, t, n);
    }
  });
  function yi(e) {
    const t = {};
    return (
      Object.keys(e).forEach((n) => {
        t[n] = e[n].defaultValue;
      }),
      t
    );
  }
  function xi(e) {
    return `__VUE_DEVTOOLS_NEXT_PLUGIN_SETTINGS__${e}__`;
  }
  function Jg(e) {
    var t, n, s;
    const r =
      (n =
        (t = bi.find((o) => {
          var i;
          return o[0].id === e && !!((i = o[0]) != null && i.settings);
        })) == null
          ? void 0
          : t[0]) != null
        ? n
        : null;
    return (s = r == null ? void 0 : r.settings) != null ? s : null;
  }
  function Pc(e, t) {
    var n, s, r;
    const o = xi(e);
    if (o) {
      const i = localStorage.getItem(o);
      if (i) return JSON.parse(i);
    }
    if (e) {
      const i =
        (s = (n = bi.find((l) => l[0].id === e)) == null ? void 0 : n[0]) != null ? s : null;
      return yi((r = i == null ? void 0 : i.settings) != null ? r : {});
    }
    return yi(t);
  }
  function Yg(e, t) {
    const n = xi(e);
    localStorage.getItem(n) || localStorage.setItem(n, JSON.stringify(yi(t)));
  }
  function Zg(e, t, n) {
    const s = xi(e),
      r = localStorage.getItem(s),
      o = JSON.parse(r || '{}'),
      i = { ...o, [t]: n };
    (localStorage.setItem(s, JSON.stringify(i)),
      es.hooks.callHookWith((l) => {
        l.forEach((a) => a({ pluginId: e, key: t, oldValue: o[t], newValue: n, settings: i }));
      }, 'setPluginSettings'));
  }
  (E(), E(), E(), E(), E(), E(), E(), E(), E(), E(), E());
  var $c,
    Dc,
    ot = (Dc = ($c = W).__VUE_DEVTOOLS_HOOK) != null ? Dc : ($c.__VUE_DEVTOOLS_HOOK = Zu()),
    Xg = {
      vueAppInit(e) {
        ot.hook('app:init', e);
      },
      vueAppUnmount(e) {
        ot.hook('app:unmount', e);
      },
      vueAppConnected(e) {
        ot.hook('app:connected', e);
      },
      componentAdded(e) {
        return ot.hook('component:added', e);
      },
      componentEmit(e) {
        return ot.hook('component:emit', e);
      },
      componentUpdated(e) {
        return ot.hook('component:updated', e);
      },
      componentRemoved(e) {
        return ot.hook('component:removed', e);
      },
      setupDevtoolsPlugin(e) {
        ot.hook('devtools-plugin:setup', e);
      },
      perfStart(e) {
        return ot.hook('perf:start', e);
      },
      perfEnd(e) {
        return ot.hook('perf:end', e);
      }
    },
    Fc = {
      on: Xg,
      setupDevToolsPlugin(e, t) {
        return ot.callHook('devtools-plugin:setup', e, t);
      }
    },
    e1 = class {
      constructor({ plugin: e, ctx: t }) {
        ((this.hooks = t.hooks), (this.plugin = e));
      }
      get on() {
        return {
          visitComponentTree: (e) => {
            this.hooks.hook('visitComponentTree', e);
          },
          inspectComponent: (e) => {
            this.hooks.hook('inspectComponent', e);
          },
          editComponentState: (e) => {
            this.hooks.hook('editComponentState', e);
          },
          getInspectorTree: (e) => {
            this.hooks.hook('getInspectorTree', e);
          },
          getInspectorState: (e) => {
            this.hooks.hook('getInspectorState', e);
          },
          editInspectorState: (e) => {
            this.hooks.hook('editInspectorState', e);
          },
          inspectTimelineEvent: (e) => {
            this.hooks.hook('inspectTimelineEvent', e);
          },
          timelineCleared: (e) => {
            this.hooks.hook('timelineCleared', e);
          },
          setPluginSettings: (e) => {
            this.hooks.hook('setPluginSettings', e);
          }
        };
      }
      notifyComponentUpdate(e) {
        var t;
        if (Pe.highPerfModeEnabled) return;
        const n = qc().find((s) => s.packageName === this.plugin.descriptor.packageName);
        if (n != null && n.id) {
          if (e) {
            const s = [e.appContext.app, e.uid, (t = e.parent) == null ? void 0 : t.uid, e];
            ot.callHook('component:updated', ...s);
          } else ot.callHook('component:updated');
          this.hooks.callHook('sendInspectorState', { inspectorId: n.id, plugin: this.plugin });
        }
      }
      addInspector(e) {
        (this.hooks.callHook('addInspector', { inspector: e, plugin: this.plugin }),
          this.plugin.descriptor.settings && Yg(e.id, this.plugin.descriptor.settings));
      }
      sendInspectorTree(e) {
        Pe.highPerfModeEnabled ||
          this.hooks.callHook('sendInspectorTree', { inspectorId: e, plugin: this.plugin });
      }
      sendInspectorState(e) {
        Pe.highPerfModeEnabled ||
          this.hooks.callHook('sendInspectorState', { inspectorId: e, plugin: this.plugin });
      }
      selectInspectorNode(e, t) {
        this.hooks.callHook('customInspectorSelectNode', {
          inspectorId: e,
          nodeId: t,
          plugin: this.plugin
        });
      }
      visitComponentTree(e) {
        return this.hooks.callHook('visitComponentTree', e);
      }
      now() {
        return Pe.highPerfModeEnabled ? 0 : Date.now();
      }
      addTimelineLayer(e) {
        this.hooks.callHook('timelineLayerAdded', { options: e, plugin: this.plugin });
      }
      addTimelineEvent(e) {
        Pe.highPerfModeEnabled ||
          this.hooks.callHook('timelineEventAdded', { options: e, plugin: this.plugin });
      }
      getSettings(e) {
        return Pc(e ?? this.plugin.descriptor.id, this.plugin.descriptor.settings);
      }
      getComponentInstances(e) {
        return this.hooks.callHook('getComponentInstances', { app: e });
      }
      getComponentBounds(e) {
        return this.hooks.callHook('getComponentBounds', { instance: e });
      }
      getComponentName(e) {
        return this.hooks.callHook('getComponentName', { instance: e });
      }
      highlightElement(e) {
        const t = e.__VUE_DEVTOOLS_NEXT_UID__;
        return this.hooks.callHook('componentHighlight', { uid: t });
      }
      unhighlightElement() {
        return this.hooks.callHook('componentUnhighlight');
      }
    },
    t1 = e1;
  (E(), E(), E(), E());
  var n1 = '__vue_devtool_undefined__',
    s1 = '__vue_devtool_infinity__',
    r1 = '__vue_devtool_negative_infinity__',
    o1 = '__vue_devtool_nan__';
  (E(), E());
  var i1 = { [n1]: 'undefined', [o1]: 'NaN', [s1]: 'Infinity', [r1]: '-Infinity' };
  (Object.entries(i1).reduce((e, [t, n]) => ((e[n] = t), e), {}), E(), E(), E(), E(), E());
  var zc, Mc;
  (Mc = (zc = W).__VUE_DEVTOOLS_KIT__REGISTERED_PLUGIN_APPS__) != null ||
    (zc.__VUE_DEVTOOLS_KIT__REGISTERED_PLUGIN_APPS__ = new Set());
  function Nc(e, t) {
    return Fc.setupDevToolsPlugin(e, t);
  }
  function l1(e, t) {
    const [n, s] = e;
    if (n.app !== t) return;
    const r = new t1({ plugin: { setupFn: s, descriptor: n }, ctx: es });
    (n.packageName === 'vuex' &&
      r.on.editInspectorState((o) => {
        r.sendInspectorState(o.inspectorId);
      }),
      s(r));
  }
  function Vc(e, t) {
    W.__VUE_DEVTOOLS_KIT__REGISTERED_PLUGIN_APPS__.has(e) ||
      (Pe.highPerfModeEnabled && !(t != null && t.inspectingComponent)) ||
      (W.__VUE_DEVTOOLS_KIT__REGISTERED_PLUGIN_APPS__.add(e),
      bi.forEach((n) => {
        l1(n, e);
      }));
  }
  (E(), E());
  var Fs = '__VUE_DEVTOOLS_ROUTER__',
    Xn = '__VUE_DEVTOOLS_ROUTER_INFO__',
    Lc,
    Uc;
  (Uc = (Lc = W)[Xn]) != null || (Lc[Xn] = { currentRoute: null, routes: [] });
  var jc, Hc;
  ((Hc = (jc = W)[Fs]) != null || (jc[Fs] = {}),
    new Proxy(W[Xn], {
      get(e, t) {
        return W[Xn][t];
      }
    }),
    new Proxy(W[Fs], {
      get(e, t) {
        if (t === 'value') return W[Fs];
      }
    }));
  function a1(e) {
    const t = new Map();
    return ((e == null ? void 0 : e.getRoutes()) || []).filter(
      (n) => !t.has(n.path) && t.set(n.path, 1)
    );
  }
  function wi(e) {
    return e.map((t) => {
      let { path: n, name: s, children: r, meta: o } = t;
      return (r != null && r.length && (r = wi(r)), { path: n, name: s, children: r, meta: o });
    });
  }
  function u1(e) {
    if (e) {
      const {
        fullPath: t,
        hash: n,
        href: s,
        path: r,
        name: o,
        matched: i,
        params: l,
        query: a
      } = e;
      return {
        fullPath: t,
        hash: n,
        href: s,
        path: r,
        name: o,
        params: l,
        query: a,
        matched: wi(i)
      };
    }
    return e;
  }
  function c1(e, t) {
    function n() {
      var s;
      const r = (s = e.app) == null ? void 0 : s.config.globalProperties.$router,
        o = u1(r == null ? void 0 : r.currentRoute.value),
        i = wi(a1(r)),
        l = console.warn;
      ((console.warn = () => {}),
        (W[Xn] = { currentRoute: o ? Ju(o) : {}, routes: Ju(i) }),
        (W[Fs] = r),
        (console.warn = l));
    }
    (n(),
      Fc.on.componentUpdated(
        Yn(() => {
          var s;
          ((s = t.value) == null ? void 0 : s.app) === e.app &&
            (n(),
            !Pe.highPerfModeEnabled && es.hooks.callHook('routerInfoUpdated', { state: W[Xn] }));
        }, 200)
      ));
  }
  function f1(e) {
    return {
      async getInspectorTree(t) {
        const n = { ...t, app: Je.value.app, rootNodes: [] };
        return (
          await new Promise((s) => {
            e.callHookWith(async (r) => {
              (await Promise.all(r.map((o) => o(n))), s());
            }, 'getInspectorTree');
          }),
          n.rootNodes
        );
      },
      async getInspectorState(t) {
        const n = { ...t, app: Je.value.app, state: null },
          s = { currentTab: `custom-inspector:${t.inspectorId}` };
        return (
          await new Promise((r) => {
            e.callHookWith(async (o) => {
              (await Promise.all(o.map((i) => i(n, s))), r());
            }, 'getInspectorState');
          }),
          n.state
        );
      },
      editInspectorState(t) {
        const n = new Fg(),
          s = {
            ...t,
            app: Je.value.app,
            set: (r, o = t.path, i = t.state.value, l) => {
              n.set(r, o, i, l || n.createDefaultSetCallback(t.state));
            }
          };
        e.callHookWith((r) => {
          r.forEach((o) => o(s));
        }, 'editInspectorState');
      },
      sendInspectorState(t) {
        const n = Lr(t);
        e.callHook('sendInspectorState', {
          inspectorId: t,
          plugin: { descriptor: n.descriptor, setupFn: () => ({}) }
        });
      },
      inspectComponentInspector() {
        return Bg();
      },
      cancelInspectComponentInspector() {
        return Og();
      },
      getComponentRenderCode(t) {
        const n = fi(Je.value, t);
        if (n)
          return typeof (n == null ? void 0 : n.type) != 'function'
            ? n.render.toString()
            : n.type.toString();
      },
      scrollToComponent(t) {
        return Ig({ id: t });
      },
      openInEditor: Gg,
      getVueInspector: $g,
      toggleApp(t, n) {
        const s = Ur.value.find((r) => r.id === t);
        s && (Wg(t), Kg(s), c1(s, Je), _c(), Vc(s.app, n));
      },
      inspectDOM(t) {
        const n = fi(Je.value, t);
        if (n) {
          const [s] = di(n);
          s && (W.__VUE_DEVTOOLS_INSPECT_DOM_TARGET__ = s);
        }
      },
      updatePluginSettings(t, n, s) {
        Zg(t, n, s);
      },
      getPluginSettings(t) {
        return { options: Jg(t), values: Pc(t) };
      }
    };
  }
  E();
  var Qc, Kc;
  (Kc = (Qc = W).__VUE_DEVTOOLS_ENV__) != null ||
    (Qc.__VUE_DEVTOOLS_ENV__ = { vitePluginDetected: !1 });
  var Wc = jg(),
    Gc,
    Jc;
  (Jc = (Gc = W).__VUE_DEVTOOLS_KIT_CONTEXT__) != null ||
    (Gc.__VUE_DEVTOOLS_KIT_CONTEXT__ = {
      hooks: Wc,
      get state() {
        return { ...Pe, activeAppRecordId: Je.id, activeAppRecord: Je.value, appRecords: Ur.value };
      },
      api: f1(Wc)
    });
  var es = W.__VUE_DEVTOOLS_KIT_CONTEXT__;
  (E(), dg(hg()));
  var Yc, Zc;
  ((Zc = (Yc = W).__VUE_DEVTOOLS_NEXT_APP_RECORD_INFO__) != null ||
    (Yc.__VUE_DEVTOOLS_NEXT_APP_RECORD_INFO__ = { id: 0, appIds: new Set() }),
    E());
  function d1(e) {
    ((Pe.highPerfModeEnabled = e ?? !Pe.highPerfModeEnabled), !e && Je.value && Vc(Je.value.app));
  }
  (E(), E(), E());
  function p1(e) {
    Pe.devtoolsClientDetected = { ...Pe.devtoolsClientDetected, ...e };
    const t = Object.values(Pe.devtoolsClientDetected).some(Boolean);
    d1(!t);
  }
  var Xc, ef;
  ((ef = (Xc = W).__VUE_DEVTOOLS_UPDATE_CLIENT_DETECTED__) != null ||
    (Xc.__VUE_DEVTOOLS_UPDATE_CLIENT_DETECTED__ = p1),
    E(),
    E(),
    E(),
    E(),
    E(),
    E(),
    E());
  var h1 = class {
      constructor() {
        ((this.keyToValue = new Map()), (this.valueToKey = new Map()));
      }
      set(e, t) {
        (this.keyToValue.set(e, t), this.valueToKey.set(t, e));
      }
      getByKey(e) {
        return this.keyToValue.get(e);
      }
      getByValue(e) {
        return this.valueToKey.get(e);
      }
      clear() {
        (this.keyToValue.clear(), this.valueToKey.clear());
      }
    },
    tf = class {
      constructor(e) {
        ((this.generateIdentifier = e), (this.kv = new h1()));
      }
      register(e, t) {
        this.kv.getByValue(e) || (t || (t = this.generateIdentifier(e)), this.kv.set(t, e));
      }
      clear() {
        this.kv.clear();
      }
      getIdentifier(e) {
        return this.kv.getByValue(e);
      }
      getValue(e) {
        return this.kv.getByKey(e);
      }
    },
    m1 = class extends tf {
      constructor() {
        (super((e) => e.name), (this.classToAllowedProps = new Map()));
      }
      register(e, t) {
        typeof t == 'object'
          ? (t.allowProps && this.classToAllowedProps.set(e, t.allowProps),
            super.register(e, t.identifier))
          : super.register(e, t);
      }
      getAllowedProps(e) {
        return this.classToAllowedProps.get(e);
      }
    };
  (E(), E());
  function g1(e) {
    if ('values' in Object) return Object.values(e);
    const t = [];
    for (const n in e) e.hasOwnProperty(n) && t.push(e[n]);
    return t;
  }
  function _1(e, t) {
    const n = g1(e);
    if ('find' in n) return n.find(t);
    const s = n;
    for (let r = 0; r < s.length; r++) {
      const o = s[r];
      if (t(o)) return o;
    }
  }
  function ts(e, t) {
    Object.entries(e).forEach(([n, s]) => t(s, n));
  }
  function jr(e, t) {
    return e.indexOf(t) !== -1;
  }
  function nf(e, t) {
    for (let n = 0; n < e.length; n++) {
      const s = e[n];
      if (t(s)) return s;
    }
  }
  var q1 = class {
    constructor() {
      this.transfomers = {};
    }
    register(e) {
      this.transfomers[e.name] = e;
    }
    findApplicable(e) {
      return _1(this.transfomers, (t) => t.isApplicable(e));
    }
    findByName(e) {
      return this.transfomers[e];
    }
  };
  (E(), E());
  var v1 = (e) => Object.prototype.toString.call(e).slice(8, -1),
    sf = (e) => typeof e > 'u',
    b1 = (e) => e === null,
    zs = (e) =>
      typeof e != 'object' || e === null || e === Object.prototype
        ? !1
        : Object.getPrototypeOf(e) === null
          ? !0
          : Object.getPrototypeOf(e) === Object.prototype,
    Si = (e) => zs(e) && Object.keys(e).length === 0,
    sn = (e) => Array.isArray(e),
    y1 = (e) => typeof e == 'string',
    x1 = (e) => typeof e == 'number' && !isNaN(e),
    w1 = (e) => typeof e == 'boolean',
    S1 = (e) => e instanceof RegExp,
    Ms = (e) => e instanceof Map,
    Ns = (e) => e instanceof Set,
    rf = (e) => v1(e) === 'Symbol',
    E1 = (e) => e instanceof Date && !isNaN(e.valueOf()),
    k1 = (e) => e instanceof Error,
    of = (e) => typeof e == 'number' && isNaN(e),
    C1 = (e) => w1(e) || b1(e) || sf(e) || x1(e) || y1(e) || rf(e),
    A1 = (e) => typeof e == 'bigint',
    T1 = (e) => e === 1 / 0 || e === -1 / 0,
    O1 = (e) => ArrayBuffer.isView(e) && !(e instanceof DataView),
    B1 = (e) => e instanceof URL;
  E();
  var lf = (e) => e.replace(/\./g, '\\.'),
    Ei = (e) => e.map(String).map(lf).join('.'),
    Vs = (e) => {
      const t = [];
      let n = '';
      for (let r = 0; r < e.length; r++) {
        let o = e.charAt(r);
        if (o === '\\' && e.charAt(r + 1) === '.') {
          ((n += '.'), r++);
          continue;
        }
        if (o === '.') {
          (t.push(n), (n = ''));
          continue;
        }
        n += o;
      }
      const s = n;
      return (t.push(s), t);
    };
  E();
  function Ot(e, t, n, s) {
    return { isApplicable: e, annotation: t, transform: n, untransform: s };
  }
  var af = [
    Ot(
      sf,
      'undefined',
      () => null,
      () => {}
    ),
    Ot(
      A1,
      'bigint',
      (e) => e.toString(),
      (e) => (typeof BigInt < 'u' ? BigInt(e) : (console.error('Please add a BigInt polyfill.'), e))
    ),
    Ot(
      E1,
      'Date',
      (e) => e.toISOString(),
      (e) => new Date(e)
    ),
    Ot(
      k1,
      'Error',
      (e, t) => {
        const n = { name: e.name, message: e.message };
        return (
          t.allowedErrorProps.forEach((s) => {
            n[s] = e[s];
          }),
          n
        );
      },
      (e, t) => {
        const n = new Error(e.message);
        return (
          (n.name = e.name),
          (n.stack = e.stack),
          t.allowedErrorProps.forEach((s) => {
            n[s] = e[s];
          }),
          n
        );
      }
    ),
    Ot(
      S1,
      'regexp',
      (e) => '' + e,
      (e) => {
        const t = e.slice(1, e.lastIndexOf('/')),
          n = e.slice(e.lastIndexOf('/') + 1);
        return new RegExp(t, n);
      }
    ),
    Ot(
      Ns,
      'set',
      (e) => [...e.values()],
      (e) => new Set(e)
    ),
    Ot(
      Ms,
      'map',
      (e) => [...e.entries()],
      (e) => new Map(e)
    ),
    Ot(
      (e) => of(e) || T1(e),
      'number',
      (e) => (of(e) ? 'NaN' : e > 0 ? 'Infinity' : '-Infinity'),
      Number
    ),
    Ot(
      (e) => e === 0 && 1 / e === -1 / 0,
      'number',
      () => '-0',
      Number
    ),
    Ot(
      B1,
      'URL',
      (e) => e.toString(),
      (e) => new URL(e)
    )
  ];
  function Hr(e, t, n, s) {
    return { isApplicable: e, annotation: t, transform: n, untransform: s };
  }
  var uf = Hr(
      (e, t) => (rf(e) ? !!t.symbolRegistry.getIdentifier(e) : !1),
      (e, t) => ['symbol', t.symbolRegistry.getIdentifier(e)],
      (e) => e.description,
      (e, t, n) => {
        const s = n.symbolRegistry.getValue(t[1]);
        if (!s) throw new Error('Trying to deserialize unknown symbol');
        return s;
      }
    ),
    I1 = [
      Int8Array,
      Uint8Array,
      Int16Array,
      Uint16Array,
      Int32Array,
      Uint32Array,
      Float32Array,
      Float64Array,
      Uint8ClampedArray
    ].reduce((e, t) => ((e[t.name] = t), e), {}),
    cf = Hr(
      O1,
      (e) => ['typed-array', e.constructor.name],
      (e) => [...e],
      (e, t) => {
        const n = I1[t[1]];
        if (!n) throw new Error('Trying to deserialize unknown typed array');
        return new n(e);
      }
    );
  function ff(e, t) {
    return e != null && e.constructor ? !!t.classRegistry.getIdentifier(e.constructor) : !1;
  }
  var df = Hr(
      ff,
      (e, t) => ['class', t.classRegistry.getIdentifier(e.constructor)],
      (e, t) => {
        const n = t.classRegistry.getAllowedProps(e.constructor);
        if (!n) return { ...e };
        const s = {};
        return (
          n.forEach((r) => {
            s[r] = e[r];
          }),
          s
        );
      },
      (e, t, n) => {
        const s = n.classRegistry.getValue(t[1]);
        if (!s)
          throw new Error(
            `Trying to deserialize unknown class '${t[1]}' - check https://github.com/blitz-js/superjson/issues/116#issuecomment-773996564`
          );
        return Object.assign(Object.create(s.prototype), e);
      }
    ),
    pf = Hr(
      (e, t) => !!t.customTransformerRegistry.findApplicable(e),
      (e, t) => ['custom', t.customTransformerRegistry.findApplicable(e).name],
      (e, t) => t.customTransformerRegistry.findApplicable(e).serialize(e),
      (e, t, n) => {
        const s = n.customTransformerRegistry.findByName(t[1]);
        if (!s) throw new Error('Trying to deserialize unknown custom value');
        return s.deserialize(e);
      }
    ),
    R1 = [df, uf, pf, cf],
    hf = (e, t) => {
      const n = nf(R1, (r) => r.isApplicable(e, t));
      if (n) return { value: n.transform(e, t), type: n.annotation(e, t) };
      const s = nf(af, (r) => r.isApplicable(e, t));
      if (s) return { value: s.transform(e, t), type: s.annotation };
    },
    mf = {};
  af.forEach((e) => {
    mf[e.annotation] = e;
  });
  var P1 = (e, t, n) => {
    if (sn(t))
      switch (t[0]) {
        case 'symbol':
          return uf.untransform(e, t, n);
        case 'class':
          return df.untransform(e, t, n);
        case 'custom':
          return pf.untransform(e, t, n);
        case 'typed-array':
          return cf.untransform(e, t, n);
        default:
          throw new Error('Unknown transformation: ' + t);
      }
    else {
      const s = mf[t];
      if (!s) throw new Error('Unknown transformation: ' + t);
      return s.untransform(e, n);
    }
  };
  E();
  var ns = (e, t) => {
    if (t > e.size) throw new Error('index out of bounds');
    const n = e.keys();
    for (; t > 0; ) (n.next(), t--);
    return n.next().value;
  };
  function gf(e) {
    if (jr(e, '__proto__')) throw new Error('__proto__ is not allowed as a property');
    if (jr(e, 'prototype')) throw new Error('prototype is not allowed as a property');
    if (jr(e, 'constructor')) throw new Error('constructor is not allowed as a property');
  }
  var $1 = (e, t) => {
      gf(t);
      for (let n = 0; n < t.length; n++) {
        const s = t[n];
        if (Ns(e)) e = ns(e, +s);
        else if (Ms(e)) {
          const r = +s,
            o = +t[++n] == 0 ? 'key' : 'value',
            i = ns(e, r);
          switch (o) {
            case 'key':
              e = i;
              break;
            case 'value':
              e = e.get(i);
              break;
          }
        } else e = e[s];
      }
      return e;
    },
    ki = (e, t, n) => {
      if ((gf(t), t.length === 0)) return n(e);
      let s = e;
      for (let o = 0; o < t.length - 1; o++) {
        const i = t[o];
        if (sn(s)) {
          const l = +i;
          s = s[l];
        } else if (zs(s)) s = s[i];
        else if (Ns(s)) {
          const l = +i;
          s = ns(s, l);
        } else if (Ms(s)) {
          if (o === t.length - 2) break;
          const a = +i,
            f = +t[++o] == 0 ? 'key' : 'value',
            u = ns(s, a);
          switch (f) {
            case 'key':
              s = u;
              break;
            case 'value':
              s = s.get(u);
              break;
          }
        }
      }
      const r = t[t.length - 1];
      if ((sn(s) ? (s[+r] = n(s[+r])) : zs(s) && (s[r] = n(s[r])), Ns(s))) {
        const o = ns(s, +r),
          i = n(o);
        o !== i && (s.delete(o), s.add(i));
      }
      if (Ms(s)) {
        const o = +t[t.length - 2],
          i = ns(s, o);
        switch (+r == 0 ? 'key' : 'value') {
          case 'key': {
            const a = n(i);
            (s.set(a, s.get(i)), a !== i && s.delete(i));
            break;
          }
          case 'value': {
            s.set(i, n(s.get(i)));
            break;
          }
        }
      }
      return e;
    };
  function Ci(e, t, n = []) {
    if (!e) return;
    if (!sn(e)) {
      ts(e, (o, i) => Ci(o, t, [...n, ...Vs(i)]));
      return;
    }
    const [s, r] = e;
    (r &&
      ts(r, (o, i) => {
        Ci(o, t, [...n, ...Vs(i)]);
      }),
      t(s, n));
  }
  function D1(e, t, n) {
    return (
      Ci(t, (s, r) => {
        e = ki(e, r, (o) => P1(o, s, n));
      }),
      e
    );
  }
  function F1(e, t) {
    function n(s, r) {
      const o = $1(e, Vs(r));
      s.map(Vs).forEach((i) => {
        e = ki(e, i, () => o);
      });
    }
    if (sn(t)) {
      const [s, r] = t;
      (s.forEach((o) => {
        e = ki(e, Vs(o), () => e);
      }),
        r && ts(r, n));
    } else ts(t, n);
    return e;
  }
  var z1 = (e, t) => zs(e) || sn(e) || Ms(e) || Ns(e) || ff(e, t);
  function M1(e, t, n) {
    const s = n.get(e);
    s ? s.push(t) : n.set(e, [t]);
  }
  function N1(e, t) {
    const n = {};
    let s;
    return (
      e.forEach((r) => {
        if (r.length <= 1) return;
        t || (r = r.map((l) => l.map(String)).sort((l, a) => l.length - a.length));
        const [o, ...i] = r;
        o.length === 0 ? (s = i.map(Ei)) : (n[Ei(o)] = i.map(Ei));
      }),
      s ? (Si(n) ? [s] : [s, n]) : Si(n) ? void 0 : n
    );
  }
  var _f = (e, t, n, s, r = [], o = [], i = new Map()) => {
    var l;
    const a = C1(e);
    if (!a) {
      M1(e, r, t);
      const h = i.get(e);
      if (h) return s ? { transformedValue: null } : h;
    }
    if (!z1(e, n)) {
      const h = hf(e, n),
        q = h ? { transformedValue: h.value, annotations: [h.type] } : { transformedValue: e };
      return (a || i.set(e, q), q);
    }
    if (jr(o, e)) return { transformedValue: null };
    const f = hf(e, n),
      u = (l = f == null ? void 0 : f.value) != null ? l : e,
      c = sn(u) ? [] : {},
      d = {};
    ts(u, (h, q) => {
      if (q === '__proto__' || q === 'constructor' || q === 'prototype')
        throw new Error(
          `Detected property ${q}. This is a prototype pollution risk, please remove it from your object.`
        );
      const v = _f(h, t, n, s, [...r, q], [...o, e], i);
      ((c[q] = v.transformedValue),
        sn(v.annotations)
          ? (d[q] = v.annotations)
          : zs(v.annotations) &&
            ts(v.annotations, (b, $) => {
              d[lf(q) + '.' + $] = b;
            }));
    });
    const p = Si(d)
      ? { transformedValue: c, annotations: f ? [f.type] : void 0 }
      : { transformedValue: c, annotations: f ? [f.type, d] : d };
    return (a || i.set(e, p), p);
  };
  (E(), E());
  function qf(e) {
    return Object.prototype.toString.call(e).slice(8, -1);
  }
  function vf(e) {
    return qf(e) === 'Array';
  }
  function V1(e) {
    if (qf(e) !== 'Object') return !1;
    const t = Object.getPrototypeOf(e);
    return !!t && t.constructor === Object && t === Object.prototype;
  }
  function L1(e, t, n, s, r) {
    const o = {}.propertyIsEnumerable.call(s, t) ? 'enumerable' : 'nonenumerable';
    (o === 'enumerable' && (e[t] = n),
      r &&
        o === 'nonenumerable' &&
        Object.defineProperty(e, t, { value: n, enumerable: !1, writable: !0, configurable: !0 }));
  }
  function Ai(e, t = {}) {
    if (vf(e)) return e.map((r) => Ai(r, t));
    if (!V1(e)) return e;
    const n = Object.getOwnPropertyNames(e),
      s = Object.getOwnPropertySymbols(e);
    return [...n, ...s].reduce((r, o) => {
      if (vf(t.props) && !t.props.includes(o)) return r;
      const i = e[o],
        l = Ai(i, t);
      return (L1(r, o, l, e, t.nonenumerable), r);
    }, {});
  }
  var xe = class {
    constructor({ dedupe: e = !1 } = {}) {
      ((this.classRegistry = new m1()),
        (this.symbolRegistry = new tf((t) => {
          var n;
          return (n = t.description) != null ? n : '';
        })),
        (this.customTransformerRegistry = new q1()),
        (this.allowedErrorProps = []),
        (this.dedupe = e));
    }
    serialize(e) {
      const t = new Map(),
        n = _f(e, t, this, this.dedupe),
        s = { json: n.transformedValue };
      n.annotations && (s.meta = { ...s.meta, values: n.annotations });
      const r = N1(t, this.dedupe);
      return (r && (s.meta = { ...s.meta, referentialEqualities: r }), s);
    }
    deserialize(e) {
      const { json: t, meta: n } = e;
      let s = Ai(t);
      return (
        n != null && n.values && (s = D1(s, n.values, this)),
        n != null && n.referentialEqualities && (s = F1(s, n.referentialEqualities)),
        s
      );
    }
    stringify(e) {
      return JSON.stringify(this.serialize(e));
    }
    parse(e) {
      return this.deserialize(JSON.parse(e));
    }
    registerClass(e, t) {
      this.classRegistry.register(e, t);
    }
    registerSymbol(e, t) {
      this.symbolRegistry.register(e, t);
    }
    registerCustom(e, t) {
      this.customTransformerRegistry.register({ name: t, ...e });
    }
    allowErrorProps(...e) {
      this.allowedErrorProps.push(...e);
    }
  };
  ((xe.defaultInstance = new xe()),
    (xe.serialize = xe.defaultInstance.serialize.bind(xe.defaultInstance)),
    (xe.deserialize = xe.defaultInstance.deserialize.bind(xe.defaultInstance)),
    (xe.stringify = xe.defaultInstance.stringify.bind(xe.defaultInstance)),
    (xe.parse = xe.defaultInstance.parse.bind(xe.defaultInstance)),
    (xe.registerClass = xe.defaultInstance.registerClass.bind(xe.defaultInstance)),
    (xe.registerSymbol = xe.defaultInstance.registerSymbol.bind(xe.defaultInstance)),
    (xe.registerCustom = xe.defaultInstance.registerCustom.bind(xe.defaultInstance)),
    (xe.allowErrorProps = xe.defaultInstance.allowErrorProps.bind(xe.defaultInstance)),
    E(),
    E(),
    E(),
    E(),
    E(),
    E(),
    E(),
    E(),
    E(),
    E(),
    E(),
    E(),
    E(),
    E(),
    E(),
    E(),
    E(),
    E(),
    E(),
    E(),
    E(),
    E(),
    E());
  var bf, yf;
  (yf = (bf = W).__VUE_DEVTOOLS_KIT_MESSAGE_CHANNELS__) != null ||
    (bf.__VUE_DEVTOOLS_KIT_MESSAGE_CHANNELS__ = []);
  var xf, wf;
  (wf = (xf = W).__VUE_DEVTOOLS_KIT_RPC_CLIENT__) != null ||
    (xf.__VUE_DEVTOOLS_KIT_RPC_CLIENT__ = null);
  var Sf, Ef;
  (Ef = (Sf = W).__VUE_DEVTOOLS_KIT_RPC_SERVER__) != null ||
    (Sf.__VUE_DEVTOOLS_KIT_RPC_SERVER__ = null);
  var kf, Cf;
  (Cf = (kf = W).__VUE_DEVTOOLS_KIT_VITE_RPC_CLIENT__) != null ||
    (kf.__VUE_DEVTOOLS_KIT_VITE_RPC_CLIENT__ = null);
  var Af, Tf;
  (Tf = (Af = W).__VUE_DEVTOOLS_KIT_VITE_RPC_SERVER__) != null ||
    (Af.__VUE_DEVTOOLS_KIT_VITE_RPC_SERVER__ = null);
  var Of, Bf;
  ((Bf = (Of = W).__VUE_DEVTOOLS_KIT_BROADCAST_RPC_SERVER__) != null ||
    (Of.__VUE_DEVTOOLS_KIT_BROADCAST_RPC_SERVER__ = null),
    E(),
    E(),
    E(),
    E(),
    E(),
    E(),
    E());
  let Ti;
  const Ls = (e) => (Ti = e),
    If = Symbol('pinia');
  function Tn(e) {
    return (
      e &&
      typeof e == 'object' &&
      Object.prototype.toString.call(e) === '[object Object]' &&
      typeof e.toJSON != 'function'
    );
  }
  var Bt;
  (function (e) {
    ((e.direct = 'direct'), (e.patchObject = 'patch object'), (e.patchFunction = 'patch function'));
  })(Bt || (Bt = {}));
  const On = typeof window < 'u',
    Rf =
      typeof window == 'object' && window.window === window
        ? window
        : typeof self == 'object' && self.self === self
          ? self
          : typeof global == 'object' && global.global === global
            ? global
            : typeof globalThis == 'object'
              ? globalThis
              : { HTMLElement: null };
  function U1(e, { autoBom: t = !1 } = {}) {
    return t &&
      /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(e.type)
      ? new Blob(['\uFEFF', e], { type: e.type })
      : e;
  }
  function Oi(e, t, n) {
    const s = new XMLHttpRequest();
    (s.open('GET', e),
      (s.responseType = 'blob'),
      (s.onload = function () {
        Df(s.response, t, n);
      }),
      (s.onerror = function () {
        console.error('could not download file');
      }),
      s.send());
  }
  function Pf(e) {
    const t = new XMLHttpRequest();
    t.open('HEAD', e, !1);
    try {
      t.send();
    } catch {}
    return t.status >= 200 && t.status <= 299;
  }
  function Qr(e) {
    try {
      e.dispatchEvent(new MouseEvent('click'));
    } catch {
      const n = new MouseEvent('click', {
        bubbles: !0,
        cancelable: !0,
        view: window,
        detail: 0,
        screenX: 80,
        screenY: 20,
        clientX: 80,
        clientY: 20,
        ctrlKey: !1,
        altKey: !1,
        shiftKey: !1,
        metaKey: !1,
        button: 0,
        relatedTarget: null
      });
      e.dispatchEvent(n);
    }
  }
  const Kr = typeof navigator == 'object' ? navigator : { userAgent: '' },
    $f =
      /Macintosh/.test(Kr.userAgent) &&
      /AppleWebKit/.test(Kr.userAgent) &&
      !/Safari/.test(Kr.userAgent),
    Df = On
      ? typeof HTMLAnchorElement < 'u' && 'download' in HTMLAnchorElement.prototype && !$f
        ? j1
        : 'msSaveOrOpenBlob' in Kr
          ? H1
          : Q1
      : () => {};
  function j1(e, t = 'download', n) {
    const s = document.createElement('a');
    ((s.download = t),
      (s.rel = 'noopener'),
      typeof e == 'string'
        ? ((s.href = e),
          s.origin !== location.origin
            ? Pf(s.href)
              ? Oi(e, t, n)
              : ((s.target = '_blank'), Qr(s))
            : Qr(s))
        : ((s.href = URL.createObjectURL(e)),
          setTimeout(function () {
            URL.revokeObjectURL(s.href);
          }, 4e4),
          setTimeout(function () {
            Qr(s);
          }, 0)));
  }
  function H1(e, t = 'download', n) {
    if (typeof e == 'string')
      if (Pf(e)) Oi(e, t, n);
      else {
        const s = document.createElement('a');
        ((s.href = e),
          (s.target = '_blank'),
          setTimeout(function () {
            Qr(s);
          }));
      }
    else navigator.msSaveOrOpenBlob(U1(e, n), t);
  }
  function Q1(e, t, n, s) {
    if (
      ((s = s || open('', '_blank')),
      s && (s.document.title = s.document.body.innerText = 'downloading...'),
      typeof e == 'string')
    )
      return Oi(e, t, n);
    const r = e.type === 'application/octet-stream',
      o = /constructor/i.test(String(Rf.HTMLElement)) || 'safari' in Rf,
      i = /CriOS\/[\d]+/.test(navigator.userAgent);
    if ((i || (r && o) || $f) && typeof FileReader < 'u') {
      const l = new FileReader();
      ((l.onloadend = function () {
        let a = l.result;
        if (typeof a != 'string') throw ((s = null), new Error('Wrong reader.result type'));
        ((a = i ? a : a.replace(/^data:[^;]*;/, 'data:attachment/file;')),
          s ? (s.location.href = a) : location.assign(a),
          (s = null));
      }),
        l.readAsDataURL(e));
    } else {
      const l = URL.createObjectURL(e);
      (s ? s.location.assign(l) : (location.href = l),
        (s = null),
        setTimeout(function () {
          URL.revokeObjectURL(l);
        }, 4e4));
    }
  }
  function Fe(e, t) {
    const n = '🍍 ' + e;
    typeof __VUE_DEVTOOLS_TOAST__ == 'function'
      ? __VUE_DEVTOOLS_TOAST__(n, t)
      : t === 'error'
        ? console.error(n)
        : t === 'warn'
          ? console.warn(n)
          : console.log(n);
  }
  function Bi(e) {
    return '_a' in e && 'install' in e;
  }
  function Ff() {
    if (!('clipboard' in navigator))
      return (Fe("Your browser doesn't support the Clipboard API", 'error'), !0);
  }
  function zf(e) {
    return e instanceof Error && e.message.toLowerCase().includes('document is not focused')
      ? (Fe(
          'You need to activate the "Emulate a focused page" setting in the "Rendering" panel of devtools.',
          'warn'
        ),
        !0)
      : !1;
  }
  async function K1(e) {
    if (!Ff())
      try {
        (await navigator.clipboard.writeText(JSON.stringify(e.state.value)),
          Fe('Global state copied to clipboard.'));
      } catch (t) {
        if (zf(t)) return;
        (Fe('Failed to serialize the state. Check the console for more details.', 'error'),
          console.error(t));
      }
  }
  async function W1(e) {
    if (!Ff())
      try {
        (Mf(e, JSON.parse(await navigator.clipboard.readText())),
          Fe('Global state pasted from clipboard.'));
      } catch (t) {
        if (zf(t)) return;
        (Fe(
          'Failed to deserialize the state from clipboard. Check the console for more details.',
          'error'
        ),
          console.error(t));
      }
  }
  async function G1(e) {
    try {
      Df(
        new Blob([JSON.stringify(e.state.value)], { type: 'text/plain;charset=utf-8' }),
        'pinia-state.json'
      );
    } catch (t) {
      (Fe('Failed to export the state as JSON. Check the console for more details.', 'error'),
        console.error(t));
    }
  }
  let Kt;
  function J1() {
    Kt || ((Kt = document.createElement('input')), (Kt.type = 'file'), (Kt.accept = '.json'));
    function e() {
      return new Promise((t, n) => {
        ((Kt.onchange = async () => {
          const s = Kt.files;
          if (!s) return t(null);
          const r = s.item(0);
          return t(r ? { text: await r.text(), file: r } : null);
        }),
          (Kt.oncancel = () => t(null)),
          (Kt.onerror = n),
          Kt.click());
      });
    }
    return e;
  }
  async function Y1(e) {
    try {
      const n = await J1()();
      if (!n) return;
      const { text: s, file: r } = n;
      (Mf(e, JSON.parse(s)), Fe(`Global state imported from "${r.name}".`));
    } catch (t) {
      (Fe('Failed to import the state from JSON. Check the console for more details.', 'error'),
        console.error(t));
    }
  }
  function Mf(e, t) {
    for (const n in t) {
      const s = e.state.value[n];
      s ? Object.assign(s, t[n]) : (e.state.value[n] = t[n]);
    }
  }
  function gt(e) {
    return { _custom: { display: e } };
  }
  const Nf = '🍍 Pinia (root)',
    Wr = '_root';
  function Z1(e) {
    return Bi(e) ? { id: Wr, label: Nf } : { id: e.$id, label: e.$id };
  }
  function X1(e) {
    if (Bi(e)) {
      const n = Array.from(e._s.keys()),
        s = e._s;
      return {
        state: n.map((o) => ({ editable: !0, key: o, value: e.state.value[o] })),
        getters: n
          .filter((o) => s.get(o)._getters)
          .map((o) => {
            const i = s.get(o);
            return {
              editable: !1,
              key: o,
              value: i._getters.reduce((l, a) => ((l[a] = i[a]), l), {})
            };
          })
      };
    }
    const t = {
      state: Object.keys(e.$state).map((n) => ({ editable: !0, key: n, value: e.$state[n] }))
    };
    return (
      e._getters &&
        e._getters.length &&
        (t.getters = e._getters.map((n) => ({ editable: !1, key: n, value: e[n] }))),
      e._customProperties.size &&
        (t.customProperties = Array.from(e._customProperties).map((n) => ({
          editable: !0,
          key: n,
          value: e[n]
        }))),
      t
    );
  }
  function e_(e) {
    return e
      ? Array.isArray(e)
        ? e.reduce(
            (t, n) => (
              t.keys.push(n.key),
              t.operations.push(n.type),
              (t.oldValue[n.key] = n.oldValue),
              (t.newValue[n.key] = n.newValue),
              t
            ),
            { oldValue: {}, keys: [], operations: [], newValue: {} }
          )
        : { operation: gt(e.type), key: gt(e.key), oldValue: e.oldValue, newValue: e.newValue }
      : {};
  }
  function t_(e) {
    switch (e) {
      case Bt.direct:
        return 'mutation';
      case Bt.patchFunction:
        return '$patch';
      case Bt.patchObject:
        return '$patch';
      default:
        return 'unknown';
    }
  }
  let ss = !0;
  const Gr = [],
    Bn = 'pinia:mutations',
    Ue = 'pinia',
    { assign: n_ } = Object,
    Jr = (e) => '🍍 ' + e;
  function s_(e, t) {
    Nc(
      {
        id: 'dev.esm.pinia',
        label: 'Pinia 🍍',
        logo: 'https://pinia.vuejs.org/logo.svg',
        packageName: 'pinia',
        homepage: 'https://pinia.vuejs.org',
        componentStateTypes: Gr,
        app: e
      },
      (n) => {
        (typeof n.now != 'function' &&
          Fe(
            'You seem to be using an outdated version of Vue Devtools. Are you still using the Beta release instead of the stable one? You can find the links at https://devtools.vuejs.org/guide/installation.html.'
          ),
          n.addTimelineLayer({ id: Bn, label: 'Pinia 🍍', color: 15064968 }),
          n.addInspector({
            id: Ue,
            label: 'Pinia 🍍',
            icon: 'storage',
            treeFilterPlaceholder: 'Search stores',
            actions: [
              {
                icon: 'content_copy',
                action: () => {
                  K1(t);
                },
                tooltip: 'Serialize and copy the state'
              },
              {
                icon: 'content_paste',
                action: async () => {
                  (await W1(t), n.sendInspectorTree(Ue), n.sendInspectorState(Ue));
                },
                tooltip: 'Replace the state with the content of your clipboard'
              },
              {
                icon: 'save',
                action: () => {
                  G1(t);
                },
                tooltip: 'Save the state as a JSON file'
              },
              {
                icon: 'folder_open',
                action: async () => {
                  (await Y1(t), n.sendInspectorTree(Ue), n.sendInspectorState(Ue));
                },
                tooltip: 'Import the state from a JSON file'
              }
            ],
            nodeActions: [
              {
                icon: 'restore',
                tooltip: 'Reset the state (with "$reset")',
                action: (s) => {
                  const r = t._s.get(s);
                  r
                    ? typeof r.$reset != 'function'
                      ? Fe(
                          `Cannot reset "${s}" store because it doesn't have a "$reset" method implemented.`,
                          'warn'
                        )
                      : (r.$reset(), Fe(`Store "${s}" reset.`))
                    : Fe(`Cannot reset "${s}" store because it wasn't found.`, 'warn');
                }
              }
            ]
          }),
          n.on.inspectComponent((s) => {
            const r = s.componentInstance && s.componentInstance.proxy;
            if (r && r._pStores) {
              const o = s.componentInstance.proxy._pStores;
              Object.values(o).forEach((i) => {
                (s.instanceData.state.push({
                  type: Jr(i.$id),
                  key: 'state',
                  editable: !0,
                  value: i._isOptionsAPI
                    ? {
                        _custom: {
                          value: se(i.$state),
                          actions: [
                            {
                              icon: 'restore',
                              tooltip: 'Reset the state of this store',
                              action: () => i.$reset()
                            }
                          ]
                        }
                      }
                    : Object.keys(i.$state).reduce((l, a) => ((l[a] = i.$state[a]), l), {})
                }),
                  i._getters &&
                    i._getters.length &&
                    s.instanceData.state.push({
                      type: Jr(i.$id),
                      key: 'getters',
                      editable: !1,
                      value: i._getters.reduce((l, a) => {
                        try {
                          l[a] = i[a];
                        } catch (f) {
                          l[a] = f;
                        }
                        return l;
                      }, {})
                    }));
              });
            }
          }),
          n.on.getInspectorTree((s) => {
            if (s.app === e && s.inspectorId === Ue) {
              let r = [t];
              ((r = r.concat(Array.from(t._s.values()))),
                (s.rootNodes = (
                  s.filter
                    ? r.filter((o) =>
                        '$id' in o
                          ? o.$id.toLowerCase().includes(s.filter.toLowerCase())
                          : Nf.toLowerCase().includes(s.filter.toLowerCase())
                      )
                    : r
                ).map(Z1)));
            }
          }),
          (globalThis.$pinia = t),
          n.on.getInspectorState((s) => {
            if (s.app === e && s.inspectorId === Ue) {
              const r = s.nodeId === Wr ? t : t._s.get(s.nodeId);
              if (!r) return;
              r && (s.nodeId !== Wr && (globalThis.$store = se(r)), (s.state = X1(r)));
            }
          }),
          n.on.editInspectorState((s) => {
            if (s.app === e && s.inspectorId === Ue) {
              const r = s.nodeId === Wr ? t : t._s.get(s.nodeId);
              if (!r) return Fe(`store "${s.nodeId}" not found`, 'error');
              const { path: o } = s;
              (Bi(r)
                ? o.unshift('state')
                : (o.length !== 1 || !r._customProperties.has(o[0]) || o[0] in r.$state) &&
                  o.unshift('$state'),
                (ss = !1),
                s.set(r, o, s.state.value),
                (ss = !0));
            }
          }),
          n.on.editComponentState((s) => {
            if (s.type.startsWith('🍍')) {
              const r = s.type.replace(/^🍍\s*/, ''),
                o = t._s.get(r);
              if (!o) return Fe(`store "${r}" not found`, 'error');
              const { path: i } = s;
              if (i[0] !== 'state')
                return Fe(`Invalid path for store "${r}":
${i}
Only state can be modified.`);
              ((i[0] = '$state'), (ss = !1), s.set(o, i, s.state.value), (ss = !0));
            }
          }));
      }
    );
  }
  function r_(e, t) {
    (Gr.includes(Jr(t.$id)) || Gr.push(Jr(t.$id)),
      Nc(
        {
          id: 'dev.esm.pinia',
          label: 'Pinia 🍍',
          logo: 'https://pinia.vuejs.org/logo.svg',
          packageName: 'pinia',
          homepage: 'https://pinia.vuejs.org',
          componentStateTypes: Gr,
          app: e,
          settings: {
            logStoreChanges: {
              label: 'Notify about new/deleted stores',
              type: 'boolean',
              defaultValue: !0
            }
          }
        },
        (n) => {
          const s = typeof n.now == 'function' ? n.now.bind(n) : Date.now;
          (t.$onAction(({ after: i, onError: l, name: a, args: f }) => {
            const u = Vf++;
            (n.addTimelineEvent({
              layerId: Bn,
              event: {
                time: s(),
                title: '🛫 ' + a,
                subtitle: 'start',
                data: { store: gt(t.$id), action: gt(a), args: f },
                groupId: u
              }
            }),
              i((c) => {
                ((rn = void 0),
                  n.addTimelineEvent({
                    layerId: Bn,
                    event: {
                      time: s(),
                      title: '🛬 ' + a,
                      subtitle: 'end',
                      data: { store: gt(t.$id), action: gt(a), args: f, result: c },
                      groupId: u
                    }
                  }));
              }),
              l((c) => {
                ((rn = void 0),
                  n.addTimelineEvent({
                    layerId: Bn,
                    event: {
                      time: s(),
                      logType: 'error',
                      title: '💥 ' + a,
                      subtitle: 'end',
                      data: { store: gt(t.$id), action: gt(a), args: f, error: c },
                      groupId: u
                    }
                  }));
              }));
          }, !0),
            t._customProperties.forEach((i) => {
              Se(
                () => Ut(t[i]),
                (l, a) => {
                  (n.notifyComponentUpdate(),
                    n.sendInspectorState(Ue),
                    ss &&
                      n.addTimelineEvent({
                        layerId: Bn,
                        event: {
                          time: s(),
                          title: 'Change',
                          subtitle: i,
                          data: { newValue: l, oldValue: a },
                          groupId: rn
                        }
                      }));
                },
                { deep: !0 }
              );
            }),
            t.$subscribe(
              ({ events: i, type: l }, a) => {
                if ((n.notifyComponentUpdate(), n.sendInspectorState(Ue), !ss)) return;
                const f = {
                  time: s(),
                  title: t_(l),
                  data: n_({ store: gt(t.$id) }, e_(i)),
                  groupId: rn
                };
                (l === Bt.patchFunction
                  ? (f.subtitle = '⤵️')
                  : l === Bt.patchObject
                    ? (f.subtitle = '🧩')
                    : i && !Array.isArray(i) && (f.subtitle = i.type),
                  i &&
                    (f.data['rawEvent(s)'] = {
                      _custom: {
                        display: 'DebuggerEvent',
                        type: 'object',
                        tooltip: 'raw DebuggerEvent[]',
                        value: i
                      }
                    }),
                  n.addTimelineEvent({ layerId: Bn, event: f }));
              },
              { detached: !0, flush: 'sync' }
            ));
          const r = t._hotUpdate;
          t._hotUpdate = Gt((i) => {
            (r(i),
              n.addTimelineEvent({
                layerId: Bn,
                event: {
                  time: s(),
                  title: '🔥 ' + t.$id,
                  subtitle: 'HMR update',
                  data: { store: gt(t.$id), info: gt('HMR update') }
                }
              }),
              n.notifyComponentUpdate(),
              n.sendInspectorTree(Ue),
              n.sendInspectorState(Ue));
          });
          const { $dispose: o } = t;
          ((t.$dispose = () => {
            (o(),
              n.notifyComponentUpdate(),
              n.sendInspectorTree(Ue),
              n.sendInspectorState(Ue),
              n.getSettings().logStoreChanges && Fe(`Disposed "${t.$id}" store 🗑`));
          }),
            n.notifyComponentUpdate(),
            n.sendInspectorTree(Ue),
            n.sendInspectorState(Ue),
            n.getSettings().logStoreChanges && Fe(`"${t.$id}" store installed 🆕`));
        }
      ));
  }
  let Vf = 0,
    rn;
  function Lf(e, t, n) {
    const s = t.reduce((r, o) => ((r[o] = se(e)[o]), r), {});
    for (const r in s)
      e[r] = function () {
        const o = Vf,
          i = n
            ? new Proxy(e, {
                get(...a) {
                  return ((rn = o), Reflect.get(...a));
                },
                set(...a) {
                  return ((rn = o), Reflect.set(...a));
                }
              })
            : e;
        rn = o;
        const l = s[r].apply(i, arguments);
        return ((rn = void 0), l);
      };
  }
  function o_({ app: e, store: t, options: n }) {
    if (!t.$id.startsWith('__hot:')) {
      if (((t._isOptionsAPI = !!n.state), !t._p._testing)) {
        Lf(t, Object.keys(n.actions), t._isOptionsAPI);
        const s = t._hotUpdate;
        se(t)._hotUpdate = function (r) {
          (s.apply(this, arguments), Lf(t, Object.keys(r._hmrPayload.actions), !!t._isOptionsAPI));
        };
      }
      r_(e, t);
    }
  }
  function i_() {
    const e = Ol(!0),
      t = e.run(() => U({}));
    let n = [],
      s = [];
    const r = Gt({
      install(o) {
        (Ls(r),
          (r._a = o),
          o.provide(If, r),
          (o.config.globalProperties.$pinia = r),
          On && s_(o, r),
          s.forEach((i) => n.push(i)),
          (s = []));
      },
      use(o) {
        return (this._a ? n.push(o) : s.push(o), this);
      },
      _p: n,
      _a: null,
      _e: e,
      _s: new Map(),
      state: t
    });
    return (On && typeof Proxy < 'u' && r.use(o_), r);
  }
  function Uf(e, t) {
    for (const n in t) {
      const s = t[n];
      if (!(n in e)) continue;
      const r = e[n];
      Tn(r) && Tn(s) && !be(s) && !yt(s) ? (e[n] = Uf(r, s)) : (e[n] = s);
    }
    return e;
  }
  const l_ = () => {};
  function jf(e, t, n, s = l_) {
    e.push(t);
    const r = () => {
      const o = e.indexOf(t);
      o > -1 && (e.splice(o, 1), s());
    };
    return (!n && Bl() && Fp(r), r);
  }
  function rs(e, ...t) {
    e.slice().forEach((n) => {
      n(...t);
    });
  }
  const a_ = (e) => e(),
    Hf = Symbol(),
    Ii = Symbol();
  function Ri(e, t) {
    e instanceof Map && t instanceof Map
      ? t.forEach((n, s) => e.set(s, n))
      : e instanceof Set && t instanceof Set && t.forEach(e.add, e);
    for (const n in t) {
      if (!t.hasOwnProperty(n)) continue;
      const s = t[n],
        r = e[n];
      Tn(r) && Tn(s) && e.hasOwnProperty(n) && !be(s) && !yt(s) ? (e[n] = Ri(r, s)) : (e[n] = s);
    }
    return e;
  }
  const u_ = Symbol('pinia:skipHydration');
  function c_(e) {
    return !Tn(e) || !Object.prototype.hasOwnProperty.call(e, u_);
  }
  const { assign: ut } = Object;
  function Qf(e) {
    return !!(be(e) && e.effect);
  }
  function Kf(e, t, n, s) {
    const { state: r, actions: o, getters: i } = t,
      l = n.state.value[e];
    let a;
    function f() {
      !l && !s && (n.state.value[e] = r ? r() : {});
      const u = Xl(s ? U(r ? r() : {}).value : n.state.value[e]);
      return ut(
        u,
        o,
        Object.keys(i || {}).reduce(
          (c, d) => (
            d in u &&
              console.warn(
                `[🍍]: A getter cannot have the same name as another state property. Rename one of them. Found with "${d}" in store "${e}".`
              ),
            (c[d] = Gt(
              H(() => {
                Ls(n);
                const p = n._s.get(e);
                return i[d].call(p, p);
              })
            )),
            c
          ),
          {}
        )
      );
    }
    return ((a = Pi(e, f, t, n, s, !0)), a);
  }
  function Pi(e, t, n = {}, s, r, o) {
    let i;
    const l = ut({ actions: {} }, n);
    if (!s._e.active) throw new Error('Pinia destroyed');
    const a = { deep: !0 };
    a.onTrigger = (I) => {
      f
        ? (p = I)
        : f == !1 &&
          !V._hotUpdating &&
          (Array.isArray(p)
            ? p.push(I)
            : console.error(
                '🍍 debuggerEvents should be an array. This is most likely an internal Pinia bug.'
              ));
    };
    let f,
      u,
      c = [],
      d = [],
      p;
    const h = s.state.value[e];
    !o && !h && !r && (s.state.value[e] = {});
    const q = U({});
    let v;
    function b(I) {
      let T;
      ((f = u = !1),
        (p = []),
        typeof I == 'function'
          ? (I(s.state.value[e]), (T = { type: Bt.patchFunction, storeId: e, events: p }))
          : (Ri(s.state.value[e], I),
            (T = { type: Bt.patchObject, payload: I, storeId: e, events: p })));
      const x = (v = Symbol());
      (Bo().then(() => {
        v === x && (f = !0);
      }),
        (u = !0),
        rs(c, T, s.state.value[e]));
    }
    const $ = o
      ? function () {
          const { state: T } = n,
            x = T ? T() : {};
          this.$patch((Q) => {
            ut(Q, x);
          });
        }
      : () => {
          throw new Error(
            `🍍: Store "${e}" is built using the setup syntax and does not implement $reset().`
          );
        };
    function C() {
      (i.stop(), (c = []), (d = []), s._s.delete(e));
    }
    const G = (I, T = '') => {
        if (Hf in I) return ((I[Ii] = T), I);
        const x = function () {
          Ls(s);
          const Q = Array.from(arguments),
            Y = [],
            me = [];
          function ae(ue) {
            Y.push(ue);
          }
          function j(ue) {
            me.push(ue);
          }
          rs(d, { args: Q, name: x[Ii], store: V, after: ae, onError: j });
          let Z;
          try {
            Z = I.apply(this && this.$id === e ? this : V, Q);
          } catch (ue) {
            throw (rs(me, ue), ue);
          }
          return Z instanceof Promise
            ? Z.then((ue) => (rs(Y, ue), ue)).catch((ue) => (rs(me, ue), Promise.reject(ue)))
            : (rs(Y, Z), Z);
        };
        return ((x[Hf] = !0), (x[Ii] = T), x);
      },
      D = Gt({ actions: {}, getters: {}, state: [], hotState: q }),
      te = {
        _p: s,
        $id: e,
        $onAction: jf.bind(null, d),
        $patch: b,
        $reset: $,
        $subscribe(I, T = {}) {
          const x = jf(c, I, T.detached, () => Q()),
            Q = i.run(() =>
              Se(
                () => s.state.value[e],
                (Y) => {
                  (T.flush === 'sync' ? u : f) && I({ storeId: e, type: Bt.direct, events: p }, Y);
                },
                ut({}, a, T)
              )
            );
          return x;
        },
        $dispose: C
      },
      V = dr(ut({ _hmrPayload: D, _customProperties: Gt(new Set()) }, te));
    s._s.set(e, V);
    const K = ((s._a && s._a.runWithContext) || a_)(() =>
      s._e.run(() => (i = Ol()).run(() => t({ action: G })))
    );
    for (const I in K) {
      const T = K[I];
      if ((be(T) && !Qf(T)) || yt(T))
        (r
          ? (q.value[I] = Ao(K, I))
          : o ||
            (h && c_(T) && (be(T) ? (T.value = h[I]) : Ri(T, h[I])), (s.state.value[e][I] = T)),
          D.state.push(I));
      else if (typeof T == 'function') {
        const x = r ? T : G(T, I);
        ((K[I] = x), (D.actions[I] = T), (l.actions[I] = T));
      } else
        Qf(T) &&
          ((D.getters[I] = o ? n.getters[I] : T),
          On && (K._getters || (K._getters = Gt([]))).push(I));
    }
    if (
      (ut(V, K),
      ut(se(V), K),
      Object.defineProperty(V, '$state', {
        get: () => (r ? q.value : s.state.value[e]),
        set: (I) => {
          if (r) throw new Error('cannot set hotState');
          b((T) => {
            ut(T, I);
          });
        }
      }),
      (V._hotUpdate = Gt((I) => {
        ((V._hotUpdating = !0),
          I._hmrPayload.state.forEach((T) => {
            if (T in V.$state) {
              const x = I.$state[T],
                Q = V.$state[T];
              typeof x == 'object' && Tn(x) && Tn(Q) ? Uf(x, Q) : (I.$state[T] = Q);
            }
            V[T] = Ao(I.$state, T);
          }),
          Object.keys(V.$state).forEach((T) => {
            T in I.$state || delete V[T];
          }),
          (f = !1),
          (u = !1),
          (s.state.value[e] = Ao(I._hmrPayload, 'hotState')),
          (u = !0),
          Bo().then(() => {
            f = !0;
          }));
        for (const T in I._hmrPayload.actions) {
          const x = I[T];
          V[T] = G(x, T);
        }
        for (const T in I._hmrPayload.getters) {
          const x = I._hmrPayload.getters[T],
            Q = o ? H(() => (Ls(s), x.call(V, V))) : x;
          V[T] = Q;
        }
        (Object.keys(V._hmrPayload.getters).forEach((T) => {
          T in I._hmrPayload.getters || delete V[T];
        }),
          Object.keys(V._hmrPayload.actions).forEach((T) => {
            T in I._hmrPayload.actions || delete V[T];
          }),
          (V._hmrPayload = I._hmrPayload),
          (V._getters = I._getters),
          (V._hotUpdating = !1));
      })),
      On)
    ) {
      const I = { writable: !0, configurable: !0, enumerable: !1 };
      ['_p', '_hmrPayload', '_getters', '_customProperties'].forEach((T) => {
        Object.defineProperty(V, T, ut({ value: V[T] }, I));
      });
    }
    return (
      s._p.forEach((I) => {
        if (On) {
          const T = i.run(() => I({ store: V, app: s._a, pinia: s, options: l }));
          (Object.keys(T || {}).forEach((x) => V._customProperties.add(x)), ut(V, T));
        } else
          ut(
            V,
            i.run(() => I({ store: V, app: s._a, pinia: s, options: l }))
          );
      }),
      V.$state &&
        typeof V.$state == 'object' &&
        typeof V.$state.constructor == 'function' &&
        !V.$state.constructor.toString().includes('[native code]') &&
        console.warn(`[🍍]: The "state" must be a plain object. It cannot be
	state: () => new MyClass()
Found in store "${V.$id}".`),
      h && o && n.hydrate && n.hydrate(V.$state, h),
      (f = !0),
      (u = !0),
      V
    );
  }
  /*! #__NO_SIDE_EFFECTS__ */ function f_(e, t, n) {
    let s;
    const r = typeof t == 'function';
    s = r ? n : t;
    function o(i, l) {
      const a = lm();
      if (((i = i || (a ? Cs(If, null) : null)), i && Ls(i), !Ti))
        throw new Error(`[🍍]: "getActivePinia()" was called but there was no active Pinia. Are you trying to use a store before calling "app.use(pinia)"?
See https://pinia.vuejs.org/core-concepts/outside-component-usage.html for help.
This will fail in production.`);
      ((i = Ti), i._s.has(e) || (r ? Pi(e, t, s, i) : Kf(e, s, i), (o._pinia = i)));
      const f = i._s.get(e);
      if (l) {
        const u = '__hot:' + e,
          c = r ? Pi(u, t, s, i, !0) : Kf(u, ut({}, s), i, !0);
        (l._hotUpdate(c), delete i.state.value[u], i._s.delete(u));
      }
      if (On) {
        const u = Ir();
        if (u && u.proxy && !l) {
          const c = u.proxy,
            d = '_pStores' in c ? c._pStores : (c._pStores = {});
          d[e] = f;
        }
      }
      return f;
    }
    return ((o.$id = e), o);
  }
  const le = f_('quiz', {
      state: () => ({
        age: '',
        gender: 'w',
        q01: '',
        q02: '',
        q03: '',
        q04: ['Bauch', 'Beine', 'Po'],
        q05: '',
        q06: '',
        q07: 'Moderat',
        q08: '',
        q09: '',
        q10: '45',
        q11: '110',
        q12: '188',
        q13: '',
        q14: '',
        q15: '',
        q16: '',
        q17: '',
        q18: '1.375,Gering',
        q19: '',
        q20: '',
        q21: '',
        q22: '',
        q23: '',
        q24: '',
        q25: '',
        q26: '',
        q27: '',
        q28: '',
        q29: '',
        q30: '',
        q31: '',
        q32: '',
        q33: '',
        q34: '',
        q35: '',
        q36: '',
        q37: '',
        q38: '',
        q39: '',
        currentScreen: 'QuizScreen01_A',
        screenHistory: [],
        quizCompleted: !1,
        results: null
      }),
      getters: {
        currentQuestion() {
          if (!this.gender) return null;
          const e = this.gender === 'male' ? this.maleQuestions : this.femaleQuestions;
          if (this.currentQuestionIndex < e.length) return e[this.currentQuestionIndex];
          {
            const t = this.currentQuestionIndex - e.length;
            return t < this.commonQuestions.length ? this.commonQuestions[t] : null;
          }
        },
        isFinished() {
          if (!this.gender) return !1;
          const e = this.gender === 'male' ? this.maleQuestions : this.femaleQuestions;
          return this.currentQuestionIndex >= e.length + this.commonQuestions.length;
        }
      },
      actions: {
        goToNextScreen(e = null) {
          (e && (this[this.getDataPropertyForScreen(this.currentScreen)] = e),
            this.screenHistory.push(this.currentScreen),
            (this.currentScreen = this.getNextScreen()));
        },
        goBack() {
          this.screenHistory.length > 0 && (this.currentScreen = this.screenHistory.pop());
        },
        getNextScreen() {
          const t = {
            QuizScreen01_A: 'QuizScreen01',
            QuizScreen01: 'QuizScreen02',
            QuizScreen02: 'QuizScreen03',
            QuizScreen03: 'QuizScreen04',
            QuizScreen04: 'QuizScreen05',
            QuizScreen05: 'QuizScreen06',
            QuizScreen06: 'QuizScreen07',
            QuizScreen07: 'QuizScreen08',
            QuizScreen08: 'QuizScreen09',
            QuizScreen09: 'QuizScreen10',
            QuizScreen10: 'QuizScreen11',
            QuizScreen11: 'QuizScreen12',
            QuizScreen12: 'QuizScreen13',
            QuizScreen13: 'QuizScreen14',
            QuizScreen14: 'QuizScreen15',
            QuizScreen15: 'QuizScreen16',
            QuizScreen16: 'QuizScreen17',
            QuizScreen17: 'QuizScreen18',
            QuizScreen18: 'QuizScreen19',
            QuizScreen19: 'QuizScreen20',
            QuizScreen20: 'QuizScreen21',
            QuizScreen21: 'QuizScreen22',
            QuizScreen22: 'QuizScreen23',
            QuizScreen23: 'QuizScreen24',
            QuizScreen24: 'QuizScreen25',
            QuizScreen25: 'QuizScreen26',
            QuizScreen26: 'QuizScreen27',
            QuizScreen27: 'QuizScreen28',
            QuizScreen28: 'QuizScreen29',
            QuizScreen29: 'QuizScreen30',
            QuizScreen30: 'QuizScreen31',
            QuizScreen31: 'QuizScreen32',
            QuizScreen32: 'QuizScreen33',
            QuizScreen33: 'QuizScreen34',
            QuizScreen34: 'QuizScreen35',
            QuizScreen35: 'QuizScreen36',
            QuizScreen36: 'QuizScreen37',
            QuizScreen37: 'QuizScreen38',
            QuizScreen38: 'QuizScreen39'
          }[this.currentScreen];
          return typeof t == 'function' ? t() : t;
        },
        getDataPropertyForScreen(e) {
          return (
            {
              QuizScreen01_A: 'age',
              QuizScreen01: 'q01',
              QuizScreen02: 'q02',
              QuizScreen03: 'q03',
              QuizScreen04: 'q04',
              QuizScreen05: 'q05',
              QuizScreen06: 'q06',
              QuizScreen07: 'q07',
              QuizScreen08: 'q08',
              QuizScreen09: 'q09',
              QuizScreen10: 'q10',
              QuizScreen11: 'q11',
              QuizScreen12: 'q12',
              QuizScreen13: 'q13',
              QuizScreen14: 'q14',
              QuizScreen15: 'q15',
              QuizScreen16: 'q16',
              QuizScreen17: 'q17',
              QuizScreen18: 'q18',
              QuizScreen19: 'q19',
              QuizScreen20: 'q20',
              QuizScreen21: 'q21',
              QuizScreen22: 'q22',
              QuizScreen23: 'q23',
              QuizScreen24: 'q24',
              QuizScreen25: 'q25',
              QuizScreen26: 'q26',
              QuizScreen27: 'q27',
              QuizScreen28: 'q28',
              QuizScreen29: 'q29',
              QuizScreen30: 'q30',
              QuizScreen31: 'q31',
              QuizScreen32: 'q32',
              QuizScreen33: 'q33',
              QuizScreen34: 'q34',
              QuizScreen35: 'q35',
              QuizScreen36: 'q36',
              QuizScreen37: 'q37',
              QuizScreen38: 'q38',
              QuizScreen39: 'q39'
            }[e] || null
          );
        },
        resetQuiz() {
          this.$reset();
        },
        setAgeGroup(e) {
          ['40-44', '45-49', '50-54', '55+'].includes(e) ? (this.age = e) : (this.age = '40-44');
        },
        completeQuiz() {
          ((this.quizCompleted = !0), this.calculateResults());
        },
        calculateResults() {
          const e = (n) => Math.round(n * 100) / 100,
            t = this.gender;
          if (t === 'm') {
            const s =
                (88.362 +
                  13.397 * parseInt(this.q11) +
                  4.799 * parseInt(this.q12) -
                  5.677 * parseInt(this.q10)) *
                parseFloat(this.q18.split(',')[0]),
              r = e(s) - 200,
              o = (parseInt(this.q12) - 80) * 2,
              i = (r * 0.25) / 9,
              l = (r - 50 - o * 4 - i * 9) / 4;
            this.results = {
              gender: t,
              calorieIntake: e(s),
              calorieIntakeRange: [e(s) - 500, e(r)],
              proteinIntake: e(o),
              fatIntake: e(i),
              carbohydrates: e(l),
              caloriesMax: e(r)
            };
          } else {
            const s =
                (444.593 +
                  9.247 * parseInt(this.q11) +
                  3.098 * parseInt(this.q12) -
                  4.33 * parseInt(this.q10)) *
                parseFloat(this.q18.split(',')[0]),
              r = e(s) - 200,
              o = (parseInt(this.q12) - 105) * 2,
              i = (r * 0.3) / 9,
              l = (r - 50 - o * 4 - i * 9) / 4;
            this.results = {
              gender: t,
              calorieIntake: e(s),
              calorieIntakeRange: [e(s) - 500, e(r)],
              proteinIntake: e(o),
              fatIntake: e(i),
              carbohydrates: e(l),
              caloriesMax: e(r)
            };
          }
        }
      }
    }),
    d_ = {
      class: 'qlfqa:!w-full qlfqa:!bg-gray-200 qlfqa:!h-[5px] qlfqa:!mb-4 qlfqa:!rounded-full'
    },
    p_ = re({
      __name: 'LoadingBar',
      props: { currentScreen: { type: String, required: !0 } },
      setup(e) {
        const t = e,
          n = [
            'QuizScreen01_A',
            'QuizScreen01',
            'QuizScreen02',
            'QuizScreen03',
            'QuizScreen04',
            'QuizScreen05',
            'QuizScreen06',
            'QuizScreen07',
            'QuizScreen08',
            'QuizScreen09',
            'QuizScreen10',
            'QuizScreen11',
            'QuizScreen12',
            'QuizScreen13',
            'QuizScreen14',
            'QuizScreen15',
            'QuizScreen16',
            'QuizScreen17',
            'QuizScreen18',
            'QuizScreen19',
            'QuizScreen20',
            'QuizScreen21',
            'QuizScreen22',
            'QuizScreen23',
            'QuizScreen24',
            'QuizScreen25',
            'QuizScreen26',
            'QuizScreen27',
            'QuizScreen28',
            'QuizScreen29',
            'QuizScreen30',
            'QuizScreen31',
            'QuizScreen32',
            'QuizScreen33',
            'QuizScreen34',
            'QuizScreen35',
            'QuizScreen36',
            'QuizScreen37',
            'QuizScreen38',
            'QuizScreen39'
          ],
          s = H(() => {
            const r = n.indexOf(t.currentScreen);
            if (r === -1) return 0;
            const o = r / (n.length - 1),
              i = Math.pow(o, 0.5);
            return Math.round(i * 100);
          });
        return (r, o) => (
          P(),
          M('div', d_, [
            _(
              'div',
              {
                class:
                  'qlfqa:!bg-yellow-400 qlfqa:!h-full qlfqa:!transition-all qlfqa:!duration-300 qlfqa:!rounded-full',
                style: nt({ width: `${s.value}%` })
              },
              null,
              4
            )
          ])
        );
      }
    }),
    h_ = { class: 'qlfqa:!mt-5 qlfqa:!flex qlfqa:!gap-4' },
    m_ = ['disabled'],
    g_ = ['disabled'],
    he = re({
      __name: 'NavigationButtons',
      props: {
        showBackButton: { type: Boolean, default: !0 },
        disableContinue: { type: Boolean, default: !1 },
        hideContinue: { type: Boolean, default: !1 },
        backText: { type: String, default: 'Zurück' },
        continueText: { type: String, default: 'Weiter' }
      },
      emits: ['back', 'continue'],
      setup(e, { emit: t }) {
        const n = e,
          s = t,
          r = (o) => {
            o.key === 'Enter' && !n.disableContinue && !n.hideContinue && s('continue');
          };
        return (
          Me(() => {
            window.addEventListener('keydown', r);
          }),
          kr(() => {
            window.removeEventListener('keydown', r);
          }),
          (o, i) => (
            P(),
            M('div', h_, [
              e.hideContinue
                ? Te('', !0)
                : (P(),
                  M(
                    'button',
                    {
                      key: 0,
                      onClick: i[0] || (i[0] = (l) => o.$emit('back')),
                      disabled: !e.showBackButton,
                      class:
                        'qlfqa:!border qlfqa:!border-solid qlfqa:!border-[#CECDCA] qlfqa:!text-[#808080] qlfqa:!px-6 qlfqa:!py-3 qlfqa:!rounded-md qlfqa:disabled:!opacity-50 qlfqa:hover:!opacity-80 qlfqa:!cursor-pointer qlfqa:!w-1/2'
                    },
                    ve(e.backText),
                    9,
                    m_
                  )),
              e.hideContinue
                ? Te('', !0)
                : (P(),
                  M(
                    'button',
                    {
                      key: 1,
                      onClick: i[1] || (i[1] = (l) => o.$emit('continue')),
                      disabled: e.disableContinue,
                      class:
                        'qlfqa:!bg-custom-yellow qlfqa:!text-[#131313] qlfqa:!px-6 qlfqa:!py-3 qlfqa:!rounded-md qlfqa:disabled:!opacity-50 qlfqa:hover:!bg-yellow-400 qlfqa:!cursor-pointer qlfqa:!w-1/2 qlfqa:!font-medium'
                    },
                    ve(e.continueText),
                    9,
                    g_
                  ))
            ])
          )
        );
      }
    }),
    __ = {
      class:
        'qlfqa:!mt-2 qlfqa:!grid qlfqa:!grid-cols-1 qlfqa:!gap-y-3 qlfqa:sm:!gap-x-4 qlfqa:!w-full'
    },
    q_ = ['onClick', 'onKeydown', 'aria-checked', 'aria-label', 'aria-description'],
    v_ = ['onMouseenter'],
    b_ = { class: 'qlfqa:!flex qlfqa:!flex-1' },
    y_ = { class: 'qlfqa:!flex qlfqa:!items-center' },
    x_ = { class: 'qlfqa:!block qlfqa:!text-sm qlfqa:!font-medium qlfqa:!text-gray-900' },
    w_ = {
      key: 0,
      class: 'qlfqa:!flex qlfqa:!items-center qlfqa:!justify-center qlfqa:!text-yellow-300'
    },
    ct = {
      __name: 'SelectionGroup',
      props: {
        modelValue: { type: [String, Number], default: null },
        options: { type: Array, default: null }
      },
      emits: ['update:modelValue'],
      setup(e, { emit: t }) {
        const n = e,
          s = t,
          r = U(n.modelValue),
          o = U(null);
        (Se(
          () => n.modelValue,
          (l) => {
            r.value = l;
          }
        ),
          Se(r, (l) => {
            s('update:modelValue', l);
          }));
        function i(l) {
          r.value = l;
        }
        return (l, a) => (
          P(),
          M('div', __, [
            (P(!0),
            M(
              Ae,
              null,
              vn(
                e.options,
                (f) => (
                  P(),
                  M(
                    'div',
                    {
                      key: f.id,
                      class: 'qlfqa:!flex-1',
                      onClick: (u) => i(f.val),
                      onKeydown: Hu(
                        ju((u) => i(f.val), ['prevent']),
                        ['space']
                      ),
                      tabindex: '0',
                      role: 'radio',
                      'aria-checked': r.value === f.val,
                      'aria-label': f.text,
                      'aria-description': `Select ${f.text}`
                    },
                    [
                      _(
                        'div',
                        {
                          class: $e([
                            r.value === f.val
                              ? 'qlfqa:!border-yellow-300 qlfqa:!ring-1 qlfqa:!ring-yellow-300'
                              : 'qlfqa:!border-gray-300',
                            o.value === f.val
                              ? 'qlfqa:!border-yellow-300 qlfqa:!ring-1 qlfqa:!ring-yellow-300'
                              : '',
                            'qlfqa:!relative qlfqa:!flex qlfqa:!cursor-pointer qlfqa:!rounded-lg qlfqa:!h-14 qlfqa:!border qlfqa:!bg-white qlfqa:!p-4 qlfqa:!shadow-md qlfqa:focus:!outline-none'
                          ]),
                          onMouseenter: (u) => (o.value = f.val),
                          onMouseleave: a[0] || (a[0] = (u) => (o.value = null))
                        },
                        [
                          _('span', b_, [_('span', y_, [_('span', x_, ve(f.text), 1)])]),
                          r.value === f.val
                            ? (P(),
                              M(
                                'span',
                                w_,
                                a[1] ||
                                  (a[1] = [
                                    _(
                                      'svg',
                                      {
                                        xmlns: 'http://www.w3.org/2000/svg',
                                        viewBox: '0 0 24 24',
                                        fill: 'currentColor',
                                        class: 'qlfqa:!size-5'
                                      },
                                      [
                                        _('path', {
                                          'fill-rule': 'evenodd',
                                          d: 'M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z',
                                          'clip-rule': 'evenodd'
                                        })
                                      ],
                                      -1
                                    )
                                  ])
                              ))
                            : Te('', !0),
                          _(
                            'span',
                            {
                              class: $e([
                                o.value === f.val ? 'qlfqa:!border' : 'qlfqa:!border-2',
                                r.value === f.val
                                  ? 'qlfqa:!border-yellow-300'
                                  : 'qlfqa:!border-transparent',
                                'qlfqa:!pointer-events-none qlfqa:!absolute qlfqa:!-inset-px qlfqa:!rounded-lg'
                              ]),
                              'aria-hidden': 'true'
                            },
                            null,
                            2
                          )
                        ],
                        42,
                        v_
                      )
                    ],
                    40,
                    q_
                  )
                )
              ),
              128
            ))
          ])
        );
      }
    };
  function Ye(e) {
    e.forEach((t) => {
      const n = new Image();
      n.src = t;
    });
  }
  const S_ = { class: 'qlfqa:!py-2' },
    E_ = { class: 'qlfqa:!flex' },
    k_ = re({
      __name: 'QuizScreen01',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = le(),
          r = U(''),
          o = [
            { id: 1, text: 'Langfristig 1-10 kg abnehmen', val: '0' },
            { id: 2, text: 'Langfristig 11-20 kg abnehmen', val: '30' },
            { id: 3, text: 'Langfristig mehr als 20 kg abnehmen', val: '40' },
            { id: 4, text: 'Mein Gewicht halten und gesünder leben', val: '-5' }
          ];
        function i() {
          var h;
          const p =
            (h = new URLSearchParams(window.location.search).get('ge')) == null
              ? void 0
              : h.toString();
          p === '1' ? (s.gender = 'w') : p === '2' && (s.gender = 'm');
        }
        const l = H(() => s.screenHistory.length > 0);
        function a() {
          n('next', r.value);
        }
        function f() {
          s.goBack();
        }
        let u = !1;
        function c() {
          if (u || !s.age) return;
          u = !0;
          const d = ['schlank', 'skinnyfat', 'uebergewichtig', 'adipoes'],
            p = s.age,
            h = p === '55+' ? '55plus' : p,
            q = d.map(
              (v) =>
                `https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage3-${h}-${v}.jpg?v=1766415621`
            );
          Ye(q);
        }
        return (
          Se(r, (d) => {
            d && c();
          }),
          Se(
            () => s.age,
            (d) => {
              d && c();
            }
          ),
          Me(() => {
            (i(), c());
          }),
          (d, p) => (
            P(),
            M('div', S_, [
              p[1] ||
                (p[1] = _(
                  'h2',
                  { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                  'Was ist dein aktuelles Ziel?',
                  -1
                )),
              _('div', E_, [
                S(
                  ct,
                  {
                    class: 'qlfqa:!flex',
                    options: o,
                    modelValue: r.value,
                    'onUpdate:modelValue': p[0] || (p[0] = (h) => (r.value = h))
                  },
                  null,
                  8,
                  ['modelValue']
                )
              ]),
              S(
                he,
                { showBackButton: l.value, disableContinue: !r.value, onBack: f, onContinue: a },
                null,
                8,
                ['showBackButton', 'disableContinue']
              )
            ])
          )
        );
      }
    }),
    C_ = () => {
      const e = (s) => {
        let r = s.replace('https:', ''),
          o = [],
          i = r.lastIndexOf('.'),
          l = r.substring(0, i),
          a = r.substring(i + 1);
        return (
          [250, 375, 420, 600, 782].forEach((u) => {
            o.push(`${l}_${u}x_crop_center.${a}`);
          }),
          o
        );
      };
      return {
        generateSrcSetImages: (s) => {
          const r = e(s),
            o = [250, 375, 420, 600, 782];
          return r.map((i, l) => `${i} ${o[l]}w`).join(', ');
        },
        convertImageUrlTo150: (s) => {
          let r = s.lastIndexOf('.'),
            o = s.substring(0, r),
            i = s.substring(r + 1);
          return `${o}_150x_crop_center.${i}`;
        }
      };
    },
    A_ = ['src', 'alt', 'sizes', 'srcset', 'aria-hidden', 'loading', 'fetchpriority'],
    je = {
      __name: 'Image',
      props: {
        src: { type: String, required: !0 },
        alt: { type: String, default: '' },
        sizes: { type: String, default: '400px' },
        loading: { type: String, default: 'lazy' },
        fetchpriority: { type: String, default: 'auto' },
        class: { type: [String, Array, Object], default: 'qlfqa:!w-full qlfqa:!h-auto' }
      },
      setup(e) {
        const { generateSrcSetImages: t } = C_(),
          n = e,
          s = H(() => n.class);
        return (r, o) =>
          e.src
            ? (P(),
              M(
                'img',
                {
                  key: 0,
                  src: e.src,
                  alt: e.alt,
                  sizes: e.sizes,
                  srcset: Ut(t)(e.src),
                  class: $e(s.value),
                  'aria-hidden': e.alt === '',
                  role: 'img',
                  loading: e.loading,
                  fetchpriority: e.fetchpriority,
                  decoding: 'async'
                },
                null,
                10,
                A_
              ))
            : Te('', !0);
      }
    },
    T_ = ['disabled'],
    $i = {
      __name: 'ImageButton',
      props: {
        text: { type: String, default: 'Weiter' },
        disabled: { type: Boolean, default: !1 },
        variant: { type: String, default: 'primary' },
        customClass: { type: String, default: '' }
      },
      emits: ['click'],
      setup(e, { emit: t }) {
        const n = e,
          s = t,
          r = H(() => {
            const i = 'qlfqa:!px-2 qlfqa:!py-2',
              l = { primary: 'qlfqa:hover:!cursor-pointer qlfqa:!text-white' };
            return `${i} ${l[n.variant] || l.primary} ${n.customClass}`;
          }),
          o = (i) => {
            s('click', i);
          };
        return (i, l) => (
          P(),
          M(
            'button',
            { onClick: o, disabled: e.disabled, class: $e(r.value) },
            [Aa(i.$slots, 'default', {}, () => [Kn(ve(e.text), 1)])],
            10,
            T_
          )
        );
      }
    },
    O_ = { class: 'qlfqa:!py-2', role: 'form', 'aria-labelledby': 'age-title' },
    B_ = {
      class: 'qlfqa:!mt-8 qlfqa:!flex qlfqa:!flex-wrap',
      role: 'radiogroup',
      'aria-label': 'Wähle deine Altersgruppe'
    },
    I_ = { class: 'qlfqa:!w-full qlfqa:!flex qlfqa:!flex-col qlfqa:!items-center' },
    R_ = re({
      __name: 'QuizScreen01_A',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = le(),
          r = U([]),
          o = [
            {
              id: 1,
              text: '40-44',
              val: '5',
              image:
                'https://qlf.de/cdn/shop/files/Quiz-Frage1-40bis44.jpg?v=1767691576&width=800',
              altText: ''
            },
            {
              id: 2,
              text: '45-49',
              val: '0',
              image:
                'https://qlf.de/cdn/shop/files/Quiz-Frage1-45-49.jpg?v=1767691576&width=800',
              altText: ''
            },
            {
              id: 3,
              text: '50-54',
              val: '0',
              image:
                'https://qlf.de/cdn/shop/files/Quiz-Frage1-50bis54_9a3663b7-8b4b-4d2a-a75f-e181e5997418.png?v=1767691580&width=800',
              altText: ''
            },
            {
              id: 4,
              text: '55+',
              val: '10',
              image:
                'https://qlf.de/cdn/shop/files/Quiz-Frage1-55plus.jpg?v=1767691576&width=800',
              altText: ''
            }
          ],
          i = {
            '18-29': [
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage2-Frau-18bis29.jpg',
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage2-Mann-18bis29.jpg'
            ],
            '30-44': [
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage2-Frau-30bis44.jpg',
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage2-Mann-30bis44.jpg'
            ],
            '45-59': [
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage2-Frau-45bis59.jpg',
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage2-Mann-45bis59.jpg'
            ],
            '60+': [
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage2-Frau-ab60.jpg',
              'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage2-Mann-ab60.jpg'
            ]
          };
        function l(u) {
          const d = (i[u] ?? []).flatMap((p) => [
            `${p}?width=320`,
            `${p}?width=400`,
            `${p}?width=800`
          ]);
          Ye(d);
        }
        function a() {
          const c = Object.values(i)
            .flat()
            .flatMap((d) => [`${d}?width=320`, `${d}?width=400`]);
          Ye(c);
        }
        Me(() => {
          a();
        });
        function f(u, c) {
          ((r.value = [u, c]), l(u), (s.age = u), n('next', u));
        }
        return (u, c) => (
          P(),
          M('div', O_, [
            c[0] ||
              (c[0] = _(
                'h1',
                {
                  id: 'age-title',
                  class: 'qlfqa:!text-2xl qlfqa:!font-medium qlfqa:!mb-4 qlfqa:!text-center'
                },
                ' Starte jetzt das Quiz und revolutioniere deinen Fettverlust ',
                -1
              )),
            c[1] ||
              (c[1] = _(
                'p',
                { class: 'qlfqa:!mb-4 qlfqa:!text-center qlfqa:!text-gray-700' },
                ' Erfahre den einfachsten Weg zum Abnehmen für deinen Körpertypen und deine Voraussetzungen. ',
                -1
              )),
            _('div', B_, [
              (P(),
              M(
                Ae,
                null,
                vn(o, (d) =>
                  S(
                    $i,
                    {
                      class: $e([
                        'qlfqa:!w-6/12 qlfqa:!flex',
                        { 'qlfqa:!border-2 qlfqa:!border-[#FED43CFF]': r.value[1] === d.val }
                      ]),
                      key: d.id,
                      onPointerenter: (p) => l(d.text),
                      onPointerdown: (p) => l(d.text),
                      onClick: (p) => f(d.text, d.val),
                      role: 'radio',
                      'aria-checked': r.value[1] === d.val,
                      'aria-label': 'Altersgruppe ' + d.text
                    },
                    {
                      default: Et(() => [
                        _('span', I_, [
                          S(
                            je,
                            {
                              src: `${d.image}?width=400`,
                              srcset: `
                            ${d.image}?width=320 320w,
                            ${d.image}?width=400 400w,
                            ${d.image}?width=800 800w
                          `,
                              alt: 'Person in Altersgruppe ' + d.text,
                              sizes: '(max-width: 640px) 50vw, 400px',
                              loading: d.id <= 2 ? 'eager' : 'lazy',
                              decoding: 'async',
                              fetchpriority: d.id === 1 ? 'high' : 'auto',
                              class: 'qlfqa:!w-full qlfqa:!h-auto'
                            },
                            null,
                            8,
                            ['src', 'srcset', 'alt', 'loading', 'fetchpriority']
                          )
                        ])
                      ]),
                      _: 2
                    },
                    1032,
                    [
                      'class',
                      'onPointerenter',
                      'onPointerdown',
                      'onClick',
                      'aria-checked',
                      'aria-label'
                    ]
                  )
                ),
                64
              ))
            ])
          ])
        );
      }
    }),
    P_ = { class: 'qlfqa:!py-2', role: 'form', 'aria-labelledby': 'age-title' },
    $_ = {
      class: 'qlfqa:!mt-8 qlfqa:!flex qlfqa:!flex-wrap',
      role: 'radiogroup',
      'aria-label': 'Wähle deinen Körpertyp'
    },
    D_ = { class: 'qlfqa:!w-full qlfqa:!flex qlfqa:!flex-col qlfqa:!items-center' },
    F_ = re({
      __name: 'QuizScreen02',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = le(),
          r = U(''),
          o = [
            { id: 1, text: 'Schlank', val: '5', slug: 'schlank' },
            { id: 2, text: 'Skinny Fat', val: '0', slug: 'skinnyfat' },
            { id: 3, text: 'Übergewichtig', val: '0', slug: 'uebergewichtig' },
            { id: 4, text: 'Adipös', val: '10', slug: 'adipoes' }
          ];
        function i(u) {
          const c = s.age;
          return `https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage3-${c === '55+' ? '55plus' : c}-${u}.jpg?v=1766415621`;
        }
        function l(u) {
          ((r.value = u), r.value && n('next', r.value));
        }
        let a = !1;
        function f() {
          if (a || !s.age) return;
          a = !0;
          const u = s.age,
            c = u === '55+' ? '55plus' : u.replace('-', 'bis'),
            p = ['schlank', 'definiert', 'kurvig', 'normal'].map(
              (h) =>
                `https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage4-${h}-${c}.jpg?v=1767718727`
            );
          Ye(p);
        }
        return (
          Se(r, (u) => {
            u && f();
          }),
          Se(
            () => s.age,
            (u) => {
              u && f();
            }
          ),
          Me(() => {
            f();
          }),
          (u, c) => (
            P(),
            M('div', P_, [
              c[0] ||
                (c[0] = _(
                  'h2',
                  { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                  'Welcher Körpertyp trifft auf dich zu?',
                  -1
                )),
              _('div', $_, [
                (P(),
                M(
                  Ae,
                  null,
                  vn(o, (d) =>
                    S(
                      $i,
                      {
                        class: $e([
                          'qlfqa:!w-6/12 qlfqa:!flex',
                          { 'qlfqa:!border-2 qlfqa:!border-[#FED43CFF]': r.value === d.val }
                        ]),
                        key: d.id,
                        onClick: (p) => l(d.val),
                        role: 'radio',
                        'aria-checked': r.value === d.val,
                        'aria-label': 'Körpertyp ' + d.text
                      },
                      {
                        default: Et(() => [
                          _('span', D_, [
                            S(
                              je,
                              {
                                src: i(d.slug),
                                alt: 'Person mit Körpertyp ' + d.text,
                                sizes: '400px',
                                class: 'qlfqa:!w-full qlfqa:!h-auto',
                                loading: 'eager',
                                fetchpriority: 'high'
                              },
                              null,
                              8,
                              ['src', 'alt']
                            )
                          ])
                        ]),
                        _: 2
                      },
                      1032,
                      ['class', 'onClick', 'aria-checked', 'aria-label']
                    )
                  ),
                  64
                ))
              ])
            ])
          )
        );
      }
    }),
    z_ = { class: 'qlfqa:!py-2', role: 'form', 'aria-labelledby': 'age-title' },
    M_ = {
      class: 'qlfqa:!mt-8 qlfqa:!flex qlfqa:!flex-wrap',
      role: 'radiogroup',
      'aria-label': 'Wähle deine Wunschfigur'
    },
    N_ = { class: 'qlfqa:!w-full qlfqa:!flex qlfqa:!flex-col qlfqa:!items-center' },
    V_ = re({
      __name: 'QuizScreen03',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = le(),
          r = U(''),
          o = [
            { id: 1, text: 'Schlank', val: '5', slug: 'schlank' },
            { id: 2, text: 'Betont & definiert', val: '0', slug: 'definiert' },
            { id: 3, text: 'Kurvig & sportlich', val: '0', slug: 'kurvig' },
            { id: 4, text: 'Normal', val: '10', slug: 'normal' }
          ];
        function i(u) {
          const c = s.age,
            d = c === '55+' ? '55plus' : c.replace('-', 'bis');
          return `https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage4-${u}-${d}.jpg?v=1767718727`;
        }
        function l(u) {
          ((r.value = u), r.value && n('next', r.value));
        }
        let a = !1;
        function f() {
          if (a || !s.gender) return;
          a = !0;
          let u;
          (s.gender === 'm'
            ? (u = [
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frage6-Mann-Bauch.png?v=1764930157',
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frage6-Mann-Po.png?v=1764930158',
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frage6-Mann-Huefte.png?v=1764930157',
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frage6-Mann-Beine.png?v=1764930157',
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frage6-Mann-Gesicht.png?v=1764930157'
              ])
            : (u = [
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frage6-Frau-Bauch.png?v=1764929110',
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frage6-Frau-Po1.png?v=1764929111',
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frage6-Frau-Huefte.png?v=1764929110',
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frage6-Frau-Beine.png?v=1764929110',
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frage6-Frau-Gesicht.png?v=1764929110'
              ]),
            Ye(u));
        }
        return (
          Se(r, (u) => {
            u && f();
          }),
          Se(
            () => s.gender,
            (u) => {
              u && f();
            }
          ),
          Me(() => {
            f();
          }),
          (u, c) => (
            P(),
            M('div', z_, [
              c[0] ||
                (c[0] = _(
                  'h2',
                  { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                  'Was ist deine Wunschfigur?',
                  -1
                )),
              _('div', M_, [
                (P(),
                M(
                  Ae,
                  null,
                  vn(o, (d) =>
                    S(
                      $i,
                      {
                        class: $e([
                          'qlfqa:!w-6/12 qlfqa:!flex',
                          { 'qlfqa:!border-2 qlfqa:!border-[#FED43CFF]': r.value === d.val }
                        ]),
                        key: d.id,
                        onClick: (p) => l(d.val),
                        role: 'radio',
                        'aria-checked': r.value === d.val,
                        'aria-label': 'Wunschfigur ' + d.text
                      },
                      {
                        default: Et(() => [
                          _('span', N_, [
                            S(
                              je,
                              {
                                src: i(d.slug),
                                alt: 'Person mit Wunschfigur ' + d.text,
                                sizes: '400px',
                                class: 'qlfqa:!w-full qlfqa:!h-auto',
                                loading: 'eager',
                                fetchpriority: 'high'
                              },
                              null,
                              8,
                              ['src', 'alt']
                            )
                          ])
                        ]),
                        _: 2
                      },
                      1032,
                      ['class', 'onClick', 'aria-checked', 'aria-label']
                    )
                  ),
                  64
                ))
              ])
            ])
          )
        );
      }
    }),
    L_ = {
      class:
        'qlfqa:!grid qlfqa:!grid-cols-1 qlfqa:!gap-y-3 qlfqa:sm:!gap-x-4 qlfqa:!w-full qlfqa:!flex'
    },
    U_ = ['onClick'],
    j_ = { class: 'qlfqa:!flex qlfqa:!flex-1 qlfqa:!items-center qlfqa:!p-4' },
    H_ = { class: 'qlfqa:!block qlfqa:!text-sm qlfqa:!font-medium qlfqa:!text-gray-900' },
    Q_ = {
      key: 0,
      class:
        'qlfqa:!flex qlfqa:!items-center qlfqa:!justify-center qlfqa:!text-yellow-300 qlfqa:!mx-3'
    },
    K_ = { class: 'qlfqa:!flex qlfqa:!flex-1 qlfqa:!p-4' },
    W_ = { class: 'qlfqa:!flex qlfqa:!items-center' },
    G_ = { class: 'qlfqa:!block qlfqa:!text-sm qlfqa:!font-medium qlfqa:!text-gray-900' },
    J_ = {
      key: 0,
      class:
        'qlfqa:!flex qlfqa:!items-center qlfqa:!justify-center qlfqa:!text-yellow-300 qlfqa:!mx-3'
    },
    It = re({
      __name: 'MultiSelectionGroup',
      props: {
        modelValue: { type: Array, default: () => [] },
        checkboxOptions: { type: Array, default: () => [] },
        exclusiveOption: { type: Object, default: null }
      },
      emits: ['update:modelValue'],
      setup(e, { emit: t }) {
        const n = e,
          s = t,
          r = U(!1);
        Se(
          () => n.modelValue,
          (l) => {
            n.exclusiveOption && l.includes(n.exclusiveOption.val)
              ? (r.value = !0)
              : (r.value = !1);
          },
          { immediate: !0 }
        );
        function o(l) {
          if (r.value) {
            ((r.value = !1), s('update:modelValue', [l.val]));
            return;
          }
          const a = [...n.modelValue],
            f = a.indexOf(l.val);
          (f === -1 ? a.push(l.val) : a.splice(f, 1), s('update:modelValue', a));
        }
        function i() {
          ((r.value = !r.value),
            r.value ? s('update:modelValue', [n.exclusiveOption.val]) : s('update:modelValue', []));
        }
        return (l, a) => (
          P(),
          M('div', L_, [
            (P(!0),
            M(
              Ae,
              null,
              vn(
                e.checkboxOptions,
                (f) => (
                  P(),
                  M(
                    'div',
                    {
                      key: f.id,
                      onClick: (u) => o(f),
                      class: $e([
                        'qlfqa:!h-14 qlfqa:!flex qlfqa:!cursor-pointer qlfqa:!rounded-lg qlfqa:!border qlfqa:!bg-white qlfqa:!shadow-md qlfqa:focus:!outline-none qlfqa:!overflow-hidden',
                        [
                          e.modelValue.includes(f.val)
                            ? 'qlfqa:!border-yellow-300 qlfqa:!ring-1 qlfqa:!ring-yellow-300'
                            : 'qlfqa:!border-gray-300'
                        ]
                      ])
                    },
                    [
                      _('span', j_, [_('span', H_, ve(f.text), 1)]),
                      e.modelValue.includes(f.val)
                        ? (P(),
                          M(
                            'span',
                            Q_,
                            a[0] ||
                              (a[0] = [
                                _(
                                  'svg',
                                  {
                                    xmlns: 'http://www.w3.org/2000/svg',
                                    viewBox: '0 0 24 24',
                                    fill: 'currentColor',
                                    class: 'qlfqa:!size-6'
                                  },
                                  [
                                    _('path', {
                                      'fill-rule': 'evenodd',
                                      d: 'M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z',
                                      'clip-rule': 'evenodd'
                                    })
                                  ],
                                  -1
                                )
                              ])
                          ))
                        : Te('', !0),
                      f.image
                        ? (P(),
                          wn(
                            je,
                            {
                              key: 1,
                              src: f.image,
                              alt: f.text,
                              fetchpriority: f.id === 1 ? 'high' : 'auto',
                              class:
                                'qlfqa:!ml-3 qlfqa:!h-full qlfqa:!object-contain qlfqa:!shrink-0'
                            },
                            null,
                            8,
                            ['src', 'alt', 'fetchpriority']
                          ))
                        : Te('', !0)
                    ],
                    10,
                    U_
                  )
                )
              ),
              128
            )),
            e.exclusiveOption
              ? (P(),
                M(
                  'div',
                  {
                    key: 0,
                    onClick: i,
                    class: $e([
                      'qlfqa:!h-14 qlfqa:!flex qlfqa:!cursor-pointer qlfqa:!rounded-lg qlfqa:!border qlfqa:!bg-white qlfqa:!shadow-md qlfqa:focus:!outline-none',
                      [
                        r.value
                          ? 'qlfqa:!border-yellow-300 qlfqa:!ring-1 qlfqa:!ring-yellow-300'
                          : 'qlfqa:!border-gray-300'
                      ]
                    ])
                  },
                  [
                    _('span', K_, [_('span', W_, [_('span', G_, ve(e.exclusiveOption.text), 1)])]),
                    r.value
                      ? (P(),
                        M(
                          'span',
                          J_,
                          a[1] ||
                            (a[1] = [
                              _(
                                'svg',
                                {
                                  xmlns: 'http://www.w3.org/2000/svg',
                                  viewBox: '0 0 24 24',
                                  fill: 'currentColor',
                                  class: 'qlfqa:!size-6'
                                },
                                [
                                  _('path', {
                                    'fill-rule': 'evenodd',
                                    d: 'M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z',
                                    'clip-rule': 'evenodd'
                                  })
                                ],
                                -1
                              )
                            ])
                        ))
                      : Te('', !0)
                  ],
                  2
                ))
              : Te('', !0)
          ])
        );
      }
    }),
    Y_ = { class: 'qlfqa:!py-2' },
    Z_ = re({
      __name: 'QuizScreen04',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = le(),
          r = U([]),
          o = U(!1),
          i = [
            {
              id: 1,
              text: 'Bauch',
              val: 'Bauch',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frage6-Mann-Bauch.png?v=1764930157'
            },
            {
              id: 2,
              text: 'Po',
              val: 'Po',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frage6-Mann-Po.png?v=1764930158'
            },
            {
              id: 3,
              text: 'Hüfte',
              val: 'Hüfte',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frage6-Mann-Huefte.png?v=1764930157'
            },
            {
              id: 4,
              text: 'Beine',
              val: 'Beine',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frage6-Mann-Beine.png?v=1764930157'
            },
            {
              id: 5,
              text: 'Gesicht',
              val: 'Gesicht',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frage6-Mann-Gesicht.png?v=1764930157'
            }
          ],
          l = [
            {
              id: 1,
              text: 'Bauch',
              val: 'Bauch',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frage6-Frau-Bauch.png?v=1764929110'
            },
            {
              id: 2,
              text: 'Po',
              val: 'Po',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frage6-Frau-Po1.png?v=1764929111'
            },
            {
              id: 3,
              text: 'Hüfte',
              val: 'Hüfte',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frage6-Frau-Huefte.png?v=1764929110'
            },
            {
              id: 4,
              text: 'Beine',
              val: 'Beine',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frage6-Frau-Beine.png?v=1764929110'
            },
            {
              id: 5,
              text: 'Gesicht',
              val: 'Gesicht',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frage6-Frau-Gesicht.png?v=1764929110'
            }
          ],
          a = H(() => (s.gender === 'm' ? i : l)),
          f = void 0,
          u = H(() => s.screenHistory.length > 0),
          c = H(() => r.value.length > 0 || o.value);
        let d = !1;
        function p() {
          if (d || !s.gender) return;
          d = !0;
          const v =
            s.gender === 'm'
              ? 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Mann_Schlaf.jpg?v=1762508775'
              : 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frau_Schlaf.jpg?v=1762508775';
          Ye([v]);
        }
        (Se(c, (v) => {
          v && p();
        }),
          Se(
            () => s.gender,
            (v) => {
              v && p();
            }
          ),
          Me(() => {
            p();
          }));
        function h() {
          let v;
          ((o.value && f) || (v = r.value), n('next', v));
        }
        function q() {
          s.goBack();
        }
        return (v, b) => (
          P(),
          M('div', Y_, [
            b[1] ||
              (b[1] = _(
                'h2',
                { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                'Welche sind deine Problemzonen?',
                -1
              )),
            b[2] ||
              (b[2] = _('p', { class: 'qlfqa:!text-gray-700' }, 'Mehrfach-Auswahl möglich', -1)),
            S(
              It,
              {
                modelValue: r.value,
                'onUpdate:modelValue': b[0] || (b[0] = ($) => (r.value = $)),
                class: 'qlfqa:!mt-4',
                checkboxOptions: a.value,
                exclusiveOption: Ut(f)
              },
              null,
              8,
              ['modelValue', 'checkboxOptions', 'exclusiveOption']
            ),
            S(
              he,
              { showBackButton: u.value, disableContinue: !c.value, onBack: q, onContinue: h },
              null,
              8,
              ['showBackButton', 'disableContinue']
            )
          ])
        );
      }
    }),
    X_ = { class: 'qlfqa:!py-2' },
    eq = re({
      __name: 'QuizScreen05',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = le(),
          r = U([]),
          o = U(!1),
          i = [
            { id: 1, text: 'Übelkeit', val: '0' },
            { id: 2, text: 'Magenkrämpfe', val: '1' },
            { id: 3, text: 'Durchfall', val: '2' }
          ],
          l = { id: 4, text: 'Nein, keine davon', val: 'nichts' },
          a = H(() => s.screenHistory.length > 0),
          f = H(() => r.value.length > 0 || o.value);
        function u() {
          let d;
          (o.value && l ? (d = [l.val]) : (d = r.value), n('next', d));
        }
        function c() {
          s.goBack();
        }
        return (d, p) => (
          P(),
          M('div', X_, [
            p[1] ||
              (p[1] = _(
                'h2',
                { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                'Hast du regelmäßig Verdauungsprobleme?',
                -1
              )),
            p[2] ||
              (p[2] = _('p', { class: 'qlfqa:!text-gray-700' }, 'Mehrfach-Auswahl möglich', -1)),
            S(
              It,
              {
                modelValue: r.value,
                'onUpdate:modelValue': p[0] || (p[0] = (h) => (r.value = h)),
                class: 'qlfqa:!mt-4',
                checkboxOptions: i,
                exclusiveOption: l
              },
              null,
              8,
              ['modelValue']
            ),
            S(
              he,
              { showBackButton: a.value, disableContinue: !f.value, onBack: c, onContinue: u },
              null,
              8,
              ['showBackButton', 'disableContinue']
            )
          ])
        );
      }
    }),
    tq = { class: 'qlfqa:!py-2' },
    nq = { class: 'qlfqa:!flex' },
    sq = re({
      __name: 'QuizScreen06',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = le(),
          r = U(''),
          o = [
            { id: 1, text: 'Ja, beides', val: '0' },
            { id: 2, text: 'Nur Blutzucker', val: '30' },
            { id: 3, text: 'Nur Schilddrüse', val: '40' },
            { id: 4, text: 'Nein, nichts dergleichen', val: '-5' }
          ],
          i = H(() => s.screenHistory.length > 0);
        function l() {
          n('next', r.value);
        }
        function a() {
          s.goBack();
        }
        return (f, u) => (
          P(),
          M('div', tq, [
            u[1] ||
              (u[1] = _(
                'h2',
                { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                'Ist dir bekannt, dass dein Blutzucker oder deine Schilddrüse auffällig ist?',
                -1
              )),
            _('div', nq, [
              S(
                ct,
                {
                  class: 'qlfqa:!flex',
                  options: o,
                  modelValue: r.value,
                  'onUpdate:modelValue': u[0] || (u[0] = (c) => (r.value = c))
                },
                null,
                8,
                ['modelValue']
              )
            ]),
            S(
              he,
              { showBackButton: i.value, disableContinue: !r.value, onBack: a, onContinue: l },
              null,
              8,
              ['showBackButton', 'disableContinue']
            )
          ])
        );
      }
    }),
    rq = { class: 'qlfqa:!py-2' },
    oq = { class: 'qlfqa:!flex' },
    iq = re({
      __name: 'QuizScreen07',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = le(),
          r = U(''),
          o = [
            { id: 1, text: 'Ich nehme schnell zu, aber nur langsam ab', val: 'Langsam' },
            { id: 2, text: 'Ich nehme einfach zu und ab', val: 'Moderat' },
            { id: 3, text: 'Ich habe Probleme Gewicht zuzunehmen', val: 'Moderat 2' }
          ],
          i = H(() => s.screenHistory.length > 0);
        function l() {
          n('next', r.value);
        }
        function a() {
          s.goBack();
        }
        return (f, u) => (
          P(),
          M('div', rq, [
            u[1] ||
              (u[1] = _(
                'h2',
                { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                'Wie ändert sich dein Gewicht normalerweise?',
                -1
              )),
            _('div', oq, [
              S(
                ct,
                {
                  class: 'qlfqa:!flex',
                  options: o,
                  modelValue: r.value,
                  'onUpdate:modelValue': u[0] || (u[0] = (c) => (r.value = c))
                },
                null,
                8,
                ['modelValue']
              )
            ]),
            S(
              he,
              { showBackButton: i.value, disableContinue: !r.value, onBack: a, onContinue: l },
              null,
              8,
              ['showBackButton', 'disableContinue']
            )
          ])
        );
      }
    }),
    lq = { class: 'qlfqa:!py-2' },
    aq = { class: 'qlfqa:!flex' },
    uq = re({
      __name: 'QuizScreen08',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = le(),
          r = U(''),
          o = [
            { id: 1, text: 'Vor weniger als 1 Jahr', val: '0' },
            { id: 2, text: '1 bis 2 Jahre her', val: '30' },
            { id: 3, text: 'Mehr als 3 Jahre her', val: '40' },
            { id: 4, text: 'Noch nie', val: '50' }
          ],
          i = H(() => s.screenHistory.length > 0);
        function l() {
          n('next', r.value);
        }
        function a() {
          s.goBack();
        }
        return (f, u) => (
          P(),
          M('div', lq, [
            u[1] ||
              (u[1] = _(
                'h2',
                { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                'Wann hast du dich das letzte mal so richtig wohl und stolz in deinem Körper gefühlt?',
                -1
              )),
            _('div', aq, [
              S(
                ct,
                {
                  class: 'qlfqa:!flex',
                  options: o,
                  modelValue: r.value,
                  'onUpdate:modelValue': u[0] || (u[0] = (c) => (r.value = c))
                },
                null,
                8,
                ['modelValue']
              )
            ]),
            S(
              he,
              { showBackButton: i.value, disableContinue: !r.value, onBack: a, onContinue: l },
              null,
              8,
              ['showBackButton', 'disableContinue']
            )
          ])
        );
      }
    }),
    cq = { class: 'qlfqa:!py-2' },
    fq = { class: 'qlfqa:!flex' },
    dq = re({
      __name: 'QuizScreen09',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = le(),
          r = U(''),
          o = [
            { id: 1, text: 'Ja, genau das ist mein Problem', val: '0' },
            { id: 2, text: 'Teilweise, aber ich kämpfe generell mit Gewicht', val: '30' },
            { id: 3, text: 'Nein', val: '40' }
          ],
          i = H(() => s.screenHistory.length > 0);
        function l() {
          n('next', r.value);
        }
        function a() {
          s.goBack();
        }
        return (f, u) => (
          P(),
          M('div', cq, [
            u[1] ||
              (u[1] = _(
                'h2',
                { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                'Hast du das Gefühl, dass dein Bauch in den letzten Jahren "plötzlich" gewachsen ist - obwohl du nichts verändert hast?',
                -1
              )),
            _('div', fq, [
              S(
                ct,
                {
                  class: 'qlfqa:!flex',
                  options: o,
                  modelValue: r.value,
                  'onUpdate:modelValue': u[0] || (u[0] = (c) => (r.value = c))
                },
                null,
                8,
                ['modelValue']
              )
            ]),
            S(
              he,
              { showBackButton: i.value, disableContinue: !r.value, onBack: a, onContinue: l },
              null,
              8,
              ['showBackButton', 'disableContinue']
            )
          ])
        );
      }
    }),
    pq = { class: 'qlfqa:!py-2' },
    hq = {
      class:
        'qlfqa:!mt-8 qlfqa:!flex qlfqa:!items-center qlfqa:!bg-transparent qlfqa:!border-b qlfqa:!pr-3 qlfqa:!border-yellow-300 qlfqa:focus:!border-yellow-400 qlfqa:focus:!border-b qlfqa:focus:!ring-yellow-300 qlfqa:!rounded-t-md'
    },
    mq = { key: 0, class: 'qlfqa:!text-red-500 qlfqa:!mt-2 qlfqa:!text-sm' },
    gq = re({
      __name: 'QuizScreen10',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = le(),
          r = U(''),
          o = U(''),
          i = H(() => s.screenHistory.length > 0);
        function l() {
          f(r.value) && n('next', r.value);
        }
        function a() {
          s.goBack();
        }
        function f(u) {
          if (u === '') return ((o.value = ''), !0);
          const c = Number(u);
          return c < 18
            ? ((o.value = 'Alter muss mindestens 18 Jahre betragen.'), !1)
            : c > 99
              ? ((o.value = 'Alter darf maximal 99 Jahre betragen.'), !1)
              : ((o.value = ''), !0);
        }
        return (u, c) => (
          P(),
          M('div', pq, [
            c[2] ||
              (c[2] = _(
                'h2',
                { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                'Wie alt bist du aktuell ganz genau?',
                -1
              )),
            _('div', hq, [
              Ln(
                _(
                  'input',
                  {
                    type: 'number',
                    'onUpdate:modelValue': c[0] || (c[0] = (d) => (r.value = d)),
                    'aria-label': 'Gebe dein Alter ein',
                    min: '18',
                    max: '99',
                    class:
                      'qlfqa:!border-none qlfqa:!block qlfqa:!min-w-0 qlfqa:!grow qlfqa:!px-4 qlfqa:!py-2 qlfqa:focus:!outline-0 qlfqa:!text-[3em] qlfqa:!font-semibold qlfqa:!text-center qlfqa:!w-full qlfqa:!box-border'
                  },
                  null,
                  512
                ),
                [[Jn, r.value]]
              ),
              c[1] ||
                (c[1] = _(
                  'div',
                  {
                    class: 'qlfqa:!text-lg qlfqa:!text-gray-500 qlfqa:!relative qlfqa:!top-[10px]'
                  },
                  'Jahre',
                  -1
                ))
            ]),
            o.value ? (P(), M('div', mq, ve(o.value), 1)) : Te('', !0),
            S(
              he,
              { showBackButton: i.value, disableContinue: !r.value, onBack: a, onContinue: l },
              null,
              8,
              ['showBackButton', 'disableContinue']
            )
          ])
        );
      }
    }),
    _q = { class: 'qlfqa:!py-2' },
    qq = {
      class:
        'qlfqa:!mt-8 qlfqa:!flex qlfqa:!items-center qlfqa:!bg-transparent qlfqa:!border-b qlfqa:!pr-3 qlfqa:!border-yellow-300 qlfqa:focus:!border-yellow-400 qlfqa:focus:!border-b qlfqa:focus:!ring-yellow-300 qlfqa:!rounded-t-md'
    },
    vq = { key: 0, class: 'qlfqa:!text-red-500 qlfqa:!mt-2 qlfqa:!text-sm' },
    bq = re({
      __name: 'QuizScreen11',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = le(),
          r = U(''),
          o = U(''),
          i = H(() => s.screenHistory.length > 0);
        function l() {
          f(r.value) && n('next', r.value);
        }
        function a() {
          s.goBack();
        }
        function f(u) {
          if (u === '') return ((o.value = ''), !0);
          const c = Number(u);
          return c < 30
            ? ((o.value = 'Gewicht muss mindestens 30 kg betragen.'), !1)
            : c > 250
              ? ((o.value = 'Gewicht darf 250 kg nicht überschreiten.'), !1)
              : ((o.value = ''), !0);
        }
        return (u, c) => (
          P(),
          M('div', _q, [
            c[2] ||
              (c[2] = _(
                'h2',
                { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                'Was ist dein aktuelles Gewicht?',
                -1
              )),
            _('div', qq, [
              Ln(
                _(
                  'input',
                  {
                    type: 'number',
                    'onUpdate:modelValue': c[0] || (c[0] = (d) => (r.value = d)),
                    'aria-label': 'Enter your weight',
                    min: '30',
                    max: '250',
                    class:
                      'qlfqa:!border-none qlfqa:!font-semibold qlfqa:!block qlfqa:!min-w-0 qlfqa:!grow qlfqa:!px-4 qlfqa:!py-3 qlfqa:focus:!outline-0 qlfqa:!text-[3em] qlfqa:!text-center'
                  },
                  null,
                  512
                ),
                [[Jn, r.value]]
              ),
              c[1] ||
                (c[1] = _(
                  'div',
                  {
                    class: 'qlfqa:!text-lg qlfqa:!text-gray-500 qlfqa:!relative qlfqa:!top-[10px]'
                  },
                  'kg',
                  -1
                ))
            ]),
            o.value ? (P(), M('div', vq, ve(o.value), 1)) : Te('', !0),
            S(
              he,
              { showBackButton: i.value, disableContinue: !r.value, onBack: a, onContinue: l },
              null,
              8,
              ['showBackButton', 'disableContinue']
            )
          ])
        );
      }
    }),
    yq = { class: 'qlfqa:!py-2' },
    xq = {
      class:
        'qlfqa:!mt-8 qlfqa:!flex qlfqa:!items-center qlfqa:!bg-transparent qlfqa:!border-b qlfqa:!pr-3 qlfqa:!border-yellow-300 qlfqa:focus:!border-yellow-400 qlfqa:focus:!border-b qlfqa:focus:!ring-yellow-300 qlfqa:!rounded-t-md'
    },
    wq = {
      key: 0,
      class:
        'qlfqa:!mt-4 qlfqa:!border qlfqa:!border-[#e0a959] qlfqa:!rounded-2xl qlfqa:!p-5 qlfqa:!bg-[#faf3e9]'
    },
    Sq = { class: 'qlfqa:!flex qlfqa:!items-center qlfqa:!gap-2' },
    Eq = { class: 'qlfqa:!font-semibold qlfqa:!text-xs' },
    kq = { class: 'qlfqa:!mt-2 qlfqa:!text-xs' },
    Cq = { key: 0, class: 'qlfqa:!text-red-500 qlfqa:!mt-2 qlfqa:!text-sm' },
    Aq = re({
      __name: 'QuizScreen12',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = le(),
          r = U(''),
          o = U(''),
          i = [
            {
              bmi_range: [0, 16],
              headline1: 'Dein BMI beträgt',
              headline2: ', womit du stark untergewichtig bist',
              text: 'Ein BMI-Wert unter 16 ist bedenklich und gilt bei Männern wie Frauen als anorektisch. Um deine Gesundheit nicht zu gefährden, raten wir dir stark von einer weiteren Abnahme ab. Bitte beende dieses Quiz daher.'
            },
            {
              bmi_range: [16, 18.5],
              headline1: 'Dein BMI beträgt',
              headline2: ', womit du untergewichtig bist',
              text: 'Dein BMI-Wert ist bereits sehr niedrig, weshalb wir dir an der Stelle nur raten können, nicht weitere Maßnahmen zur Gewichtsreduktion zu unternehmen. Bitte beende daher dieses Quiz jetzt.'
            },
            {
              bmi_range: [18.5, 25],
              headline1: 'Dein BMI beträgt',
              headline2: ', womit du Normalgewicht hast',
              text: 'Klasse, dein BMI-Wert ist im grünen Bereich. Das ist eine gute Ausgangslage, deine Gesundheit und dein Wohlbefinden zu optimieren, gezielt Fett zu verlieren, den Körper zu straffen und schöne Muskulatur aufzubauen.'
            },
            {
              bmi_range: [25, 30],
              headline1: 'Dein BMI beträgt',
              headline2: ', womit du Übergewicht hast',
              text: 'Dein BMI-Wert ist bereits erhöht und das Risiko diverser Krankheiten beginnt zu steigen (Herz-Kreislauf, Diabetes Typ-2, Krebs). Mit den richtigen Strategien kannst du jedoch schnell beeindruckende Resultate erzielen.'
            },
            {
              bmi_range: [30, 999],
              headline1: 'Dein BMI beträgt',
              headline2: ', womit du starkes Übergewicht hast',
              text: 'Du leidest somit an einem stark erhöhten Risiko für diverse Krankheiten, wie Diabetes Typ-2, Krebs & Herz-Kreislauf-Erkrankungen. Zusammen können wir aber schnelle und wichtige Verbesserungen erzielen.'
            }
          ],
          l = H(() => s.screenHistory.length > 0),
          a = H(() => (!r.value || !s.q10 ? !1 : parseFloat(c()) < 18.5));
        function f() {
          p(r.value) && n('next', r.value);
        }
        function u() {
          s.goBack();
        }
        function c() {
          const h = parseInt(s.q11),
            q = parseInt(r.value);
          return (h / (q / 100) ** 2).toFixed(2);
        }
        function d() {
          const h = parseFloat(c());
          return i.find((v) => h >= v.bmi_range[0] && h < v.bmi_range[1]) || null;
        }
        function p(h) {
          if (h === '') return ((o.value = ''), !0);
          const q = Number(h);
          return q < 60
            ? ((o.value = 'Größe muss mindestens 60 cm betragen.'), !1)
            : q > 250
              ? ((o.value = 'Größe darf maximal 250 cm betragen.'), !1)
              : ((o.value = ''), !0);
        }
        return (h, q) => (
          P(),
          M('div', yq, [
            q[3] ||
              (q[3] = _(
                'h2',
                { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                'Wie groß bist du?',
                -1
              )),
            _('div', xq, [
              Ln(
                _(
                  'input',
                  {
                    type: 'number',
                    'onUpdate:modelValue': q[0] || (q[0] = (v) => (r.value = v)),
                    'aria-label': 'Gebe deine Größe ein',
                    min: '30',
                    max: '250',
                    class:
                      'qlfqa:!border-none qlfqa:!block qlfqa:!min-w-0 qlfqa:!grow qlfqa:!px-4 qlfqa:!py-2 qlfqa:focus:!outline-0 qlfqa:!text-[3em] qlfqa:!font-semibold qlfqa:!text-center qlfqa:!w-full qlfqa:!box-border'
                  },
                  null,
                  512
                ),
                [[Jn, r.value]]
              ),
              q[1] ||
                (q[1] = _(
                  'div',
                  {
                    class: 'qlfqa:!text-lg qlfqa:!text-gray-500 qlfqa:!relative qlfqa:!top-[10px]'
                  },
                  'cm',
                  -1
                ))
            ]),
            S(
              Dr,
              { name: 'fade' },
              {
                default: Et(() => {
                  var v, b, $;
                  return [
                    r.value && Ut(s).q10 && d()
                      ? (P(),
                        M('div', wq, [
                          _('div', Sq, [
                            q[2] ||
                              (q[2] = _(
                                'div',
                                {
                                  class:
                                    'qlfqa:!text-sm qlfqa:!border qlfqa:!border-[#e0a959] qlfqa:!text-[#e0a959] qlfqa:!rounded-full qlfqa:!flex qlfqa:!w-[20px] qlfqa:!h-[20px] qlfqa:!justify-center qlfqa:!items-center qlfqa:!font-bold'
                                },
                                '!',
                                -1
                              )),
                            _(
                              'h3',
                              Eq,
                              ve((v = d()) == null ? void 0 : v.headline1) +
                                ' ' +
                                ve(c()) +
                                ve((b = d()) == null ? void 0 : b.headline2),
                              1
                            )
                          ]),
                          _('p', kq, ve(($ = d()) == null ? void 0 : $.text), 1)
                        ]))
                      : Te('', !0)
                  ];
                }),
                _: 1
              }
            ),
            o.value ? (P(), M('div', Cq, ve(o.value), 1)) : Te('', !0),
            S(
              he,
              {
                showBackButton: l.value,
                disableContinue: !r.value,
                hideContinue: a.value,
                onBack: u,
                onContinue: f
              },
              null,
              8,
              ['showBackButton', 'disableContinue', 'hideContinue']
            )
          ])
        );
      }
    }),
    Tq = { class: 'qlfqa:!py-2' },
    Oq = {
      class:
        'qlfqa:!mt-8 qlfqa:!flex qlfqa:!items-center qlfqa:!bg-transparent qlfqa:!border-b qlfqa:!pr-3 qlfqa:!border-yellow-300 qlfqa:focus:!border-yellow-400 qlfqa:focus:!border-b qlfqa:focus:!ring-yellow-300 qlfqa:!rounded-t-md'
    },
    Bq = { key: 0, class: 'qlfqa:!text-red-500 qlfqa:!mt-2 qlfqa:!text-sm' },
    Iq = re({
      __name: 'QuizScreen13',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = le(),
          r = U(''),
          o = U(''),
          i = H(() => s.screenHistory.length > 0);
        function l() {
          f(r.value) && n('next', r.value);
        }
        function a() {
          s.goBack();
        }
        function f(u) {
          if (u === '') return ((o.value = ''), !0);
          const c = Number(u);
          return c < 30
            ? ((o.value = 'Gewicht muss mindestens 30 kg betragen.'), !1)
            : c > 250
              ? ((o.value = 'Gewicht darf 250 kg nicht überschreiten.'), !1)
              : ((o.value = ''), !0);
        }
        return (u, c) => (
          P(),
          M('div', Tq, [
            c[2] ||
              (c[2] = _(
                'h2',
                { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                'Was ist dein Zielgewicht?',
                -1
              )),
            _('div', Oq, [
              Ln(
                _(
                  'input',
                  {
                    type: 'number',
                    'onUpdate:modelValue': c[0] || (c[0] = (d) => (r.value = d)),
                    'aria-label': 'Enter your weight',
                    min: '30',
                    max: '250',
                    class:
                      'qlfqa:!border-none qlfqa:!font-semibold qlfqa:!block qlfqa:!min-w-0 qlfqa:!grow qlfqa:!px-4 qlfqa:!py-3 qlfqa:focus:!outline-0 qlfqa:!text-[3em] qlfqa:!text-center'
                  },
                  null,
                  512
                ),
                [[Jn, r.value]]
              ),
              c[1] || (c[1] = _('div', null, 'kg', -1))
            ]),
            o.value ? (P(), M('div', Bq, ve(o.value), 1)) : Te('', !0),
            S(
              he,
              { showBackButton: i.value, disableContinue: !r.value, onBack: a, onContinue: l },
              null,
              8,
              ['showBackButton', 'disableContinue']
            )
          ])
        );
      }
    }),
    Rq = { class: 'qlfqa:!py-2' },
    Pq = re({
      __name: 'QuizScreen14',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = le(),
          r = U([]),
          o = U(!1),
          i = [
            { id: 1, text: 'Gesundheit verbessern', val: '0' },
            { id: 2, text: 'Mein Aussehen verändern', val: '1' },
            { id: 3, text: 'Mich glücklicher und wohler fühlen', val: '2' },
            { id: 4, text: 'Arzt hat es empfohlen', val: '3' },
            { id: 5, text: 'Mehr Energie & Vitalität im Alltag', val: '4' }
          ],
          l = { id: 6, text: 'Andere Gründe', val: 'andere' },
          a = H(() => s.screenHistory.length > 0),
          f = H(() => r.value.length > 0 || o.value);
        function u() {
          let d;
          (o.value && l ? (d = [l.val]) : (d = r.value), n('next', d));
        }
        function c() {
          s.goBack();
        }
        return (d, p) => (
          P(),
          M('div', Rq, [
            p[1] ||
              (p[1] = _(
                'h2',
                { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                'Was ist deine Hauptmotivation abzunehmen?',
                -1
              )),
            p[2] ||
              (p[2] = _('p', { class: 'qlfqa:!text-gray-700' }, 'Mehrfach-Auswahl möglich', -1)),
            S(
              It,
              {
                modelValue: r.value,
                'onUpdate:modelValue': p[0] || (p[0] = (h) => (r.value = h)),
                class: 'qlfqa:!mt-4',
                checkboxOptions: i,
                exclusiveOption: l
              },
              null,
              8,
              ['modelValue']
            ),
            S(
              he,
              { showBackButton: a.value, disableContinue: !f.value, onBack: c, onContinue: u },
              null,
              8,
              ['showBackButton', 'disableContinue']
            )
          ])
        );
      }
    }),
    $q = { class: 'qlfqa:!py-2' },
    Dq = { class: 'qlfqa:!flex' },
    Fq = re({
      __name: 'QuizScreen15',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = le(),
          r = U(''),
          o = [
            { id: 1, text: 'Urlaub', val: '0' },
            { id: 2, text: 'Hochzeit', val: '30' },
            { id: 3, text: 'Sommer', val: '40' },
            { id: 4, text: 'Abnehmen nach Schwangerschaft', val: '-5' },
            { id: 5, text: 'Geburtstagsfeier', val: '50' },
            { id: 6, text: 'Nein, ich will mich einfach wieder wohler fühlen!', val: '60' }
          ],
          i = H(() => s.screenHistory.length > 0);
        function l() {
          n('next', r.value);
        }
        function a() {
          s.goBack();
        }
        return (f, u) => (
          P(),
          M('div', $q, [
            u[1] ||
              (u[1] = _(
                'h2',
                { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                'Gibt es ein bestimmtes Ziel, um abzunehmen?',
                -1
              )),
            _('div', Dq, [
              S(
                ct,
                {
                  class: 'qlfqa:!flex',
                  options: o,
                  modelValue: r.value,
                  'onUpdate:modelValue': u[0] || (u[0] = (c) => (r.value = c))
                },
                null,
                8,
                ['modelValue']
              )
            ]),
            S(
              he,
              { showBackButton: i.value, disableContinue: !r.value, onBack: a, onContinue: l },
              null,
              8,
              ['showBackButton', 'disableContinue']
            )
          ])
        );
      }
    }),
    zq = {
      class:
        'qlfqa:!mt-2 qlfqa:!grid qlfqa:!grid-cols-2 qlfqa:!gap-3 qlfqa:sm:!gap-x-4 qlfqa:!w-full'
    },
    Mq = ['onClick', 'onKeydown', 'aria-checked', 'aria-label', 'aria-description'],
    Nq = ['onMouseenter'],
    Vq = { class: 'qlfqa:!flex qlfqa:!flex-1 qlfqa:!justify-center' },
    Lq = { class: 'qlfqa:!flex qlfqa:!items-center' },
    Uq = { class: 'qlfqa:!block qlfqa:!text-xs qlfqa:!font-medium qlfqa:!text-gray-900' },
    jq = {
      key: 0,
      class: 'qlfqa:!flex qlfqa:!items-center qlfqa:!justify-center qlfqa:!text-yellow-300'
    },
    Us = {
      __name: 'SelectionGroupGrid',
      props: {
        modelValue: { type: [String, Number], default: null },
        options: { type: Array, default: null }
      },
      emits: ['update:modelValue'],
      setup(e, { emit: t }) {
        const n = e,
          s = t,
          r = U(n.modelValue),
          o = U(null);
        (Se(
          () => n.modelValue,
          (l) => {
            r.value = l;
          }
        ),
          Se(r, (l) => {
            s('update:modelValue', l);
          }));
        function i(l) {
          r.value = l;
        }
        return (l, a) => (
          P(),
          M('div', zq, [
            (P(!0),
            M(
              Ae,
              null,
              vn(
                e.options,
                (f) => (
                  P(),
                  M(
                    'div',
                    {
                      key: f.id,
                      class: 'qlfqa:!flex-1',
                      onClick: (u) => i(f.val),
                      onKeydown: Hu(
                        ju((u) => i(f.val), ['prevent']),
                        ['space']
                      ),
                      tabindex: '0',
                      role: 'radio',
                      'aria-checked': r.value === f.val,
                      'aria-label': f.text,
                      'aria-description': `Select ${f.text}`
                    },
                    [
                      _(
                        'div',
                        {
                          class: $e([
                            r.value === f.val
                              ? 'qlfqa:!border-yellow-300 qlfqa:!ring-1 qlfqa:!ring-yellow-300'
                              : 'qlfqa:!border-gray-300',
                            o.value === f.val
                              ? 'qlfqa:!border-yellow-300 qlfqa:!ring-1 qlfqa:!ring-yellow-300'
                              : '',
                            'qlfqa:!relative qlfqa:!flex qlfqa:!cursor-pointer qlfqa:!rounded-lg qlfqa:!h-14 qlfqa:!border qlfqa:!bg-white qlfqa:!p-4 qlfqa:!shadow-md qlfqa:focus:!outline-none'
                          ]),
                          onMouseenter: (u) => (o.value = f.val),
                          onMouseleave: a[0] || (a[0] = (u) => (o.value = null))
                        },
                        [
                          _('span', Vq, [_('span', Lq, [_('span', Uq, ve(f.text), 1)])]),
                          r.value === f.val
                            ? (P(),
                              M(
                                'span',
                                jq,
                                a[1] ||
                                  (a[1] = [
                                    _(
                                      'svg',
                                      {
                                        xmlns: 'http://www.w3.org/2000/svg',
                                        viewBox: '0 0 24 24',
                                        fill: 'currentColor',
                                        class: 'qlfqa:!size-5'
                                      },
                                      [
                                        _('path', {
                                          'fill-rule': 'evenodd',
                                          d: 'M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z',
                                          'clip-rule': 'evenodd'
                                        })
                                      ],
                                      -1
                                    )
                                  ])
                              ))
                            : Te('', !0),
                          _(
                            'span',
                            {
                              class: $e([
                                o.value === f.val ? 'qlfqa:!border' : 'qlfqa:!border-2',
                                r.value === f.val
                                  ? 'qlfqa:!border-yellow-300'
                                  : 'qlfqa:!border-transparent',
                                'qlfqa:!pointer-events-none qlfqa:!absolute qlfqa:!-inset-px qlfqa:!rounded-lg'
                              ]),
                              'aria-hidden': 'true'
                            },
                            null,
                            2
                          )
                        ],
                        42,
                        Nq
                      )
                    ],
                    40,
                    Mq
                  )
                )
              ),
              128
            ))
          ])
        );
      }
    },
    Hq = { class: 'qlfqa:!py-2' },
    Qq = { class: 'qlfqa:!mb-4' },
    Kq = { class: 'qlfqa:!flex' },
    Wq = re({
      __name: 'QuizScreen16',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = le(),
          r = U(''),
          o = [
            { id: 1, text: 'Weniger als 5h', val: '0' },
            { id: 2, text: '5 - 6 Stunden', val: '30' },
            { id: 3, text: '7 - 8 Stunden', val: '40' },
            { id: 4, text: 'Mehr als 8 Stunden', val: '-5' }
          ],
          i = [
            {
              id: 1,
              gender: 'w',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frau_Schlaf.jpg?v=1762508775',
              alt: ''
            },
            {
              id: 2,
              gender: 'm',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Mann_Schlaf.jpg?v=1762508775',
              alt: ''
            }
          ],
          l = H(() => i.find((p) => p.gender === s.gender) || i[0]),
          a = H(() => s.screenHistory.length > 0);
        function f() {
          n('next', r.value);
        }
        function u() {
          s.goBack();
        }
        let c = !1;
        function d() {
          if (c || !s.gender) return;
          c = !0;
          const p =
            s.gender === 'm'
              ? 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Mann_trinken.jpg?v=1762509220'
              : 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frau_trinken.jpg?v=1762509219';
          Ye([p]);
        }
        return (
          Se(r, (p) => {
            p && d();
          }),
          Se(
            () => s.gender,
            (p) => {
              p && d();
            }
          ),
          Me(() => {
            d();
          }),
          (p, h) => (
            P(),
            M('div', Hq, [
              h[1] ||
                (h[1] = _(
                  'h2',
                  { class: 'qlfqa:!text-xl qlfqa:!font-medium qlfqa:!mb-6 qlfqa:!text-center' },
                  'Wie viel schläfst du?',
                  -1
                )),
              _('div', Qq, [
                S(
                  je,
                  {
                    src: l.value.image,
                    alt: l.value.alt,
                    sizes: '400px',
                    class: 'qlfqa:!w-full qlfqa:!rounded-md',
                    loading: 'eager',
                    fetchpriority: 'high'
                  },
                  null,
                  8,
                  ['src', 'alt']
                )
              ]),
              _('div', Kq, [
                S(
                  Us,
                  {
                    class: 'qlfqa:!flex',
                    options: o,
                    modelValue: r.value,
                    'onUpdate:modelValue': h[0] || (h[0] = (q) => (r.value = q))
                  },
                  null,
                  8,
                  ['modelValue']
                )
              ]),
              S(
                he,
                {
                  class: 'qlfqa:!mt-6',
                  showBackButton: a.value,
                  disableContinue: !r.value,
                  onBack: u,
                  onContinue: f
                },
                null,
                8,
                ['showBackButton', 'disableContinue']
              )
            ])
          )
        );
      }
    }),
    Gq = { class: 'qlfqa:!py-2' },
    Jq = { class: 'qlfqa:!mb-4' },
    Yq = { class: 'qlfqa:!flex' },
    Zq = re({
      __name: 'QuizScreen17',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = le(),
          r = U(''),
          o = [
            { id: 1, text: 'Weniger als 1 Liter', val: '0' },
            { id: 2, text: '1 - 2 Liter', val: '30' },
            { id: 3, text: '2 - 3 Liter', val: '40' },
            { id: 4, text: 'Mehr als 3 Liter', val: '-5' }
          ],
          i = [
            {
              id: 1,
              gender: 'w',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frau_trinken.jpg?v=1762509219',
              alt: ''
            },
            {
              id: 2,
              gender: 'm',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Mann_trinken.jpg?v=1762509220',
              alt: ''
            }
          ],
          l = H(() => i.find((p) => p.gender === s.gender) || i[0]),
          a = H(() => s.screenHistory.length > 0);
        function f() {
          n('next', r.value);
        }
        function u() {
          s.goBack();
        }
        let c = !1;
        function d() {
          if (c || !s.gender) return;
          c = !0;
          const p =
            s.gender === 'm'
              ? 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Bewegung_Mann.jpg?v=1762509349'
              : 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Bewegung_Frau.jpg?v=1762509349';
          Ye([p]);
        }
        return (
          Se(r, (p) => {
            p && d();
          }),
          Se(
            () => s.gender,
            (p) => {
              p && d();
            }
          ),
          Me(() => {
            d();
          }),
          (p, h) => (
            P(),
            M('div', Gq, [
              h[1] ||
                (h[1] = _(
                  'h2',
                  { class: 'qlfqa:!text-lg qlfqa:!text-center qlfqa:!font-medium qlfqa:!mb-6' },
                  'Wie viel Wasser trinkst du?',
                  -1
                )),
              _('div', Jq, [
                S(
                  je,
                  {
                    src: l.value.image,
                    alt: l.value.alt,
                    sizes: '400px',
                    class: 'qlfqa:!w-full qlfqa:!rounded-md'
                  },
                  null,
                  8,
                  ['src', 'alt']
                )
              ]),
              _('div', Yq, [
                S(
                  Us,
                  {
                    class: 'qlfqa:!flex',
                    options: o,
                    modelValue: r.value,
                    'onUpdate:modelValue': h[0] || (h[0] = (q) => (r.value = q))
                  },
                  null,
                  8,
                  ['modelValue']
                )
              ]),
              S(
                he,
                {
                  class: 'qlfqa:!mt-6',
                  showBackButton: a.value,
                  disableContinue: !r.value,
                  onBack: u,
                  onContinue: f
                },
                null,
                8,
                ['showBackButton', 'disableContinue']
              )
            ])
          )
        );
      }
    }),
    Xq = { class: 'qlfqa:!py-2' },
    ev = { class: 'qlfqa:!mb-4' },
    tv = { class: 'qlfqa:!flex' },
    nv = re({
      __name: 'QuizScreen18',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = le(),
          r = U(''),
          o = [
            { id: 1, text: 'Kaum bis gar nicht', val: '1.2,Inaktiv' },
            { id: 2, text: 'Kleiner Spaziergang', val: '1.375,Gering' },
            { id: 3, text: 'Großer Spaziergang', val: '1.55,Moderat' },
            { id: 4, text: 'Viel Bewegung', val: '1.725,Aktiv' }
          ],
          i = [
            {
              id: 1,
              gender: 'w',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Bewegung_Frau.jpg?v=1762509349',
              alt: ''
            },
            {
              id: 2,
              gender: 'm',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Bewegung_Mann.jpg?v=1762509349',
              alt: ''
            }
          ],
          l = H(() => i.find((p) => p.gender === s.gender) || i[0]),
          a = H(() => s.screenHistory.length > 0);
        function f() {
          n('next', r.value);
        }
        function u() {
          s.goBack();
        }
        let c = !1;
        function d() {
          if (c) return;
          c = !0;
          const p =
            s.gender === 'm'
              ? 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Mann_Sport.jpg?v=1762509441'
              : 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frau_Sport.jpg?v=1762509440';
          Ye([p]);
        }
        return (
          Se(r, (p) => {
            p && d();
          }),
          (p, h) => (
            P(),
            M('div', Xq, [
              h[1] ||
                (h[1] = _(
                  'h2',
                  { class: 'qlfqa:!text-lg qlfqa:!text-center qlfqa:!font-medium qlfqa:!mb-6' },
                  'Bewegst du dich täglich?',
                  -1
                )),
              _('div', ev, [
                S(
                  je,
                  {
                    src: l.value.image,
                    alt: l.value.alt,
                    sizes: '400px',
                    class: 'qlfqa:!w-full qlfqa:!rounded-md'
                  },
                  null,
                  8,
                  ['src', 'alt']
                )
              ]),
              _('div', tv, [
                S(
                  Us,
                  {
                    class: 'qlfqa:!flex',
                    options: o,
                    modelValue: r.value,
                    'onUpdate:modelValue': h[0] || (h[0] = (q) => (r.value = q))
                  },
                  null,
                  8,
                  ['modelValue']
                )
              ]),
              S(
                he,
                {
                  class: 'qlfqa:!mt-6',
                  showBackButton: a.value,
                  disableContinue: !r.value,
                  onBack: u,
                  onContinue: f
                },
                null,
                8,
                ['showBackButton', 'disableContinue']
              )
            ])
          )
        );
      }
    }),
    sv = { class: 'qlfqa:!py-2' },
    rv = { class: 'qlfqa:!mb-4' },
    ov = { class: 'qlfqa:!flex' },
    iv = re({
      __name: 'QuizScreen19',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = le(),
          r = U(''),
          o = [
            { id: 1, text: 'Nein, aktuell nicht', val: '0' },
            { id: 2, text: '1 bis 2 x / Woche', val: '30' },
            { id: 3, text: '2 bis 3 x / Woche', val: '40' },
            { id: 4, text: 'Mehr als 3 x / Woche', val: '-5' }
          ],
          i = [
            {
              id: 1,
              gender: 'w',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frau_Sport.jpg?v=1762509440',
              alt: ''
            },
            {
              id: 2,
              gender: 'm',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Mann_Sport.jpg?v=1762509441',
              alt: ''
            }
          ],
          l = H(() => i.find((p) => p.gender === s.gender) || i[0]),
          a = H(() => s.screenHistory.length > 0);
        function f() {
          n('next', r.value);
        }
        function u() {
          s.goBack();
        }
        let c = !1;
        function d() {
          if (c) return;
          c = !0;
          const p =
            s.gender === 'm'
              ? 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Mann_Treppen.jpg?v=1762509528'
              : 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frauen_Treppen.jpg?v=1762509528';
          Ye([p]);
        }
        return (
          Se(r, (p) => {
            p && d();
          }),
          (p, h) => (
            P(),
            M('div', sv, [
              h[1] ||
                (h[1] = _(
                  'h2',
                  { class: 'qlfqa:!text-lg qlfqa:!text-center qlfqa:!font-medium qlfqa:!mb-6' },
                  'Machst du regelmäßig Sport?',
                  -1
                )),
              _('div', rv, [
                S(
                  je,
                  {
                    src: l.value.image,
                    alt: l.value.alt,
                    sizes: '400px',
                    class: 'qlfqa:!w-full qlfqa:!rounded-md'
                  },
                  null,
                  8,
                  ['src', 'alt']
                )
              ]),
              _('div', ov, [
                S(
                  Us,
                  {
                    class: 'qlfqa:!flex',
                    options: o,
                    modelValue: r.value,
                    'onUpdate:modelValue': h[0] || (h[0] = (q) => (r.value = q))
                  },
                  null,
                  8,
                  ['modelValue']
                )
              ]),
              S(
                he,
                {
                  class: 'qlfqa:!mt-6',
                  showBackButton: a.value,
                  disableContinue: !r.value,
                  onBack: u,
                  onContinue: f
                },
                null,
                8,
                ['showBackButton', 'disableContinue']
              )
            ])
          )
        );
      }
    }),
    lv = { class: 'qlfqa:!py-2' },
    av = { class: 'qlfqa:!mb-4' },
    uv = { class: 'qlfqa:!flex' },
    cv = re({
      __name: 'QuizScreen20',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = le(),
          r = U(''),
          o = [
            { id: 1, text: 'Nein, eher nicht', val: '0' },
            { id: 2, text: 'Ja, eher schon', val: '30' }
          ],
          i = [
            {
              id: 1,
              gender: 'w',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frauen_Treppen.jpg?v=1762509528',
              alt: ''
            },
            {
              id: 2,
              gender: 'm',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Mann_Treppen.jpg?v=1762509528',
              alt: ''
            }
          ],
          l = H(() => i.find((p) => p.gender === s.gender) || i[0]),
          a = H(() => s.screenHistory.length > 0);
        function f() {
          n('next', r.value);
        }
        function u() {
          s.goBack();
        }
        let c = !1;
        function d() {
          if (c) return;
          c = !0;
          const p = [
            'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Diaeten-Scheitern.jpg',
            s.gender === 'm'
              ? 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Jojo-Effekt-Mann.jpg'
              : 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Jojo-Effekt-Frau.jpg'
          ];
          Ye(p);
        }
        return (
          Se(r, (p) => {
            p && d();
          }),
          (p, h) => (
            P(),
            M('div', lv, [
              h[1] ||
                (h[1] = _(
                  'h2',
                  { class: 'qlfqa:!text-lg qlfqa:!text-center qlfqa:!font-medium qlfqa:!mb-6' },
                  'Außer Atem bei Treppen?',
                  -1
                )),
              _('div', av, [
                S(
                  je,
                  {
                    src: l.value.image,
                    alt: l.value.alt,
                    sizes: '400px',
                    class: 'qlfqa:!w-full qlfqa:!rounded-md'
                  },
                  null,
                  8,
                  ['src', 'alt']
                )
              ]),
              _('div', uv, [
                S(
                  Us,
                  {
                    class: 'qlfqa:!flex',
                    options: o,
                    modelValue: r.value,
                    'onUpdate:modelValue': h[0] || (h[0] = (q) => (r.value = q))
                  },
                  null,
                  8,
                  ['modelValue']
                )
              ]),
              S(
                he,
                {
                  class: 'qlfqa:!mt-6',
                  showBackButton: a.value,
                  disableContinue: !r.value,
                  onBack: u,
                  onContinue: f
                },
                null,
                8,
                ['showBackButton', 'disableContinue']
              )
            ])
          )
        );
      }
    }),
    fv = { class: 'qlfqa:!py-2' },
    dv = re({
      __name: 'QuizScreen21',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = le(),
          r = U([]),
          o = U(!1),
          i = [
            { id: 1, text: 'Emotionales essen oder aus Langeweile', val: '0' },
            { id: 2, text: 'Zu viel essen', val: '1' },
            { id: 3, text: 'Oft Snacks essen', val: '2' },
            { id: 4, text: 'Mahlzeiten häufiger komplett auslassen', val: '3' }
          ],
          l = { id: 5, text: 'Keine der Aufgezählten', val: 'nichts' },
          a = H(() => s.screenHistory.length > 0),
          f = H(() => r.value.length > 0 || o.value);
        function u() {
          let d;
          (o.value && l ? (d = [l.val]) : (d = r.value), n('next', d));
        }
        function c() {
          s.goBack();
        }
        return (d, p) => (
          P(),
          M('div', fv, [
            p[1] ||
              (p[1] = _(
                'h2',
                { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                'Hast du einige dieser Angewohnheiten?',
                -1
              )),
            p[2] ||
              (p[2] = _('p', { class: 'qlfqa:!text-gray-700' }, 'Mehrfach-Auswahl möglich', -1)),
            S(
              It,
              {
                modelValue: r.value,
                'onUpdate:modelValue': p[0] || (p[0] = (h) => (r.value = h)),
                class: 'qlfqa:!mt-4',
                checkboxOptions: i,
                exclusiveOption: l
              },
              null,
              8,
              ['modelValue']
            ),
            S(
              he,
              { showBackButton: a.value, disableContinue: !f.value, onBack: c, onContinue: u },
              null,
              8,
              ['showBackButton', 'disableContinue']
            )
          ])
        );
      }
    }),
    pv = { class: 'qlfqa:!py-2' },
    hv = re({
      __name: 'QuizScreen22',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = le(),
          r = U([]),
          o = U(!1),
          i = [
            { id: 1, text: 'Low Carb oder Keto', val: '0' },
            { id: 2, text: 'Intermittierendes Fasten', val: '1' },
            { id: 3, text: 'Kalorien zählen', val: '2' },
            { id: 4, text: 'Weight Watchers (oder ähnliches)', val: '3' }
          ],
          l = { id: 5, text: 'Keine der Aufgezählten', val: 'nichts' },
          a = H(() => s.screenHistory.length > 0),
          f = H(() => r.value.length > 0 || o.value);
        function u() {
          let d;
          (o.value && l ? (d = [l.val]) : (d = r.value), n('next', d));
        }
        function c() {
          s.goBack();
        }
        return (d, p) => (
          P(),
          M('div', pv, [
            p[1] ||
              (p[1] = _(
                'h2',
                { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                'Hast du schon solche Diäten ausprobiert?',
                -1
              )),
            p[2] ||
              (p[2] = _('p', { class: 'qlfqa:!text-gray-700' }, 'Mehrfach-Auswahl möglich', -1)),
            S(
              It,
              {
                modelValue: r.value,
                'onUpdate:modelValue': p[0] || (p[0] = (h) => (r.value = h)),
                class: 'qlfqa:!mt-4',
                checkboxOptions: i,
                exclusiveOption: l
              },
              null,
              8,
              ['modelValue']
            ),
            S(
              he,
              { showBackButton: a.value, disableContinue: !f.value, onBack: c, onContinue: u },
              null,
              8,
              ['showBackButton', 'disableContinue']
            )
          ])
        );
      }
    }),
    mv = { class: 'qlfqa:!py-2' },
    gv = { class: 'qlfqa:!flex' },
    _v = re({
      __name: 'QuizScreen23',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = le(),
          r = U(''),
          o = [
            { id: 1, text: 'Kurzfristiger Erfolg, dann wieder zugenommen', val: '0' },
            { id: 2, text: 'Kaum Wirkung, obwohl ich mich bemüht habe', val: '30' },
            { id: 3, text: 'Gar keine Erfahrung', val: '40' }
          ],
          i = H(() => s.screenHistory.length > 0);
        function l() {
          n('next', r.value);
        }
        function a() {
          s.goBack();
        }
        return (f, u) => (
          P(),
          M('div', mv, [
            u[1] ||
              (u[1] = _(
                'h2',
                { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                'Wie sind deine bisherigen Erfahrungen mit Abnehmen oder Diäten?',
                -1
              )),
            _('div', gv, [
              S(
                ct,
                {
                  class: 'qlfqa:!flex',
                  options: o,
                  modelValue: r.value,
                  'onUpdate:modelValue': u[0] || (u[0] = (c) => (r.value = c))
                },
                null,
                8,
                ['modelValue']
              )
            ]),
            S(
              he,
              { showBackButton: i.value, disableContinue: !r.value, onBack: a, onContinue: l },
              null,
              8,
              ['showBackButton', 'disableContinue']
            )
          ])
        );
      }
    }),
    qv = { class: 'qlfqa:!py-2', role: 'article' },
    vv = { class: 'qlfqa:!mb-4' },
    bv = {
      class: 'qlfqa:!mt-8 qlfqa:!flex qlfqa:!justify-center qlfqa:!gap-4',
      role: 'group',
      'aria-label': 'Navigation'
    },
    yv = ['disabled', 'aria-disabled'],
    xv = re({
      __name: 'QuizScreen24',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = le(),
          r = U('checked'),
          o = H(() => s.screenHistory.length > 0),
          i = H(() =>
            s.gender === 'm'
              ? 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Jojo-Effekt-Mann.jpg'
              : 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Jojo-Effekt-Frau.jpg'
          ),
          l = H(() =>
            s.gender === 'm'
              ? 'Grafik, die zeigt, dass Diäten langfristig nicht funktionieren bei Männern'
              : 'Grafik, die zeigt, dass Diäten langfristig nicht funktionieren bei Frauen'
          );
        function a() {
          n('next', r.value);
        }
        function f() {
          s.goBack();
        }
        let u = !1;
        function c() {
          if (u) return;
          u = !0;
          const d =
            s.gender === 'm'
              ? 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Trafo_Mann_Stoffwechsel_Quiz.jpg?v=1762509639'
              : 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Trafo_Frau_Stoffwechsel_Quiz.jpg?v=1762509639';
          Ye([d]);
        }
        return (
          Me(() => {
            c();
          }),
          (d, p) => (
            P(),
            M('div', qv, [
              p[0] ||
                (p[0] = _(
                  'h2',
                  { class: 'qlfqa:!text-xl qlfqa:!font-medium qlfqa:!mb-6 qlfqa:!text-center' },
                  'Schluss mit der Diät-Falle 😣',
                  -1
                )),
              p[1] ||
                (p[1] = _(
                  'p',
                  { class: 'qlfqa:!text-gray-700 qlfqa:!text-center' },
                  ' Die Statistik beweist - Klassische Diäten scheitern nicht nur, sondern machen es jedes Mal leichter mehr an ungesunden Fett zuzunehmen. ',
                  -1
                )),
              _('div', vv, [
                S(je, {
                  src: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Diaeten-Scheitern.jpg?width=400',
                  srcset: `
                    https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Diaeten-Scheitern.jpg?width=320 320w,
                    https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Diaeten-Scheitern.jpg?width=400 400w,
                    https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Diaeten-Scheitern.jpg?width=800 800w
                  `,
                  sizes: '400px',
                  alt: 'Diagramm das zeigt, dass Diäten langfristig nicht funktionieren',
                  loading: 'eager',
                  fetchpriority: 'high',
                  decoding: 'async',
                  width: '400',
                  height: '300',
                  class: 'qlfqa:!w-full qlfqa:!h-auto'
                }),
                S(
                  je,
                  {
                    src: `${i.value}?width=400`,
                    srcset: `
                    ${i.value}?width=320 320w,
                    ${i.value}?width=400 400w,
                    ${i.value}?width=800 800w
                  `,
                    sizes: '400px',
                    alt: l.value,
                    loading: 'eager',
                    fetchpriority: 'high',
                    decoding: 'async',
                    width: '400',
                    height: '300',
                    class: 'qlfqa:!w-full qlfqa:!h-auto'
                  },
                  null,
                  8,
                  ['src', 'srcset', 'alt']
                )
              ]),
              _('div', bv, [
                _(
                  'button',
                  {
                    onClick: f,
                    disabled: !o.value,
                    'aria-disabled': !o.value,
                    'aria-label': 'Zurück zum vorherigen Schritt',
                    class:
                      'qlfqa:!border qlfqa:!border-solid qlfqa:!border-[#CECDCA] qlfqa:!text-[#808080] qlfqa:!px-6 qlfqa:!py-3 qlfqa:!rounded-md qlfqa:disabled:!opacity-50 qlfqa:hover:!opacity-80 qlfqa:!cursor-pointer qlfqa:!w-1/2'
                  },
                  ' Zurück ',
                  8,
                  yv
                ),
                _(
                  'button',
                  {
                    onPointerenter: c,
                    onPointerdown: c,
                    onClick: a,
                    'aria-label': 'Alles klar und weiter',
                    class:
                      'qlfqa:!bg-yellow-500 qlfqa:!text-black qlfqa:!px-6 qlfqa:!py-3 qlfqa:!rounded-md qlfqa:disabled:!opacity-50 qlfqa:hover:!bg-yellow-400 qlfqa:!cursor-pointer qlfqa:!w-1/2'
                  },
                  ' Weiter ',
                  32
                )
              ])
            ])
          )
        );
      }
    }),
    wv = { class: 'loading-bar-container' },
    Sv = { key: 0, class: 'qlfqa:!flex qlfqa:!justify-between qlfqa:!items-center qlfqa:!mb-2' },
    Ev = { class: 'qlfqa:!flex qlfqa:!items-center qlfqa:!gap-2' },
    kv = {
      key: 0,
      width: '16',
      height: '16',
      viewBox: '0 0 24 24',
      xmlns: 'http://www.w3.org/2000/svg'
    },
    Cv = { key: 1, class: 'qlfqa:!text-xs qlfqa:!font-medium qlfqa:!w-[35px]' },
    Av = { class: 'loading-bar-wrapper' },
    Tv = { class: 'loading-bar-track' },
    Ov = { key: 0, class: 'loading-bar-percentage' },
    Yr = re({
      __name: 'LoadingBarConfigurable',
      props: {
        duration: { default: 4e3 },
        showPercentage: { type: Boolean, default: !0 },
        easingFunction: { default: 'linear' },
        autoStart: { type: Boolean, default: !0 },
        label: { default: '' }
      },
      emits: ['complete', 'progress'],
      setup(e, { expose: t, emit: n }) {
        const s = e,
          r = n,
          o = U(0),
          i = U(!1);
        let l = null,
          a = null;
        const f = {
          linear: (h) => h,
          easeIn: (h) => h * h,
          easeOut: (h) => h * (2 - h),
          easeInOut: (h) => (h < 0.5 ? 2 * h * h : -1 + (4 - 2 * h) * h)
        };
        function u(h) {
          a || (a = h);
          const q = h - a,
            v = Math.min(q / s.duration, 1),
            b = f[s.easingFunction](v);
          ((o.value = b * 100),
            r('progress', o.value),
            v < 1
              ? (l = requestAnimationFrame(u))
              : ((o.value = 100), (i.value = !1), r('complete')));
        }
        function c() {
          (d(), (i.value = !0), (l = requestAnimationFrame(u)));
        }
        function d() {
          (l !== null && (cancelAnimationFrame(l), (l = null)),
            (a = null),
            (o.value = 0),
            (i.value = !1));
        }
        function p() {
          (l !== null && (cancelAnimationFrame(l), (l = null)), (i.value = !1));
        }
        return (
          Me(() => {
            s.autoStart && c();
          }),
          kr(() => {
            l !== null && cancelAnimationFrame(l);
          }),
          t({ start: c, reset: d, pause: p, progress: o }),
          (h, q) => (
            P(),
            M('div', wv, [
              h.label
                ? (P(),
                  M('div', Sv, [
                    _(
                      'span',
                      {
                        class: $e([
                          'qlfqa:!text-xs',
                          { 'qlfqa:font-bold': i.value, 'qlfqa:opacity-75': !i.value }
                        ])
                      },
                      ve(h.label),
                      3
                    ),
                    _('span', Ev, [
                      i.value
                        ? (P(),
                          M(
                            'svg',
                            kv,
                            q[0] ||
                              (q[0] = [
                                _(
                                  'path',
                                  {
                                    d: 'M10.72,19.9a8,8,0,0,1-6.5-9.79A7.77,7.77,0,0,1,10.4,4.16a8,8,0,0,1,9.49,6.52A1.54,1.54,0,0,0,21.38,12h.13a1.37,1.37,0,0,0,1.38-1.54,11,11,0,1,0-12.7,12.39A1.54,1.54,0,0,0,12,21.34h0A1.47,1.47,0,0,0,10.72,19.9Z',
                                    class: 'spinner_6kVp'
                                  },
                                  null,
                                  -1
                                )
                              ])
                          ))
                        : Te('', !0),
                      h.showPercentage
                        ? (P(), M('span', Cv, ve(Math.round(o.value)) + '% ', 1))
                        : Te('', !0)
                    ])
                  ]))
                : Te('', !0),
              _('div', Av, [
                _('div', Tv, [
                  _(
                    'div',
                    { class: 'loading-bar-fill', style: nt({ width: `${o.value}%` }) },
                    null,
                    4
                  )
                ]),
                h.showPercentage && !h.label
                  ? (P(), M('div', Ov, ve(Math.round(o.value)) + '% ', 1))
                  : Te('', !0)
              ])
            ])
          )
        );
      }
    }),
    Bv = { class: 'qlfqa:!py-2', role: 'article' },
    Iv = { class: 'qlfqa:!mt-8' },
    Rv = {
      class:
        'qlfqa:!text-center qlfqa:!text-sm qlfqa:!mt-6 qlfqa:!flex qlfqa:!items-center qlfqa:!justify-center qlfqa:!gap-2 qlfqa:!font-bold qlfqa:!text-black'
    },
    Pv = { class: 'qlfqa:!mb-4 qlfqa:!mt-8' },
    Di = 300,
    $v = re({
      __name: 'QuizScreen25',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = le(),
          r = U('checked'),
          o = U(),
          i = U(),
          l = U(),
          a = U(),
          f = U(0);
        function u() {
          setTimeout(() => {
            var b;
            ((f.value = 2), (b = i.value) == null || b.start());
          }, Di);
        }
        function c() {
          setTimeout(() => {
            var b;
            ((f.value = 3), (b = l.value) == null || b.start());
          }, Di);
        }
        function d() {
          setTimeout(() => {
            var b;
            ((f.value = 4), (b = a.value) == null || b.start());
          }, Di);
        }
        function p() {
          ((f.value = 0),
            setTimeout(() => {
              n('next', r.value);
            }, 1e3));
        }
        const h = [
            {
              id: 1,
              gender: 'w',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Trafo_Frau_Stoffwechsel_Quiz.jpg?v=1762509639',
              alt: ''
            },
            {
              id: 2,
              gender: 'm',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Trafo_Mann_Stoffwechsel_Quiz.jpg?v=1762509639',
              alt: ''
            }
          ],
          q = H(() => h.find((b) => b.gender === s.gender) || h[0]);
        function v() {
          const b = [
            s.gender === 'm'
              ? 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Stoffwechsel-Typ_Mann.png'
              : 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Stoffwechsel-Typ_Frau.png',
            'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/sofa.png',
            'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/ziel.png',
            'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/blitz.png',
            s.gender === 'm'
              ? 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage26-Mann-BMI-25.jpg'
              : 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage26-Frau-BMI-25.jpg'
          ];
          Ye(b);
        }
        return (
          Me(() => {
            var b;
            ((f.value = 1), (b = o.value) == null || b.start(), v());
          }),
          (b, $) => (
            P(),
            M('div', Bv, [
              $[2] ||
                ($[2] = _(
                  'h2',
                  { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4 qlfqa:!text-center' },
                  'Deine Daten werden jetzt analysiert',
                  -1
                )),
              _('div', Iv, [
                S(
                  Yr,
                  {
                    ref_key: 'loadingBar1',
                    ref: o,
                    label: 'Persönliche Angaben werden ausgewertet',
                    duration: 2e3,
                    autoStart: !1,
                    class: 'qlfqa:!mb-4',
                    easingFunction: 'easeOut',
                    onComplete: u
                  },
                  null,
                  512
                ),
                S(
                  Yr,
                  {
                    ref_key: 'loadingBar2',
                    ref: i,
                    label: 'Individuelle Umstände werden abgeglichen',
                    duration: 2200,
                    autoStart: !1,
                    class: 'qlfqa:!mb-4',
                    easingFunction: 'easeOut',
                    onComplete: c
                  },
                  null,
                  512
                ),
                S(
                  Yr,
                  {
                    ref_key: 'loadingBar3',
                    ref: l,
                    label: 'Gesundheit & Langfristiger Erfolg berechnet',
                    duration: 2500,
                    autoStart: !1,
                    class: 'qlfqa:!mb-4',
                    easingFunction: 'easeOut',
                    onComplete: d
                  },
                  null,
                  512
                ),
                S(
                  Yr,
                  {
                    ref_key: 'loadingBar4',
                    ref: a,
                    label: 'Abgleich mit der wissenschaftlichen Datenbank',
                    duration: 1e4,
                    autoStart: !1,
                    easingFunction: 'easeInOut',
                    onComplete: p
                  },
                  null,
                  512
                )
              ]),
              _('p', Rv, [
                S(je, {
                  src: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/testis.jpg?v=1754585128',
                  alt: 'Testimonials',
                  class: 'qlfqa:!w-auto qlfqa:!h-7',
                  sizes: '100px'
                }),
                $[0] ||
                  ($[0] = _(
                    'svg',
                    {
                      width: '25px',
                      height: '25px',
                      viewBox: '0 0 24 24',
                      fill: 'none',
                      xmlns: 'http://www.w3.org/2000/svg'
                    },
                    [
                      _('rect', { width: '24', height: '24' }),
                      _('path', {
                        'fill-rule': 'evenodd',
                        'clip-rule': 'evenodd',
                        d: 'M9.55879 3.6972C10.7552 2.02216 13.2447 2.02216 14.4412 3.6972L14.6317 3.96387C14.8422 4.25867 15.1958 4.41652 15.5558 4.37652L16.4048 4.28218C18.3156 4.06988 19.9301 5.68439 19.7178 7.59513L19.6235 8.44415C19.5835 8.8042 19.7413 9.15774 20.0361 9.36831L20.3028 9.55879C21.9778 10.7552 21.9778 13.2447 20.3028 14.4412L20.0361 14.6317C19.7413 14.8422 19.5835 15.1958 19.6235 15.5558L19.7178 16.4048C19.9301 18.3156 18.3156 19.9301 16.4048 19.7178L15.5558 19.6235C15.1958 19.5835 14.8422 19.7413 14.6317 20.0361L14.4412 20.3028C13.2447 21.9778 10.7553 21.9778 9.55879 20.3028L9.36831 20.0361C9.15774 19.7413 8.8042 19.5835 8.44414 19.6235L7.59513 19.7178C5.68439 19.9301 4.06988 18.3156 4.28218 16.4048L4.37652 15.5558C4.41652 15.1958 4.25867 14.8422 3.96387 14.6317L3.6972 14.4412C2.02216 13.2447 2.02216 10.7553 3.6972 9.55879L3.96387 9.36831C4.25867 9.15774 4.41652 8.8042 4.37652 8.44414L4.28218 7.59513C4.06988 5.68439 5.68439 4.06988 7.59513 4.28218L8.44415 4.37652C8.8042 4.41652 9.15774 4.25867 9.36831 3.96387L9.55879 3.6972ZM15.7071 9.29289C16.0976 9.68342 16.0976 10.3166 15.7071 10.7071L11.8882 14.526C11.3977 15.0166 10.6023 15.0166 10.1118 14.526L8.29289 12.7071C7.90237 12.3166 7.90237 11.6834 8.29289 11.2929C8.68342 10.9024 9.31658 10.9024 9.70711 11.2929L11 12.5858L14.2929 9.29289C14.6834 8.90237 15.3166 8.90237 15.7071 9.29289Z',
                        fill: '#3D7FDE'
                      })
                    ],
                    -1
                  )),
                $[1] ||
                  ($[1] = _(
                    'span',
                    { class: 'qlfqa:!text-[0.7rem]' },
                    'über 500.000 Kunden vertrauen QLF',
                    -1
                  ))
              ]),
              _('div', Pv, [
                S(
                  je,
                  {
                    src: q.value.image,
                    alt: q.value.alt,
                    sizes: '400px',
                    class: 'qlfqa:!rounded-md'
                  },
                  null,
                  8,
                  ['src', 'alt']
                )
              ])
            ])
          )
        );
      }
    }),
    Dv = { class: 'qlfqa:!py-2', role: 'article' },
    Fv = { class: 'bmi-chart-wrapper' },
    zv = { class: 'bmi-chart' },
    Mv = { class: 'bmi-chart-track' },
    Nv = { class: 'bmi-chart-bottom' },
    Vv = {
      key: 0,
      class:
        'qlfqa:!mt-4 qlfqa:!border qlfqa:!border-[#e0a959] qlfqa:!rounded-2xl qlfqa:!p-5 qlfqa:!bg-[#faf3e9]'
    },
    Lv = { class: 'qlfqa:!flex qlfqa:!items-center qlfqa:!gap-2' },
    Uv = { class: 'qlfqa:!font-semibold qlfqa:!text-xs' },
    jv = { class: 'qlfqa:!mt-2 qlfqa:!text-xs' },
    Hv = { class: 'qlfqa:!text-gray-700 qlfqa:!text-xs qlfqa:!m-0' },
    Qv = { class: 'qlfqa:!text-sm qlfqa:!font-bold' },
    Kv = {
      class: 'qlfqa:!mt-8 qlfqa:!flex qlfqa:!justify-center qlfqa:!gap-4',
      role: 'group',
      'aria-label': 'Navigation'
    },
    Wv = ['disabled', 'aria-disabled'],
    Gv = re({
      __name: 'QuizScreen26',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = le(),
          r = U('checked'),
          o = U([]),
          i = U(0),
          l = U(!1),
          a = H(() => '20%'),
          f = H(() => '21%'),
          u = H(() => '22%'),
          c = H(() => '37%'),
          d = [
            {
              id: 1,
              headline: 'STOFFWECHSEL-TYP',
              text: s.q07.replace(' 2', ''),
              imageM:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Stoffwechsel-Typ_Mann.png',
              imageW:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Stoffwechsel-Typ_Frau.png'
            },
            {
              id: 2,
              headline: 'LEBENSSTIL',
              text: s.q18.split(',')[1],
              image: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/sofa.png'
            },
            {
              id: 3,
              headline: 'ZIEL-ZONEN',
              text: s.q04.toString().replaceAll(',', ', '),
              image: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/ziel.png'
            },
            {
              id: 4,
              headline: 'ERFOLGS-CHANCE',
              text: 'Sehr hoch',
              image: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/blitz.png'
            }
          ],
          p = [
            {
              bmi_range: [0, 18.5],
              headline: 'Risiken eines ungesunden BMI',
              text: 'Bluthochdruck, erhöhtes Risiko für Herzinfarkt, Schlaganfall, Typ-2 Diabetes sowie chronische Rücken- und Gelenkschmerzen. Mit den richtigen Maßnahmen kannst du jedoch schnell, sicher und effektiv abnehmen.'
            },
            {
              bmi_range: [25, 999],
              headline: 'Risiken eines ungesunden BMI',
              text: 'Bluthochdruck, erhöhtes Risiko für Herzinfarkt, Schlaganfall, Typ-2 Diabetes sowie chronische Rücken- und Gelenkschmerzen. Mit den richtigen Maßnahmen kannst du jedoch schnell, sicher und effektiv abnehmen.'
            }
          ];
        function h() {
          const x = parseInt(s.q11),
            Q = parseInt(s.q12);
          return (x / (Q / 100) ** 2).toFixed(2);
        }
        function q() {
          const x = parseFloat(h());
          return p.find((Y) => x >= Y.bmi_range[0] && x < Y.bmi_range[1]) || null;
        }
        function v(x) {
          const ae = ((Math.max(15, Math.min(40, x)) - 15) / 25) * 100;
          return Math.min(ae, 100);
        }
        const b = H(() => {
          const x = parseFloat(h());
          return x <= 35
            ? 'calc(.5rem + 2px)'
            : x >= 40
              ? '-19px'
              : `calc(.5rem + 2px + ${((x - 35) / 5) * -19}px)`;
        });
        function $() {
          const x = parseFloat(h()),
            Q = v(x);
          setTimeout(() => {
            ((i.value = Q),
              setTimeout(() => {
                l.value = !0;
              }, 1500));
          }, 300);
        }
        const C = (x) =>
            'imageM' in x && 'imageW' in x ? (s.gender === 'm' ? x.imageM : x.imageW) : x.image,
          G = H(() => {
            const x = parseFloat(h());
            return isNaN(x) || x < 18.5
              ? 'lt20'
              : x < 25
                ? 'gte20_lt25'
                : x < 30
                  ? 'gte25_lt30'
                  : x < 35
                    ? 'gte30_lt35'
                    : 'gte35';
          }),
          D = {
            m: {
              lt20: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage26-Mann-BMI-unter20.jpg',
              gte20_lt25:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage26-Mann-BMI-ueber20.jpg',
              gte25_lt30:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage26-Mann-BMI-25.jpg',
              gte30_lt35:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage26-Mann-BMI-30.jpg',
              gte35:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage26-Mann-BMI-35Plus.jpg'
            },
            w: {
              lt20: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage26-Frau-BMI-ueber20.jpg',
              gte20_lt25:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage26-Frau-BMI-25.jpg',
              gte25_lt30:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage26-Frau-BMI-25.jpg',
              gte30_lt35:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage26-Frau-BMI-30.jpg',
              gte35:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Quiz-Frage26-Frau-BMI-35Plus.jpg'
            }
          },
          te = H(() => {
            const x = s.gender === 'm' ? 'm' : 'w',
              Q = D[x][G.value];
            return Q
              ? {
                  backgroundImage: `image-set(
      url(${Q}?width=400) 1x,
      url(${Q}?width=800) 2x
    )`,
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'calc(50% + 35px) center',
                  backgroundSize: 'contain'
                }
              : {};
          }),
          V = H(() => s.screenHistory.length > 0);
        function ce() {
          n('next', r.value);
        }
        function K() {
          s.goBack();
        }
        let I = !1;
        function T() {
          if (I) return;
          I = !0;
          const x =
            s.gender === 'm'
              ? 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Mann_Opt-In.jpg?v=1762511943'
              : 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frau_Opt-In.jpg?v=1762511942';
          Ye([x]);
        }
        return (
          Me(() => {
            (d.forEach((x, Q) => {
              setTimeout(() => {
                o.value.push(x);
              }, Q * 150);
            }),
              $());
          }),
          (x, Q) => (
            P(),
            M('div', Dv, [
              Q[4] ||
                (Q[4] = _(
                  'h2',
                  { class: 'qlfqa:!text-lg qlfqa:!text-center qlfqa:!font-medium qlfqa:!mb-4' },
                  'Deine Ausgangslage',
                  -1
                )),
              _('div', Fv, [
                _('div', zv, [
                  Q[2] ||
                    (Q[2] = cu(
                      '<div class="bmi-chart-top"><div class="bmi-top-value">15</div><div class="bmi-top-value">18.5</div><div class="bmi-top-value">25</div><div class="bmi-top-value">30</div><div class="bmi-top-value">40</div></div>',
                      1
                    )),
                  _('div', Mv, [
                    Q[1] || (Q[1] = _('div', { class: 'bmi-chart-track-track' }, null, -1)),
                    _(
                      'div',
                      {
                        class: $e(['bmi-chart-pointer', { 'show-details': l.value }]),
                        style: nt({ left: i.value + '%' })
                      },
                      [
                        Q[0] || (Q[0] = _('div', { class: 'bmi-chart-pointer-point' }, null, -1)),
                        S(
                          Dr,
                          { name: 'fade' },
                          {
                            default: Et(() => [
                              l.value
                                ? (P(),
                                  M(
                                    'div',
                                    {
                                      key: 0,
                                      class: 'bmi-chart-pointer-tag',
                                      style: nt({ left: b.value })
                                    },
                                    ' Du - ' + ve(h()),
                                    5
                                  ))
                                : Te('', !0)
                            ]),
                            _: 1
                          }
                        )
                      ],
                      6
                    )
                  ]),
                  _('div', Nv, [
                    _(
                      'div',
                      {
                        class: 'bmi-bottom-value underweight',
                        style: nt([{ width: a.value }, { width: 'auto' }])
                      },
                      'Untergewicht',
                      4
                    ),
                    _(
                      'div',
                      { class: 'bmi-bottom-value normal', style: nt({ width: f.value }) },
                      'Normal',
                      4
                    ),
                    _(
                      'div',
                      {
                        class: 'bmi-bottom-value overweight',
                        style: nt([{ width: u.value }, { width: 'auto' }])
                      },
                      'Übergewicht',
                      4
                    ),
                    _(
                      'div',
                      { class: 'bmi-bottom-value obese', style: nt({ width: c.value }) },
                      'Hoher BMI',
                      4
                    )
                  ])
                ])
              ]),
              S(
                Dr,
                { name: 'fade' },
                {
                  default: Et(() => {
                    var Y, me;
                    return [
                      q()
                        ? (P(),
                          M('div', Vv, [
                            _('div', Lv, [
                              Q[3] ||
                                (Q[3] = _(
                                  'div',
                                  {
                                    class:
                                      'qlfqa:!text-sm qlfqa:!border qlfqa:!border-[#e0a959] qlfqa:!text-[#e0a959] qlfqa:!rounded-full qlfqa:!flex qlfqa:!w-[20px] qlfqa:!h-[20px] qlfqa:!justify-center qlfqa:!items-center qlfqa:!font-bold'
                                  },
                                  ' ! ',
                                  -1
                                )),
                              _('h3', Uv, ve((Y = q()) == null ? void 0 : Y.headline), 1)
                            ]),
                            _('p', jv, ve((me = q()) == null ? void 0 : me.text), 1)
                          ]))
                        : Te('', !0)
                    ];
                  }),
                  _: 1
                }
              ),
              _(
                'div',
                {
                  class:
                    'qlfqa:!bg-white qlfqa:!rounded-xl qlfqa:!p-5 qlfqa:!mt-4 qlfqa:!w-full qlfqa:!h-[330px] qlfqa:!flex qlfqa:!flex-col qlfqa:!justify-evenly',
                  style: nt(te.value)
                },
                [
                  S(
                    x0,
                    { name: 'stagger-fade' },
                    {
                      default: Et(() => [
                        (P(!0),
                        M(
                          Ae,
                          null,
                          vn(
                            o.value,
                            (Y, me) => (
                              P(),
                              M(
                                'div',
                                {
                                  key: Y.id,
                                  style: nt({ '--stagger-delay': `${(me + 2) * 250}ms` }),
                                  class:
                                    'qlfqa:!flex qlfqa:!gap-x-4 qlfqa:!items-center qlfqa:!mb-3'
                                },
                                [
                                  S(
                                    je,
                                    {
                                      src: `${C(Y)}?width=80`,
                                      srcset: `
                        ${C(Y)}?width=40 40w,
                        ${C(Y)}?width=80 80w,
                        ${C(Y)}?width=120 120w`,
                                      sizes: '40px',
                                      alt: Y.headline,
                                      loading: 'lazy',
                                      fetchpriority: 'low',
                                      decoding: 'async',
                                      width: '40',
                                      height: '40',
                                      class: 'qlfqa:!w-[40px] qlfqa:!h-[40px] object-cover'
                                    },
                                    null,
                                    8,
                                    ['src', 'srcset', 'alt']
                                  ),
                                  _('div', null, [
                                    _('h3', Hv, ve(Y.headline), 1),
                                    _('p', Qv, ve(Y.text), 1)
                                  ])
                                ],
                                4
                              )
                            )
                          ),
                          128
                        ))
                      ]),
                      _: 1
                    }
                  )
                ],
                4
              ),
              _('div', Kv, [
                _(
                  'button',
                  {
                    onClick: K,
                    disabled: !V.value,
                    'aria-disabled': !V.value,
                    'aria-label': 'Zurück zum vorherigen Schritt',
                    class:
                      'qlfqa:!border qlfqa:!border-solid qlfqa:!border-[#CECDCA] qlfqa:!text-[#808080] qlfqa:!px-6 qlfqa:!py-3 qlfqa:!rounded-md qlfqa:disabled:!opacity-50 qlfqa:hover:!opacity-80 qlfqa:!cursor-pointer qlfqa:!w-1/2'
                  },
                  ' Zurück ',
                  8,
                  Wv
                ),
                _(
                  'button',
                  {
                    onPointerenter: T,
                    onPointerdown: T,
                    onClick: ce,
                    'aria-label': 'Alles klar und weiter',
                    class:
                      'qlfqa:!bg-yellow-500 qlfqa:!text-black qlfqa:!px-6 qlfqa:!py-3 qlfqa:!rounded-md qlfqa:disabled:!opacity-50 qlfqa:hover:!bg-yellow-400 qlfqa:!cursor-pointer qlfqa:!w-1/2'
                  },
                  ' Weiter ',
                  32
                )
              ])
            ])
          )
        );
      }
    }),
    Jv = { class: 'qlfqa:!py-2' },
    Yv = re({
      __name: 'QuizScreen27',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = le(),
          r = U([]),
          o = U(!1),
          i = [
            { id: 1, text: 'Süßigkeiten', val: '0' },
            { id: 2, text: 'Salzige Snacks', val: '1' },
            { id: 3, text: 'Fast Food', val: '2' },
            { id: 4, text: 'Zuckerhaltige Getränke', val: '3' }
          ],
          l = { id: 5, text: 'Keine der Aufgezählten', val: 'nichts' },
          a = H(() => s.screenHistory.length > 0),
          f = H(() => r.value.length > 0 || o.value);
        function u() {
          let d;
          (o.value && l ? (d = [l.val]) : (d = r.value), n('next', d));
        }
        function c() {
          s.goBack();
        }
        return (d, p) => (
          P(),
          M('div', Jv, [
            p[1] ||
              (p[1] = _(
                'h2',
                { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                'Welche sind deine häufigsten Gelüste?',
                -1
              )),
            p[2] ||
              (p[2] = _('p', { class: 'qlfqa:!text-gray-700' }, 'Mehrfach-Auswahl möglich', -1)),
            S(
              It,
              {
                modelValue: r.value,
                'onUpdate:modelValue': p[0] || (p[0] = (h) => (r.value = h)),
                class: 'qlfqa:!mt-4',
                checkboxOptions: i,
                exclusiveOption: l
              },
              null,
              8,
              ['modelValue']
            ),
            S(
              he,
              { showBackButton: a.value, disableContinue: !f.value, onBack: c, onContinue: u },
              null,
              8,
              ['showBackButton', 'disableContinue']
            )
          ])
        );
      }
    }),
    Zv = { class: 'qlfqa:!py-2' },
    Xv = { class: 'qlfqa:!flex' },
    eb = re({
      __name: 'QuizScreen28',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = le(),
          r = U(''),
          o = [
            { id: 1, text: 'Täglich / fast täglich', val: '0' },
            { id: 2, text: 'Mehrmals pro Woche', val: '30' },
            { id: 3, text: 'Selten', val: '40' }
          ],
          i = H(() => s.screenHistory.length > 0);
        function l() {
          n('next', r.value);
        }
        function a() {
          s.goBack();
        }
        return (f, u) => (
          P(),
          M('div', Zv, [
            u[1] ||
              (u[1] = _(
                'h2',
                { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                'Wie oft hast du in den letzten 12 Monaten starken Stress erlebt?',
                -1
              )),
            _('div', Xv, [
              S(
                ct,
                {
                  class: 'qlfqa:!flex',
                  options: o,
                  modelValue: r.value,
                  'onUpdate:modelValue': u[0] || (u[0] = (c) => (r.value = c))
                },
                null,
                8,
                ['modelValue']
              )
            ]),
            S(
              he,
              { showBackButton: i.value, disableContinue: !r.value, onBack: a, onContinue: l },
              null,
              8,
              ['showBackButton', 'disableContinue']
            )
          ])
        );
      }
    }),
    tb = { class: 'qlfqa:!py-2' },
    nb = re({
      __name: 'QuizScreen29',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = le(),
          r = U([]),
          o = U(!1),
          i = [
            { id: 1, text: 'Stress (z.B. Arbeit oder Familien-Leben)', val: '0' },
            { id: 2, text: 'Scheidung oder Trennung', val: '1' },
            { id: 3, text: 'Langsamer Stoffwechel oder höheres Alter', val: '2' },
            { id: 4, text: 'Covid-19 Pandemie', val: '3' },
            { id: 5, text: 'Verletzungen oder Unfälle', val: '4' }
          ],
          l = { id: 6, text: 'Keine der Aufgezählten', val: 'nichts' },
          a = H(() => s.screenHistory.length > 0),
          f = H(() => r.value.length > 0 || o.value);
        function u() {
          let d;
          (o.value && l ? (d = [l.val]) : (d = r.value), n('next', d));
        }
        function c() {
          s.goBack();
        }
        return (d, p) => (
          P(),
          M('div', tb, [
            p[1] ||
              (p[1] = _(
                'h2',
                { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                'Hast du einige dieser Angewohnheiten?',
                -1
              )),
            p[2] ||
              (p[2] = _('p', { class: 'qlfqa:!text-gray-700' }, 'Mehrfach-Auswahl möglich', -1)),
            S(
              It,
              {
                modelValue: r.value,
                'onUpdate:modelValue': p[0] || (p[0] = (h) => (r.value = h)),
                class: 'qlfqa:!mt-4',
                checkboxOptions: i,
                exclusiveOption: l
              },
              null,
              8,
              ['modelValue']
            ),
            S(
              he,
              { showBackButton: a.value, disableContinue: !f.value, onBack: c, onContinue: u },
              null,
              8,
              ['showBackButton', 'disableContinue']
            )
          ])
        );
      }
    }),
    sb = { class: 'qlfqa:!py-2' },
    rb = re({
      __name: 'QuizScreen30',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = le(),
          r = U([]),
          o = U(!1),
          i = [
            { id: 1, text: 'Ich halte keine Diät lange durch', val: '0' },
            { id: 2, text: 'Ich bekomme ständig Heißhunger auf Süßes', val: '1' },
            { id: 3, text: 'Ich habe keine Energie für Sport', val: '2' },
            { id: 4, text: 'Ich weiß nicht, was und wie viel ich essen soll', val: '3' }
          ],
          l = { id: 5, text: 'Andere Gründe', val: 'anderes' },
          a = H(() => s.screenHistory.length > 0),
          f = H(() => r.value.length > 0 || o.value);
        function u() {
          let d;
          (o.value && l ? (d = [l.val]) : (d = r.value), n('next', d));
        }
        function c() {
          s.goBack();
        }
        return (d, p) => (
          P(),
          M('div', sb, [
            p[1] ||
              (p[1] = _(
                'h2',
                { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                'Was fällt dir beim Abnehmen am schwersten?',
                -1
              )),
            p[2] ||
              (p[2] = _('p', { class: 'qlfqa:!text-gray-700' }, 'Mehrfach-Auswahl möglich', -1)),
            S(
              It,
              {
                modelValue: r.value,
                'onUpdate:modelValue': p[0] || (p[0] = (h) => (r.value = h)),
                class: 'qlfqa:!mt-4',
                checkboxOptions: i,
                exclusiveOption: l
              },
              null,
              8,
              ['modelValue']
            ),
            S(
              he,
              { showBackButton: a.value, disableContinue: !f.value, onBack: c, onContinue: u },
              null,
              8,
              ['showBackButton', 'disableContinue']
            )
          ])
        );
      }
    }),
    ob = { class: 'qlfqa:!py-2' },
    ib = { class: 'qlfqa:!flex' },
    lb = re({
      __name: 'QuizScreen31',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = le(),
          r = U(''),
          o = [
            { id: 1, text: '1-3 (kaum)', val: '0' },
            { id: 2, text: '4-7 (mittel)', val: '30' },
            { id: 3, text: '8-10 (sehr stark, es belastet mich)', val: '40' }
          ],
          i = H(() => s.screenHistory.length > 0);
        function l() {
          n('next', r.value);
        }
        function a() {
          s.goBack();
        }
        return (f, u) => (
          P(),
          M('div', ob, [
            u[1] ||
              (u[1] = _(
                'h2',
                { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                'Wie sehr stört dich dein Bauchfett auf einer Skala von 1-10?',
                -1
              )),
            _('div', ib, [
              S(
                ct,
                {
                  class: 'qlfqa:!flex',
                  options: o,
                  modelValue: r.value,
                  'onUpdate:modelValue': u[0] || (u[0] = (c) => (r.value = c))
                },
                null,
                8,
                ['modelValue']
              )
            ]),
            S(
              he,
              { showBackButton: i.value, disableContinue: !r.value, onBack: a, onContinue: l },
              null,
              8,
              ['showBackButton', 'disableContinue']
            )
          ])
        );
      }
    });
  function ab() {
    return {
      createFormData: (n, s = null) => {
        let r = new FormData();
        for (let o in n) n.hasOwnProperty(o) && r.append(o, n[o]);
        return (s !== null && r.append('_method', s), r);
      },
      sD: (n) =>
        n.replace(/[a-zA-Z]/g, function (s) {
          return String.fromCharCode(
            (s <= 'Z' ? 90 : 122) >= (s = s.charCodeAt(0) + 13) ? s : s - 26
          );
        })
    };
  }
  const ub = { class: 'qlfqa:!py-2', role: 'form', 'aria-labelledby': 'optin-title' },
    cb = { class: 'qlfqa:!mb-4' },
    fb = {
      class:
        'qlfqa:!mt-4 qlfqa:!flex qlfqa:!items-center qlfqa:!bg-transparent qlfqa:!border qlfqa:!border-gray-500 qlfqa:focus:!border-yellow-400 qlfqa:!rounded-md',
      role: 'group',
      'aria-labelledby': 'name-label'
    },
    db = ['aria-invalid'],
    pb = ['aria-invalid', 'aria-describedby'],
    hb = {
      key: 0,
      id: 'email-error',
      class: 'qlfqa:!text-red-500 qlfqa:!mt-2 qlfqa:!text-sm',
      role: 'alert',
      'aria-live': 'assertive'
    },
    mb = { class: 'qlfqa:!mt-2 qlfqa:!flex qlfqa:!justify-center' },
    gb = ['disabled', 'aria-disabled'],
    _b = {
      class:
        'qlfqa:!my-8 qlfqa:!flex qlfqa:!justify-center qlfqa:!underline qlfqa:!underline-offset-1 qlfqa:!text-gray-500'
    },
    qb =
      'uggcf://dysfnvbncc.dhnaghzyrncsvgarff.pu/sfqsUq306squ6/sfqqr49wstUqsqfkwW/Z78kA4op67sGq17D8MY2wHqI/2zp3wUt385uU46z4',
    vb = re({
      __name: 'QuizScreen32',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = U(''),
          r = U(''),
          o = U(''),
          { sD: i } = ab(),
          l = le();
        function a(C) {
          return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(C);
        }
        function f() {
          return (
            (o.value = ''),
            s.value.trim()
              ? r.value.trim()
                ? a(r.value.trim())
                  ? !0
                  : ((o.value = 'Bitte gebe eine gültige E-Mail-Adresse ein.'), !1)
                : ((o.value = 'Bitte gebe deine E-Mail-Adresse ein.'), !1)
              : ((o.value = 'Bitte gebe deinen Vornamen ein.'), !1)
          );
        }
        const u = H(() => s.value.trim() !== '' && r.value.trim() !== '' && a(r.value.trim()));
        function c() {
          if (!f()) return;
          const C = [
            { type: 'name', value: s.value.trim() },
            { type: 'email', value: r.value.trim() }
          ];
          (u.value && p(), n('next', C));
        }
        function d() {
          return i(qb);
        }
        function p() {
          const C = d(),
            G = { username: s.value.trim(), useremail: r.value.trim() };
          fetch(C, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(G)
          }).catch((D) => {
            console.error('Error sending opt-in data:', D);
          });
        }
        function h() {
          n('next', []);
        }
        const q = [
            {
              id: 1,
              gender: 'w',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Frau_Opt-In.jpg?v=1762511942',
              alt: ''
            },
            {
              id: 2,
              gender: 'm',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Mann_Opt-In.jpg?v=1762511943',
              alt: ''
            }
          ],
          v = H(() => q.find((C) => C.gender === l.gender) || q[0]);
        let b = !1;
        function $() {
          if (b) return;
          b = !0;
          const C =
            l.gender === 'm'
              ? 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Trafo_Mann_Stoffwechsel_Quiz_3d36a4c1-5986-4743-80a2-5bad9319d814.jpg?v=1762510934'
              : 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Nicole-Trafo.jpg?v=1769996540';
          Ye([C]);
        }
        return (
          Me(() => {
            $();
          }),
          (C, G) => (
            P(),
            M('div', ub, [
              G[4] ||
                (G[4] = _(
                  'h2',
                  {
                    id: 'optin-title',
                    class: 'qlfqa:!text-2xl qlfqa:!font-medium qlfqa:!mb-4 qlfqa:!text-center'
                  },
                  'Fast geschafft!',
                  -1
                )),
              _('div', cb, [
                S(
                  je,
                  {
                    src: v.value.image,
                    alt: v.value.alt,
                    class: 'qlfqa:!rounded-md',
                    sizes: '400px',
                    loading: 'eager',
                    fetchpriority: 'high'
                  },
                  null,
                  8,
                  ['src', 'alt']
                )
              ]),
              G[5] ||
                (G[5] = _(
                  'p',
                  { class: 'qlfqa:!mb-4 qlfqa:!text-gray-700 qlfqa:!text-center' },
                  [
                    Kn(' Möchtest du '),
                    _('b', null, 'zusätzlich 5 wissenschaftliche Tipps'),
                    Kn(' um deinen Stoffwechsel dauerhaft zu beschleunigen? ')
                  ],
                  -1
                )),
              _('div', fb, [
                G[2] ||
                  (G[2] = _(
                    'label',
                    { id: 'name-label', class: 'qlfqa:!sr-only' },
                    'Dein Vorname',
                    -1
                  )),
                Ln(
                  _(
                    'input',
                    {
                      type: 'text',
                      'onUpdate:modelValue': G[0] || (G[0] = (D) => (s.value = D)),
                      'aria-label': 'Dein Vorname',
                      'aria-required': 'true',
                      placeholder: 'Dein Vorname',
                      class:
                        'qlfqa:!mb-0 qlfqa:!block qlfqa:!bg-white qlfqa:!min-w-0 qlfqa:!grow qlfqa:!px-4 qlfqa:!py-3 qlfqa:focus:!outline-0 qlfqa:!rounded-md qlfqa-quiz'
                    },
                    null,
                    512
                  ),
                  [[Jn, s.value]]
                )
              ]),
              _(
                'div',
                {
                  class: $e([
                    'qlfqa:!mt-2 qlfqa:!flex qlfqa:!items-center qlfqa:!bg-transparent qlfqa:!border qlfqa:!border-gray-500 qlfqa:focus:!border-yellow-400 qlfqa:!rounded-md',
                    {
                      'qlfqa:!border-red-500':
                        o.value && r.value.trim() !== '' && !a(r.value.trim())
                    }
                  ]),
                  role: 'group',
                  'aria-labelledby': 'email-label',
                  'aria-invalid': o.value !== '' && r.value.trim() !== '' && !a(r.value.trim())
                },
                [
                  G[3] ||
                    (G[3] = _(
                      'label',
                      { id: 'email-label', class: 'qlfqa:!sr-only' },
                      'Deine E-Mail Adresse',
                      -1
                    )),
                  Ln(
                    _(
                      'input',
                      {
                        type: 'email',
                        'onUpdate:modelValue': G[1] || (G[1] = (D) => (r.value = D)),
                        placeholder: 'Deine E-Mail Adresse',
                        'aria-label': 'Deine E-Mail Adresse',
                        'aria-required': 'true',
                        'aria-invalid': r.value.trim() !== '' && !a(r.value.trim()),
                        'aria-describedby': o.value ? 'email-error' : void 0,
                        class:
                          'qlfqa:!mb-0 qlfqa:!block qlfqa:!bg-white qlfqa:!min-w-0 qlfqa:!grow qlfqa:!px-4 qlfqa:!py-3 qlfqa:focus:!outline-0 qlfqa:!rounded-md qlfqa-quiz',
                        onBlur: f
                      },
                      null,
                      40,
                      pb
                    ),
                    [[Jn, r.value]]
                  )
                ],
                10,
                db
              ),
              o.value ? (P(), M('div', hb, ve(o.value), 1)) : Te('', !0),
              _('div', mb, [
                _(
                  'button',
                  {
                    onPointerenter: $,
                    onPointerdown: $,
                    onClick: c,
                    disabled: !u.value,
                    'aria-disabled': !u.value,
                    'aria-label': 'Weiter zum Ergebnis',
                    class:
                      'qlfqa:!text-white qlfqa:!px-6 qlfqa:!py-3 qlfqa:!rounded-md qlfqa:disabled:!opacity-50 qlfqa:!cursor-pointer qlfqa:!w-full qlfqa:!bg-[#323232]'
                  },
                  ' Weiter ',
                  40,
                  gb
                )
              ]),
              _('div', _b, [
                _(
                  'button',
                  {
                    onPointerenter: $,
                    onPointerdown: $,
                    onClick: h,
                    'aria-label': 'Ohne Ratgeber zum Ergebnis',
                    class: 'qlfqa:!cursor-pointer qlfqa:!font-semibold'
                  },
                  ' Ich möchte ohne Ratgeber zum Ergebnis ',
                  32
                )
              ])
            ])
          )
        );
      }
    }),
    bb = { class: 'qlfqa:!py-2' },
    yb = { class: 'qlfqa:!flex' },
    xb = re({
      __name: 'QuizScreen33',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = le(),
          r = U(''),
          o = [
            { id: 1, text: '100-200 €', val: '0' },
            { id: 2, text: '200-400 €', val: '30' },
            { id: 3, text: 'Mehr als 500 €', val: '40' },
            { id: 4, text: 'Gar nichts', val: '-5' }
          ],
          i = H(() => s.screenHistory.length > 0);
        function l() {
          n('next', r.value);
        }
        function a() {
          s.goBack();
        }
        return (f, u) => (
          P(),
          M('div', bb, [
            u[1] ||
              (u[1] = _(
                'h2',
                { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                'Wie viel wärst du bereit, monatlich für eine Abnehm-Spritze zu zahlen?',
                -1
              )),
            _('div', yb, [
              S(
                ct,
                {
                  class: 'qlfqa:!flex',
                  options: o,
                  modelValue: r.value,
                  'onUpdate:modelValue': u[0] || (u[0] = (c) => (r.value = c))
                },
                null,
                8,
                ['modelValue']
              )
            ]),
            S(
              he,
              { showBackButton: i.value, disableContinue: !r.value, onBack: a, onContinue: l },
              null,
              8,
              ['showBackButton', 'disableContinue']
            )
          ])
        );
      }
    }),
    wb = { class: 'qlfqa:!py-2' },
    Sb = { class: 'qlfqa:!flex' },
    Eb = re({
      __name: 'QuizScreen34',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = le(),
          r = U(''),
          o = [
            { id: 1, text: 'Sehr wichtig', val: '0' },
            { id: 2, text: 'Wichtig', val: '30' },
            { id: 3, text: 'Mir ist meine Gesundheit langfristig wichtiger', val: '40' }
          ],
          i = H(() => s.screenHistory.length > 0);
        function l() {
          n('next', r.value);
        }
        function a() {
          s.goBack();
        }
        return (f, u) => (
          P(),
          M('div', wb, [
            u[1] ||
              (u[1] = _(
                'h2',
                { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                'Wie wichtig ist es dir, schnell Gewicht zu verlieren - auch wenn Risiken bestehen?',
                -1
              )),
            _('div', Sb, [
              S(
                ct,
                {
                  class: 'qlfqa:!flex',
                  options: o,
                  modelValue: r.value,
                  'onUpdate:modelValue': u[0] || (u[0] = (c) => (r.value = c))
                },
                null,
                8,
                ['modelValue']
              )
            ]),
            S(
              he,
              { showBackButton: i.value, disableContinue: !r.value, onBack: a, onContinue: l },
              null,
              8,
              ['showBackButton', 'disableContinue']
            )
          ])
        );
      }
    }),
    kb = { class: 'qlfqa:!py-2' },
    Cb = { class: 'qlfqa:!flex' },
    Ab = re({
      __name: 'QuizScreen35',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = le(),
          r = U(''),
          o = [
            { id: 1, text: 'Lieber eine "schnelle Spritze" mit hohen Risiken', val: '0' },
            { id: 2, text: 'Eine nachhaltige Lösung ohne Nebenwirkungen', val: '30' }
          ],
          i = H(() => s.screenHistory.length > 0);
        function l() {
          n('next', r.value);
        }
        function a() {
          s.goBack();
        }
        return (f, u) => (
          P(),
          M('div', kb, [
            u[1] ||
              (u[1] = _(
                'h2',
                { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                'Wenn du wählen müsstest:',
                -1
              )),
            _('div', Cb, [
              S(
                ct,
                {
                  class: 'qlfqa:!flex',
                  options: o,
                  modelValue: r.value,
                  'onUpdate:modelValue': u[0] || (u[0] = (c) => (r.value = c))
                },
                null,
                8,
                ['modelValue']
              )
            ]),
            S(
              he,
              { showBackButton: i.value, disableContinue: !r.value, onBack: a, onContinue: l },
              null,
              8,
              ['showBackButton', 'disableContinue']
            )
          ])
        );
      }
    }),
    Tb = { class: 'qlfqa:!py-2' },
    Ob = re({
      __name: 'QuizScreen36',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = le(),
          r = U([]),
          o = U(!1),
          i = [
            { id: 1, text: 'Ich strahle richtig vor Selbstbewusstsein', val: '0' },
            { id: 2, text: 'Ich kann mein Leben endlich voll genießen', val: '1' },
            { id: 3, text: 'Ich zeige mich gerne wieder am Strand', val: '2' },
            { id: 4, text: 'Ich bin jeden Tag voller Energie und Freude', val: '3' },
            { id: 5, text: 'Ich fühle mich einfach wieder wohl in mir selbst', val: '4' }
          ],
          l = { id: 6, text: 'Andere', val: 'andere' },
          a = H(() => s.screenHistory.length > 0),
          f = H(() => r.value.length > 0 || o.value);
        function u() {
          let d;
          (o.value && l ? (d = [l.val]) : (d = r.value), n('next', d));
        }
        function c() {
          s.goBack();
        }
        return (d, p) => (
          P(),
          M('div', Tb, [
            p[1] ||
              (p[1] = _(
                'h2',
                { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                'Wenn du daran denkst, dein Wunschgewicht zu erreichen, was begeistert dich am meisten?',
                -1
              )),
            p[2] ||
              (p[2] = _('p', { class: 'qlfqa:!text-gray-700' }, 'Mehrfach-Auswahl möglich', -1)),
            S(
              It,
              {
                modelValue: r.value,
                'onUpdate:modelValue': p[0] || (p[0] = (h) => (r.value = h)),
                class: 'qlfqa:!mt-4',
                checkboxOptions: i,
                exclusiveOption: l
              },
              null,
              8,
              ['modelValue']
            ),
            S(
              he,
              { showBackButton: a.value, disableContinue: !f.value, onBack: c, onContinue: u },
              null,
              8,
              ['showBackButton', 'disableContinue']
            )
          ])
        );
      }
    }),
    Bb = { class: 'qlfqa:!py-2' },
    Ib = re({
      __name: 'QuizScreen37',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = le(),
          r = U([]),
          o = U(!1),
          i = [
            { id: 1, text: 'Endlich wieder flacher Bauch', val: '0' },
            { id: 2, text: 'Straffer & jünger wirken', val: '1' },
            { id: 3, text: 'Mehr Energie & Gesundheit spüren', val: '2' },
            { id: 4, text: 'In meine alten Lieblingskleider passen', val: '3' }
          ],
          l = { id: 5, text: 'Andere', val: 'andere' },
          a = H(() => s.screenHistory.length > 0),
          f = H(() => r.value.length > 0 || o.value);
        function u() {
          let d;
          (o.value && l ? (d = [l.val]) : (d = r.value), n('next', d));
        }
        function c() {
          s.goBack();
        }
        return (d, p) => (
          P(),
          M('div', Bb, [
            p[1] ||
              (p[1] = _(
                'h2',
                { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                'Wie möchtest du dich in 3 Monaten fühlen, wenn du morgens in den Spiegel schaust?',
                -1
              )),
            p[2] ||
              (p[2] = _('p', { class: 'qlfqa:!text-gray-700' }, 'Mehrfach-Auswahl möglich', -1)),
            S(
              It,
              {
                modelValue: r.value,
                'onUpdate:modelValue': p[0] || (p[0] = (h) => (r.value = h)),
                class: 'qlfqa:!mt-4',
                checkboxOptions: i,
                exclusiveOption: l
              },
              null,
              8,
              ['modelValue']
            ),
            S(
              he,
              { showBackButton: a.value, disableContinue: !f.value, onBack: c, onContinue: u },
              null,
              8,
              ['showBackButton', 'disableContinue']
            )
          ])
        );
      }
    }),
    Rb = { class: 'qlfqa:!py-2', role: 'article' },
    Pb = { class: 'qlfqa:!text-gray-700 qlfqa:!text-center qlfqa:!mb-4' },
    $b = { class: 'qlfqa:!mb-4' },
    Db = {
      class: 'qlfqa:!mt-6 qlfqa:!flex qlfqa:!justify-center qlfqa:!gap-4',
      role: 'group',
      'aria-label': 'Navigation'
    },
    Fb = ['disabled', 'aria-disabled'],
    zb = re({
      __name: 'QuizScreen38',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          s = le(),
          r = U('checked'),
          o = H(() => s.screenHistory.length > 0),
          i = [
            {
              id: 1,
              gender: 'w',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Nicole-Trafo.jpg?v=1769996540',
              alt: ''
            },
            {
              id: 2,
              gender: 'm',
              image:
                'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Trafo_Mann_Stoffwechsel_Quiz_3d36a4c1-5986-4743-80a2-5bad9319d814.jpg?v=1762510934',
              alt: ''
            }
          ],
          l = H(() => i.find((d) => d.gender === s.gender) || i[0]),
          a = [
            {
              id: 1,
              gender: 'm',
              text: 'Dank moderner Wissenschaft haben wir mehr als 250.000 Männern seit 2018 zur Traumfigur verholfen. Zusammen schaffen wir das auch. 💛'
            },
            {
              id: 2,
              gender: 'w',
              text: 'Dank moderner Wissenschaft haben wir mehr als 250.000 Frauen seit 2018 zur Traumfigur verholfen. Zusammen schaffen wir das auch. 💛'
            }
          ],
          f = H(() => a.find((d) => d.gender === s.gender) || a[0]);
        function u() {
          n('next', r.value);
        }
        function c() {
          s.goBack();
        }
        return (d, p) => (
          P(),
          M('div', Rb, [
            p[0] ||
              (p[0] = _(
                'h2',
                { class: 'qlfqa:!text-xl qlfqa:!font-medium qlfqa:!mb-6 qlfqa:!text-center' },
                'Du bist in guten Händen',
                -1
              )),
            _('p', Pb, ve(f.value.text), 1),
            _('div', $b, [
              S(
                je,
                {
                  src: l.value.image,
                  alt: l.value.alt,
                  class: 'qlfqa:!rounded-md',
                  sizes: '400px'
                },
                null,
                8,
                ['src', 'alt']
              )
            ]),
            _('div', Db, [
              _(
                'button',
                {
                  onClick: c,
                  disabled: !o.value,
                  'aria-disabled': !o.value,
                  'aria-label': 'Zurück zum vorherigen Schritt',
                  class:
                    'qlfqa:!border qlfqa:!border-solid qlfqa:!border-[#CECDCA] qlfqa:!text-[#808080] qlfqa:!px-6 qlfqa:!py-3 qlfqa:!rounded-md qlfqa:disabled:!opacity-50 qlfqa:hover:!opacity-80 qlfqa:!cursor-pointer qlfqa:!w-1/2'
                },
                ' Zurück ',
                8,
                Fb
              ),
              _(
                'button',
                {
                  onClick: u,
                  'aria-label': 'Alles klar und weiter',
                  class:
                    'qlfqa:!bg-yellow-500 qlfqa:!text-black qlfqa:!px-6 qlfqa:!py-3 qlfqa:!rounded-md qlfqa:disabled:!opacity-50 qlfqa:hover:!bg-yellow-400 qlfqa:!cursor-pointer qlfqa:!w-1/2'
                },
                ' Weiter '
              )
            ])
          ])
        );
      }
    }),
    Mb = { class: 'qlfqa:!py-2', role: 'article' },
    Nb = { class: 'qlfqa:!mb-4' },
    Vb = { class: 'weight-predict-chart__chart-wrapper' },
    Lb = { 'data-weight-chart': 'weight-predict', class: 'weight-predict-chart__chart' },
    Ub = { class: 'weight-predict-chart__top-value weight-predict-chart__text-value' },
    jb = { class: 'weight-predict-chart__bottom-right-value weight-predict-chart__text-value' },
    Hb = re({
      __name: 'QuizScreen39',
      setup(e) {
        const t = le(),
          n = U(!1),
          s = H(() => {
            const l = new Date(),
              a = new Date(l);
            a.setDate(a.getDate() + 28);
            const f = [
                'Januar',
                'Februar',
                'März',
                'April',
                'Mai',
                'Juni',
                'Juli',
                'August',
                'September',
                'Oktober',
                'November',
                'Dezember'
              ],
              u = a.getDate(),
              c = f[a.getMonth()],
              d = a.getFullYear();
            return `${u}. ${c} ${d}`;
          });
        Me(function () {
          (t.completeQuiz(),
            setTimeout(() => {
              n.value = !0;
            }, 3200));
        });
        function r() {
          i();
        }
        let o = !1;
        function i() {
          if (!o) {
            o = !0;
            try {
              const l = new URLSearchParams();
              if (t.results) {
                const c = t.results;
                (l.append('calorieIntake1', c.calorieIntakeRange[0]),
                  l.append('calorieIntake2', c.calorieIntakeRange[1]),
                  l.append('proteinIntake', c.proteinIntake),
                  l.append('fatIntake', c.fatIntake),
                  l.append('carbohydrates', c.carbohydrates));
              } else
                (l.append('calorieIntakeRange', '0'),
                  l.append('calorieIntake2', '0'),
                  l.append('proteinIntake', '0'),
                  l.append('fatIntake', '0'),
                  l.append('carbohydrates', '0'));
              const a = 'https://qlf.de/pages/deinplan',
                f = 'https://qlf.de/pages/deinplan';
              let u;
              t.gender === 'w' ? (u = `${a}?${l.toString()}`) : (u = `${f}?${l.toString()}`);
              try {
                window.location.href = u;
              } catch {
                window.location.replace(u);
              }
            } catch {
              window.location.href = 'https://qlf.de/pages/stoffwechsel';
            }
          }
        }
        return (l, a) => (
          P(),
          M('div', Mb, [
            a[6] ||
              (a[6] = _(
                'h2',
                { class: 'qlfqa:!text-xl qlfqa:!font-medium qlfqa:!mb-6 qlfqa:!text-center' },
                'Geschafft 🤩',
                -1
              )),
            a[7] ||
              (a[7] = _(
                'p',
                { class: 'qlfqa:!text-gray-700 qlfqa:!text-center qlfqa:!mb-4' },
                ' Wir haben jetzt alle Informationen, um dir mithilfe der Studienlage und unserer Datenbank deinen ersten 4-Wochen Fahrplan zum Fettverlust zu erstellen! ',
                -1
              )),
            _('div', Nb, [
              _('div', Vb, [
                _('div', Lb, [
                  a[1] ||
                    (a[1] = _(
                      'div',
                      {
                        class: 'weight-predict-chart__grid-item weight-predict-chart__grid-item-1'
                      },
                      null,
                      -1
                    )),
                  a[2] ||
                    (a[2] = _(
                      'div',
                      {
                        class: 'weight-predict-chart__grid-item weight-predict-chart__grid-item-2'
                      },
                      null,
                      -1
                    )),
                  a[3] ||
                    (a[3] = _(
                      'div',
                      {
                        class: 'weight-predict-chart__grid-item weight-predict-chart__grid-item-3'
                      },
                      null,
                      -1
                    )),
                  _('div', Ub, ve(Ut(t).q11) + ' kg', 1),
                  a[4] ||
                    (a[4] = _(
                      'div',
                      {
                        class:
                          'weight-predict-chart__bottom-left-value weight-predict-chart__text-value'
                      },
                      'JETZT',
                      -1
                    )),
                  _('div', jb, ve(s.value), 1),
                  a[5] ||
                    (a[5] = cu(
                      '<div class="weight-predict-chart__svg-wrapper"><svg preserveAspectRatio="xMidYMid meet" class="weight-predict-chart__svg-chart" viewBox="0 0 400 150" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><linearGradient id="area-gradient" x1="0%" x2="100%" y1="0%" y2="0%"><stop offset="0%" stop-color="rgba(253, 213, 57, 0.22)"></stop><stop offset="100%" stop-color="rgba(253, 213, 57, 0.1)"></stop></linearGradient></defs><line x1="10" y1="0" x2="10" y2="150" stroke="#ccc" stroke-width="0.6" stroke-miterlimit="10"></line><line x1="100" y1="0" x2="100" y2="150" stroke="#ccc" stroke-width="0.6" stroke-miterlimit="10"></line><line x1="200" y1="0" x2="200" y2="150" stroke="#ccc" stroke-width="0.6" stroke-miterlimit="10"></line><line x1="300" y1="0" x2="300" y2="150" stroke="#ccc" stroke-width="0.6" stroke-miterlimit="10"></line><line x1="400" y1="0" x2="400" y2="150" stroke="#ccc" stroke-width="0.6" stroke-miterlimit="10"></line><path d="M11,30.222C56.267,35.587,101.533,40.953,146.8,55.762C192.067,70.572,237.333,103.851,282.6,119.08C302,125.607,321.4,132.923,340.8,135.423C360.2,137.923,379.6,138.548,399,139.173L399,89.173C379.6,91.048,360.2,92.923,340.8,92.923C321.4,92.923,302,88.107,282.6,84.08C237.333,74.684,192.067,43.622,146.8,38.262C101.533,32.902,56.267,31.562,11,30.222Z" fill="url(#area-gradient)" opacity="0"><animate attributeName="opacity" from="0" to="1" dur="0.6s" begin="0.5s" fill="freeze"></animate></path><circle cx="11" cy="30.222222222222264" r="4" fill="#fdd539"></circle><path id="drawPath" d="M11,30.222C56.267,33.021,101.533,35.819,146.8,47.012C192.067,58.206,237.333,89.267,282.6,101.58C302,106.857,321.4,114.173,340.8,114.173C360.2,114.173,379.6,114.173,399,114.173" stroke="#fdd539" stroke-width="3" fill="none" stroke-linecap="round" pathLength="1" stroke-dasharray="1" stroke-dashoffset="1"><animate id="lineAnim" attributeName="stroke-dashoffset" from="1" to="0.0" dur="1.5s" fill="freeze" calcMode="spline" keyTimes="0;1" keySplines="0.25 0.1 0.25 1"></animate></path><g id="marker" visibility="hidden"><circle r="7.2" fill="#fdd539" stroke="#fdd539" stroke-width="0"></circle><circle r="7" fill="#fdd539" stroke="#fff" stroke-width="2" stroke-opacity="1"></circle><animateMotion id="markerMotion" begin="lineAnim.end" dur="2s" fill="freeze" calcMode="spline" keyTimes="0;1" keySplines="0.25 0.1 0.25 1" keyPoints="0;0.875"><mpath xlink:href="#drawPath"></mpath></animateMotion><set attributeName="visibility" to="visible" begin="markerMotion.begin" fill="freeze"></set><animateTransform attributeName="transform" type="scale" values="1;1.2;1" begin="markerMotion.end" dur="0.4s" fill="freeze"></animateTransform></g></svg></div>',
                      1
                    )),
                  _(
                    'div',
                    {
                      'data-bounds': 'tooltip',
                      class: $e([
                        { 'weight-predict-chart__goal-label--visible': n.value },
                        'weight-predict-chart__goal-label'
                      ])
                    },
                    a[0] ||
                      (a[0] = [
                        _('div', { class: 'weight-predict-chart__goal-label-chevron' }, null, -1),
                        _(
                          'div',
                          { class: 'weight-predict-chart__goal-label-text' },
                          [Kn(' 2 - 5 Kilo'), _('br'), Kn(' Fettverlust ')],
                          -1
                        )
                      ]),
                    2
                  )
                ])
              ])
            ]),
            _(
              'div',
              {
                class: 'qlfqa:!mt-8 qlfqa:!flex qlfqa:!justify-center qlfqa:!gap-4',
                role: 'group',
                'aria-label': 'Navigation'
              },
              [
                _(
                  'button',
                  {
                    onClick: r,
                    'aria-label': 'Alles klar und weiter',
                    class:
                      'qlfqa:!bg-yellow-500 qlfqa:!text-black qlfqa:!px-6 qlfqa:!py-3 qlfqa:!rounded-md qlfqa:disabled:!opacity-50 qlfqa:hover:!bg-yellow-400 qlfqa:!cursor-pointer qlfqa:!w-full qlfqa:!font-semibold'
                  },
                  ' Weiter zur finalen Berechnung! '
                )
              ]
            )
          ])
        );
      }
    }),
    Qb = { class: 'quiz-container' },
    Kb = re({
      __name: 'Quiz',
      setup(e) {
        const t = le(),
          n = {
            QuizScreen01_A: R_,
            QuizScreen01: k_,
            QuizScreen02: F_,
            QuizScreen03: V_,
            QuizScreen04: Z_,
            QuizScreen05: eq,
            QuizScreen06: sq,
            QuizScreen07: iq,
            QuizScreen08: uq,
            QuizScreen09: dq,
            QuizScreen10: gq,
            QuizScreen11: bq,
            QuizScreen12: Aq,
            QuizScreen13: Iq,
            QuizScreen14: Pq,
            QuizScreen15: Fq,
            QuizScreen16: Wq,
            QuizScreen17: Zq,
            QuizScreen18: nv,
            QuizScreen19: iv,
            QuizScreen20: cv,
            QuizScreen21: dv,
            QuizScreen22: hv,
            QuizScreen23: _v,
            QuizScreen24: xv,
            QuizScreen25: $v,
            QuizScreen26: Gv,
            QuizScreen27: Yv,
            QuizScreen28: eb,
            QuizScreen29: nb,
            QuizScreen30: rb,
            QuizScreen31: lb,
            QuizScreen32: vb,
            QuizScreen33: xb,
            QuizScreen34: Eb,
            QuizScreen35: Ab,
            QuizScreen36: Ob,
            QuizScreen37: Ib,
            QuizScreen38: zb,
            QuizScreen39: Hb
          },
          s = H(() => n[t.currentScreen]);
        function r(o) {
          t.goToNextScreen(o);
        }
        return (o, i) => (
          P(),
          M('div', Qb, [
            Ut(t).currentScreen !== 'HealthPhase2Screen'
              ? (P(),
                wn(p_, { key: 0, 'current-screen': Ut(t).currentScreen }, null, 8, [
                  'current-screen'
                ]))
              : Te('', !0),
            S(
              Dr,
              { name: Ut(t).currentScreen === 'QuizScreen32' ? 'zoom' : 'fade', mode: 'out-in' },
              { default: Et(() => [(P(), wn(Kh(s.value), { onNext: r }, null, 32))]), _: 1 },
              8,
              ['name']
            )
          ])
        );
      }
    }),
    Wb = (e, t) => {
      const n = e.__vccOpts || e;
      for (const [s, r] of t) n[s] = r;
      return n;
    },
    Gb = {},
    Jb = {
      class:
        'qlfqa:!min-h-screen qlfqa:!flex qlfqa:!flex-col qlfqa:!items-center qlfqa:sm:!pt-0 qlfqa:!bg-[#F6F4F2]'
    },
    Yb = {
      class:
        'qlfqa:!w-full qlfqa:sm:!max-w-md qlfqa:!mt-4 qlfqa:!px-6 qlfqa:!bg-[#F6F4F2] qlfqa:!overflow-hidden'
    };
  function Zb(e, t) {
    return (
      P(),
      M('div', Jb, [
        _('div', Yb, [
          t[0] ||
            (t[0] = _(
              'img',
              {
                src: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/logo.png?v=1753083867',
                alt: 'Logo',
                style: { width: '50px !important', height: '50px !important' }
              },
              null,
              -1
            )),
          Aa(e.$slots, 'default')
        ])
      ])
    );
  }
  const Xb = Wb(Gb, [['render', Zb]]),
    ey = re({
      __name: 'Index',
      setup(e) {
        const t = le();
        return (
          Me(() => {
            const s = new URLSearchParams(window.location.search).get('age'),
              r = s ? s.replace(/\s+/g, '+').trim() : null;
            t.setAgeGroup(r || '40-44');
          }),
          (n, s) => (P(), wn(Xb, null, { default: Et(() => [S(Kb)]), _: 1 }))
        );
      }
    });
  window.__QLFQuizGlp1AppMounted = window.__QLFQuizGlp1AppMounted || {};
  function ty(e = {}) {
    const { elementId: t = 'qlfglp1quizapp' } = e;
    if (!document.getElementById(t))
      return (console.warn(`Element with id "${t}" not found`), null);
    if (window.__QLFQuizGlp1AppMounted[t])
      return (
        console.info(`App already mounted on #${t}, reusing existing instance`),
        window.__QLFQuizGlp1AppMounted[t]
      );
    const s = i_(),
      r = R0(ey);
    return (r.use(s), r.mount(`#${t}`), (window.__QLFQuizGlp1AppMounted[t] = r), r);
  }
  return (
    typeof window < 'u' &&
      document.getElementById('qlfswquizapp') &&
      setTimeout(() => {
        document.getElementById('qlfglp1quizapp') &&
          !window.__QLFQuizGlp1AppMounted.qlfglp1quizapp &&
          window.QLFQuizGlp1App();
      }, 0),
    ty
  );
});
